/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/jquery.validation.d.ts" />
/// <reference path="../lib/jquery.validation.unobtrusive.d.ts" />
/// <reference path="../lib/bootbox.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/waitingdialog.d.ts" />
/// <reference path="../../node_modules/dayjs/index.d.ts" />
/// <reference path="../../node_modules/dayjs/plugin/localeData.d.ts" />
/// <reference path="../../node_modules/dayjs/plugin/customParseFormat.d.ts" />
/// <reference path="../../node_modules/dayjs/plugin/localizedFormat.d.ts" />
/// <reference path="../../node_modules/dayjs/plugin/timezone.d.ts" />
//var waitingDialog = new globalThis.waitingDialogHelper ();
// step 0
// step 1 combind ts files
// step 2 commented out "/* js */" lines only between IMPORT START and IMPORT END
// step 3 compile ts
// step 4 comment out "/* ts */" lines only between IMPORT START and IMPORT END
// step 5 uncomment out "/* js */" lines only between IMPORT START and IMPORT END
// IMPORT START
/////*x* ts */ import dayjs from "../../wwwroot/lib/dayjs1.11.10/dayjs.min.js";
/////*x* ts */ import utc from "../../wwwroot/lib/dayjs1.11.10/plugin/utc";
/////*x* ts */ import timezone from "../../wwwroot/lib/dayjs1.11.10/plugin/timezone";
/////*x* ts */ import localizedFormat from "../../wwwroot/lib/dayjs1.11.10/plugin/localizedFormat";
/////*x* ts */ import { GlobalModal } from "../lib/GlobalModal";
/////*x* ts */ import { FileUpload } from "../standaloneComponents/FileUpload";
// timezone
/*x* js */ dayjs.extend(dayjs_plugin_utc);
/*x* js */ dayjs.extend(dayjs_plugin_timezone);
/*x* js */ dayjs.extend(dayjs_plugin_localizedFormat);
/*x* js */ dayjs.extend(dayjs_plugin_advancedFormat);
/*x* js */ dayjs.extend(dayjs_plugin_customParseFormat);
/////*x* ts */ dayjs.extend(utc);
/////*x* ts */ dayjs.extend(timezone);
/////*x* ts */ dayjs.extend(localizedFormat);
//var tzAbbr = function (dateInput:Date = null) {
//    var dateObject = dateInput || new Date(),
//        dateString = dateObject + "",
//        tzAbbr: any = (
//            dateString.match(/\(([^\)]+)\)$/) ||
//            dateString.match(/([A-Z]+) [\d]{4}$/)
//        );
//    if (tzAbbr) {
//        tzAbbr = tzAbbr[1].match(/[A-Z]/g).join("");
//    }
//    if (!tzAbbr && /(GMT\W*\d{4})/.test(dateString)) {
//        return RegExp.$1;
//    }
//    return tzAbbr;
//};
// moved to helper.admin.js
//function debounce(func, wait, immediate) {
//    var timeout;
//    return function () {
//        var context = this, args = arguments;
//        var later = function () {
//            timeout = null;
//            if (!immediate) func.apply(context, args);
//        };
//        var callNow = immediate && !timeout;
//        clearTimeout(timeout);
//        timeout = setTimeout(later, wait);
//        if (callNow) func.apply(context, args);
//    };
//};
function handleMultiSelectClick(otherOption, checked) {
    if (checked) {
        otherOption.closest("li").addClass("disabled");
        otherOption.attr("disabled", "true");
    }
    else {
        otherOption.closest("li").removeClass("disabled");
        otherOption.removeAttr("disabled");
    }
}
function iframeResize(container) {
    var targetIFrame = container.find("iframe");
    if (targetIFrame.length === 1) {
        var constrainByHeight = targetIFrame.attr("data-constrain-width-by-height");
        constrainByHeight = constrainByHeight.toLowerCase();
        var constrainByWidth = targetIFrame.attr("data-constrain-height-by-width");
        constrainByWidth = constrainByWidth.toLowerCase();
        var width = targetIFrame.closest('div.container').width();
        var height = width * 0.75;
        var windowHeight = $(window).height();
        var iFrameWidth = width;
        var iFrameHeight = windowHeight;
        if (constrainByHeight == "true" || constrainByWidth == "true") {
            if (constrainByHeight == "true") {
                if (width > windowHeight) {
                    iFrameWidth = windowHeight;
                }
            }
            if (constrainByWidth == "true") {
                if (windowHeight > width) {
                    iFrameHeight = width;
                }
            }
        }
        else {
            iFrameHeight = iFrameWidth * (9 / 16);
        }
        targetIFrame.css('height', iFrameHeight + 'px');
        targetIFrame.css('width', iFrameWidth + 'px');
        targetIFrame.attr('width', iFrameWidth);
        targetIFrame.attr('height', iFrameHeight);
    }
}
;
function getBaseURL(url) {
    var baseUrl = "";
    if (url) {
        var pathArray = url.split('/');
        if (pathArray.length > 3) {
            var protocol = pathArray[0];
            if (protocol === "http:" || protocol === "https:") {
                var host = pathArray[2];
                baseUrl = protocol + '//' + host;
            }
        }
    }
    return baseUrl;
}
;
(function ($) {
    //Enable swiping...
    $(".carousel-inner .item").swipe({
        //Generic swipe handler for all directions
        //swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
        //    gage.log("You swiped " + direction);
        //},
        swipeLeft: function (event, direction, distance, duration, fingerCount) {
            $('.carousel').carousel('next');
        },
        swipeRight: function (event, direction, distance, duration, fingerCount) {
            $('.carousel').carousel('prev');
        },
        //Default is 75px, set to 0 for demo so any distance triggers swipe
        threshold: 0
    });
    // Normalize Carousel Heights - pass in Bootstrap Carousel items.
    $.fn.carouselHeights = function () {
        var items = $(this), //grab all slides
        heights = [], //create empty array to store height values
        tallest; //create variable to make note of the tallest slide
        var normalizeHeights = function () {
            items.each(function () {
                heights.push($(this).height());
            });
            tallest = Math.max.apply(null, heights); //cache largest value
            items.each(function () {
                var topMargin = (tallest - $(this).height()) / 2;
                $(this).css('min-height', tallest + 'px');
                $(this).find('img').css('padding-top', topMargin + 'px');
                $(this).find('.carousel-caption').css({ 'margin-bottom': topMargin + 'px', 'margin-top': topMargin + 'px' });
            });
        };
        normalizeHeights();
        $(window).on('resize orientationchange', function () {
            //reset vars
            tallest = 0;
            heights.length = 0;
            items.each(function () {
                $(this).css('min-height', '0'); //reset min-height
            });
            normalizeHeights(); //run it again 
        });
    };
    jQuery(function ($) {
        $(window).on('load', function () {
            $.each($('.widget.carousel'), function () {
                $(this).find('.item').carouselHeights();
            });
        });
    });
    $(document).ready(function () {
        $(".js-overlay-link a").on("click", function (e) {
            e.stopImmediatePropagation();
        });
        $(".js-overlay-link").on("click", function (e) {
            var slide = $(this).closest(".item.active");
            var link = $(slide).find("a").first();
            var destination = $(link).attr("href");
            var target = $(link).attr("target");
            if (target == "_blank") {
                window.open(destination);
            }
            else {
                window.location.href = destination;
            }
        });
        function accordionCarouselTransition(e) {
            var slides = $(e.currentTarget).find(".accordion-item");
            $(slides).find(".accordion-button").removeClass("active");
            $(slides).find(".accordion-button").attr("aria-expanded", "false");
            $(slides[e.to]).find(".accordion-button").addClass("active");
            $(slides[e.to]).find(".accordion-button").attr("aria-expanded", "true");
        }
        function tabbedCarouselTransition(e) {
            var slides = $(e.currentTarget).find(".nav.nav-tabs .nav-item");
            $(slides).find(".nav-link").removeClass("active");
            $(slides[e.to]).find(".nav-link").addClass("active");
        }
        function imageCarouselTransition(e) {
            var slideContainer = $(e.currentTarget).closest(".carousel-image");
            var altSlideId = $(slideContainer).attr("data-alt-carousel");
            var slideIndicatorId = $(slideContainer).attr("data-carousel-indicator");
            var slideIndicators = $("#" + slideIndicatorId).find("button");
            $(slideIndicators).removeClass("active");
            $(slideIndicators[e.to]).addClass("active");
            if (e.direction == "left") {
                $("#" + altSlideId + "-top").carousel('next');
                $("#" + altSlideId + "-bottom").carousel('next');
            }
            else if (e.direction == "right") {
                $("#" + altSlideId + "-top").carousel('prev');
                $("#" + altSlideId + "-bottom").carousel('prev');
            }
        }
        // carousel accordion tab
        $(".carousel-accordion").on("slide.bs.carousel", accordionCarouselTransition);
        // carousel tab button
        $(".carousel-tabbed").on("slide.bs.carousel", tabbedCarouselTransition);
        // carousel image transition
        $(".carousel-image").on("slide.bs.carousel", imageCarouselTransition);
    });
    $(".js-scrollable").each(function (i, el) {
        var containerWidth = $(el).find(".scrollable-container").outerWidth();
        var itemsWidth = 0;
        var scrollableItems = $(el).find(".scrollable-item");
        var slideEvent = $(el).attr("data-slide-event");
        var slideTarget = $(el).attr("data-slide-target");
        var rightScrollWidth = $(".js-scroller-right").outerWidth();
        var leftScrollWidth = $(".js-scroller-left").outerWidth();
        function handleEventSlide(e) {
            var scrollItems = $(slideTarget).find(".scrollable-item");
            if (scrollItems.length > 0) {
                var lPos = $(scrollItems[e.to]).position().left;
                var rPos = lPos + $(scrollItems[e.to]).width();
                var sContainerLPos = $(slideTarget).find(".scrollable-container").position().left;
                var sContainerRPos = sContainerLPos + $(slideTarget).find(".scrollable-container").width();
                var sItemsLPos = $(scrollableItems).position().left;
                var newPos = null;
                // Auto Slide right
                if (rPos > sContainerRPos) {
                    newPos = sItemsLPos - (rPos - sContainerRPos) - rightScrollWidth;
                    $(scrollableItems).stop(true).animate({ left: newPos + 'px' });
                }
                // Auto Slide left
                if (lPos < sContainerLPos) {
                    newPos = sItemsLPos - lPos;
                    $(scrollableItems).stop(true).animate({ left: newPos + 'px' });
                }
            }
        }
        if (scrollableItems.length > 0) {
            $.each(scrollableItems, function (y, e) {
                itemsWidth += $(e).outerWidth();
            });
        }
        if (itemsWidth > containerWidth) {
            $(el).find(".scrollable-icon").css('display', 'block');
            $(".js-scroller-left").on("click", function (btn) {
                var leftPos = $(scrollableItems).position().left;
                if (leftPos != 0) {
                    var newLeftPos = leftPos + 100;
                    if (newLeftPos > 0) {
                        newLeftPos = 0;
                    }
                    $(scrollableItems).stop(true).animate({ left: newLeftPos + 'px' });
                }
            });
            $(".js-scroller-right").on("click", function (btn) {
                var leftPos = $(scrollableItems).position().left;
                var newLeftPos = leftPos - 100;
                var itemWidthHidden = itemsWidth + newLeftPos;
                if (itemWidthHidden <= containerWidth) {
                    var y = Math.abs(leftPos) + containerWidth;
                    var diff = itemsWidth - y;
                    newLeftPos = leftPos - diff - rightScrollWidth - leftScrollWidth;
                }
                $(scrollableItems).stop(true).animate({ left: newLeftPos + 'px' });
            });
            if (slideEvent) {
                $(el).parent(slideTarget).on("slide.bs.carousel", handleEventSlide);
            }
        }
    });
})(jQuery);
/// <reference path="../lib/helper.admin.d.ts" />
/*
$('.display-entitlement-info').on('click', function () {

    var loadurl = $(this).data('load-url');
    var entitlementID = $(this).data('entitlement-id');
    $('#entitlement-detail-modal').find('.modal-body').empty();

    $('#entitlement-detail-modal').modal('show').find('.modal-body').load(loadurl);
    //$(".entitlement-data-" + entitlementID).show();
    //$(".entitlement-data-" + entitlementID).load(loadurl);
    return false;
});
*/
// entitlement badges - click to expand
(function () {
    var clickHandler = function (e) {
        if (!$(e.target).siblings(".widget-entitlement-info").is(":visible")) {
            if ($(e.target).hasClass('widget-entitlement-info') || $(e.target).parents('.widget-entitlement-info').length) {
                // User clicked inside open modal
                // Check if they clicked close button, otherwise ignore
                if ($(e.target).hasClass('close')) {
                    $(document.body).off("click", clickHandler);
                    $(".widget-entitlement-info").addClass('hidden');
                }
            }
            else {
                // If click is outside of modal, simply close
                $(document.body).off("click", clickHandler);
                $(".widget-entitlement-info").addClass('hidden');
            }
        }
    };
    $(".btn-entitlement-download").on("click", function () {
        var parent = $(this);
        var message = $(this).closest(".widget-entitlement-wrapper").data("generating-message");
        parent.attr("disabled", "disabled");
        var globalModal = new GlobalModal("entitlement-" + parent.data("peid"));
        globalModal.openGlobalModal(message, "modal", { origin: $(this) });
        $.ajax({
            method: "GET",
            url: '/API/Entitlement/DownloadEntitlementFile/' + parent.data("peid")
        })
            .done(function (data, textStatus, request) {
            if (data.url !== undefined) {
                globalModal.closeGlobalModal();
                parent.removeAttr("disabled");
                window.location = data.url;
            }
            else {
                globalThis.gage.HandleAjaxFail(request);
            }
        });
    });
    $(".js-entitlement-img").on("click", function (e) {
        // Explicitly hide all entitlement panels, we do not allow more
        // than one to be open at a time.
        $(".widget-entitlement-info").addClass('hidden');
        // Show only the active info panel
        $(this).siblings(".widget-entitlement-info").removeClass('hidden');
        $(document.body).off("click", clickHandler);
        $(document.body).on("click", clickHandler);
    });
})();
// Global Navigation
$(document).ready(function () {
    var menuItem = $('.dropdown-submenu .dropdown-toggle');
    var submenuItem = $('.dropdown-submenu ul');
    $(submenuItem).hide();
    $(menuItem).on('click', function () {
        var parentEl = $(this).parent('.dropdown-submenu');
        parentEl.toggleClass('nav-open');
        parentEl.children('ul').slideToggle();
        if ($(this).attr('aria-expanded') == 'false' || $(this).attr('aria-expanded') == undefined) {
            $(this).attr('aria-expanded', 'true');
        }
        else {
            $(this).attr('aria-expanded', 'false');
        }
        return false;
    });
    $(".primary-navigation, .mobile-navigation, .secondary-navigation").on("show.bs.dropdown", ".js-top-level-nav", function (e) {
        $(this).closest("li.dropdown").addClass("open");
    });
    $(".primary-navigation, .mobile-navigation, .secondary-navigation").on("hide.bs.dropdown", ".js-top-level-nav", function (e) {
        $(this).closest("li.dropdown").removeClass("open");
    });
    //$(".mobile-navigation").on("show.bs.dropdown", ".js-top-level-nav", function (e) {
    //    $(this).closest("li.dropdown").addClass("open");
    //});
    //$(".mobile-navigation").on("hide.bs.dropdown", ".js-top-level-nav", function (e) {
    //    $(this).closest("li.dropdown").removeClass("open");
    //});
    $('.navbar-toggler').on('click', function () {
        if ($('body').hasClass("mobile-nav-open")) {
            $('body').removeClass("mobile-nav-open");
            $('.js-navbar-scroll').height('auto');
        }
        else {
            var windowHeight = window.innerHeight;
            var headerHeight = $('#globalHeader').outerHeight(true);
            $('body').addClass("mobile-nav-open");
            $('.js-navbar-scroll').height(windowHeight - headerHeight);
        }
    });
    function accomodateHeader() {
        if ($('body').hasClass("mobile-nav-open")) {
            if ($('body').css('overflow') === "hidden") {
                var windowHeight = window.innerHeight;
                var headerHeight = $('#globalHeader').outerHeight(true);
                $('.js-navbar-scroll').height(windowHeight - headerHeight);
            }
            else {
                $('body').removeClass("mobile-nav-open");
                $('.js-navbar-scroll').height('auto');
                $('.navbar-nav-container').removeClass('in');
            }
        }
        if ($('body').hasClass("sticky-menu")) {
            var headerHeight = $('header').outerHeight(true);
            var pageWrapperMargin = $('.page-wrapper').css('margin-top');
            if (pageWrapperMargin != "0px") {
                $('body.sticky-menu').find('.page-wrapper').css('margin-top', headerHeight);
            }
        }
    }
    ;
    $(window).on("resize", debounce(accomodateHeader, 250, false));
    // $(window).resize(debounce(accomodateHeader, 250, false));
    accomodateHeader();
});
$(document).ready(function () {
    $('.momentUtcDate').each(function () {
        if ($(this).is('input')) {
            var momDate = dayjs($(this).val() + ' +0000', 'M/D/YY hh:mm:ss Z');
            $(this).val(momDate.format('l'));
        }
        else {
            var momDate = dayjs(this.innerText + ' +0000', 'M/D/YY hh:mm:ss Z');
            if (momDate.isValid())
                this.innerText = momDate.format('l');
        }
    });
    $('.momentUtcDateTime').each(function () {
        var momDate = dayjs(this.innerText + ' +0000', 'M/D/YY hh:mm:ss Z');
        if (momDate.isValid())
            this.innerText = momDate.format('l LT');
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/jquery.validation.unobtrusive.d.ts" />
/// <reference path="profile.d.ts"/>
class NZProfileFields {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        if ($(this._widget).find(".js-mode").val() == "ProfileEdit") {
            $(this._widget).find(".js-Market").closest(".profile-group").addClass("hide");
        }
        $(this._widget).find(".span-Market").closest(".profile-group").addClass("hide");
        $(this._widget).find(".js-Market").on("change", function (e) {
            if ($(e.currentTarget).find("option:selected").text() == "Australia") {
                window.location.href = window.location.pathname + "?market=b3783eaa94fb5b196a39ba7e300bAU";
            }
            else if ($(e.currentTarget).find("option:selected").text() == "United States/Canada") {
                window.location.href = window.location.pathname + "?market=c2daff463a1241e6a1833be7040USA";
            }
            else if ($(e.currentTarget).find("option:selected").text() == "United Kingdom") {
                window.location.href = window.location.pathname + "?market=87da1754c1124a3a9d459d4c365UK";
            }
            else if ($(e.currentTarget).find("option:selected").text() == "India") {
                window.location.href = window.location.pathname + "?market=f60f436ff42142779d697b0692227d6eIN";
            }
            else if ($(e.currentTarget).find("option:selected").text() == "South East Asia") {
                window.location.href = window.location.pathname + "?market=7252d824047d48dfb78c32e7f61ca058SG";
            }
            else if ($(e.currentTarget).find("option:selected").text() == "Business Events") {
                window.location.href = window.location.pathname + "?market=3a94f9a1ec2742238c8a80e499383881BE";
            }
            else {
                window.location.href = window.location.pathname + "?market=";
            }
        });
        $(this._widget).find(".js-JobRole").on("change", function (e) {
            var otherRow = "." + $(e.currentTarget).attr("data-other-field-id") + "-row";
            var otherField = "." + $(e.currentTarget).attr("data-other-field-id");
            $(otherField).val("");
            $(otherRow).addClass("hide");
            if ($(e.currentTarget).val() == "9999") {
                $(otherRow).removeClass("hide");
            }
        });
        $(this._widget).find(".js-CompanyName").on("change", function (e) {
            var otherRow = "." + $(e.currentTarget).attr("data-other-field-id") + "-row";
            var otherField = "." + $(e.currentTarget).attr("data-other-field-id");
            $(otherField).val("");
            $(otherRow).addClass("hide");
            if ($(e.currentTarget).val() == "9999") {
                $(otherRow).removeClass("hide");
            }
        });
        //$(this._widget).find(".js-ABTA_TTANumber").on("keyup", function () {
        //    $(this).val($(this).val().replace(/[^0-9\.]/g, ''));
        //});
        //$(this._widget).find(".js-IATANumber").on("keyup", function () {
        //    $(this).val($(this).val().replace(/[^0-9\.]/g, ''));
        //});
        //$(this._widget).find(".js-IATANumber").attr("maxlength", 8);
        //$(this._widget).find(".js-ABTA_TTANumber").attr("maxlength", 7);
        //if ($(this._widget).find(".js-PhysicalAddressCountry").val() == "9999") {
        //    $(this._widget).find(".js-PhysicalAddressStateProvince").closest(".form-group").addClass("hide");
        //}
        //if ($(this._widget).find(".js-PostalAddressCountry").val() == "9999") {
        //    $(this._widget).find(".js-PostalAddressStateProvince").closest(".form-group").addClass("hide");
        //}
        $(this._widget).find("#sameasphysicaladdress").on("click", function (e) {
            var container = $(e.currentTarget).closest(".widget-nz-profile-fields");
            if ($(container).find("#sameasphysicaladdress").is(":checked")) {
                $(container).find(".js-postaladdressgroup").addClass("hide");
            }
            else {
                $(container).find(".js-postaladdressgroup").removeClass("hide");
            }
        });
        $(this._widget).find(".js-PhysicalAddressCountry").on("change", function (e) {
            var otherRow = "." + $(e.currentTarget).attr("data-other-field-id") + "-row";
            var otherField = "." + $(e.currentTarget).attr("data-other-field-id");
            $(otherField).val("");
            $(otherRow).addClass("hide");
            var container = $(e.currentTarget).closest(".widget-nz-profile-fields");
            var isPostalAddressSameasPhysicalAddress = $(container).find("#sameasphysicaladdress").is(":checked");
            var el = $(container).find(".js-PhysicalAddressStateProvince");
            var county = $(container).find(".js-County");
            var zipCode = $(container).find(".js-PhysicalAddressZipPostal");
            var postalAddressCountry = $(container).find(".PostalAddressCountry");
            var postalAddressStateProvince = $(container).find(".js-PostalAddressStateProvince");
            var postalAddressZipPostal = $(container).find(".js-PostalAddressZipPostal");
            $(el).empty();
            $(county).empty();
            if ($(e.currentTarget).val() == "9999") {
                var x = 1;
                //$(otherRow).removeClass("hide");
                //$(zipCode).attr("data-val-regex", "");
                //$(zipCode).attr("data-val-regex-pattern", "");
                //$(zipCode).attr('data-val', 'false');
                //$(el).closest(".form-group").addClass("hide");
                //$(el).attr("data-val-regex", "");
                //$(el).attr("data-val-regex-pattern", "");
                //$(el).attr('data-val', 'false');
                //var form = $(".form-horizontal")
                //    .removeData("validator") /* added by the raw jquery.validate plugin */
                //    .removeData("unobtrusiveValidation");
                //$.validator.unobtrusive.parse(form);
            }
            else {
                $(el).closest(".form-group").removeClass("hide");
                var params = {
                    countryID: $(e.currentTarget).val(),
                    countryType: "PhysicalAddressCountry"
                };
                $.ajax({
                    url: ("/Profile/GetStateProvinces"),
                    type: "GET",
                    data: params,
                    dataType: 'json',
                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
                }).done(function (data) {
                    if (data != null) {
                        $(zipCode).attr("data-val-regex", data.zipCodeRegexMessage);
                        $(zipCode).attr("data-val-regex-pattern", data.zipCodeRegex);
                        $.each(data.results, function (value, key) {
                            $(el).append('<option value="' + key.value + '">' + key.text + '</option>');
                        });
                        if (isPostalAddressSameasPhysicalAddress) {
                            $(postalAddressCountry).val($(e.currentTarget).val());
                            $(postalAddressStateProvince).empty();
                            $.each(data.results, function (value, key) {
                                $(postalAddressStateProvince).append('<option value="' + key.value + '">' + key.text + '</option>');
                            });
                            $(postalAddressZipPostal).attr("data-val-regex", data.zipCodeRegexMessage);
                            $(postalAddressZipPostal).attr("data-val-regex-pattern", data.zipCodeRegex);
                        }
                        var mobilephone = $(container).find(".js-MobilePhoneNumber");
                        var businessphone = $(container).find(".js-BusinessPhoneNumber");
                        if ($(container).find(".js-Market :selected").text() == "Business Events" || $(container).find(".js-market-value").val() == "Business Events") {
                        }
                        else {
                            $(mobilephone).attr("data-val-regex", data.phoneRegexMessage);
                            $(mobilephone).attr("data-val-regex-pattern", data.phoneRegex);
                            $(businessphone).attr("data-val-regex", data.phoneRegexMessage);
                            $(businessphone).attr("data-val-regex-pattern", data.phoneRegex);
                        }
                        var form = $(".form-horizontal")
                            .removeData("validator") /* added by the raw jquery.validate plugin */
                            .removeData("unobtrusiveValidation");
                        // @ts-ignore
                        $.validator.unobtrusive.parse(form);
                    }
                });
                if ($(e.currentTarget).val() == "1237" || $(e.currentTarget).val() == "1110" || $(e.currentTarget).val() == "1254") {
                    $.ajax({
                        url: ("/Profile/GetCounties"),
                        type: "GET",
                        data: params,
                        dataType: 'json',
                        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
                    }).done(function (data) {
                        if (data != null) {
                            $.each(data.results, function (value, key) {
                                $(county).append('<option value="' + key.value + '">' + key.text + '</option>');
                            });
                        }
                    });
                }
            }
        });
        $(this._widget).find(".js-PostalAddressCountry").on("change", function (e) {
            var otherRow = "." + $(e.currentTarget).attr("data-other-field-id") + "-row";
            var otherField = "." + $(e.currentTarget).attr("data-other-field-id");
            $(otherField).val("");
            $(otherRow).addClass("hide");
            var container = $(e.currentTarget).closest(".widget-nz-profile-fields");
            var el = $(container).find(".js-PostalAddressStateProvince");
            var zipCode = $(container).find(".js-PostalAddressZipPostal");
            $(el).empty();
            if ($(e.currentTarget).val() == "9999") {
                var x = 1;
                //$(otherRow).removeClass("hide");
                //$(zipCode).attr("data-val-regex", "");
                //$(zipCode).attr("data-val-regex-pattern", "");
                //$(zipCode).attr('data-val', 'false');
                //$(el).closest(".form-group").addClass("hide");
                //$(el).attr("data-val-regex", "");
                //$(el).attr("data-val-regex-pattern", "");
                //$(el).attr('data-val', 'false');
                //var form = $(".form-horizontal")
                //    .removeData("validator") /* added by the raw jquery.validate plugin */
                //    .removeData("unobtrusiveValidation");
                //$.validator.unobtrusive.parse(form);
            }
            else {
                $(el).closest(".form-group").removeClass("hide");
                var params = {
                    countryID: $(e.currentTarget).val(),
                    countryType: "PostalAddressCountry"
                };
                $.ajax({
                    url: ("/Profile/GetStateProvinces"),
                    type: "GET",
                    data: params,
                    dataType: 'json',
                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
                }).done(function (data) {
                    if (data != null) {
                        $(zipCode).attr("data-val-regex", data.zipCodeRegexMessage);
                        $(zipCode).attr("data-val-regex-pattern", data.zipCodeRegex);
                        var mobilephone = $(container).find(".js-MobilePhoneNumber");
                        var businessphone = $(container).find(".js-BusinessPhoneNumber");
                        var form = $(".form-horizontal")
                            .removeData("validator") /* added by the raw jquery.validate plugin */
                            .removeData("unobtrusiveValidation");
                        // @ts-ignore
                        $.validator.unobtrusive.parse(form);
                        $.each(data.results, function (value, key) {
                            $(el).append('<option value="' + key.value + '">' + key.text + '</option>');
                        });
                    }
                });
            }
        });
        $(this._widget).find("#profile-registration").on("click", function (e) {
            // upload images
            e.preventDefault();
            var container = $(e.currentTarget).closest(".widget-nz-profile-fields");
            $(container).find(".Profile-Other-JobRole-span").remove();
            $(container).find(".Profile-Other-PhysicalAddressCountry-span").remove();
            $(container).find(".Profile-Other-PostalAddressCountry-span").remove();
            $(container).find(".Profile-TermsAndConditions-div").remove();
            $(container).find(".Profile-IATANumber-div").remove();
            $(container).find(".Profile-CompanyName-Other-div").remove();
            $(container).find(".Profile-MobilePhoneNumber-div").remove();
            $(container).find(".Profile-BusinessPhoneNumber-div").remove();
            if ($(container).find("#sameasphysicaladdress").is(":checked")) {
                me.setPostalAddress(container);
            }
            var isValid = true;
            var form = $(container).find("form");
            if (form.valid()) {
                if ($(container).find(".js-CompanyName").length > 0) {
                    if ($(container).find(".js-CompanyName").val() === "9999") {
                        if ($(container).find(".Profile-Other-CompanyName").val() == "") {
                            var companyName = $(container).find(".js-CompanyName");
                            var otherCompanyName = $(container).find(".Profile-Other-CompanyName");
                            var data = "<div class='text-danger field-validation-error Profile-CompanyName-Other-div'>" + $(companyName).attr("data-val-required") + "</div>";
                            $(container).find(".Profile-CompanyName-Other-div").remove();
                            $(otherCompanyName).after(data);
                            isValid = false;
                        }
                    }
                }
                //if ($(container).find(".js-IATANumber").length > 0) {
                //    if ($(container).find(".js-IATANumber").val() !== "" && $(container).find(".js-IATANumber").val().length < 7) {
                //        var validationCheckBox = $(container).find(".js-IATANumber");
                //        var data = "<div class='text-danger field-validation-error Profile-IATANumber-div'>" + $(validationCheckBox).attr("data-val-regex") + "</div>";
                //        $(container).find(".Profile-IATANumber-div").remove();
                //        $(validationCheckBox).after(data);
                //        isValid = false;
                //    }
                //}
                //if ($(container).find(".js-ABTA_TTANumber").length > 0) {
                //    if ($(container).find(".js-ABTA_TTANumber ").val() !== "") {
                //        var abtanummberRegex = new RegExp($(container).find(".js-ABTA_TTANumber").attr("data-val-regex-pattern"));
                //        if (!abtanummberRegex.test($(container).find(".js-ABTA_TTANumber").val())) {
                //            var validationCheckBox = $(container).find(".js-ABTA_TTANumber ");
                //            var data = "<div class='text-danger field-validation-error Profile-ABTA_TTANumber-div'>" + $(validationCheckBox).attr("data-val-regex") + "</div>";
                //            $(container).find(".Profile-ABTA_TTANumber-div").remove();
                //            $(validationCheckBox).after(data);
                //            isValid = false;
                //        }
                //    }
                //}
                if ($(container).find(".js-MobilePhoneNumber").length > 0) {
                    if ($(container).find(".js-MobilePhoneNumber").val() !== "") {
                        if ($(container).find(".js-Market :selected").text() == "Business Events" || $(container).find(".js-market-value").val() == "Business Events") {
                            isValid = true;
                        }
                        else {
                            var phoneRegex = new RegExp($(container).find(".js-MobilePhoneNumber").attr("data-val-regex-pattern"));
                            if (!phoneRegex.test($(container).find(".js-MobilePhoneNumber").val() + "")) {
                                var validationCheckBox = $(container).find(".js-MobilePhoneNumber");
                                var attr = $(validationCheckBox).attr("data-val-regex");
                                if (typeof attr !== 'undefined') {
                                    var data = "<div class='text-danger field-validation-error Profile-MobilePhoneNumber-div'>" + $(validationCheckBox).attr("data-val-regex") + "</div>";
                                    $(container).find(".Profile-MobilePhoneNumber-div").remove();
                                    $(container).find(".helptext-MobilePhoneNumber").after(data);
                                    isValid = false;
                                }
                            }
                        }
                    }
                }
                if ($(container).find(".js-BusinessPhoneNumber").length > 0) {
                    if ($(container).find(".js-BusinessPhoneNumber").val() !== "") {
                        if ($(container).find(".js-Market :selected").text() == "Business Events" || $(container).find(".js-market-value").val() == "Business Events") {
                            isValid = true;
                        }
                        else {
                            var phoneRegex = new RegExp($(container).find(".js-BusinessPhoneNumber").attr("data-val-regex-pattern"));
                            if (!phoneRegex.test($(container).find(".js-BusinessPhoneNumber").val() + "")) {
                                var validationCheckBox = $(container).find(".js-BusinessPhoneNumber");
                                $(container).find(".Profile-BusinessPhoneNumber-div").remove();
                                var data = "<div class='text-danger field-validation-error Profile-BusinessPhoneNumber-div'>" + $(validationCheckBox).attr("data-val-regex") + "</div>";
                                $(container).find(".Profile-BusinessPhoneNumber-div").remove();
                                $(container).find(".helptext-BusinessPhoneNumber").after(data);
                                isValid = false;
                            }
                            else if ($(container).find(".js-BusinessPhoneNumber").attr("asp-nzprofilefield-country-id") === "1237" ||
                                $(container).find(".js-BusinessPhoneNumber").attr("asp-nzprofilefield-country-id") === "1110" ||
                                $(container).find(".js-BusinessPhoneNumber").attr("asp-nzprofilefield-country-id") === "1254") {
                                if ($(container).find(".js-BusinessPhoneNumber").val() !== "" && $(container).find(".js-BusinessPhoneNumber").val().length < 10 || $(container).find(".js-BusinessPhoneNumber").val().length > 15) {
                                    var attr = $(validationCheckBox).attr("data-val-regex");
                                    if (typeof attr !== 'undefined') {
                                        var validationCheckBox = $(container).find(".js-BusinessPhoneNumber");
                                        $(container).find(".Profile-BusinessPhoneNumber-div").remove();
                                        var data = "<div class='text-danger field-validation-error Profile-BusinessPhoneNumber-div'>" + $(validationCheckBox).attr("data-val-regex") + "</div>";
                                        $(container).find(".Profile-BusinessPhoneNumber-div").remove();
                                        $(container).find(".helptext-BusinessPhoneNumber").after(data);
                                        isValid = false;
                                    }
                                }
                            }
                        }
                    }
                }
                if ($(container).find(".js-TermsAndConditions").length > 0) {
                    if (!$(container).find(".js-TermsAndConditions").is(":checked")) {
                        var validationCheckBox = $(container).find(".js-TermsAndConditions");
                        var data = "<div class='text-danger field-validation-error Profile-TermsAndConditions-div'>" + $(validationCheckBox).attr("data-val-required") + "</div>";
                        $(container).find(".Profile-TermsAndConditions-div").remove();
                        $(container.find(".checkbox-other-TermsAndConditions")).after(data);
                        isValid = false;
                    }
                }
                if ($(container).find(".js-JobRole").val() === "9999" && $(container).find(".Profile-Other-JobRole").val() === "") {
                    $(container).find(".Profile-Other-JobRole").addClass("input-validation-error");
                    var otherTextBox = $(container).find(".Profile-Other-JobRole");
                    var data = "<span class='text-danger field-validation-error Profile-Other-JobRole-span'>" + $(otherTextBox).attr("data-required-message") + "</span>";
                    $(container).find(".Profile-Other-JobRole-span").remove();
                    $(otherTextBox).after(data);
                    isValid = false;
                }
                else {
                    $(container).find(".Profile-Other-JobRole").removeClass("input-validation-error");
                }
                //if ($(container).find(".js-PhysicalAddressCountry").val() === "9999" && $(container).find(".Profile-Other-PhysicalAddressCountry").val() === "") {
                //    $(container).find(".Profile-Other-PhysicalAddressCountry").addClass("input-validation-error");
                //    var otherTextBox = $(container).find(".Profile-Other-PhysicalAddressCountry");
                //    var data = "<span class='text-danger field-validation-error Profile-Other-PhysicalAddressCountry-span'>" + $(otherTextBox).attr("data-required-message") + "</span>";
                //    $(container).find(".Profile-Other-PhysicalAddressCountry-span").remove();
                //    $(otherTextBox).after(data);
                //    isValid = false;
                //}
                //else {
                //    $(container).find(".Profile-Other-PhysicalAddressCountry").removeClass("input-validation-error")
                //}
                //if ($(container).find(".js-PostalAddressCountry").val() === "9999" && $(container).find(".Profile-Other-PostalAddressCountry").val() === "") {
                //    $(container).find(".Profile-Other-PostalAddressCountry").addClass("input-validation-error");
                //    var otherTextBox = $(container).find(".Profile-Other-PostalAddressCountry");
                //    var data = "<span class='text-danger field-validation-error Profile-Other-PostalAddressCountry-span'>" + $(otherTextBox).attr("data-required-message") + "</span>";
                //    $(container).find(".Profile-Other-PostalAddressCountry-span").remove();
                //    $(otherTextBox).after(data);
                //    isValid = false;
                //}
                //{
                //    $(container).find(".Profile-Other-PostalAddressCountry").remove("input-validation-error");
                //}
                if (isValid) {
                    var imageOne = $(".js-image-upload-container")[0];
                    var imageTwo = $(".js-image-upload-container")[1];
                    if (imageOne != undefined) {
                        uploadProfileImage(imageOne, function () {
                            if (imageTwo != undefined) {
                                uploadProfileImage(imageTwo, function () {
                                    form.trigger("submit");
                                });
                            }
                            else {
                                form.trigger("submit");
                            }
                        });
                    }
                    else {
                        form.trigger("submit");
                    }
                }
            }
            else {
                return false;
            }
        });
    }
    setPostalAddress(container) {
        $(container).find(".js-PostalAddressStreet1").val($(container).find(".js-PhysicalAddressStreet1").val());
        $(container).find(".js-PostalAddressStreet2").val($(container).find(".js-PhysicalAddressStreet2").val());
        $(container).find(".js-PostalAddressStateProvince").val($(container).find(".js-PhysicalAddressStateProvince").val());
        $(container).find(".js-PostalAddressSuburb").val($(container).find(".js-PhysicalAddressSuburb").val());
        $(container).find(".js-PostalAddressCity").val($(container).find(".js-PhysicalAddressCity").val());
        $(container).find(".js-PostalAddressCountry").val($(container).find(".js-PhysicalAddressCountry").val());
        $(container).find(".js-PostalAddressStateProvince").val($(container).find(".js-PhysicalAddressStateProvince").val());
        //var el = $(container).find(".js-PostalAddressStateProvince");
        //$(el).empty();
        //if ($(container).find(".js-PhysicalAddressCountry").val() !== "9999") {
        //    var params = {
        //        countryID: $(container).find(".js-PostalAddressCountry").val(),
        //        countryType: "PhysicalAddressCountry"
        //    };
        //    $.ajax({
        //        url: ("/Profile/GetStateProvinces"),
        //        type: "GET",
        //        data: params,
        //        dataType: 'json',
        //        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
        //    }).done(function (data) {
        //        if (data != null) {
        //            $.each(data.results,
        //                function (value, key) {
        //                    $(el).append('<option value="' + key.value + '">' + key.text + '</option>');
        //                });
        //            $(el).val($(container).find(".js-PhysicalAddressStateProvince").val());
        //        }
        //    });
        //}
        //else {
        //    $(container).find(".js-PostalAddressStateProvince").val($(container).find(".js-PhysicalAddressStateProvince").val());
        //}
        $(container).find(".js-PostalAddressZipPostal").val($(container).find(".js-PhysicalAddressZipPostal").val());
        $(container).find(".Profile-Other-PostalAddressCountry").val($(container).find(".Profile-Other-PhysicalAddressCountry").val());
    }
}
$(function () {
    // locate all product list widgets on page
    $(".widget-nz-profile-fields").each(function (index, item) {
        $(item).data("manager", new NZProfileFields(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class Quiz {
    constructor() {
        this.isQuizCompleted = false;
        this.isPassed = false;
        this.canTryAgain = false;
        this.submittingAnswer = false;
    }
    StartQuiz(el) {
        this.$quizWrapper = $(el).closest(".widget-quiz-wrapper");
        if (this.$quizWrapper.find('#quizTimedQuiz').val() === "true")
            stopTimer(el);
        var quizID = parseInt(this.$quizWrapper.attr("data-quizid"));
        var parent = this;
        parent.isQuizCompleted = false;
        parent.isPassed = false;
        parent.canTryAgain = false;
        parent.score = 0;
        $(".widget-quiz-retry").addClass("hide");
        $(".widget-quiz-summary-fail").addClass("hide");
        $.ajax({
            contentType: "application/json",
            method: "GET",
            url: '/API/Content/QuizStart/' + quizID
        }).done(function (response) {
            if (response.success == true) {
                switch (response.data.status) {
                    case 1:
                        // New Session
                        break;
                    case 2:
                        // Existing Session
                        break;
                    case 3: // Already attempted max times
                    case 4: // Access Denied
                    case 5: // Retry Lockout
                        $("#general-message-headline").text(response.data.errorHeadline);
                        $("#general-message-text").text(response.data.errorText);
                        $("#general-message-modal").modal();
                        return;
                }
                var rID = response.data.identifier;
                var elapsedSeconds = response.data.elapsedSeconds;
                var totalSeconds = parent.$quizWrapper.find('#quizSeconds').val() - elapsedSeconds;
                parent.$quizWrapper.find('#quizSeconds').val(totalSeconds);
                parent.$quizWrapper.attr("data-rid", rID);
                $(response.data.questionsAlreadyAnswered).each(function (i, e) {
                    parent.$quizWrapper.find(".widget-quiz-question[data-questionid='" + e + "']").remove();
                });
                parent.$quizWrapper.find(".widget-quiz-intro").addClass("hide");
                parent.$quizWrapper.find(".widget-quiz-question:first").removeClass("hide");
                parent.$quizWrapper.attr("data-currentquestionnumber", parent.$quizWrapper.find('#quizFirstQuestion').val());
                if (parent.$quizWrapper.find('#quizTimedQuiz').val() === "true") {
                    startTimer(el);
                }
            }
        });
    }
    SelectQuizAnswer(el) {
        if ($(el).closest(".widget-quiz-question").attr("data-multipleanswerselection") === "multiple-answer") {
            if ($(el).closest(".widget-quiz-answer-text").hasClass("widget-quiz-question-selected")) {
                $(el).closest(".widget-quiz-answer-text").removeClass("widget-quiz-question-selected");
            }
            else {
                $(el).parent().addClass("widget-quiz-question-selected");
            }
        }
        else {
            $(el).closest(".widget-quiz-question-answers").find(".widget-quiz-question-selected").removeClass("widget-quiz-question-selected");
            $(el).parent().addClass("widget-quiz-question-selected");
        }
        if ($(el).closest(".widget-quiz-question").attr("data-open-answer-selection") === "openanswer") {
            if ($(el).closest(".widget-quiz-answer-submitted").val() != "") {
                $(el).closest(".widget-quiz-question").find(".widget-quiz-question-submit").removeClass("disabled");
            }
            else {
                $(el).closest(".widget-quiz-question").find(".widget-quiz-question-submit").addClass("disabled");
            }
        }
        else {
            $(el).closest(".widget-quiz-question").find(".widget-quiz-question-submit").removeClass("disabled");
        }
    }
    SelectQuizMatch(el) {
        var proceed = true;
        $(".widget-quiz-answer-match").each(function (i, e) {
            var selected = $(e).val();
            if (selected == "") {
                proceed = false;
            }
        });
        if (proceed) {
            $(el).closest(".widget-quiz-question-answers").find(".widget-quiz-question-selected").removeClass("widget-quiz-question-selected");
            $(el).parent().addClass("widget-quiz-question-selected");
            $(el).closest(".widget-quiz-question").find(".widget-quiz-question-submit").removeClass("disabled");
        }
    }
    SubmitAnswer(el) {
        this.$quizWrapper = $(el).closest(".widget-quiz-wrapper");
        var $quizQuestion = $(el).closest(".widget-quiz-question");
        var quizID = parseInt(this.$quizWrapper.attr("data-quizid"));
        var quizLanguageID = parseInt(this.$quizWrapper.attr("data-quizlanguageid"));
        var questionID = parseInt($quizQuestion.attr("data-questionid"));
        var answerID = parseInt($quizQuestion.find(".widget-quiz-question-selected").attr("data-aid"));
        var answers = [];
        var multipleAnswers = [];
        if ($quizQuestion.attr("data-multipleanswerselection") == "multiple-answer") {
            $quizQuestion.find(".widget-quiz-question-selected").each(function (i, e) {
                multipleAnswers.push(parseInt($(e).attr("data-aid")));
            });
            answerID = 0;
        }
        var submittedAnswer = "";
        if ($quizQuestion.attr("data-open-answer-selection") == "openanswer") {
            submittedAnswer = $quizQuestion.find(".widget-quiz-answer-submitted").val();
            answerID = 0;
        }
        // or
        $quizQuestion.find(".widget-quiz-answer-match").each(function (i, e) {
            answers.push({
                ItemId: parseInt($(e).attr("data-answernumber")),
                MatchedItemId: $(e).val()
            });
        });
        var timedOut = this.$quizWrapper.find('#quizTimedOut').val();
        var dto = {
            QuizLanguageID: quizLanguageID,
            QuestionID: questionID,
            AnswerID: answerID,
            Answers: answers,
            MultipleAnswers: multipleAnswers,
            TimedOut: timedOut,
            SubmittedAnswer: submittedAnswer
        };
        var parent = this;
        $(el).addClass("disabled");
        $.ajax({
            data: JSON.stringify(dto),
            contentType: "application/json; charset=utf-8",
            processData: true,
            method: "POST",
            url: '/API/Content/QuizSubmitAnswer/' + this.$quizWrapper.attr("data-rid"),
            headers: {
                'RequestVerificationToken': getAntiForgeryToken()
            }
        }).done(function (response) {
            if (response.success == true) {
                if ((response.data.isCorrect == true) || (response.data.isCorrect == false && response.data.mustAnswerCorrect == false)) {
                    var currentQuestionNumber = parseInt($quizQuestion.attr("data-questionnumber"));
                    parent.$quizWrapper.attr("data-currentquestionnumber", currentQuestionNumber + 1);
                }
                $quizQuestion.addClass("hide");
                parent.canTryAgain = response.data.allowRetry;
                if (response.data.isCompleted == true) {
                    parent.isQuizCompleted = true;
                    parent.isPassed = response.data.isPassed;
                    parent.score = response.data.score;
                    if (parent.isPassed) {
                        if (parent.$quizWrapper.find('#quizTimedQuiz').val() === "true")
                            stopTimer(el);
                        // Check if a Level Up has occurred
                        $.ajax({
                            contentType: "application/json",
                            method: "GET",
                            url: '/API/Notification/GetNotifications'
                        }).done(function (response) {
                            if (response.length > 0) {
                                $("#notification-container").html(response);
                            }
                        });
                    }
                }
                if ((response.data.title !== undefined && response.data.title.length > 0) || (response.data.text !== undefined && response.data.text.length > 0)) {
                    $(".widget-quiz-answer-result-title").html(response.data.title);
                    $(".widget-quiz-answer-result-text").html(response.data.text);
                    $(".widget-quiz-answer-result").removeClass("hide");
                    if (response.data.questionType == "OpenAnswer") {
                        if (response.data.displayOpenAnswers == true && response.data.allPossibleAnswers !== "") {
                            $(".widget-quiz-all-possible-answers-container").removeClass("hide");
                            $(".widget-quiz-all-possible-answers-container").find(".widget-quiz-all-possible-answers").html(response.data.allPossibleAnswers);
                        }
                    }
                }
                else {
                    if (parent.isQuizCompleted == true) {
                        if (parent.isPassed == true) {
                            parent.$quizWrapper.find(".widget-quiz-summary-success").removeClass("hide");
                        }
                        else {
                            if (parent.canTryAgain == true) {
                                $(".widget-quiz-retry").removeClass("hide");
                            }
                            stopTimer(el);
                            parent.$quizWrapper.find(".widget-quiz-summary-fail").removeClass("hide");
                        }
                    }
                    else {
                        parent.NextQuestion(el);
                    }
                }
                if (parent.isQuizCompleted == true) {
                    if (parent.isPassed == true) {
                        globalThis.gage.TrackWidget(parent.$quizWrapper);
                    }
                }
            }
            parent.submittingAnswer = false;
        });
    }
    NextQuestion(el) {
        var $quizWrapper = $(el).closest(".widget-quiz-wrapper");
        var $quizQuestion = $(el).closest(".widget-quiz-question");
        var currentQuestionNumber = parseInt($quizWrapper.attr("data-currentquestionnumber"));
        $(".widget-quiz-answer-result").addClass("hide");
        $(".widget-quiz-all-possible-answers-container").addClass("hide");
        $(".widget-quiz-all-possible-answers-container").find(".widget-quiz-all-possible-answers").html("");
        var completedWithNext = $quizWrapper.find(".widget-quiz-question[data-questionnumber='" + currentQuestionNumber + "']").text().length < 1;
        if (this.isQuizCompleted == true || completedWithNext) {
            if (this.isPassed == true) {
                $quizWrapper.find(".widget-quiz-summary-success").removeClass("hide");
            }
            else {
                if (this.canTryAgain == true) {
                    $(".widget-quiz-retry").removeClass("hide");
                }
                stopTimer(el);
                $quizWrapper.find(".widget-quiz-summary-fail").removeClass("hide");
            }
        }
        else {
            $quizWrapper.find(".widget-quiz-question-selected").removeClass("widget-quiz-question-selected");
            $quizWrapper.find(".widget-quiz-question[data-questionnumber='" + currentQuestionNumber + "']").removeClass("hide");
        }
    }
}
var quiz = new Quiz();
$(document).ready(function () {
    $("body").on("click", ".widget-quiz-question-start", function () {
        quiz.StartQuiz(this);
    });
    $("body").on("click", ".widget-quiz-retry", function () {
        location.reload();
    });
    $("body").on("click", ".widget-quiz-answer-selection", function () {
        quiz.SelectQuizAnswer(this);
    });
    $("body").on("keyup", ".widget-quiz-answer-submitted", function () {
        quiz.SelectQuizAnswer(this);
    });
    $("body").on("change", ".widget-quiz-answer-match", function () {
        quiz.SelectQuizMatch(this);
    });
    $("body").on("click", ".widget-quiz-question-submit", function () {
        if (quiz.submittingAnswer === false) {
            globalThis.gage.log("Clicked from " + $(this).attr("data-questionid"));
            quiz.SubmitAnswer(this);
        }
    });
    $("body").on("click", ".widget-quiz-question-next", function () { quiz.NextQuestion(this); });
    $(".widget-quiz-wrapper").each(function () { autoStart(this); });
    $(".widget-quiz-matches-dropdown, .js-widget-quiz-selection").on("click", function (e) {
        $(e.target).closest(".widget-quiz-answer-box-a").find(".widget-quiz-selection").addClass("hide");
        var menuopt = $(this).attr("data-controls");
        if ($("#" + menuopt).hasClass("hide")) {
            $("#" + menuopt).removeClass("hide");
        }
        else {
            $("#" + menuopt).addClass("hide");
        }
        var bodyClickHandler = function (e) {
            if ($(e.target).closest(".widget-quiz-matches").length > -1) {
                if (!$(e.target).hasClass("widget-quiz-matches-dropdown") && $(e.target).closest(".widget-quiz-matches-dropdown").length == 0) {
                    if (!$(e.target).hasClass("js-widget-quiz-selection") && $(e.target).closest(".js-widget-quiz-selection").length == 0) {
                        $("#" + menuopt).addClass("hide");
                        $.each($(".widget-quiz-selection"), function (i, e) {
                            if ($(this).html() === "") {
                                $(this).addClass("hide");
                            }
                            else {
                                $(this).removeClass("hide");
                            }
                        });
                        $("body").off("click", bodyClickHandler);
                    }
                }
            }
        };
        $("body").on("click", bodyClickHandler);
    });
    $(".widget-quiz-match-box").on("click", function (e) {
        var parentEl = $(e.target).closest(".widget-quiz-answer-box-a");
        if (parentEl.length > -1) {
            var buttonText = $(this).find(".widget-quiz-match-box-text").text();
            buttonText = buttonText.trim();
            if (buttonText.length > 0) {
                var originalLength = buttonText.length;
                var buttonText = buttonText.substring(0, 69);
                if (originalLength > 70) {
                    buttonText += "...";
                }
                $(parentEl).find(".widget-quiz-matches-dropdown .js-btn-text").text(buttonText);
            }
            var match = $(e.target).closest(".widget-quiz-match-box");
            var matchId = $(match).attr("data-quizquestionanswerid");
            $(parentEl).find(".widget-quiz-answer-match").val(matchId);
            var html = match.html();
            $(parentEl).find(".widget-quiz-selection").html("<div class='widget-quiz-match-box clearfix'>" + html + "</div>");
            $(".widget-quiz-selection").removeClass("hide");
        }
        var questionContainer = $(e.target).closest(".widget-quiz-question");
        var answers = $(questionContainer).find(".widget-quiz-answer-match");
        var complete = true;
        $.each(answers, function (i, e) {
            if ($(e).val() == "") {
                complete = false;
            }
        });
        if (complete) {
            $(questionContainer).find(".widget-quiz-question-submit").removeClass("disabled");
        }
    });
});
function autoStart(el) {
    var $quizWrapper = $(el).closest(".widget-quiz-wrapper");
    if ($quizWrapper.find('#quizFreshStart').val() === "false") {
        quiz.StartQuiz(el);
    }
}
var interval;
function startTimer(el) {
    var $quizWrapper = $(el).closest(".widget-quiz-wrapper");
    var second = $quizWrapper.find('#quizSeconds').val() % 60;
    var totalMinutes = $quizWrapper.find('#quizSeconds').val() / 60;
    var minute = totalMinutes % 60;
    var hour = Math.floor(totalMinutes / 60);
    var hours = hour < 10 ? '0' + hour : hour;
    var minutes = minute < 10 ? '0' + minute : minute;
    var seconds = second < 10 ? '0' + second : second;
    var timer2 = hours + ":" + minutes + ":" + seconds;
    interval = setInterval(function () {
        var timer = timer2.split(':');
        var hour = parseInt(timer[0], 10);
        var minute = parseInt(timer[1], 10);
        var second = parseInt(timer[2], 10);
        --second;
        if (second < 0) {
            --minute;
            second = 59;
        }
        if (minute < 0) {
            --hour;
            minute = 59;
        }
        if (hour < 0) {
            second = 0;
            minute = 0;
            hour = 0;
            clearInterval(interval);
            $quizWrapper.find('#quizTimedOut').val(true);
        }
        var minutes = (minute < 10) ? '0' + minute : minute;
        var seconds = (second < 10) ? '0' + second : second;
        $quizWrapper.find('.quiz-countdown').html(hours + ":" + minutes + ':' + seconds);
        timer2 = hours + ":" + minutes + ':' + seconds;
    }, 1000);
}
function stopTimer(el) {
    var $quizWrapper = $(el).closest(".widget-quiz-wrapper");
    clearInterval(interval);
    $quizWrapper.find('#quizTimedOut').val(false);
}
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/bootbox.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
export class CatalogProductList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    LoadMore(button) {
        var params = this.buildParams();
        params.ViewType = $(button).attr("data-view-type");
        if (params.ViewType == "viewall") {
            $(button).addClass("disabled");
        }
        var me = this;
        var categoryIds = $(button).closest(".catalog-product-list").find(".js-catalog-filter").find(".js-child-item-category:checked").map(function () {
            return $(this).attr("data-identifier");
        }).get().join(",");
        params.ItemCategory = categoryIds;
        var url = '/Content/RenderProductList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseInt(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find(".js-product-list").append(data);
            if ((me._totalPages == (me._pageIndex + 1)) || (params.ViewType != "viewall" && params.ViewType != "viewmore")) {
                $(me._widget).find(".btn-view-more").addClass("hidden");
            }
        }));
    }
    showMobileFilter(e) {
        var options = {
            content: "panel-product-list",
            origin: $(e)
        };
        var content = $(this._widget).find('.catalog-filter').html();
        this._globalModal.openGlobalModal(content, "panel", options);
    }
    hideMobileFilter() {
        this._globalModal.closeGlobalModal();
    }
    initialize() {
        this._pageIndex = 0;
        this._categoryIdentifier = $(this._widget).attr("data-category-identifier");
        this._totalPages = parseInt($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).attr("data-take"));
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._sortBy = $(this._widget).attr("data-sort-by");
        this._globalModal = new GlobalModal(this._widgetId);
        this.bindControls();
    }
    bindControls() {
        // VB lives on
        var me = this;
        $(this._widget).find(".btn-view-more").on("click", function () {
            me.LoadMore(this);
        });
        $(this._widget).find(".js-accordion-parent").on("click", function (e) {
            e.preventDefault();
            $(e.currentTarget).find('i').toggleClass('fa-plus fa-minus');
        });
        $(this._widget).find(".js-product-sorting").on("click", function (e) {
            e.preventDefault();
            var value = "";
            var sortBy = $(e.currentTarget).attr("data-sortby");
            $(e.currentTarget).closest(".results-filter").find(".sorting").remove();
            if (sortBy === "points") {
                if ($(e.currentTarget).attr("data-sorttype") !== "asc") {
                    $(e.currentTarget).attr("data-sorttype", "asc");
                    value = "pointsascending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-up-long\"> </span>");
                }
                else {
                    $(e.currentTarget).attr("data-sorttype", "desc");
                    value = "pointsdescending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-down-long\"> </span>");
                }
            }
            else if (sortBy === "name") {
                if ($(e.currentTarget).attr("data-sorttype") !== "asc") {
                    $(e.currentTarget).attr("data-sorttype", "asc");
                    value = "alphabeticascending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-up-long\"> </span>");
                }
                else {
                    $(e.currentTarget).attr("data-sorttype", "desc");
                    value = "alphabeticdescending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-down-long\"> </span>");
                }
            }
            else if (sortBy === "recent") {
                if ($(e.currentTarget).attr("data-sorttype") !== "asc") {
                    $(e.currentTarget).attr("data-sorttype", "asc");
                    value = "recentascending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-up-long\"> </span>");
                }
                else {
                    $(e.currentTarget).attr("data-sorttype", "desc");
                    value = "recentdescending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-down-long\"> </span>");
                }
            }
            else if (sortBy === "publish") {
                if ($(e.currentTarget).attr("data-sorttype") !== "asc") {
                    $(e.currentTarget).attr("data-sorttype", "asc");
                    value = "publishascending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-up-long\"> </span>");
                }
                else {
                    $(e.currentTarget).attr("data-sorttype", "desc");
                    value = "publishdescending";
                    $(e.currentTarget).append("<span class=\"pull-right sorting fa-solid fa-down-long\"> </span>");
                }
            }
            $(me._widget).attr("data-sort-by", value);
            me._sortBy = value;
            me.applySort($(e.currentTarget));
            //me.applySorting(value);
        });
        $(this._widget).find('.js-mobile-filter').on('click', function () {
            me.showMobileFilter(this);
        });
        $(this._widget).find(".js-clear-product-filter").on('click', function (e) {
            e.preventDefault();
            var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''), urlQueryString = document.location.search;
            if (urlQueryString) {
                var key = "itemcategory";
                var params = "";
                var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
                params = urlQueryString.replace(removeRegex, "$1");
                params = params.replace(/[&;]$/, "");
                window.history.replaceState({}, "", baseUrl + params);
                window.location.href = baseUrl + params;
            }
            // window.location.href = baseUrl;
        });
        $(this._widget).find('.js-apply-product-filter').on('click', function (e) {
            e.preventDefault();
            me.applyFilter($(e.currentTarget));
            //var categoryIds = $(e.currentTarget).closest(".js-catalog-filter").find(".js-child-item-category:checked").map(function () {
            //    return $(this).attr("data-identifier");
            //}).get().join(",");
            //var key = "itemcategory";
            //var value = categoryIds;
            //var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            //    urlQueryString = location.search,
            //    newParam = key + '=' + categoryIds,
            //    params = '?' + newParam;
            //// If the "search" string exists, then build params from it
            //if (urlQueryString) {
            //    var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
            //    var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
            //    if (typeof value == 'undefined' || value == null || value === '') { // Remove param if value is empty
            //        params = urlQueryString.replace(removeRegex, "$1");
            //        params = params.replace(/[&;]$/, "");
            //    } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            //        var oldValue = me.getParameterByName(key);
            //        var urlValue = "";
            //        var remove = me.compareArrays(oldValue.split(","), value.split(","));
            //        var add = me.compareArrays(value.split(","), oldValue.split(","));
            //        var modifiedArray = oldValue.split(",").filter(el => remove.indexOf(el) < 0);
            //        modifiedArray = modifiedArray.concat(add);
            //        var newValue = modifiedArray.join(",");
            //        if (urlQueryString.indexOf(key + "=") !== -1) {
            //            urlValue = urlQueryString.replace('&' + key + '=' + oldValue, '&' + key + '=' + newValue);
            //        }
            //        else {
            //            urlValue = urlQueryString.replace(key + '=' + oldValue, '?' + key + '=' + value);
            //        }
            //        params = urlValue;
            //    } else { // Otherwise, add it to end of query string
            //        params = urlQueryString + '&' + newParam;
            //    }
            //}
            //history.pushState({ state: 1, rand: Math.random() }, '', urlValue);
            //window.location.href = baseUrl + params;
        });
        if ($("input[name=bundle]:checked").length) {
            $("input[name=bundle]:checked").each(function (i, el) {
                $(el).closest(".overlay-triangle").addClass("red-triangle");
            });
            $(".js-customize-multiple").removeAttr("disabled");
        }
        $("body").on("click", "input[name=bundle]", function () {
            var values = [];
            var enablesmultipledownload = [];
            $("input[name=bundle]").closest(".overlay-triangle").removeClass("red-triangle");
            $("input[name=bundle]:checked").each(function (i, el) {
                values.push($(el).val());
                if ($(el).attr("data-enables-multipledownload") === "True") {
                    enablesmultipledownload.push($(el).val());
                }
                $(el).closest(".overlay-triangle").addClass("red-triangle");
            });
            if (values.length) {
                $(".js-customize-multiple").removeAttr("disabled");
            }
            else {
                $(".js-customize-multiple").attr("disabled", "true");
            }
            if (enablesmultipledownload.length) {
                $(".js-download-multiple").removeAttr("disabled");
            }
            else {
                $(".js-download-multiple").attr("disabled", "true");
            }
        });
        $("body").on("click", ".js-unselect-all", function () {
            $("input[name=bundle]").closest(".overlay-triangle").removeClass("red-triangle");
            $(".js-customize-multiple").attr("disabled", "true");
            $(".js-download-multiple").attr("disabled", "true");
            $("input[name=bundle]:checked").each(function (i, el) {
                $(el).prop("checked", false);
            });
        });
        $("body").on("click", ".js-select-all", function () {
            $("input[name=bundle]").closest(".overlay-triangle").addClass("red-triangle");
            $(".js-customize-multiple").removeAttr("disabled");
            $(".js-download-multiple").removeAttr("disabled");
            $("input[name=bundle]").each(function (i, el) {
                $(el).prop("checked", true);
            });
        });
        $("body").on("click", ".js-download-multiple", function (e) {
            e.preventDefault();
            var array = [];
            $("input[name=bundle]").each(function (i, el) {
                if ($(el).prop("checked") === true) {
                    array.push($(el).closest(".catalog-item").attr("data-product-catalog-assignment"));
                }
            });
            var pcaIdentfiers = array.join(",");
            var params = { pcaIdentifiers: "" };
            params.pcaIdentifiers = array.join(",");
            var url = "/Catalog/Product/DownloadAllFiles?languageId=1001&pcaIdentifiers=" + pcaIdentfiers;
            window.location.href = url;
        });
        $("body").on("click", ".js-customize-multiple", function (e) {
            e.preventDefault();
            var array = [];
            var url = $(e.currentTarget).closest(".widget.catalog-product-list").attr("data-productdetail-url");
            $("input[name=bundle]").each(function (i, el) {
                if ($(el).prop("checked") === true) {
                    array.push($(el).closest(".catalog-item").attr("data-product-catalog-assignment"));
                }
            });
            var assigmentIdentfiers = array.join(",");
            document.location.href = url + "?product-id=" + assigmentIdentfiers;
        });
        if ($(this._widget).find('#defaultfilterexpand').val() == "expandfirst") {
            $('.accordion .accordion-group .accordion-heading a').eq(0).trigger('click');
        }
        else if (($(this._widget).find('#defaultfilterexpand').val() == "expandall")) {
            $('.accordion .accordion-group .accordion-heading a').trigger('click');
        }
        /* Handle product overlay click */
        $(".js-download-menu-overlay").on("click", function (event) {
            var xScreenPos = event.screenX;
            var yScreenPos = event.screenY;
            var productContainer = $(this).closest("li");
            if (xScreenPos != 0 && yScreenPos != 0) {
                var xLocation = event.pageX - $(this).offset().left;
                var yLocation = event.pageY - $(this).offset().top;
                if ($(productContainer).hasClass("product-list-view-item")) {
                    var imageColumnWidth = $(productContainer).find(".product-list-image-wrapper").outerWidth();
                    xLocation = xLocation - imageColumnWidth;
                }
                $(productContainer).find(".dropdown-menu").css({
                    "top": yLocation,
                    "left": xLocation
                });
            }
            else {
                $(productContainer).find(".dropdown-menu").css({
                    "top": "100%",
                    "left": "0"
                });
            }
        });
        /* Handle mouseover of customization multiselect checkbox */
        //$(".js-overlay-triangle").trigger("hover", (
        //    function () {
        //        $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").addClass("hover");
        //    }, function () {
        //        $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").removeClass("hover");
        //    }
        //);
        $(".js-overlay-triangle").on("mouseenter", function () {
            $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").addClass("hover");
        }, function () {
            $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").removeClass("hover");
        }).on("mouseleave", function () {
            $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").removeClass("hover");
        }, function () {
            $(this).closest("li.catalog-item.product").find(".js-product-tile-overlay").addClass("hover");
        });
    }
    applyFilter(button) {
        this._pageIndex = 0;
        var customizationcontainer = $(this._widget).find(".js-customization-container");
        var norecordscontainer = $(this._widget).find(".no-data-container");
        $(norecordscontainer).addClass("hide");
        var categoryIds = $(button).closest(".js-catalog-filter").find(".js-child-item-category:checked").map(function () {
            return $(this).attr("data-identifier");
        }).get().join(",");
        var params = {
            Identifier: this._categoryIdentifier,
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            ViewType: "",
            ItemCategory: categoryIds
        };
        var me = this;
        var url = '/Content/RenderProductList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseInt(request.getResponseHeader("X-TotalPages"));
            $(customizationcontainer).show();
            if (me._totalPages === 0) {
                $(customizationcontainer).hide();
                $(norecordscontainer).removeClass("hide");
            }
            $(me._widget).find(".js-product-list").html(data);
            $(me._widget).find(".btn-view-more").show();
            $(me._widget).find(".btn-view-more").removeClass("hide");
            if (me._totalPages === (me._pageIndex + 1)) {
                $(me._widget).find(".btn-view-more").hide();
            }
        }));
    }
    applySort(button) {
        var categoryIds = $(button).closest(".js-catalog-filter").find(".js-child-item-category:checked").map(function () {
            return $(this).attr("data-identifier");
        }).get().join(",");
        var params = {
            Identifier: this._categoryIdentifier,
            Take: this._take,
            PageIndex: 0,
            SortBy: this._sortBy,
            ViewType: "",
            ItemCategory: categoryIds
        };
        var me = this;
        var url = '/Content/RenderProductList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseInt(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find(".js-product-list").html(data);
            $(me._widget).find(".btn-view-more").show();
            if (me._totalPages === (me._pageIndex + 1)) {
                $(me._widget).find(".btn-view-more").hide();
            }
        }));
    }
    //private applySorting(value) {
    //    var me = this;
    //    var key = "sortby";
    //    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
    //        urlQueryString = location.search,
    //        newParam = key + '=' + value;
    //    var urlValue = "";
    //    var params = "";
    //    if (urlQueryString) {
    //        var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
    //        var oldValue = me.getParameterByName(key);
    //        if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
    //            if (urlQueryString.indexOf(key + "=") !== -1) {
    //                urlValue = urlQueryString.replace('&' + key + '=' + oldValue, '&' + key + '=' + value);
    //            }
    //            else {
    //                urlValue = urlQueryString.replace(key + '=' + oldValue, '?' + key + '=' + value);
    //            }
    //            params = urlValue;
    //        } else { // Otherwise, add it to end of query string
    //            params = urlQueryString + '&' + newParam;
    //        }
    //        history.pushState({ state: 1, rand: Math.random() }, '', urlValue);
    //        window.location.href = baseUrl + params;
    //    }
    //}
    compareArrays(array1, array2) {
        var difference = [];
        for (var i = 0; i < array1.length; i++) {
            if ($.inArray(array1[i], array2) == -1) {
                difference.push(array1[i]);
            }
        }
        return difference;
    }
    getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    buildParams() {
        if (this._totalPages > this._pageIndex) {
            this._pageIndex++;
        }
        var params = {
            ItemCategory: "",
            Identifier: this._categoryIdentifier,
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            ViewType: ""
        };
        return params;
    }
}
class ShoppingCartList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    UpdateItem(cartItemId, quantity) {
        if (quantity < 0) {
            return;
        }
        if (quantity == 0) {
            this.deleteItem(cartItemId, "");
            return;
        }
        var params = { "Id": cartItemId, "Quantity": quantity };
        var me = this;
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var url = '/Api/ShoppingCart/UpdateItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            if ($(me._widget).find(".cart-item-row").length === 0) {
                $(me._widget).find(".js-panel-noitems-incart").remove();
            }
        }));
    }
    deleteCartImageItem(cartItemId, imageId) {
        var me = this;
        var params = { "Id": cartItemId, "ImageId": imageId };
        var cartrow = $(me._widget).find(".cart-item-row[data-row-cartid='" + cartItemId + "']");
        var participantInfo = $(me._widget).find(".cart-participant-info");
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var noItemsInforow = $(me._widget).find(".shoppingcart-notiemsincart");
        var url = '/Api/ShoppingCart/DeleteShutterStockItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            window.location.href = shoppingcarturl;
        }));
    }
    deleteCartStaplesItem(cartItemId, productId) {
        var me = this;
        var params = { "Id": cartItemId, "clientProductId": productId };
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var url = '/Api/ShoppingCart/DeleteStaplesItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            window.location.href = shoppingcarturl;
        }));
    }
    deleteCartAdobeItem(cartItemId, productId) {
        var me = this;
        var params = { "Id": cartItemId, "clientProductId": productId };
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var url = '/Api/ShoppingCart/DeleteAdobeItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            window.location.href = shoppingcarturl;
        }));
    }
    deleteCartAdobeCommerceItem(cartItemId, adobeCommerceProductId) {
        var me = this;
        var params = { "Id": cartItemId, "clientProductId": adobeCommerceProductId };
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var url = '/Api/ShoppingCart/DeleteAdobeCommerceItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            window.location.href = shoppingcarturl;
        }));
    }
    deleteItem(cartItemId, shoppingcarturl) {
        var me = this;
        var params = { "Id": cartItemId };
        var cartrow = $(me._widget).find(".cart-item-row[data-row-cartid='" + cartItemId + "']");
        var participantInfo = $(me._widget).find(".cart-participant-info");
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var noItemsInforow = $(me._widget).find(".shoppingcart-notiemsincart");
        var url = '/Api/ShoppingCart/DeleteItem';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            $.when(me.GetParticipantInfo().done(function (data, textStatus, response) {
                $(participantInfo).html(data);
                $(me._widget).find(".btn-updatecart").on("click", function (e) {
                    me.UpdateCart(e.currentTarget);
                });
                var cartItemCount = "0";
                if ($(participantInfo).find("#cartItemCount").val() === "0" || $(participantInfo).find("#cartItemCount").val() === "") {
                    $(noItemsInforow).removeClass("hide");
                }
                else {
                    cartItemCount = $(participantInfo).find("#cartItemCount").val();
                }
                updateCartItemCount(cartItemCount);
                $(me._widget).find(".btn-checkout").attr("href", $(me._widget).data("checkouturl"));
                if (shoppingcarturl != "") {
                    window.location.href = shoppingcarturl;
                }
            }));
            $(cartrow).remove();
            if ($(me._widget).find(".cart-item-row").length === 0) {
                updateCartItemCount(null);
                $(me._widget).find(".js-panel-noitems-incart").remove();
            }
        }));
    }
    deleteItemOnly(cartItemId, shoppingcarturl) {
        var me = this;
        var params = { "Id": cartItemId };
        var cartrow = $(me._widget).find(".cart-item-row[data-row-cartid='" + cartItemId + "']");
        var participantInfo = $(me._widget).find(".cart-participant-info");
        var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
        var noItemsInforow = $(me._widget).find(".shoppingcart-notiemsincart");
        var url = '/Api/ShoppingCart/DeleteItemOnly';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            $.when(me.GetParticipantInfo().done(function (data, textStatus, response) {
                $(participantInfo).html(data);
                $(me._widget).find(".btn-updatecart").on("click", function (e) {
                    me.UpdateCart(e.currentTarget);
                });
                var cartItemCount = "0";
                if ($(participantInfo).find("#cartItemCount").val() === "0" || $(participantInfo).find("#cartItemCount").val() === "") {
                    $(noItemsInforow).removeClass("hide");
                }
                else {
                    cartItemCount = $(participantInfo).find("#cartItemCount").val();
                }
                updateCartItemCount(cartItemCount);
                $(me._widget).find(".btn-checkout").attr("href", $(me._widget).data("checkouturl"));
                if (shoppingcarturl != "") {
                    window.location.href = shoppingcarturl;
                }
            }));
            $(cartrow).remove();
            if ($(me._widget).find(".cart-item-row").length === 0) {
                updateCartItemCount(null);
                $(me._widget).find(".js-panel-noitems-incart").remove();
            }
        }));
    }
    GetParticipantInfo() {
        return $.ajax({
            //contentType: "application/json",
            method: "GET",
            url: '/Api/ShoppingCart/GetItemsDetailsInCart'
        });
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        $(this._widget).find(".btn-checkout").attr("href", $(this._widget).data("checkouturl"));
        this.bindControls();
    }
    bindControls() {
        // VB lives on
        var me = this;
        $(me._widget).find(".js-remove-shopping-cart-item").on("click", function (e) {
            var cancelText = $(e.currentTarget).attr("data-cancel-text");
            var removeAllText = $(e.currentTarget).attr("data-removeall-text");
            var removeCartOnlyText = $(e.currentTarget).attr("data-cartonly-text");
            var removeCartTitleText = $(e.currentTarget).attr("data-removecart-title-text");
            var removeCartContinueText = $(e.currentTarget).attr("data-remove-continue-text");
            var removeCartOkText = $(e.currentTarget).attr("data-remove-ok-text");
            if ($(e.currentTarget).attr("data-iscustomizable") === "false") {
                bootbox.confirm({
                    title: removeCartTitleText,
                    message: "<p>" + removeCartContinueText + "</p>",
                    buttons: {
                        confirm: {
                            label: removeCartOkText,
                            className: 'btn-success'
                        },
                        cancel: {
                            label: cancelText,
                            className: 'btn-danger'
                        }
                    },
                    callback(result) {
                        if (result) {
                            var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
                            me.deleteItem(parseInt($(e.currentTarget).attr("data-cartid")), shoppingcarturl);
                            return true;
                        }
                    }
                });
            }
            else {
                var dialog = bootbox.dialog({
                    title: removeCartTitleText,
                    message: "<p>" + removeCartContinueText + "</p>",
                    buttons: {
                        cancel: {
                            label: cancelText,
                            className: 'btn-danger',
                            callback() {
                                return true;
                            }
                        },
                        removecartonly: {
                            label: removeCartOnlyText,
                            className: 'btn-success',
                            callback() {
                                var shoppingcarturl = $(me._widget).attr("data-shoppingcarturl");
                                me.deleteItemOnly(parseInt($(e.currentTarget).attr("data-cartid")), shoppingcarturl);
                                return true;
                            }
                        },
                        removeall: {
                            label: removeAllText,
                            className: 'btn-success',
                            callback() {
                                me.deleteItem(parseInt($(e.currentTarget).attr("data-cartid")), "");
                                return true;
                            }
                        }
                    }
                });
            }
        });
        $(me._widget).find(".remove-shopping-cart-image-item").on("click", function (e) {
            var listContainer = $(e.currentTarget).closest(".js-shopping-cart-item-list-container");
            var cancelText = $(listContainer).attr("data-cancel-text");
            var removeCartOkText = $(listContainer).attr("data-remove-ok-text");
            var removeCartImageItemText = $(listContainer).attr("data-remove-shutter-stock-cart-image-text");
            var cartItemId = $(listContainer).attr("data-cart-item-id");
            var imageId = $(e.currentTarget).attr("data-image-id");
            bootbox.confirm({
                title: "",
                message: "<p>" + removeCartImageItemText + "</p>",
                buttons: {
                    confirm: {
                        label: removeCartOkText,
                        className: 'btn-success'
                    },
                    cancel: {
                        label: cancelText,
                        className: 'btn-danger'
                    }
                },
                callback(result) {
                    if (result) {
                        me.deleteCartImageItem(cartItemId, imageId);
                        return true;
                    }
                }
            });
        });
        $(me._widget).find(".js-remove-selected-adobecommerce-product-from-cart").on("click", function (e) {
            var listContainer = $(e.currentTarget).closest(".js-adobecommerce-selected-products-list-cpntainer");
            var cancelText = $(listContainer).attr("data-cancel-text");
            var removeCartOkText = $(listContainer).attr("data-remove-ok-text");
            var removeCartImageItemText = $(listContainer).attr("data-remove-product-from-cart-text");
            var cartItemId = $(listContainer).attr("data-cart-item-id");
            var productId = $(e.currentTarget).attr("data-product-id");
            bootbox.confirm({
                title: "",
                message: "<p>" + removeCartImageItemText + "</p>",
                buttons: {
                    confirm: {
                        label: removeCartOkText,
                        className: 'btn-success'
                    },
                    cancel: {
                        label: cancelText,
                        className: 'btn-danger'
                    }
                },
                callback(result) {
                    if (result) {
                        me.deleteCartAdobeCommerceItem(cartItemId, productId);
                        return true;
                    }
                }
            });
        });
        $(me._widget).find(".js-remove-selected-staples-product-from-cart").on("click", function (e) {
            var listContainer = $(e.currentTarget).closest(".js-staples-selected-products-list-cpntainer");
            var cancelText = $(listContainer).attr("data-cancel-text");
            var removeCartOkText = $(listContainer).attr("data-remove-ok-text");
            var removeCartImageItemText = $(listContainer).attr("data-remove-product-from-cart-text");
            var cartItemId = $(listContainer).attr("data-cart-item-id");
            var productId = $(e.currentTarget).attr("data-product-id");
            bootbox.confirm({
                title: "",
                message: "<p>" + removeCartImageItemText + "</p>",
                buttons: {
                    confirm: {
                        label: removeCartOkText,
                        className: 'btn-success'
                    },
                    cancel: {
                        label: cancelText,
                        className: 'btn-danger'
                    }
                },
                callback(result) {
                    if (result) {
                        me.deleteCartStaplesItem(cartItemId, productId);
                        return true;
                    }
                }
            });
        });
        $(me._widget).find(".js-remove-shopping-cart-item-only").on("click", function (e) {
            me.deleteItemOnly(parseInt($(e.currentTarget).attr("data-cartid")), "");
        });
        $(me._widget).find(".btn-updatecart").on("click", function (e) {
            me.UpdateCart($(e.currentTarget));
        });
        $(me._widget).find(".quantitytext").on("change", function () {
            var updateCartButton = $(me._widget).find(".btn-updatecart");
            me.UpdateCart($(updateCartButton));
        });
        $(me._widget).find(".btn-checkout").on("click", function (e) {
            e.preventDefault();
            me.ValidateCart($(e.currentTarget));
        });
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
    }
    ValidateCart(button) {
        var me = this;
        var checkOutCartUrl = ($(me._widget).data("checkouturl"));
        var midQuantityAllowedMessage = $(button).attr("data-mid-quantity-allowed-for-cart-message");
        var minQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var maxQuantityAllowedMessage = $(button).attr("data-max-quantity-allowed-for-cart-message");
        var proceed1 = true;
        var proceed2 = true;
        if ($(me._widget).find("#cartItemCount").val() !== "0" || $(me._widget).find("#cartItemCount").val() !== "") {
            var items = [];
            $(me._widget).find(".cart-item-row").each(function () {
                var item = {
                    Quantity: $(this).find(".quantitytext").val()
                };
                var minQuantityAllowed = $(this).attr("data-min-quantity-per-order");
                var maxQuantityAllowed = $(this).attr("data-max-quantity-per-order");
                if (item.Quantity < parseInt(minQuantityAllowed)) {
                    $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
                    proceed1 = false;
                }
                if (item.Quantity > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1) {
                    $('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 0));
                    proceed2 = false;
                }
                if (!(item.Quantity < parseInt(minQuantityAllowed)) &&
                    !(item.Quantity > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1)) {
                    items.push(item);
                }
            });
            if (!proceed1 && !proceed2) {
                alert(midQuantityAllowedMessage);
                return false;
            }
            else if (!proceed1) {
                alert(minQuantityAllowedMessage);
                return false;
            }
            else if (!proceed2) {
                alert(maxQuantityAllowedMessage);
                return false;
            }
            //alert(checkOutCartUrl);
            window.location.href = checkOutCartUrl;
        }
    }
    UpdateCart(button) {
        var me = this;
        var participantInfo = $(me._widget).find(".cart-participant-info");
        var noItemsInforow = $(me._widget).find(".shoppingcart-notiemsincart");
        var shoppingCartUrl = $(button).attr("data-shopping-cart-url");
        var midQuantityAllowedMessage = $(button).attr("data-mid-quantity-allowed-for-cart-message");
        var minQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var maxQuantityAllowedMessage = $(button).attr("data-max-quantity-allowed-for-cart-message");
        var pleaseWaitMessageForCart = $(button).attr("data-please-wait-message");
        var proceed1 = true;
        var proceed2 = true;
        if ($(me._widget).find("#cartItemCount").val() !== "0" || $(me._widget).find("#cartItemCount").val() !== "") {
            var items = [];
            $(me._widget).find(".cart-item-row").each(function () {
                var format = $(this).data("item-format");
                var item = {
                    CartID: $(this).data("row-cartid"),
                    Quantity: $(this).find(".quantitytext").val(),
                    Price: $(this).data("item-price"),
                    TotalPrice: formatColumn(($(this).find(".quantitytext").val() * $(this).data("item-price")), format),
                    Delete: false
                };
                //item.TotalPrice = addCommas($(this).find(".quantitytext").val() * item.Price);
                var minQuantityAllowed = $(this).attr("data-min-quantity-per-order");
                var maxQuantityAllowed = $(this).attr("data-max-quantity-per-order");
                if (item.Quantity == 0) {
                    item.Delete = true;
                }
                else {
                    item.Delete = false;
                }
                var itemQuantity = item.Quantity;
                if (itemQuantity < parseInt(minQuantityAllowed)) {
                    $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
                    $(this).find(".quantitytext").val(Math.max(parseInt(minQuantityAllowed), 1));
                    item.Quantity = Math.max(parseInt(minQuantityAllowed), 1);
                    proceed1 = false;
                }
                if (itemQuantity > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1) {
                    $('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 0));
                    $(this).find(".quantitytext").val(Math.max(parseInt(maxQuantityAllowed), 0));
                    item.Quantity = Math.max(parseInt(maxQuantityAllowed), 0);
                    proceed2 = false;
                }
                items.push(item);
            });
            if (!proceed1 && !proceed2) {
                alert(midQuantityAllowedMessage);
                waitingDialog.hide();
            }
            else if (!proceed1) {
                alert(minQuantityAllowedMessage);
                waitingDialog.hide();
            }
            else if (!proceed2) {
                alert(maxQuantityAllowedMessage);
                waitingDialog.hide();
            }
            waitingDialog.show(pleaseWaitMessageForCart);
            var url = '/Api/ShoppingCart/UpdateCart';
            $.when(submitAjaxRequest(items, url, "POST").done(function (data, textStatus, request) {
                window.location.href = shoppingCartUrl;
            }));
        }
    }
}
class CatalogProductDetail {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    FinalizeItem(button) {
        var me = this;
        if (me.ValidateItemQuantity(button)) {
            var params = this.buildParams();
            var me = this;
            if (!me.CheckAttribute()) {
                $(me._widget).find(".cart-notification-error").fadeIn(400);
                window.setTimeout(function () {
                    $(me._widget).find(".cart-notification-error").fadeOut(1000);
                }, 2000);
                $(me._widget).find(".btn-finalize").button("reset");
                return;
            }
            ;
            params.OrderNow = 1;
            $('.ajax-loader-container').show();
            var url = '/Api/ShoppingCart/AddItem';
            $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
                updateCartItemCount(data.cartItemCount);
                if (data.limited) {
                    if (data.currentCartItemCount == 0) {
                        $('.ajax-loader-container').hide();
                        var maxQuantityAllowedEverMessage = $(button).attr("data-max-quantity-allowed-ever-message");
                        alert(maxQuantityAllowedEverMessage);
                        return;
                    }
                    else {
                        $('.ajax-loader-container').hide();
                        alert(data.productNotAvailableMessage);
                        if ($(".quantity-input").length > 0) {
                            $(".quantity-input").val(data.currentCartItemCount);
                        }
                        return;
                    }
                }
                else {
                    if (data.redirectUrl !== "") {
                        window.location.href = data.redirectUrl;
                    }
                    // animate or show notification that the item was added
                    $(me._widget).find(".cart-notification-final").fadeIn(400);
                    window.setTimeout(function () {
                        $(me._widget).find(".cart-notification-final").fadeOut(1500);
                    }, 2000);
                }
                var maxQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
                if (parseInt(maxQuantityAllowed) != -1) {
                    var orderedCount = parseInt($(me._widget).find(".quantity-input").val());
                    var availableCount = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
                    var newCount = parseInt(availableCount) - orderedCount;
                    if (newCount < 1) {
                        newCount = 0;
                        $(me._widget).find(".quantity-input").val(newCount);
                    }
                    $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order", newCount);
                    $(me._widget).find(".quantity-input").attr("max", newCount);
                }
                $(me._widget).find(".btn-finalize").button("reset");
                //ajax for addOrder here to automatically run
                var params = { "addressId": 0 };
                var url = '/Api/ParticipantOrder/AddOrder';
                $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
                    $('.ajax-loader-container').hide();
                    if (data.status == "OK" && data.participantOrderId > 0) {
                        $(me._widget).find(".panel-thankyou").removeClass("hide");
                        $(me._widget).find(".panel-thankyou").find(".order-number").html(data.participantOrderId);
                        var detailLink = $(me._widget).find(".panel-thankyou").find(".order-detail-link").attr("href");
                        detailLink += data.identifier;
                        $(me._widget).find(".panel-thankyou").find(".order-detail-link").attr("href", detailLink);
                        $(me._widget).find(".panel-thankyou").find(".btn-viewdetail").attr("href", detailLink);
                        $(me._widget).find(".js-finalize-button").attr('disabled', 'disabled');
                        refreshCartCount(true);
                    }
                    else {
                        alert(data.status);
                        if (data.cartUrl != undefined)
                            window.location.href = data.cartUrl;
                    }
                }));
            }));
        }
    }
    AddItemToCart(button) {
        var me = this;
        if (me.ValidateItemQuantity(button)) {
            var params = this.buildParams();
            if ($(button).attr("data-check-sku-exist") !== "") {
                params.CheckSkuExists = $(button).attr("data-check-sku-exist") == "true" ? true : false;
            }
            var me = this;
            if (!me.CheckAttribute()) {
                $(me._widget).find(".cart-notification-error").fadeIn(400);
                window.setTimeout(function () {
                    $(me._widget).find(".cart-notification-error").fadeOut(1000);
                }, 2000);
                $(me._widget).find(".btn-add-to-cart").button("reset");
                $(me._widget).find(".js-addtocart-button").button("reset");
                return;
            }
            ;
            var url = '/Api/ShoppingCart/AddItem';
            $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
                updateCartItemCount(data.cartItemCount);
                if (data.limited) {
                    if (data.currentCartItemCount == 0) {
                        $('.ajax-loader-container').hide();
                        var maxQuantityAllowedEverMessage = $(button).attr("data-max-quantity-allowed-ever-message");
                        alert(maxQuantityAllowedEverMessage);
                        return;
                    }
                    else {
                        $(me._widget).find(".cart-notification-partial").fadeIn(400);
                        window.setTimeout(function () { $(me._widget).find(".cart-notification-partial").fadeOut(1000); }, 2000);
                    }
                }
                else {
                    if (data.redirectUrl !== "") {
                        window.location.href = data.redirectUrl;
                    }
                    // animate or show notification that the item was added
                    $(me._widget).find(".cart-notification").fadeIn(400);
                    window.setTimeout(function () {
                        $(me._widget).find(".cart-notification").fadeOut(1000);
                    }, 2000);
                }
                var maxQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
                if (parseInt(maxQuantityAllowed) != -1) {
                    var orderedCount = parseInt($(me._widget).find(".quantity-input").val());
                    var availableCount = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
                    var newCount = parseInt(availableCount) - orderedCount;
                    if (newCount < 1) {
                        newCount = 0;
                        $(me._widget).find(".quantity-input").val(newCount);
                    }
                    $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order", newCount);
                    $(me._widget).find(".quantity-input").attr("max", newCount);
                }
                $(me._widget).find(".btn-add-to-cart").button("reset");
                $(me._widget).find(".js-addtocart-button").button("reset");
            }));
        }
    }
    ValidateItemQuantity(button) {
        var me = this;
        var midQuantityAllowedMessage = $(button).attr("data-mid-quantity-allowed-for-cart-message");
        var minQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var maxQuantityAllowedMessage = $(button).attr("data-max-quantity-allowed-for-cart-message");
        var minQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-min-quantity-per-order");
        var maxQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
        var selectedQuantity = $(this._widget).find(".quantity-input").val();
        if (parseInt(maxQuantityAllowed) != -1 && parseInt(maxQuantityAllowed) < parseInt(minQuantityAllowed)) {
            //$('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 1));
            alert(midQuantityAllowedMessage);
            return false;
        }
        if (parseInt(selectedQuantity) < parseInt(minQuantityAllowed)) {
            $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
            alert(minQuantityAllowedMessage);
            return false;
        }
        if (parseInt(selectedQuantity) > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1) {
            $('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 0));
            alert(maxQuantityAllowedMessage);
            return false;
        }
        return true;
    }
    UpdateCart(button) {
        var me = this;
        if (!me.CheckAttribute()) {
            $(me._widget).find(".cart-notification-error").fadeIn(400);
            window.setTimeout(function () {
                $(me._widget).find(".cart-notification-error").fadeOut(1000);
            }, 2000);
            $(me._widget).find(".btn-update-cart").button("reset");
            return;
        }
        ;
        var midQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var minQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var maxQuantityAllowedMessage = $(button).attr("data-max-quantity-allowed-for-cart-message");
        var minQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-min-quantity-per-order");
        var maxQuantityAllowed = $(me._widget).find(".quantity-input").attr("data-max-quantity-per-order");
        if (parseInt(maxQuantityAllowed) != -1 && parseInt(maxQuantityAllowed) < parseInt(minQuantityAllowed)) {
            alert(midQuantityAllowedMessage);
        }
        if ($(this._widget).find(".quantity-input").val() < parseInt(minQuantityAllowed)) {
            $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
            alert(minQuantityAllowedMessage);
        }
        if ($(this._widget).find(".quantity-input").val() > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1) {
            $('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 0));
            alert(maxQuantityAllowedMessage);
        }
        var attributes = [];
        var selectedSku = "";
        if ($(me._widget).find(".attribute-selector").length > 0) {
            $.each($(this._widget).find(".attribute-selector"), function (index, item) {
                if ($(item).find(":selected").val() !== "") {
                    attributes.push($(item).find(":selected").val());
                    selectedSku = $(item).find(":selected").attr("data-product-sku-id");
                }
            });
        }
        else {
            selectedSku = $(button).attr("data-sku-in-cart");
        }
        var item = {
            "Id": null,
            "Quantity": 0,
            "Attributes": null
        };
        item.Id = $(button).attr("data-cart-item-id");
        item.Quantity = $(this._widget).find(".quantity-input").val();
        var updatedCartId = "";
        if (attributes.length > 0) {
            item.Attributes = attributes;
        }
        var productskusincart = $(me._widget).find(".js-product-detail-container").attr("data-product-skus-in-cart");
        if (productskusincart !== "") {
            var items = productskusincart.split(",");
            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    var skuItems = items[i].split("|");
                    if (skuItems.length > 0) {
                        if (skuItems[1] == selectedSku) {
                            updatedCartId = skuItems[0];
                            item.Id = updatedCartId;
                            break;
                        }
                    }
                }
            }
        }
        /* if item is not in cart and you add it*/
        if (updatedCartId == "") {
            $(button).attr("data-check-sku-exist", "false");
            me.AddItemToCart(button);
        }
        else {
            var cartUrl = $(me._widget).find(".js-product-detail-container").attr("data-cart-url");
            if (updatedCartId !== "" && $(me._widget).find(".js-product-detail-container").find(".js-product-template-form").attr("data-is-product-customizeable") == "True") {
                var title = $(me._widget).find(".js-product-detail-container").attr("data-cart-confirm-text-title");
                var confirmText = $(me._widget).find(".js-product-detail-container").attr("data-cart-confirm-text");
                var updateButton = $(me._widget).find(".js-product-detail-container").attr("data-update-text");
                var addButton = $(me._widget).find(".js-product-detail-container").attr("data-add-text");
                var cancelButton = $(me._widget).find(".js-product-detail-container").attr("data-cancel-text");
                var dialog = bootbox.dialog({
                    title: title,
                    message: confirmText,
                    size: 'large',
                    buttons: {
                        update: {
                            label: updateButton,
                            className: 'btn-warning',
                            callback: function () {
                                var params = item;
                                var url = '/Api/ShoppingCart/UpdateItem';
                                $.when(submitAjaxRequest(params, url, "POST")
                                    .done(function (data, textStatus, request) {
                                    updateCartItemCount(data.cartItemCount);
                                    window.location.href = cartUrl;
                                }));
                            }
                        },
                        add: {
                            label: addButton,
                            className: 'btn-info',
                            callback: function () {
                                $(button).attr("data-check-sku-exist", "false");
                                me.AddItemToCart(button);
                            }
                        },
                        cancel: {
                            label: cancelButton,
                            className: 'btn-danger'
                        },
                    }
                });
            }
            else {
                var params = item;
                var url = '/Api/ShoppingCart/UpdateItem';
                $.when(submitAjaxRequest(params, url, "POST")
                    .done(function (data, textStatus, request) {
                    updateCartItemCount(data.cartItemCount);
                    window.location.href = cartUrl;
                }));
            }
        }
    }
    CheckAttribute() {
        var me = this;
        if ($(this._widget).find(".attribute-selector").length > 0) {
            var attributes = [];
            var attributeCount = 0;
            $.each($(this._widget).find(".attribute-selector"), function (index, item) {
                if ($(item).find(":selected").val() !== "") {
                    attributes.push($(item).find(":selected").val());
                }
                attributeCount += 1;
            });
            if (attributes.length === 0 || attributeCount !== attributes.length) {
                return false;
            }
        }
        return true;
    }
    GetItemFromAttributes() {
        var params = this.buildParams();
        var me = this;
        $(me._widget).find(".panel-thankyou").addClass("hide");
        var attribSelected = $(me._widget).find(".attribute-selector").find(":selected").val();
        if (attribSelected == "") {
            $(me._widget).find('#ItemQuantity').html("");
            $(me._widget).find('#ItemQuantity').val("");
            $(me._widget).find('#ItemQuantity').attr('min', '1');
            $(me._widget).find('#ItemQuantity').attr('data-min-quantity-per-order', '1');
            $(me._widget).find('#ItemQuantity').attr('max', '0');
            $(me._widget).find('#ItemQuantity').attr('max-length', 1);
            $(me._widget).find('#ItemQuantity').attr('data-max-quantity-per-order', '0');
            return false;
        }
        var url = '/Api/ShoppingCart/GetItemPrice';
        $.when(submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            if (data.status == "OK") {
                $(me._widget).find(".points-value").text(data.formattedPrice);
                $(me._widget).find(".points-value").attr("data-price", data.price);
                if ($(me._widget).find(".js-download-action-button").length > 0) {
                    if (data.price > 0) {
                        $(me._widget).find(".js-download-action-button").addClass("hide");
                        $(me._widget).find(".btn-add-to-cart").removeAttr('disabled');
                        $(me._widget).find(".btn-add-to-cart").removeClass("hide");
                        $(me._widget).find(".js-addtocart-button").removeAttr('disabled');
                        $(me._widget).find(".js-addtocart-button").removeClass("hide");
                        $(me._widget).find(".js-quantity-container").removeClass("hide");
                    }
                    else {
                        $(me._widget).find(".js-download-action-button").removeClass("hide");
                        $(me._widget).find(".js-download-action-button").removeAttr('disabled');
                        $(me._widget).find(".js-quantity-container").addClass("hide");
                        $(me._widget).find(".btn-add-to-cart").addClass("hide");
                        $(me._widget).find(".js-addtocart-button").addClass("hide");
                    }
                }
                if (data.bypassCheckoutProcessForZeroCostOrders) {
                    $(me._widget).find(".btn-finalize").removeClass("hide");
                    $(me._widget).find(".btn-add-to-cart").addClass("hide");
                    $(me._widget).find(".js-addtocart-button").addClass("hide");
                }
                else {
                    $(me._widget).find(".btn-add-to-cart").removeClass("hide");
                    $(me._widget).find(".js-addtocart-button").removeClass("hide");
                    $(me._widget).find(".btn-finalize").addClass("hide");
                }
                if (data.isInventoryEnabled == true) {
                    if (data.quantityInHand > 0) {
                        $(me._widget).find(".btn-add-to-cart").prop('disabled', false);
                        $(me._widget).find(".js-addtocart-button").prop('disabled', false);
                        $(me._widget).find(".btn-add-to-cart").html($(me._widget).find(".btn-add-to-cart").attr("data-button-text"));
                        $(me._widget).find(".js-addtocart-button").html($(me._widget).find(".js-addtocart-button").attr("data-button-text"));
                        $(me._widget).find(".quantity-input").removeAttr("disabled");
                        $(me._widget).find(".btn-finalize").prop('disabled', false);
                        $(me._widget).find(".btn-finalize").html($(me._widget).find(".btn-finalize").attr("data-button-text"));
                    }
                    else {
                        $(me._widget).find(".btn-add-to-cart").html($(me._widget).find(".btn-add-to-cart").attr("data-out-of-stock"));
                        $(me._widget).find(".btn-add-to-cart").prop('disabled', true);
                        $(me._widget).find(".js-addtocart-button").html($(me._widget).find(".js-addtocart-button").attr("data-out-of-stock"));
                        $(me._widget).find(".js-addtocart-button").prop('disabled', true);
                        $(me._widget).find(".quantity-input").prop("disabled", true);
                        $(me._widget).find(".btn-finalize").html($(me._widget).find(".btn-finalize").attr("data-out-of-stock"));
                        $(me._widget).find(".btn-finalize").prop('disabled', true);
                    }
                }
                //else {
                //    $(me._widget).find(".btn-finalize").prop('disabled', false);
                //    $(me._widget).find(".btn-add-to-cart").prop('disabled', false);
                //}
                $(me._widget).find(".js-sku-name").html(data.skuName);
                $(me._widget).find(".js-sku-name").parent("div").removeClass("hidden");
                var min = parseInt(data.minPerOrder);
                var max = parseInt(data.maxPerOrder);
                if (max == -1) {
                    max = 99999;
                }
                //$(me._widget).find('#ItemQuantity').html(max.toString());
                //$(me._widget).find('#ItemQuantity').val(max.toString());   
                if ($(this._widget).find(".js-product-template-form").find("#ItemQuantity").val() == "") {
                    $(me._widget).find('#ItemQuantity').html(min.toString());
                    $(me._widget).find('#ItemQuantity').val(min.toString());
                }
                $(me._widget).find('#ItemQuantity').attr('min', min);
                $(me._widget).find('#ItemQuantity').attr('data-min-quantity-per-order', min);
                $(me._widget).find('#ItemQuantity').val(min.toString());
                $(me._widget).find('#ItemQuantity').attr('max', max);
                $(me._widget).find('#ItemQuantity').attr('max-length', max.toString().length);
                $(me._widget).find('#ItemQuantity').attr('data-max-quantity-per-order', max);
            }
        }));
    }
    GetCustomizedItemFromAttributes() {
        var params = {
            Identifier: this._identifier,
            ProductId: this._productId,
            Quantity: $(this._widget).find(".quantity-input").val(),
            Attributes: [],
            ProductCustomizationId: null
        };
        var me = this;
        $.each($(this._widget).find(".customized-attribute-selector"), function (index, item) {
            if ($(this).find(":selected").val() !== "") {
                params.Attributes.push($(this).find(":selected").val());
            }
        });
        var me = this;
        var url = '/Api/ShoppingCart/GetItemPrice';
        $.when(submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            if (data.status == "OK") {
                $(me._widget).find(".points-value").text(data.formattedPrice);
                $(me._widget).find(".points-value").attr("data-price", data.price);
                if (data.bypassCheckoutProcessForZeroCostOrders) {
                    $(me._widget).find(".btn-finalize").removeClass('hide');
                    $(me._widget).find(".js-addtocart-button").addClass('hide');
                }
                else {
                    $(me._widget).find(".js-addtocart-button").removeClass('hide');
                    $(me._widget).find(".btn-finalize").addClass('hide');
                }
                if (data.isInventoryEnabled == true) {
                    if (data.quantityInHand > 0) {
                        $(me._widget).find(".js-addtocart-button").prop('disabled', false);
                        $(me._widget).find(".js-addtocart-button").html($(me._widget).find(".js-addtocart-button").attr("data-button-text"));
                        $(me._widget).find(".quantity-input").removeAttr("disabled");
                        $(me._widget).find(".btn-finalize").prop('disabled', false);
                        $(me._widget).find(".btn-finalize").html($(me._widget).find(".js-addtocart-button").attr("data-button-text"));
                    }
                    else {
                        $(me._widget).find(".js-addtocart-button").html($(me._widget).find(".js-addtocart-button").attr("data-out-of-stock"));
                        $(me._widget).find(".js-addtocart-button").prop('disabled', true);
                        $(me._widget).find(".quantity-input").prop("disabled", true);
                        $(me._widget).find(".btn-finalize").html($(me._widget).find(".js-addtocart-button").attr("data-out-of-stock"));
                        $(me._widget).find(".btn-finalize").prop('disabled', true);
                    }
                }
                //else {
                //    $(me._widget).find(".btn-finalize").prop('disabled', false);
                //    $(me._widget).find(".js-addtocart-button").prop('disabled', false);
                //}
                $(me._widget).find(".js-quantity-row").removeClass("hide");
                if (parseInt($(me._widget).find(".points-value").attr("data-price")) <= 0) {
                    $(me._widget).find(".js-quantity-row").addClass("hide");
                }
                $(me._widget).find(".js-sku-name").html(data.skuName);
                $(me._widget).find(".js-sku-name").parent("div").removeClass("hidden");
            }
        }));
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._identifier = $(this._widget).find(".js-product-template-form").attr("data-product-catalog-identifier");
        this._productId = parseInt($(this._widget).find(".js-product-template-form").attr("data-product-id"));
        if ($(this._widget).find(".js-product-template-form").find("#ItemQuantity").val() == "") {
            this._quantity = 1;
        }
        this._globalModal = new GlobalModal(this._widgetId);
        this.bindControls();
    }
    bindControls() {
        // VB lives on
        var me = this;
        $(this._widget).find(".js-finalize-button").on("click", function (e) {
            me.FinalizeItem($(e.currentTarget));
        });
        $(this._widget).find(".btn-add-to-cart").on("click", function (e) {
            me.AddItemToCart($(e.currentTarget));
        });
        $(me._widget).find(".btn-update-cart").on("click", function (e) {
            me.UpdateCart($(e.currentTarget));
        });
        $(this._widget).find(".quantity-input").on("keyup", function () {
            me._quantity = parseInt($(this).val());
        });
        $(this._widget).find('.js-product-download-by-language').on('change', function (e) {
            e.preventDefault();
            $(me._widget).find(".js-download-action-button").removeAttr("disabled");
            if ($(e.currentTarget).val() !== "") {
                var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''), urlQueryString = document.location.search;
                if (urlQueryString) {
                    var key = "selected-locale";
                    var params = "";
                    var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
                    params = urlQueryString.replace(removeRegex, "$1");
                    params = params.replace(/[&;]$/, "");
                    window.history.replaceState({}, "", baseUrl + params);
                    window.location.href = baseUrl + params + "&selected-locale=" + $(e.currentTarget).val();
                }
            }
            else {
                $(me._widget).find(".js-download-action-button").attr("disabled", "disabled");
                $(me._widget).find(".js-download-action-button").removeAttr("href");
            }
        });
        $(this._widget).find(".attribute-selector").on("change", function () {
            $(me._widget).find(".btn-add-to-cart").removeAttr("disabled");
            $(me._widget).find(".js-addtocart-button").removeAttr("disabled");
            if (!me.CheckAttribute()) {
                $(me._widget).find(".btn-add-to-cart").prop("disabled", true);
                $(me._widget).find(".btn-add-to-cart").addClass("hide");
                $(me._widget).find(".js-addtocart-button").prop("disabled", true);
                $(me._widget).find(".js-addtocart-button").addClass("hide");
                if ($(me._widget).find(".js-download-action-button").length > 0) {
                    $(me._widget).find(".js-download-action-button").prop("disabled", true);
                    $(me._widget).find(".js-download-action-button").addClass("hide");
                }
            }
            me.GetItemFromAttributes();
        });
        $.each($(this._widget).find(".js-product-customization-field-type-dropdown"), function (i, e) {
            var dropDown = this;
            if ($(dropDown).length === 1) {
                var textarea = $(dropDown).closest(".js-product-customization-field-type-dropdown-container")
                    .find(".js-product-customization-field-type-text-area");
                $(textarea).on("change", function (e) {
                    var assetLibraryType = $(dropDown).attr("data-asset-library-type");
                    if ($(dropDown).attr("data-allow-user-to-change-selection") === "True" && (assetLibraryType === "Text" || assetLibraryType === "")) {
                        var oldValue = $(dropDown).val();
                        var mismatchValueForAssetLibrary = $(dropDown).attr("data-value-mismatch-asset-library");
                        var mismatchValue = $(dropDown).attr("data-value-mismatch");
                        var valueToDisplay = mismatchValueForAssetLibrary;
                        if (assetLibraryType == "Text") {
                            valueToDisplay = valueToDisplay.replace("##typetoreplace##", assetLibraryType);
                        }
                        else {
                            valueToDisplay = mismatchValue;
                        }
                        if ($(textarea).val() !== "" && $(textarea).val() !== $(textarea).attr("data-original-value")) {
                            if (!window.confirm(valueToDisplay)) {
                                $(e.currentTarget).val(oldValue);
                                return false;
                            }
                        }
                        $(dropDown).attr("data-selected-value", $(dropDown).val());
                        $(textarea).removeClass("hide");
                        $(textarea).val($(e.currentTarget).val());
                        $(textarea).attr("data-field-name", $(dropDown).attr("data-original-field-name"));
                        $(textarea).attr("data-original-value", $(dropDown).val());
                        $(dropDown).removeAttr("data-field-name");
                    }
                    else {
                        $(textarea).addClass("hide");
                        $(textarea).val("");
                        $(textarea).removeAttr("data-field-name");
                        $(dropDown).attr("data-field-name", $(dropDown).attr("data-original-field-name"));
                    }
                });
            }
        });
        $(this._widget).find(".js-product-customization-field-type-dropdown").on("change", function (e) {
            e.preventDefault();
            var textarea = $(e.currentTarget).closest(".js-product-customization-field-type-dropdown-container")
                .find(".js-product-customization-field-type-text-area");
            var assetLibraryType = $(e.currentTarget).attr("data-asset-library-type");
            if ($(e.currentTarget).attr("data-allow-user-to-change-selection") === "True" && (assetLibraryType === "Text" || assetLibraryType === "")) {
                var oldValue = $(e.currentTarget).attr("data-selected-value");
                var mismatchValueForAssetLibrary = $(e.currentTarget).attr("data-value-mismatch-asset-library");
                var mismatchValue = $(e.currentTarget).attr("data-value-mismatch");
                var valueToDisplay = mismatchValueForAssetLibrary;
                if (assetLibraryType == "Text") {
                    valueToDisplay = valueToDisplay.replace("##typetoreplace##", assetLibraryType);
                }
                else {
                    valueToDisplay = mismatchValue;
                }
                if ($(textarea).val() !== "" && $(textarea).val() !== $(textarea).attr("data-original-value")) {
                    if (!window.confirm(valueToDisplay)) {
                        $(e.currentTarget).val(oldValue);
                        return false;
                    }
                }
                $(e.currentTarget).attr("data-selected-value", $(e.currentTarget).val());
                $(textarea).removeClass("hide");
                $(textarea).val($(e.currentTarget).val());
                $(textarea).attr("data-field-name", $(e.currentTarget).attr("data-original-field-name"));
                $(textarea).attr("data-original-value", $(e.currentTarget).val());
                $(e.currentTarget).removeAttr("data-field-name");
            }
            else {
                $(textarea).addClass("hide");
                $(textarea).val("");
                $(textarea).removeAttr("data-field-name");
                $(e.currentTarget).attr("data-field-name", $(e.currentTarget).attr("data-original-field-name"));
            }
        });
        //$(this._widget).find(".attribute-selector").change();
        $(me._widget).find(".btn-add-to-cart").removeAttr("disabled");
        $(me._widget).find(".js-addtocart-button").removeAttr("disabled");
        if (!me.CheckAttribute()) {
            $(me._widget).find(".btn-add-to-cart").prop("disabled", true);
            $(me._widget).find(".btn-add-to-cart").addClass("hide");
            $(me._widget).find(".js-addtocart-button").prop("disabled", true);
            $(me._widget).find(".js-addtocart-button").addClass("hide");
            if ($(me._widget).find(".js-download-action-button").length > 0) {
                $(me._widget).find(".js-download-action-button").prop("disabled", true);
                $(me._widget).find(".js-download-action-button").addClass("hide");
            }
        }
        me.GetItemFromAttributes();
        //$(this._widget).find(".customized-attribute-selector").on("change", function () {
        //    $(me._widget).find(".btn-add-to-cart").removeAttr("disabled");
        //    if (!me.CheckAttribute()) {
        //        $(me._widget).find(".btn-add-to-cart").attr("disabled", "disabled");
        //    }
        //    me.GetCustomizedItemFromAttributes();
        //});
        if (!me.CheckAttribute()) {
            $(me._widget).find(".btn-add-to-cart").attr("disabled", "disabled");
            $(me._widget).find(".js-addtocart-button").attr("disabled", "disabled");
        }
        $.each($(me._widget).find(".js-product-template-form"), function (i, e) {
            if ($(e).attr("data-is-listbased-email") === "True") {
                me.setEmailInformation($(e));
            }
            if ($(e).attr("data-microsite-based") === "True") {
                me.setMicrositeInformation($(e), me);
            }
            me.setMicrositeLookupUrl($(e), me);
            if ($(e).attr("data-social-post-based") === "True") {
                me.setSocialPostInformation($(e));
            }
            if ($(e).attr("data-direct-mail-based") === "True") {
                me.setDirectMailInformation($(e));
            }
        });
    }
    setApproximateCostContainer(button) {
        var container = $(button).closest(".js-direct-mail-configuration-container");
        $(container).find(".js-direct-mail-list-selector").addClass("hide");
        $(container).find(".js-direct-mail-list-selector button").removeAttr("data-contact-list-id");
        $(container).find(".js-direct-mail-list-cost-container").addClass("hide");
        if ($(button).val() != "" && $(button).find(':selected').attr('data-number-contacts') !== "0") {
            var numberOfContacts = $(button).find(':selected').attr('data-number-contacts');
            var formattedNumberOfContacts = $(button).find(':selected').attr('data-formatted-number-of-contacts');
            var totalPrice = $(button).find(':selected').attr('data-total-price');
            if (numberOfContacts !== "0") {
                $(container).find(".js-direct-mail-list-selector").removeClass("hide");
                $(container).find(".js-direct-mail-list-selector button").attr("data-contact-list-id", $(button).val());
                $(container).find(".js-direct-mail-list-cost-container").removeClass("hide");
                var appxroximateCostCopy = $(container).find(".js-direct-mail-list-cost-container").find(".js-approximatcostcopy").attr("data-approximate-cost-copy");
                $(container).find(".js-direct-mail-list-cost-container").find(".js-approximatcostcopy").html(appxroximateCostCopy.replace("{0}", formattedNumberOfContacts).replace("{1}", totalPrice));
            }
        }
    }
    setDirectMailInformation(item) {
        var me = this;
        $(item).find(".js-direct-mail-list-selector button").on("click", function (e) {
            if ($(e.currentTarget).attr("data-contact-list-id") !== "") {
                me.openDirectMailUploadedListRecipients($(e.currentTarget));
            }
        });
        $(item).find(".js-upload-direct-mail-list").on("click", function (e) {
            e.preventDefault();
            me.OpenDirectMailUploadModal($(e.currentTarget));
        });
        $(item).find(".js-direct-mail-list-container").on("change", function (e) {
            me.setApproximateCostContainer(this);
        });
    }
    setMicrositeLookupUrl(item, self) {
        $.each($(item).find(".js-microsite-url-lookup-container"), function (i, e) {
            var itemId = "-" + $(e).attr("data-field-identifier");
            $(item).find(".js-microsite-lookup-url-selector").on("change", function (e) {
                if ($(this).val() === "custom") {
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-enter-microsite-url-row").removeClass("hidden");
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-enter-microsite-url-row").find(".js-enter-microsite-url").removeClass("hidden");
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-microsite-url-value").val("");
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-enter-microsite-url-row").find(".js-enter-microsite-url").val("");
                }
                else {
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-enter-microsite-url-row").addClass("hidden");
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-enter-microsite-url-row").find(".js-enter-microsite-url").addClass("hidden");
                    $(this).closest(".js-microsite-url-lookup-container").find(".js-microsite-url-value").val($(this).closest(".js-microsite-url-lookup-container").find(".js-microsite-lookup-url-selector").val());
                }
            });
            $(item).find(".js-enter-microsite-url").on("blur", function (e) {
                $(this).closest(".js-microsite-url-lookup-container")
                    .find(".js-microsite-url-value").val($(this).closest(".js-microsite-url-lookup-container")
                    .find(".js-enter-microsite-url-row").find(".js-enter-microsite-url").val());
            });
        });
    }
    SetNames(container, isScheduled) {
        var appendWithLaunchName = "";
        var appendWithArchiveDate = "";
        if (isScheduled) {
            if ($(container).find("#launch-date").val() !== "") {
                appendWithLaunchName = dayjs.utc($(container).find("#launch-date").val()).format('MM/DD/YYYY').toString();
            }
        }
        else {
            appendWithLaunchName = dayjs.utc((new Date()).toISOString()).format('MM/DD/YYYY').toString();
        }
        if ($(container).find("#archive-date").val() !== "") {
            appendWithArchiveDate = dayjs.utc($(container).find("#archive-date").val()).format('MM/DD/YYYY').toString();
        }
        var microsoftFriendlyName = $(container).find(".js-microsite-friendly-name").attr("data-microsite-friendly-name") + " " + (appendWithLaunchName !== "" ? appendWithLaunchName + " - " + appendWithArchiveDate : appendWithArchiveDate);
        var contactListName = $(container).find(".js-contact-list-name").attr("data-contact-list-name") + " " + (appendWithLaunchName !== "" ? appendWithLaunchName + " - " + appendWithArchiveDate : appendWithArchiveDate);
        $(container).find(".js-microsite-friendly-name").val(microsoftFriendlyName);
        $(container).find(".js-contact-list-name").val(contactListName);
    }
    setMicrositeInformation(item, self) {
        var me = this;
        GlobalPopulateTimeZones($(item).find(".time-zone"));
        $(item).find('#launch-date').on("change", function (e) {
            var container = $(this).closest(".js-microsite-launch-details-container");
            var itemId = "-" + $(container).attr("data-field-identifier");
            if ($(container).find("input[name=launch" + itemId + "]:checked").val() === "schedule") {
                self.SetNames(container, true);
            }
            else {
                self.SetNames(container, false);
            }
        });
        $(item).find('#archive-date').on("change", function (e) {
            var container = $(this).closest(".js-microsite-launch-details-container");
            self.SetNames(container, true);
        });
        if ($(item).find(".js-launch-time-zone-data").val() !== "" && $(item).find(".js-launch-time-zone-data").val() !== undefined) {
            $(".js-launch-time-zone").val($(".js-launch-time-zone-data").val());
        }
        if ($(item).find(".js-archive-time-zone-data").val() !== "" && $(item).find(".js-archive-time-zone-data").val() !== undefined) {
            $(item).find(".js-archive-time-zone").val($(".js-archive-time-zone-data").val());
        }
        if ($(item).find("#launch-date-full").val() !== "") {
            ReloadForCustomizationAndOrder($(item).find('#launch-date-full').val(), $(item).find(".js-schedule-launch-config").find(".js-launch-time-zone").val(), $(item).find('#launch-time'), $(item).find('#launch-date'));
        }
        if ($(item).find("#archive-date-full").val() !== "") {
            ReloadForCustomizationAndOrder($(item).find('#archive-date-full').val(), $(item).find(".js-schedule-archive-config").find(".js-archive-time-zone").val(), $(item).find('#archive-time'), $(item).find('#archive-date'));
        }
        var launchDateEl = $(item).find('#launch-date-picker').get(0);
        var launchTimeEl = $(item).find('#launch-time-picker').get(0);
        var archiveDateEl = $(item).find('#archive-date-picker').get(0);
        var archiveTimeEl = $(item).find('#archive-time-picker').get(0);
        ConfigureDatePicker($(item).find('#launch-date-picker'));
        ConfigureDatePicker($(item).find('#archive-date-picker'));
        ConfigureTimePicker($(item).find('#launch-time-picker'));
        ConfigureTimePicker($(item).find('#archive-time-picker'));
        //InitializeDatePickerForOrder(launchDateEl, launchTimeEl, archiveDateEl, archiveTimeEl);
        me.bindLocalizedTime();
        $.each($(item).find(".js-microsite-launch-details-container"), function (i, e) {
            var itemId = "-" + $(e).attr("data-field-identifier");
            $(item).find("input[name=launch" + itemId + "]").on("change", function (e) {
                var me = this;
                if ($(this).val() === "schedule") {
                    $(this).closest(".js-microsite-launch-details-container").find(".js-schedule-launch-config").removeClass("hidden");
                    var container = $(this).closest(".js-microsite-launch-details-container");
                    self.SetNames(container, true);
                }
                else {
                    $(this).closest(".js-microsite-launch-details-container").find(".js-schedule-launch-config").addClass("hidden");
                    var container = $(this).closest(".js-microsite-launch-details-container");
                    self.SetNames(container, false);
                }
            });
            $(item).find("input[name=archive" + itemId + "]").on("change", function (e) {
                if ($(this).val() === "archive") {
                    $(this).closest(".js-microsite-launch-details-container").find(".js-archive-list-schedule").removeClass("hidden");
                }
                else {
                    $(this).closest(".js-microsite-launch-details-container").find(".js-archive-list-schedule").addClass("hidden");
                }
            });
        });
    }
    setSocialPostInformation(item) {
        var me = this;
    }
    setEmailInformation(item) {
        var me = this;
        GlobalPopulateTimeZones($(item).find(".time-zone"));
        $(item).find(".js-email-recipient-list-selector button").on("click", function (e) {
            if ($(e.currentTarget).attr("data-contact-list-id") !== "") {
                me.openEmailUploadedListRecipients($(e.currentTarget));
            }
        });
        $(item).find(".js-email-seed-list-selector button").on("click", function (e) {
            if ($(e.currentTarget).attr("data-contact-list-id") !== "") {
                me.openEmailUploadedListRecipients($(e.currentTarget));
            }
        });
        $(item).find(".js-resend-verification-email").on("click", function (e) {
            e.preventDefault();
            var verifyEmailContainer = $(e.currentTarget).closest(".js-verify-email-container");
            var linkFromConfirmationEmailContainer = $(verifyEmailContainer).find(".js-link-from-confirmation-email-container");
            var message = $(e.currentTarget).attr("data-confirmation-email-send-out");
            $.ajax({
                method: "GET",
                url: "/SendGridVerification/ResendVerificationEmail/" + $(e.currentTarget).attr("data-sender-identity")
            }).done(function (data) {
                if (data != null) {
                    if (data) {
                        $(linkFromConfirmationEmailContainer).removeClass("hide");
                        $(linkFromConfirmationEmailContainer).find("js-resend-verification-email").attr("data-sender-identity", data.senderIdentity);
                        alert(message);
                    }
                }
            });
        });
        $(item).find(".js-custom-sender-field").on("blur", function (e) {
            var restrictToVerifiedDomainsOnly = $(e.currentTarget).attr("data-restrict-to-verified-domains-only");
            //if (restrictToVerifiedDomainsOnly == "true") {
            me.CheckIsEmailInVerifiedDomain($(e.currentTarget), item, false);
            //}
        });
        $(item).find(".js-verify-confirmation-link").on("click", function (e) {
            e.preventDefault();
            $(verifyEmailContainer).attr("data-sender-verified", "false");
            var verifyEmailContainer = $(e.currentTarget).closest(".js-verify-email-container");
            var linkFromConfirmationEmailContainer = $(verifyEmailContainer).find(".js-link-from-confirmation-email-container");
            var verifiedMessage = $(e.currentTarget).attr("data-confirm-message");
            var sendGridConfirmationLinkDTO = {
                url: $(linkFromConfirmationEmailContainer).find(".js-link-from-confirmation-email").val()
            };
            $(verifyEmailContainer).find(".js-verify-sender").removeAttr("disabled");
            $(verifyEmailContainer).find(".js-verify-sender").removeClass("hide");
            $(verifyEmailContainer).find(".js-view-sender-list").removeClass("hide");
            var url = "/SendGridVerification/VerifySenderRequest";
            $.when(submitAjaxRequest(sendGridConfirmationLinkDTO, url, "POST").done(function (data) {
                waitingDialog.hide();
                if (data != null) {
                    if (data.isVerified) {
                        $(verifyEmailContainer).attr("data-sender-verified", "true");
                        $(linkFromConfirmationEmailContainer).find(".js-link-from-confirmation-email").val("");
                        $(linkFromConfirmationEmailContainer).addClass("hide");
                        $(linkFromConfirmationEmailContainer).find("js-resend-verification-email").attr("data-sender-identity", "");
                        $(verifyEmailContainer).find(".js-verified-icon").removeClass("hide");
                        $(verifyEmailContainer).find(".js-custom-sender-field").attr("readonly", "true");
                        alert(verifiedMessage);
                    }
                    else if (data.exceptionErrors != "") {
                        alert(data.exceptionErrors);
                        $(linkFromConfirmationEmailContainer).find(".js-link-from-confirmation-email").val("");
                        $(linkFromConfirmationEmailContainer).addClass("hide");
                        $(linkFromConfirmationEmailContainer).find("js-resend-verification-email").attr("data-sender-identity", "");
                        $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
                        waitingDialog.hide();
                    }
                }
                else {
                    waitingDialog.hide();
                }
            }));
        });
        $(item).find(".js-verify-sender").on("click", function (e) {
            e.preventDefault();
            me.SendCreateRequest($(e.currentTarget), item, false);
        });
        $(item).find(".js-send-recipient-list").on("change", function (e) {
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector").addClass("hide");
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector button").removeAttr("data-contact-list-id");
            if ($(e.currentTarget).val() != "" && $(e.currentTarget).attr("data-number-contacts") !== "0") {
                var numberOfContacts = $(item).find(".js-send-recipient-list").find(':selected').attr('data-number-contacts');
                if (numberOfContacts !== "0") {
                    $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector").removeClass("hide");
                    $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector button").attr("data-contact-list-id", $(e.currentTarget).val());
                }
            }
        });
        $(item).find(".js-send-seed-list").on("change", function (e) {
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-seed-list-selector").addClass("hide");
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-seed-list-selector button").removeAttr("data-contact-list-id");
            if ($(e.currentTarget).val() != "" && $(e.currentTarget).attr("data-number-contacts") !== "0") {
                var numberOfContacts = $(item).find(".js-send-seed-list").find(':selected').attr('data-number-contacts');
                if (numberOfContacts !== "0") {
                    $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-seed-list-selector").removeClass("hide");
                    $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-seed-list-selector button").attr("data-contact-list-id", $(e.currentTarget).val());
                }
            }
        });
        if ($(item).find(".js-send-time-zone-data").val() !== "" && $(item).find(".js-send-time-zone-data").val() !== undefined) {
            $(".js-send-time-zone").val($(".js-send-time-zone-data").val());
        }
        if ($(item).find(".js-seed-send-time-zone-data").val() !== "" && $(item).find(".js-seed-send-time-zone-data").val() !== undefined) {
            $(item).find(".js-seed-send-time-zone").val($(".js-seed-send-time-zone-data").val());
        }
        if ($(item).find("#send-date-full").val() !== "") {
            ReloadForCustomizationAndOrder($(item).find('#send-date-full').val(), $(item).find(".js-schedule-send-config").find(".js-send-time-zone").val(), $(item).find('#send-time'), $(item).find('#send-date'));
        }
        if ($(item).find("#seed-send-date-full").val() !== "") {
            ReloadForCustomizationAndOrder($(item).find('#seed-send-date-full').val(), $(item).find(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val(), $(item).find('#seed-send-time'), $(item).find('#seed-send-date'));
        }
        var sendDateEl = $(item).find('#send-date-picker').get(0);
        var sendTimeEl = $(item).find('#send-time-picker').get(0);
        var seedDateEl = $(item).find('#seed-send-date-picker').get(0);
        var seedTimeEl = $(item).find('#seed-send-time-picker').get(0);
        ConfigureDatePicker($(item).find('#send-date-picker'));
        ConfigureDatePicker($(item).find('#seed-send-date-picker'));
        ConfigureTimePicker($(item).find('#send-time-picker'));
        ConfigureTimePicker($(item).find('#seed-send-time-picker'));
        //InitializeDatePickerForOrder(sendDateEl, sendTimeEl, seedDateEl, seedTimeEl);
        $(item).find(".js-upload-recipient-list").on("click", function (e) {
            e.preventDefault();
            me.OpenUploadModal($(e.currentTarget));
        });
        $(item).find(".js-search-list-by-email").on("click", function (e) {
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector").addClass("hide");
            var recipentlist = $(item).find(".js-send-recipient-list");
            e.preventDefault();
            var email = $(item).find(".js-email-to-search").val();
            if (email != "") {
                $('#ajax-loading').modal();
                $.ajax({
                    method: "GET",
                    url: "/EmailCampaign/GetContactListByEmailAddress/" + email
                }).done(function (data) {
                    $("#ajax-loading").modal("hide");
                    if (data != null) {
                        if (data.length == 1) {
                            $(recipentlist).find("option").each(function () {
                                if ($(this).val() != data && $(this).val() != "") {
                                    this.remove();
                                }
                            });
                        }
                    }
                }).fail(function (response, textStatus, errorThrown) {
                    alert(errorThrown);
                });
            }
        });
        $(item).find(".js-search-list-by-email-reset").on("click", function (e) {
            $(e.currentTarget).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector").addClass("hide");
            $(item).find(".js-email-to-search").val("");
            var originalList = $(item).find(".js-send-recipient-list-clone");
            var recipentlist = $(item).find(".js-send-recipient-list");
            $(recipentlist).empty();
            e.preventDefault();
            $(originalList).find("option").each(function () {
                $('<option>').val($(this).val()).text($(this).text()).attr('data-number-contacts', $(this).attr("data-number-contacts")).appendTo($(recipentlist));
            });
        });
        $(item).find(".js-upload-seed-list").on("click", function (e) {
            e.preventDefault();
            me.OpenUploadModal($(e.currentTarget));
        });
        me.bindLocalizedTime();
        $.each($(item).find(".js-email-send-details-container"), function (i, e) {
            var itemId = "-" + $(e).attr("data-field-identifier");
            $(item).find("input[name=listSend" + itemId + "]").on("change", function (e) {
                if ($(this).val() === "schedule") {
                    $(this).closest(".js-email-send-details-container").find(".js-schedule-send-config").removeClass("hidden");
                }
                else {
                    $(this).closest(".js-email-send-details-container").find(".js-schedule-send-config").addClass("hidden");
                }
            });
            $(item).find("input[name=seedListSend" + itemId + "]").on("change", function (e) {
                if ($(this).val() === "seperate") {
                    $(this).closest(".js-email-send-details-container").find(".js-seed-list-schedule").removeClass("hidden");
                }
                else {
                    $(this).closest(".js-email-send-details-container").find(".js-seed-list-schedule").addClass("hidden");
                }
            });
        });
        $.each($(item).find(".js-fromaddress-container"), function (i, e) {
            $(item).find("input[name=fromname]").on("change", function (e) {
                if ($(this).val() === "defaultSender") {
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").attr("data-field-name", "EmailFrom");
                    $(this).closest(".js-fromaddress-container").find(".js-custom-sender-field").removeAttr("data-field-name");
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").removeClass("hide");
                    $(this).closest(".js-fromaddress-container").find(".js-verify-email-container").addClass("hide");
                    $(this).closest(".js-fromaddress-container").find(".js-verify-email-container").find(".js-custom-sender-field").val("");
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").attr("data-isrequired", "True");
                    $(this).closest(".js-fromaddress-container").find(".js-verify-email-container").find(".js-custom-sender-field").removeAttr("data-isrequired");
                }
                else {
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").removeAttr("data-field-name");
                    $(this).closest(".js-fromaddress-container").find(".js-custom-sender-field").attr("data-field-name", "EmailFrom");
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").addClass("hide");
                    $(this).closest(".js-fromaddress-container").find(".js-verify-email-container").removeClass("hide");
                    $(this).closest(".js-fromaddress-container").find(".js-default-sender-field").removeAttr("data-isrequired");
                    $(this).closest(".js-fromaddress-container").find(".js-verify-email-container").find(".js-custom-sender-field").attr("data-isrequired", "True");
                }
            });
        });
        $(document).on("change", ".js-send-separate-seed-email", function (e) {
            if ($(this).is(":checked")) {
                $(this).closest(".js-email-send-details-container").find(".js-schedule-seed-send-config").removeClass("hidden");
            }
            else {
                $(this).closest(".js-email-send-details-container").find(".js-schedule-seed-send-config").addClass("hidden");
            }
        });
    }
    OpenDirectMailUploadModal(button) {
        waitingDialog.show("");
        var me = this;
        var assignmentIdentifier = $(button).attr("data-product-catalogassignment-identifier");
        var locale = $(button).attr("data-locale");
        var emailDirectMailDetailsContainer = $(button).closest(".js-direct-mail-configuration-container");
        var appendToName = "";
        $.when(me.GetDirectMailUploadModal(assignmentIdentifier, locale).done(function (data, textStatus, response) {
            var options = {
                classes: "configure-send-modal",
                origin: $(button)
            };
            me._globalModal.openGlobalModal(data, "panel", options);
            var confirmContainer = $(".global-modal").find(".js-confirm-direct-mail-file-container");
            var fileUploadContainer = $(".global-modal").find(".js-direct-mail-file-upload-container");
            var tableBody = $(".global-modal").find(".js-response-items-body");
            if (appendToName !== "") {
                $(".global-modal").find(".js-list-name").attr("value", $(".global-modal").find(".js-list-name").attr("value") + " - " + appendToName);
            }
            waitingDialog.hide();
            $(".global-modal").find(".js-chose-new-file").on('click', function (e) {
                e.preventDefault();
                $(tableBody).empty();
                $(".global-modal").find(".js-confirm-file").prop("disabled", false);
                $(confirmContainer).addClass("hide");
                $(fileUploadContainer).removeClass("hide");
            });
            $(".global-modal").find(".js-upload-direct-mail-list").on('click', function (e) {
                var assignmentIdentifier = $(e.currentTarget).attr("data-product-catalog-assignment-identifier");
                var uploadType = $(e.currentTarget).attr("data-upload-type");
                var noSelectedFileMessage = $(e.currentTarget).attr("data-no-file-selected-message");
                var mapFieldNameLabel = $(e.currentTarget).attr("data-map-field-names-label");
                var fileNameRequired = $(e.currentTarget).attr("data-list-name-required");
                var parentContainer = $(e.currentTarget).closest(".js-upload-direct-mail-recipient-container");
                e.preventDefault();
                if ($(".global-modal").find(".js-list-name").val() == "") {
                    alert(fileNameRequired);
                    return false;
                }
                var formData = new FormData();
                var element = document.getElementById("uploadDirectMailList");
                var file = element.files[0];
                if (element.files.length > 0) {
                    formData.append('file', file);
                    formData.append('assignmentIdentifier', assignmentIdentifier);
                    formData.append('uploadType', uploadType);
                    formData.append('listName', $(".global-modal").find(".js-list-name").val());
                    formData.append('confirm', "false");
                    waitingDialog.show("");
                    var url = ("/DirectMail/UploadDirectMailRecipients");
                    $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
                        waitingDialog.hide();
                        if (data != null) {
                            $(fileUploadContainer).addClass("hide");
                            $(confirmContainer).removeClass("hide");
                            var result = "";
                            $(tableBody).empty();
                            if (data.errorMessage.length == 0) {
                                result += "<tr>";
                                result += "<td>" + data.numberOfEntries + " </td>";
                                result += "<td>" + $(confirmContainer).attr("data-list-number-of-entries") + " </td>";
                                result += "</tr>";
                            }
                            else {
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                                result += "<tr>";
                                result += "<td colspan='2'>" + data.errorMessage + "</td>";
                                result += "</tr>";
                            }
                            $(tableBody).html(result);
                        }
                    }));
                }
                else {
                    waitingDialog.hide();
                    bootbox.alert(noSelectedFileMessage);
                    return false;
                }
            });
            $(".global-modal").find(".js-confirm-direct-mail-file").on('click', function (e) {
                e.preventDefault();
                var assignmentIdentifier = $(e.currentTarget).attr("data-product-catalog-assignment-identifier");
                var uploadType = $(e.currentTarget).attr("data-upload-type");
                var noSelectedFileMessage = $(e.currentTarget).attr("data-no-file-selected-message");
                var fileNameRequired = $(e.currentTarget).attr("data-list-name-required");
                if ($(".global-modal").find(".js-list-name").val() == "") {
                    alert(fileNameRequired);
                    $(e.currentTarget).prop("disabled", false);
                    waitingDialog.hide();
                    return false;
                }
                e.preventDefault();
                var formData = new FormData();
                var element = document.getElementById("uploadDirectMailList");
                var file = element.files[0];
                if (element.files.length > 0) {
                    $(e.currentTarget).prop("disabled", true);
                    waitingDialog.show("");
                    formData.append('file', file);
                    formData.append('assignmentIdentifier', assignmentIdentifier);
                    formData.append('uploadType', uploadType);
                    formData.append('listName', $(".global-modal").find(".js-list-name").val());
                    formData.append('confirm', "true");
                    var url = ("/DirectMail/UploadDirectMailRecipients");
                    $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
                        if (data != null) {
                            var result = "";
                            $(tableBody).empty();
                            if (data.errorMessage.length != 0) {
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                                result += "<tr>";
                                result += "<td colspan='2'>" + data.errorMessage + "</td>";
                                result += "</tr>";
                                $(tableBody).html(result);
                                $(".global-modal").find(".js-confirm-direct-mail-file").removeAttr("disabled");
                                waitingDialog.hide();
                                return false;
                            }
                            else {
                                $(e.currentTarget).prop("disabled", false);
                                waitingDialog.hide();
                                $(button).attr("data-contact-list-id", data.contactListId);
                                $(button).attr("data-contact-list-name", data.contactListName);
                                var dropdown = $(button).closest(".form-group").find(".js-direct-mail-list-container");
                                var dropdownContainer = $(dropdown).closest(".js-direct-mail-contact-list-container");
                                var dropdownclone = $(button).closest(".form-group").find(".js-direct-mail-list-container-clone");
                                var directMailListSelector = $(button).closest(".form-group").find(".js-direct-mail-list-selector").removeClass("hide");
                                var directMailListSelectorButton = $(button).closest(".form-group").find(".js-direct-mail-list-selector button");
                                $(directMailListSelectorButton).removeAttr("data-contact-list-id");
                                $(directMailListSelectorButton).attr("data-contact-list-id", data.contactListId);
                                var contactListId = data.contactListId;
                                $.ajax({
                                    method: "GET",
                                    url: "/DirectMail/GetDirectMailContactLists/" + assignmentIdentifier
                                }).done(function (data) {
                                    waitingDialog.hide();
                                    if (data != null) {
                                        $(dropdownContainer).html(data);
                                        $(dropdownContainer).find(".js-direct-mail-list-container").val(contactListId);
                                        //$(dropDown).val(contactListId);
                                        me.setApproximateCostContainer($(dropdownContainer).find(".js-direct-mail-list-container"));
                                        $($(dropdownContainer).find(".js-direct-mail-list-container")).on("change", function (e) {
                                            me.setApproximateCostContainer(this);
                                        });
                                        //var container = $(dropDown).closest(".js-direct-mail-configuration-container");
                                        //$(container).find(".js-direct-mail-list-selector").addClass("hide");
                                        //$(container).find(".js-direct-mail-list-selector button").removeAttr("data-contact-list-id");
                                        //$(container).find(".js-direct-mail-list-cost-container").addClass("hide");
                                        //if ($(dropDown).val() != "" && $(dropDown).find(':selected').attr('data-number-contacts') !== "0") {
                                        //    var numberOfContacts = $(dropDown).find(':selected').attr('data-number-contacts')
                                        //    var formattedNumberOfContacts = $(dropDown).find(':selected').attr('data-formatted-number-of-contacts');
                                        //    var totalPrice = $(dropDown).find(':selected').attr('data-total-price');
                                        //    if (numberOfContacts !== "0") {
                                        //        $(container).find(".js-direct-mail-list-selector").removeClass("hide");
                                        //        $(container).find(".js-direct-mail-list-selector button").attr("data-contact-list-id", $(button).val());
                                        //        $(container).find(".js-direct-mail-list-cost-container").removeClass("hide");
                                        //        var appxroximateCostCopy = $(container).find(".js-direct-mail-list-cost-container").find(".js-approximatcostcopy").attr("data-approximate-cost-copy");
                                        //        $(container).find(".js-direct-mail-list-cost-container").find(".js-approximatcostcopy").html(appxroximateCostCopy.replace("{0}", formattedNumberOfContacts).replace("{1}", totalPrice));
                                        //    }
                                        //}
                                        me._globalModal.closeGlobalModal();
                                    }
                                });
                            }
                        }
                        else {
                            $(e.currentTarget).prop("disabled", false);
                            waitingDialog.hide();
                        }
                    }));
                }
                else {
                    $(e.currentTarget).prop("disabled", false);
                    waitingDialog.hide();
                    bootbox.alert(noSelectedFileMessage);
                    return false;
                }
            });
        }));
    }
    OpenUploadModal(button) {
        waitingDialog.show("");
        var me = this;
        var uploadType = $(button).attr("data-upload-type");
        var assignmentIdentifier = $(button).attr("data-product-catalogassignment-identifier");
        var locale = $(button).attr("data-locale");
        var emailSendDetailsContainer = $(button).closest(".js-email-send-details-container");
        var appendToName = "";
        if ($(emailSendDetailsContainer).find("input:radio[name='listSend']:checked").val() === "immediately") {
            appendToName = dayjs.utc((new Date()).toISOString()).local().format('MM/DD/YYYY').toString();
        }
        if ($(emailSendDetailsContainer).find("input:radio[name='listSend']:checked").val() === "immediately") {
            appendToName = dayjs.utc((new Date()).toISOString()).local().format('MM/DD/YYYY').toString();
        }
        if ($(emailSendDetailsContainer).find(".js-send-separate-seed-email").is(":checked") &&
            $(emailSendDetailsContainer).find("input:radio[name='seedListSend']:checked").val() === "seperate") {
            appendToName = "";
        }
        $.when(me.GetUploadModal(uploadType, assignmentIdentifier, locale).done(function (data, textStatus, response) {
            var options = {
                classes: "configure-send-modal",
                origin: $(button)
            };
            me._globalModal.openGlobalModal(data, "panel", options);
            var confirmContainer = $(".global-modal").find(".js-confirm-file-container");
            var fileUploadContainer = $(".global-modal").find(".js-file-upload-container");
            var tableBody = $(".global-modal").find(".js-response-items-body");
            if (appendToName !== "") {
                $(".global-modal").find(".js-list-name").attr("value", $(".global-modal").find(".js-list-name").attr("value") + " - " + appendToName);
            }
            waitingDialog.hide();
            $(".global-modal").find(".js-chose-new-file").on('click', function (e) {
                e.preventDefault();
                $(tableBody).empty();
                $(".global-modal").find(".js-confirm-file").prop("disabled", false);
                $(confirmContainer).addClass("hide");
                $(fileUploadContainer).removeClass("hide");
            });
            $(".global-modal").find(".js-upload-email-list").on('click', function (e) {
                var assignmentIdentifier = $(e.currentTarget).attr("data-product-catalog-assignment-identifier");
                var uploadType = $(e.currentTarget).attr("data-upload-type");
                var noSelectedFileMessage = $(e.currentTarget).attr("data-no-file-selected-message");
                var mapFieldNameLabel = $(e.currentTarget).attr("data-map-field-names-label");
                var fileNameRequired = $(e.currentTarget).attr("data-list-name-required");
                var parentContainer = $(e.currentTarget).closest(".js-upload-email-recipient-container");
                e.preventDefault();
                if ($(".global-modal").find(".js-list-name").val() == "") {
                    alert(fileNameRequired);
                    return false;
                }
                var formData = new FormData();
                var element = document.getElementById("uploadRecipientList");
                var file = element.files[0];
                if (element.files.length > 0) {
                    formData.append('file', file);
                    formData.append('assignmentIdentifier', assignmentIdentifier);
                    formData.append('uploadType', uploadType);
                    formData.append('listName', $(".global-modal").find(".js-list-name").val());
                    formData.append('confirm', "false");
                    waitingDialog.show("");
                    var url = ("/EmailCampaign/UploadEmailRecipients");
                    $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
                        waitingDialog.hide();
                        if (data != null) {
                            $(fileUploadContainer).addClass("hide");
                            $(confirmContainer).removeClass("hide");
                            $(confirmContainer).find(".js-confirm-file").removeClass("hide");
                            $(confirmContainer).find("#mismatchedFieldNameMessage").addClass("hide");
                            var result = "";
                            $(tableBody).empty();
                            if (data.fileHeaderNames != null && data.fileHeaderNames.length > 0) {
                                result += "<tr>";
                                result += "<td>" + mapFieldNameLabel + ": </td>";
                                result += "<td>" + "<select class='js-mapped-field-name'>";
                                jQuery.each(data.fileHeaderNames, function (index, item) {
                                    if (item.isDefault == false) {
                                        result += "<option value='" + item.headerName + "'>" + item.headerName + "</option>";
                                    }
                                    else {
                                        result += "<option value='" + item.headerName + "' selected =selected'>" + item.headerName + "</option>";
                                    }
                                });
                                result += "</select>";
                                result += "</tr>";
                                $(confirmContainer).find(".js-map-email-file").removeClass("hide");
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                            }
                            else if (data.hasMismatchedColumnNames == true) {
                                $(confirmContainer).find("#mismatchedFieldNameMessage").removeClass("hide");
                                $(confirmContainer).find(".js-confirm-file").remove();
                            }
                            else if (data.errorMessage.length == 0) {
                                result += "<tr>";
                                result += "<td>" + data.numberOfEntries + " </td>";
                                result += "<td>" + $(confirmContainer).attr("data-list-number-of-entries") + " </td>";
                                result += "</tr>";
                                if (data.missingFieldsCount > 0) {
                                    result += "<tr>";
                                    result += "<td>" + data.missingFieldsCount + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-missing-field") +
                                        " </td>";
                                    result += "</tr>";
                                }
                                if (data.entriesWithMissingData > 0) {
                                    result += "<tr>";
                                    result += "<td>" + data.entriesWithMissingData + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-missing-data") +
                                        " </td>";
                                    result += "</tr>";
                                }
                                if (data.entriesWithInvalidEmailData) {
                                    result += "<tr>";
                                    result += "<td>" + data.entriesWithInvalidEmailData + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-invalid-email") +
                                        " </td>";
                                    result += "</tr>";
                                }
                            }
                            else {
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                                result += "<tr>";
                                result += "<td colspan='2'>" + data.errorMessage + "</td>";
                                result += "</tr>";
                            }
                            $(tableBody).html(result);
                        }
                    }));
                }
                else {
                    waitingDialog.hide();
                    bootbox.alert(noSelectedFileMessage);
                    return false;
                }
            });
            $(".global-modal").find(".js-map-email-file").on('click', function (e) {
                waitingDialog.show("");
                var assignmentIdentifier = $(e.currentTarget).attr("data-product-catalog-assignment-identifier");
                var uploadType = $(e.currentTarget).attr("data-upload-type");
                var noSelectedFileMessage = $(e.currentTarget).attr("data-no-file-selected-message");
                var mapFieldNameLabel = $(e.currentTarget).attr("data-map-field-names-label");
                var fileNameRequired = $(e.currentTarget).attr("data-list-name-required");
                if ($(".global-modal").find(".js-list-name").val() === "") {
                    alert(fileNameRequired);
                    return false;
                }
                e.preventDefault();
                var formData = new FormData();
                var element = document.getElementById("uploadRecipientList");
                var file = element.files[0];
                if (element.files.length > 0) {
                    formData.append('file', file);
                    formData.append('assignmentIdentifier', assignmentIdentifier);
                    formData.append('uploadType', uploadType);
                    formData.append('listName', $(".global-modal").find(".js-list-name").val());
                    if ($(".global-modal").find(".js-mapped-field-name").length > 0 || $(".global-modal").find("#mappedfieldname").val() !== "") {
                        if ($(".global-modal").find(".js-mapped-field-name").length > 0) {
                            formData.append('emailFieldName', $(".global-modal").find(".js-mapped-field-name").val());
                            $(".global-modal").find("#mappedfieldname").val($(".global-modal").find(".js-mapped-field-name").val());
                        }
                        else {
                            formData.append('emailFieldName', $(".global-modal").find("#mappedfieldname").val());
                        }
                        if ($(".global-modal").find("#mappedfieldname").val() !== "") {
                            formData.append('confirm', "map");
                        }
                        else {
                            formData.append('confirm', "true");
                        }
                    }
                    else {
                        formData.append('confirm', "true");
                    }
                    var url = ("/EmailCampaign/UploadEmailRecipients");
                    $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
                        waitingDialog.hide();
                        if (data != null) {
                            var result = "";
                            $(tableBody).empty();
                            if (data.errorMessage.length != 0) {
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                                result += "<tr>";
                                result += "<td colspan='2'>" + data.errorMessage + "</td>";
                                result += "</tr>";
                            }
                            else {
                                $(fileUploadContainer).addClass("hide");
                                $(confirmContainer).removeClass("hide");
                                $(confirmContainer).find(".js-confirm-file").removeClass("hide");
                                $(confirmContainer).find(".js-map-email-file").addClass("hide");
                                result += "<tr>";
                                result += "<td>" + data.numberOfEntries + " </td>";
                                result += "<td>" + $(confirmContainer).attr("data-list-number-of-entries") + " </td>";
                                result += "</tr>";
                                if (data.missingFieldsCount > 0) {
                                    result += "<tr>";
                                    result += "<td>" + data.missingFieldsCount + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-missing-field") +
                                        " </td>";
                                    result += "</tr>";
                                }
                                if (data.entriesWithMissingData > 0) {
                                    result += "<tr>";
                                    result += "<td>" + data.entriesWithMissingData + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-missing-data") +
                                        " </td>";
                                    result += "</tr>";
                                }
                                if (data.entriesWithInvalidEmailData) {
                                    result += "<tr>";
                                    result += "<td>" + data.entriesWithInvalidEmailData + " </td>";
                                    result += "<td>" +
                                        $(confirmContainer).attr("data-list-number-of-entries-with-invalid-email") +
                                        " </td>";
                                    result += "</tr>";
                                }
                            }
                            $(tableBody).html(result);
                        }
                    }));
                }
                else {
                    waitingDialog.hide();
                    bootbox.alert(noSelectedFileMessage);
                    return false;
                }
            });
            $(".global-modal").find(".js-confirm-file").on('click', function (e) {
                e.preventDefault();
                var assignmentIdentifier = $(e.currentTarget).attr("data-product-catalog-assignment-identifier");
                var uploadType = $(e.currentTarget).attr("data-upload-type");
                var noSelectedFileMessage = $(e.currentTarget).attr("data-no-file-selected-message");
                var fileNameRequired = $(e.currentTarget).attr("data-list-name-required");
                if ($(".global-modal").find(".js-list-name").val() == "") {
                    alert(fileNameRequired);
                    $(e.currentTarget).prop("disabled", false);
                    waitingDialog.hide();
                    return false;
                }
                e.preventDefault();
                var formData = new FormData();
                var element = document.getElementById("uploadRecipientList");
                var file = element.files[0];
                if (element.files.length > 0) {
                    $(e.currentTarget).prop("disabled", true);
                    waitingDialog.show("");
                    formData.append('file', file);
                    formData.append('assignmentIdentifier', assignmentIdentifier);
                    formData.append('uploadType', uploadType);
                    formData.append('listName', $(".global-modal").find(".js-list-name").val());
                    if ($(".global-modal").find(".js-mapped-field-name").length > 0 || $(".global-modal").find("#mappedfieldname").val() !== "") {
                        if ($(".global-modal").find(".js-mapped-field-name").length > 0) {
                            formData.append('emailFieldName', $(".global-modal").find(".js-mapped-field-name").val());
                            $(".global-modal").find("#mappedfieldname").val($(".global-modal").find(".js-mapped-field-name").val());
                        }
                        else {
                            formData.append('emailFieldName', $(".global-modal").find("#mappedfieldname").val());
                        }
                        formData.append('confirm', "true");
                    }
                    else {
                        formData.append('confirm', "true");
                    }
                    var url = ("/EmailCampaign/UploadEmailRecipients");
                    $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
                        if (data != null) {
                            var result = "";
                            $(tableBody).empty();
                            if (data.errorMessage.length != 0) {
                                $(confirmContainer).find(".js-confirm-file").addClass("hide");
                                result += "<tr>";
                                result += "<td colspan='2'>" + data.errorMessage + "</td>";
                                result += "</tr>";
                                $(tableBody).html(result);
                                waitingDialog.hide();
                                return false;
                            }
                            else {
                                $(e.currentTarget).prop("disabled", false);
                                waitingDialog.hide();
                                $(button).attr("data-contact-list-id", data.contactListId);
                                $(button).attr("data-contact-list-name", data.contactListName);
                                var dropdown = uploadType === "seed" ? $(button).closest(".js-email-send-details-container").find(".js-send-seed-list") : (button).closest(".js-email-send-details-container").find(".js-send-recipient-list");
                                var dropdownclone = uploadType === "seed" ? $(button).closest(".js-email-send-details-container").find(".js-send-seed-list-clone") : (button).closest(".js-email-send-details-container").find(".js-send-recipient-list-clone");
                                var emailListSelector = uploadType === "seed" ? $(button).closest(".js-email-send-details-container").find(".js-email-seed-list-selector").removeClass("hide") : $(button).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector").removeClass("hide");
                                var emailListSelectorButton = uploadType === "seed" ? $(button).closest(".js-email-send-details-container").find(".js-email-seed-list-selector button") : $(button).closest(".js-email-send-details-container").find(".js-email-recipient-list-selector button");
                                $(emailListSelectorButton).removeAttr("data-contact-list-id");
                                $(emailListSelectorButton).attr("data-contact-list-id", data.contactListId);
                                if ($(dropdown).length > 0) {
                                    $(dropdown).empty();
                                    $(dropdown).append($("<option />").val("").text(""));
                                    $.each(data.contactLists, function () {
                                        $('<option>').val(this.id).text(this.name.split("|")[0]).attr('data-number-contacts', this.numberOfContacts).appendTo($(dropdown));
                                    });
                                    $(dropdown).val(data.contactListId);
                                }
                                if ($(dropdownclone).length > 0) {
                                    $(dropdownclone).empty();
                                    $(dropdownclone).append($("<option />").val("").text(""));
                                    $.each(data.contactLists, function () {
                                        $('<option>').val(this.id).text(this.name.split("|")[0]).attr('data-number-contacts', this.numberOfContacts).appendTo($(dropdownclone));
                                    });
                                    $(dropdownclone).val(data.contactListId);
                                }
                                //$(dropdown).on("click", function (e) {
                                //	e.preventDefault();
                                //	if ($(e.currentTarget).attr("data-contact-list-id") !== "") {
                                //		me.openEmailUploadedListRecipients($(e.currentTarget));
                                //	}
                                //});
                                me._globalModal.closeGlobalModal();
                            }
                        }
                        else {
                            $(e.currentTarget).prop("disabled", false);
                            waitingDialog.hide();
                        }
                    }));
                }
                else {
                    $(e.currentTarget).prop("disabled", false);
                    waitingDialog.hide();
                    bootbox.alert(noSelectedFileMessage);
                    return false;
                }
            });
        }));
    }
    CheckIsEmailInVerifiedDomain(text, item, isReposted) {
        waitingDialog.show("");
        var me = this;
        var verifyEmailContainer = $(text).closest(".js-verify-email-container");
        $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
        $(verifyEmailContainer).attr("data-sender-verified", "false");
        var linkFromConfirmationEmailContainer = $(verifyEmailContainer).find(".js-link-from-confirmation-email-container");
        var fromEmail = $(item).find(".js-custom-sender-field").val() !== "" ? $.trim((item).find(".js-custom-sender-field").val()).toLowerCase() : "";
        $(verifyEmailContainer).attr("data-sender-verified", "false");
        var verifiedMessage = $(text).attr("data-confirm-message");
        var invalidEmailMessage = $(item).find(".js-custom-sender-field").attr("data-invalid-email-message");
        if (fromEmail === "") {
            bootbox.alert($(item).find(".js-custom-sender-field").attr("data-required-message"));
            waitingDialog.hide();
            return false;
        }
        if (!me.IsValidFromEmailAddress(fromEmail)) {
            bootbox.alert($(item).find(".js-custom-sender-field").attr("data-invalid-email-message"));
            waitingDialog.hide();
            return false;
        }
        var verifiedDomainList = $(text).attr("data-verified-domain-list");
        if (verifiedDomainList != "") {
            var restrictToVerifiedDomainsOnly = $(text).attr("data-restrict-to-verified-domains-only");
            var isValidDomainForEmail = false;
            var domain = fromEmail.split("@")[1];
            if (verifiedDomainList != "") {
                var verifiedDomainListArray = verifiedDomainList.split(',');
                if (verifiedDomainListArray.length > 0 && verifiedDomainListArray.indexOf(domain) !== -1) {
                    isValidDomainForEmail = true;
                    waitingDialog.hide();
                    //bootbox.alert(verifiedMessage);
                    $(verifyEmailContainer).find(".js-verified-icon").removeClass("hide");
                    $(verifyEmailContainer).attr("data-sender-verified", "true");
                    return false;
                }
                if (!isValidDomainForEmail && restrictToVerifiedDomainsOnly == 'true') {
                    bootbox.alert($(text).attr("data-domain-mismatch-message"));
                    waitingDialog.hide();
                    return false;
                }
            }
        }
    }
    SendCreateRequest(button, item, isReposted) {
        waitingDialog.show("");
        var me = this;
        var verifyEmailContainer = $(button).closest(".js-verify-email-container");
        var linkFromConfirmationEmailContainer = $(verifyEmailContainer).find(".js-link-from-confirmation-email-container");
        var fromEmail = $(item).find(".js-custom-sender-field").val() !== "" ? $.trim((item).find(".js-custom-sender-field").val()).toLowerCase() : "";
        $(verifyEmailContainer).attr("data-sender-verified", "false");
        var verifiedMessage = $(button).attr("data-confirm-message");
        var invalidEmailMessage = $(item).find(".js-custom-sender-field").attr("data-invalid-email-message");
        if (fromEmail === "") {
            bootbox.alert($(item).find(".js-custom-sender-field").attr("data-required-message"));
            waitingDialog.hide();
            return;
        }
        if (!me.IsValidFromEmailAddress(fromEmail)) {
            bootbox.alert($(item).find(".js-custom-sender-field").attr("data-invalid-email-message"));
            waitingDialog.hide();
            return;
        }
        var verifiedDomainList = $(button).attr("data-verified-domain-list");
        var restrictToVerifiedDomainsOnly = $(button).attr("data-restrict-to-verified-domains-only");
        if (verifiedDomainList != "") {
            var isValidDomainForEmail = false;
            var domain = fromEmail.split("@")[1];
            var verifiedDomainListArray = verifiedDomainList.split(',');
            if (verifiedDomainListArray.length > 0 && verifiedDomainListArray.indexOf(domain) !== -1) {
                isValidDomainForEmail = true;
                waitingDialog.hide();
                bootbox.alert(verifiedMessage);
                $(verifyEmailContainer).find(".js-verified-icon").removeClass("hide");
                $(verifyEmailContainer).attr("data-sender-verified", "true");
                return false;
            }
            if (!isValidDomainForEmail && restrictToVerifiedDomainsOnly == 'true') {
                bootbox.alert($(button).attr("data-domain-mismatch-message"));
                waitingDialog.hide();
                return false;
            }
        }
        var caller = $(button).attr("data-button-identifier");
        $(verifyEmailContainer).find(".js-verify-sender").removeAttr("disabled");
        var fromAddress = $(item).find(".js-custom-sender-field").val();
        var sendGridConfirmationLinkDTO = {
            fromAddress: fromAddress
        };
        var verifyFromAddressAft = getAntiForgeryToken();
        $.ajax({
            method: "POST",
            url: "/SendGridVerification/VerifyFromAddress",
            data: JSON.stringify(sendGridConfirmationLinkDTO),
            cache: false,
            traditional: true,
            contentType: "application/json; charset=utf-8",
            headers: {
                'RequestVerificationToken': verifyFromAddressAft
            }
        }).done(function (data) {
            if (data != null) {
                if (data.userExists) {
                    if (data.isVerified) {
                        alert(verifiedMessage);
                        me.SetVerificationData(verifyEmailContainer, data);
                        waitingDialog.hide();
                    }
                    else {
                        me.OpenSendGridConfirmationLinkModal(caller, fromAddress);
                        waitingDialog.hide();
                    }
                }
                else {
                    if (isReposted) {
                        var submitContainer = $(".global-modal").find(".submit-sender-information-container");
                        var dto = {
                            nickName: $(submitContainer).find("#nickname").val(),
                            from_Email: $(submitContainer).find("#fromemail").val(),
                            from_Name: $(submitContainer).find("#displayname").val(),
                            reply_To: $(submitContainer).find("#replyto").val(),
                            address: $(submitContainer).find("#address").val(),
                            city: $(submitContainer).find("#city").val(),
                            country: $(submitContainer).find("#country").val(),
                        };
                        var url = '/SendGridVerification/CreateVerifiedSenderRequest';
                        $.when(submitAjaxRequest(dto, url, "POST").done(function (data) {
                            me._globalModal.closeGlobalModal();
                            if (data != null) {
                                if (data.isNewUserCreated) {
                                    if (data.userCreated.verified == false) {
                                        me.OpenSendGridConfirmationLinkModal(caller, fromAddress);
                                        waitingDialog.hide();
                                    }
                                    else {
                                        me.SetVerificationData(verifyEmailContainer, data);
                                        waitingDialog.hide();
                                    }
                                }
                                else {
                                    if (data.error != null) {
                                        if (data.error.errors.length > 0) {
                                            if (data.error.errors[0].field != null) {
                                                bootbox.alert(data.error.errors[0].field + " " + data.error.errors[0].message);
                                            }
                                            else {
                                                bootbox.alert(data.error.errors[0].message);
                                            }
                                            waitingDialog.hide();
                                            return;
                                        }
                                    }
                                    if (data.exceptionErrors !== "") {
                                        bootbox.alert(data.exceptionErrors);
                                        $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
                                        waitingDialog.hide();
                                        return;
                                    }
                                    if (data.canSendRequestAgain) {
                                        me.SendCreateRequest(button, item, true);
                                    }
                                }
                            }
                        }));
                    }
                    else {
                        var sendGridConfirmationLinkDTO = {
                            fromAddress: fromAddress
                        };
                        var getSenderInformationFormAft = getAntiForgeryToken();
                        $.ajax({
                            method: "POST",
                            url: "/SendGridVerification/GetSenderInformationForm",
                            data: JSON.stringify(sendGridConfirmationLinkDTO),
                            cache: false,
                            traditional: true,
                            contentType: "application/json; charset=utf-8",
                            headers: {
                                'RequestVerificationToken': getSenderInformationFormAft
                            }
                        }).done(function (data) {
                            waitingDialog.hide();
                            if (data != null) {
                                var options = {
                                    classes: "configure-sender-information-modal ",
                                };
                                me._globalModal.openGlobalModal(data, "panel", options);
                                $(".global-modal").find(".js-submit-sender-information").attr("caller", caller);
                                $(".global-modal").find(".js-submit-sender-information").on("click", function (e) {
                                    var submitContainer = $(".global-modal").find(".submit-sender-information-container");
                                    var errorMessage = "";
                                    if ($(submitContainer).find("#nickname").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-nickname-required-message") + "</br>";
                                    }
                                    if ($(submitContainer).find("#replyTo").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-replyto-required-message") + "</br>";
                                    }
                                    if ($(submitContainer).find("#displayname").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-displayname-required-message") + "</br>";
                                    }
                                    if ($(submitContainer).find("#address").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-address-required-message") + "</br/>";
                                    }
                                    if ($(submitContainer).find("#city").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-city-required-message") + "</br>";
                                    }
                                    if ($(submitContainer).find("#country").val() === "") {
                                        errorMessage += $(submitContainer).attr("data-country-required-message") + "</br>";
                                    }
                                    if (errorMessage !== "") {
                                        bootbox.alert(errorMessage);
                                        waitingDialog.hide();
                                        return;
                                    }
                                    else {
                                        var dto = {
                                            nickName: $(submitContainer).find("#nickname").val(),
                                            from_Email: $(submitContainer).find("#fromemail").val(),
                                            from_Name: $(submitContainer).find("#displayname").val(),
                                            reply_To: $(submitContainer).find("#replyto").val(),
                                            address: $(submitContainer).find("#address").val(),
                                            city: $(submitContainer).find("#city").val(),
                                            country: $(submitContainer).find("#country").val(),
                                        };
                                        var url = '/SendGridVerification/CreateVerifiedSenderRequest';
                                        $.when(submitAjaxRequest(dto, url, "POST").done(function (data) {
                                            if (data != null) {
                                                if (data.isNewUserCreated) {
                                                    if (data.userCreated.verified == false) {
                                                        me.OpenSendGridConfirmationLinkModal(caller, fromAddress);
                                                        waitingDialog.hide();
                                                    }
                                                    else {
                                                        me.SetVerificationData(verifyEmailContainer, data);
                                                        waitingDialog.hide();
                                                    }
                                                    me._globalModal.closeGlobalModal();
                                                }
                                                else {
                                                    if (data.error != null) {
                                                        if (data.error.errors.length > 0) {
                                                            if (data.error.errors[0].field != null) {
                                                                bootbox.alert(data.error.errors[0].field + " " + data.error.errors[0].message);
                                                            }
                                                            else {
                                                                bootbox.alert(data.error.errors[0].message);
                                                            }
                                                            me._globalModal.closeGlobalModal();
                                                            waitingDialog.hide();
                                                            return;
                                                        }
                                                    }
                                                    if (data.exceptionErrors != "") {
                                                        bootbox.alert(data.exceptionErrors);
                                                        $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
                                                        waitingDialog.hide();
                                                        me._globalModal.closeGlobalModal();
                                                        return;
                                                    }
                                                    if (data.canSendRequestAgain) {
                                                        me.SendCreateRequest(button, item, true);
                                                    }
                                                }
                                            }
                                        }));
                                    }
                                });
                            }
                        });
                    }
                }
            }
        });
    }
    SetVerificationData(verifyEmailContainer, data) {
        $(verifyEmailContainer).find(".js-verified-icon").removeClass("hide");
        $(verifyEmailContainer).attr("data-sender-verified", "true");
        if (data.isNewUserCreated) {
            $(verifyEmailContainer).closest(".js-email-configuration-container").find(".js-reply-to").val(data.userCreated.reply_To);
            $(verifyEmailContainer).closest(".js-email-configuration-container").find(".js-from-name").val(data.userCreated.from_Name);
        }
        else if (data.existingUser != null) {
            $(verifyEmailContainer).closest(".js-email-configuration-container").find(".js-reply-to").val(data.existingUser.reply_To);
            $(verifyEmailContainer).closest(".js-email-configuration-container").find(".js-from-name").val(data.existingUser.from_Name);
        }
    }
    IsValidFromEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }
    OpenSendGridConfirmationLinkModal(caller, fromAddress) {
        waitingDialog.hide();
        var me = this;
        var sendGridConfirmationLinkDTO = {
            fromAddress: fromAddress
        };
        var getConfirmationLinkFormaft = getAntiForgeryToken();
        $.ajax({
            method: "POST",
            url: "/SendGridVerification/GetConfirmationLinkForm",
            data: JSON.stringify(sendGridConfirmationLinkDTO),
            cache: false,
            traditional: true,
            contentType: "application/json; charset=utf-8",
            headers: {
                'RequestVerificationToken': getConfirmationLinkFormaft
            }
        }).done(function (data) {
            if (data != null) {
                var options = {
                    classes: "configure-sender-confirmation-modal",
                };
                me._globalModal.openGlobalModal(data, "panel", options);
                $(".global-modal").find(".js-verify-confirmation-link").attr("caller", caller);
                $(".global-modal").find(".js-verify-confirmation-link").on("click", function (e) {
                    e.preventDefault();
                    var buttonId = $(e.currentTarget).attr("caller");
                    var verifyEmailContainer = $("[data-button-identifier=" + buttonId + "]").closest(".js-verify-email-container");
                    var verifiedMessage = $(".global-modal").find(".submit-confirmation-link-container").attr("data-confirm-message");
                    var errorMessage = $(".global-modal").find(".submit-confirmation-link-container").attr("data-confirm-error-message");
                    $(verifyEmailContainer).attr("data-sender-verified", "false");
                    var fromEmail = $(e.currentTarget).attr("data-from-email-address");
                    var sendGridConfirmationLinkDTO = {
                        url: $(".global-modal").find(".js-link-from-confirmation-email").val(),
                        fromEmail: fromEmail
                    };
                    var url = "/SendGridVerification/VerifySenderRequest";
                    $.when(submitAjaxRequest(sendGridConfirmationLinkDTO, url, "POST").done(function (data) {
                        if (data != null) {
                            if (data.isVerified) {
                                $(verifyEmailContainer).attr("data-sender-verified", "true");
                                $(verifyEmailContainer).find(".js-verified-icon").removeClass("hide");
                                me._globalModal.closeGlobalModal();
                                $(".global-modal").find(".js-link-from-confirmation-email").val("");
                                me.SetVerificationData(verifyEmailContainer, data);
                                alert(verifiedMessage);
                            }
                            else if (!data.isVerified) {
                                bootbox.alert(errorMessage);
                                $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
                                $(verifyEmailContainer).attr("data-sender-verified", "false");
                                $(".global-modal").find(".js-link-from-confirmation-email").val("");
                            }
                            else if (data.exceptionErrors != "") {
                                bootbox.alert(data.exceptionErrors);
                                $(verifyEmailContainer).find(".js-verified-icon").addClass("hide");
                            }
                        }
                        else {
                        }
                    }));
                });
            }
            else {
            }
        });
    }
    openDirectMailUploadedListRecipients(button) {
        var me = this;
        var contactListId = $(button).attr("data-contact-list-id");
        waitingDialog.show("");
        $.ajax({
            method: "GET",
            url: "/DirectMail/GetDirectMailUploadedListRecipientsByContactId/" + contactListId
        }).done(function (data, textStatus, request) {
            waitingDialog.hide();
            if (data) {
                var globalModal = new GlobalModal(contactListId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-direct-mail-uploaded-list-recipients").attr("data-contact-list-id", contactListId);
                $(".global-modal-inner-container").find(".js-download-direct-mail-uploaded-list-recipients").click(function (e) {
                    var contactListId = $(e.currentTarget).attr("data-contact-list-id");
                    window.location.href = "/Catalog/ProductCustomization/DownloadDirectMailUploadedListRecipientsByContactId/" + contactListId + "/" + $(".global-modal-inner-container").find(".js-directmailuploadedlistrecipientsdownloadfiletype").val();
                });
            }
            else {
                waitingDialog.hide();
            }
        });
        waitingDialog.hide();
    }
    openEmailUploadedListRecipients(button) {
        var me = this;
        var contactListId = $(button).attr("data-contact-list-id");
        waitingDialog.show("");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetEmailUploadedListRecipientsByContactId/" + contactListId
        }).done(function (data, textStatus, request) {
            waitingDialog.hide();
            if (data) {
                var globalModal = new GlobalModal(contactListId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").attr("data-contact-list-id", contactListId);
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").click(function (e) {
                    var contactListId = $(e.currentTarget).attr("data-contact-list-id");
                    window.location.href = "/EmailCampaign/DownloadEmailUploadedListRecipientsByContactId/" + contactListId + "/" + $(".global-modal-inner-container").find(".js-emailuploadedlistrecipientsdownloadfiletype").val();
                });
            }
            else {
                waitingDialog.hide();
            }
        });
        waitingDialog.hide();
    }
    GetUploadModal(uploadType, assignmentIdentifier, locale) {
        return $.ajax({
            method: "GET",
            url: '/EmailCampaign/GetListUpload/' + uploadType + "/" + assignmentIdentifier + "/" + locale,
        });
    }
    GetDirectMailUploadModal(assignmentIdentifier, locale) {
        return $.ajax({
            method: "GET",
            url: '/DirectMail/GetDirectMailListUpload/' + assignmentIdentifier + "/" + locale,
        });
    }
    bindLocalizedTime() {
        var me = this;
        $.each($(me._widget).find(".localized-time-email-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + "  <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
        });
    }
    buildParams() {
        var params = {
            Identifier: this._identifier,
            ProductId: this._productId,
            Quantity: $(this._widget).find(".quantity-input").val(),
            Attributes: [],
            OrderNow: 0,
            CheckSkuExists: true
        };
        var me = this;
        $.each($(this._widget).find(".attribute-selector"), function (index, item) {
            if ($(this).find(":selected").val() !== "") {
                params.Attributes.push($(this).find(":selected").val());
            }
        });
        return params;
    }
}
class Checkout {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    GetParticipantInfo() {
        return $.ajax({
            //contentType: "application/json",
            method: "GET",
            url: '/Api/ShoppingCart/GetItemsDetailsInCart'
        });
    }
    canProceedToSubmit(button) {
        var me = this;
        var participantInfo = $(me._widget).find(".cart-participant-info");
        var noItemsInforow = $(me._widget).find(".shoppingcart-notiemsincart");
        var shoppingCartUrl = $(button).attr("data-shopping-cart-url");
        var midQuantityAllowedMessage = $(button).attr("data-mid-quantity-allowed-for-cart-message");
        var minQuantityAllowedMessage = $(button).attr("data-min-quantity-allowed-for-cart-message");
        var maxQuantityAllowedMessage = $(button).attr("data-max-quantity-allowed-for-cart-message");
        var minQuantityAllowed = $(button).attr("data-min-quantity-per-order");
        var maxQuantityAllowed = $(button).attr("data-max-quantity-per-order");
        var proceed1 = true;
        var proceed2 = true;
        if ($(me._widget).find("#cartItemCount").val() !== "0" || $(me._widget).find("#cartItemCount").val() !== "") {
            var items = [];
            $(me._widget).find(".checkout-item-row").each(function () {
                var item = {
                    Quantity: parseInt($(this).find(".quantitytext").html())
                };
                if (item.Quantity < parseInt(minQuantityAllowed)) {
                    proceed1 = false;
                }
                if (item.Quantity > parseInt(maxQuantityAllowed) && parseInt(maxQuantityAllowed) != -1) {
                    proceed2 = false;
                }
            });
            if (!proceed1 && !proceed2) {
                $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
                alert(midQuantityAllowedMessage);
                return false;
            }
            else if (!proceed1) {
                $('#ItemQuantity').val(Math.max(parseInt(minQuantityAllowed), 1));
                alert(minQuantityAllowedMessage);
                return false;
            }
            else if (!proceed2) {
                $('#ItemQuantity').val(Math.max(parseInt(maxQuantityAllowed), 0));
                alert(maxQuantityAllowedMessage);
                return false;
            }
        }
        return true;
    }
    AddOrder(btn) {
        var me = this;
        if (!me.canProceedToSubmit(btn)) {
            return false;
        }
        var addressId = $(me._widget).find("#address-list").val() != null ? parseInt($(me._widget).find("#address-list").val()) : 0;
        if (addressId === 0 && $(btn).attr("data-should-check-address") == "True") {
            var addressRequiredMessage = $(btn).attr("data-address-required-message");
            bootbox.alert(addressRequiredMessage);
            $(btn).removeAttr('disabled');
            btn.button('reset');
            return;
        }
        var OrderNotesRequired = $(me._widget).find("#shopping-cart-order-notes-required").val() === "true";
        var OrderNotes = $(me._widget).find("#OrderNotes").val();
        if (OrderNotes == undefined)
            OrderNotes = "";
        if (OrderNotesRequired && OrderNotes.trim() === "") {
            alert("Order Notes are required");
            $(btn).removeAttr('disabled');
            btn.button('reset');
            return;
        }
        var cartUrl = $(btn).attr("data-cart-url");
        var orderUrl = $(btn).attr("data-order-detail-url");
        var firstName = $(me._widget).find("#hidden-first-name").val();
        var lastName = $(me._widget).find("#hidden-last-name").val();
        $(".btn-submitorder").attr('disabled', 'disabled');
        if ($(btn).attr("data-should-check-address") == "False") {
            addressId = 0;
        }
        var params = {
            "addressId": addressId, "OrderNotes": OrderNotes, "FirstName": firstName, "LastName": lastName
        };
        var url = '/Api/ParticipantOrder/AddOrder';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data) {
            $(".btn-submitorder").removeAttr('disabled');
            if (data.status == "OK" && data.participantOrderId > 0) {
                $(me._widget).find(".js-checkout-order-notes").hide();
                var detailLink = $(me._widget).find(".panel-thankyou").find(".order-detail-link").attr("href");
                detailLink += data.identifier;
                window.location.href = detailLink;
                btn.button('reset');
            }
            else {
                alert(data.status);
                btn.button('reset');
                if (data.cartUrl != undefined)
                    window.location.href = data.cartUrl;
            }
        }));
    }
    GetDistributorAddresses() {
        return $.ajax({
            method: "GET",
            url: '/Api/Checkout/GetDistributorAddress'
        });
    }
    GetAddressForm(addressId, showNames) {
        return $.ajax({
            method: "GET",
            url: '/Api/Checkout/GetAddressForm',
            data: { addressId: addressId, showNames: showNames }
        });
    }
    ShowAddressForm(btn, container, mode, action) {
        var me = this;
        var sourceButton = btn;
        var addressId = "";
        if (mode == "edit") {
            addressId = $(container).find("#address-list").val();
        }
        if ((addressId == "" || addressId == "0") && mode == "edit") {
            bootbox.alert($(btn).attr("data-select-address-to-edit-message"));
            return false;
        }
        var showNames = $(btn).data('display-names');
        $.when(me.GetAddressForm(addressId, showNames).done(function (data, textStatus, response) {
            if (data) {
                var options = {
                    classes: "checkout-address-modal",
                    origin: $(sourceButton)
                };
                me._globalModal.openGlobalModal(data.responseMessage, "modal", options);
                $(".global-modal").find(".js-add-new-shippingaddress").on('click', function (e) {
                    e.preventDefault();
                    if (me.ValidateShippingAddress()) {
                        var address = $(".global-modal").find("#address").val();
                        var address2 = $(".global-modal").find("#address2").val();
                        var city = $(".global-modal").find("#city").val();
                        var state = $(".global-modal").find("#state").val().substring(5);
                        var zipCode = $(".global-modal").find("#zipCode").val();
                        var country = $(".global-modal").find("#country").val().substring(0, 4);
                        var phoneNumber = $(".global-modal").find("#phonenumber").val();
                        var addressId = $(".global-modal").find("#addressId").val();
                        var addressName = $(".global-modal").find("#addressName").val();
                        var companyName = $(".global-modal").find("#companyName").val();
                        var firstName = $(".global-modal").find("#firstName").val();
                        var lastName = $(".global-modal").find("#lastName").val();
                        var email = $(".global-modal").find("#email").val();
                        var saveAddressButton = this;
                        me.AddParticipantAddress(addressId, firstName, lastName, companyName, addressName, address, address2, city, state, zipCode, country, phoneNumber, saveAddressButton, me._widget, action, email);
                    }
                });
            }
        }));
    }
    ValidateShippingAddress() {
        var _a, _b, _c, _d, _e, _f;
        var isValid = true;
        var message = "";
        // validators  
        var validators = $(".global-modal").find("#country option:selected").data('validators');
        var emailValidator = "[\\u00C0\\u00C2\\u00C4\\u00C7\\u00C8\\u00C9\\u00CA\\u00CB\\u00CE\\u00CF\\u00D4\\u00DA\\u00DB\\u00E0\\u00E2\\u00E4\\u00E7\\u00E8\\u00E9\\u00EA\\u00EB\\u00EE\\u00EF\\u00F4\\u00FA\\u00FBa-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?";
        var zipValidator = "";
        var phoneValidator = "";
        if (validators != undefined && validators != null && validators != "") {
            emailValidator = (_b = (_a = validators === null || validators === void 0 ? void 0 : validators.email) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "[\\u00C0\\u00C2\\u00C4\\u00C7\\u00C8\\u00C9\\u00CA\\u00CB\\u00CE\\u00CF\\u00D4\\u00DA\\u00DB\\u00E0\\u00E2\\u00E4\\u00E7\\u00E8\\u00E9\\u00EA\\u00EB\\u00EE\\u00EF\\u00F4\\u00FA\\u00FBa-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?";
            zipValidator = (_d = (_c = validators === null || validators === void 0 ? void 0 : validators.postal) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "";
            phoneValidator = (_f = (_e = validators === null || validators === void 0 ? void 0 : validators.phone) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : "";
        }
        // required and validation
        if ($(".global-modal").find("#address").attr("data-attribute-required-to-save") == "REQUIRED" && $(".global-modal").find("#address").is(":visible")) {
            if ($(".global-modal").find("#address").val() == "") {
                message += $(".global-modal").find("#address").data("required");
                isValid = false;
            }
        }
        if ($(".global-modal").find("#address2").attr("data-attribute-required-to-save") == "REQUIRED" && $(".global-modal").find("#address").is(":visible")) {
            if ($(".global-modal").find("#address2").val() == "") {
                message += "\n" + $(".global-modal").find("#address2").data("required");
                isValid = false;
            }
        }
        if ($(".global-modal").find("#city").attr("data-attribute-required-to-save") == "REQUIRED" && $(".global-modal").find("#city").is(":visible")) {
            if ($(".global-modal").find("#city").val() == "") {
                message += "\n" + $(".global-modal").find("#city").data("required");
                isValid = false;
            }
        }
        if ($(".global-modal").find("#state").attr("data-attribute-required-to-save") == "REQUIRED" && $(".global-modal").find("#state").is(":visible")) {
            if ($(".global-modal").find("#state").val() == "") {
                var countryId = $(".global-modal #country").val().substring(0, 4);
                var found = false;
                $('.global-modal').find('#state > option').each(function () {
                    if (this.value.substring(0, 4) === countryId && this.value !== "") {
                        found = true;
                    }
                });
                if (found) {
                    message += "\n" + $(".global-modal").find("#state").data("required");
                    isValid = false;
                }
            }
        }
        if ($(".global-modal").find("#zipCode").is(":visible")) {
            if ($(".global-modal").find("#zipCode").attr("data-attribute-required-to-save") == "REQUIRED") {
                if ($(".global-modal").find("#zipCode").val() == "") {
                    message += "\n" + $(".global-modal").find("#zipCode").data("required");
                    isValid = false;
                }
                if ($(".global-modal").find("#zipCode").val() !== "" && zipValidator != "") {
                    var regex = new RegExp(zipValidator);
                    if (regex.test($(".global-modal").find("#zipCode").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#zipCode").data("invalid");
                        isValid = false;
                    }
                }
            }
            else if ($(".global-modal").find("#zipCode").attr("data-attribute-required-to-save") == "OPTIONAL") {
                if ($(".global-modal").find("#zipCode").val() !== "" && zipValidator != "") {
                    var regex = new RegExp(zipValidator);
                    if (regex.test($(".global-modal").find("#zipCode").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#zipCode").data("invalid");
                        isValid = false;
                    }
                }
            }
        }
        if ($(".global-modal").find("#country").attr("data-attribute-required-to-save") == "REQUIRED" && $(".global-modal").find("#country").is(":visible")) {
            if ($(".global-modal").find("#country").val() == "") {
                message += "\n" + $(".global-modal").find("#country").data("required");
                isValid = false;
            }
        }
        if ($(".global-modal").find("#email").is(":visible")) {
            if ($(".global-modal").find("#email").attr("data-attribute-required-to-save") == "REQUIRED") {
                if ($(".global-modal").find("#email").val() == "") {
                    message += "\n" + $(".global-modal").find("#email").data("required");
                    isValid = false;
                }
                if ($(".global-modal").find("#email").val() !== "" && emailValidator != "") {
                    var regex = new RegExp(emailValidator);
                    if (regex.test($(".global-modal").find("#email").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#email").data("invalid");
                        isValid = false;
                    }
                }
            }
            else if ($(".global-modal").find("#email").attr("data-attribute-required-to-save") == "OPTIONAL") {
                if ($(".global-modal").find("#email").val() !== "" && emailValidator != "") {
                    var regex = new RegExp(emailValidator);
                    if (regex.test($(".global-modal").find("#email").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#email").data("invalid");
                        isValid = false;
                    }
                }
            }
        }
        if ($(".global-modal").find("#phonenumber").is(":visible")) {
            if ($(".global-modal").find("#phonenumber").attr("data-attribute-required-to-save") == "REQUIRED") {
                if ($(".global-modal").find("#phonenumber").val() == "") {
                    message += "\n" + $(".global-modal").find("#phonenumber").data("required");
                    isValid = false;
                }
                if ($(".global-modal").find("#phonenumber").val() !== "" && phoneValidator != "") {
                    var regex = new RegExp(phoneValidator);
                    if (regex.test($(".global-modal").find("#phonenumber").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#phonenumber").data("invalid");
                        isValid = false;
                    }
                }
            }
            else if ($(".global-modal").find("#phonenumber").attr("data-attribute-required-to-save") == "OPTIONAL") {
                if ($(".global-modal").find("#phonenumber").val() !== "" && phoneValidator != "") {
                    var regex = new RegExp(phoneValidator);
                    if (regex.test($(".global-modal").find("#phonenumber").val())) {
                        //valid
                    }
                    else {
                        message += "\n" + $(".global-modal").find("#phonenumber").data("invalid");
                        isValid = false;
                    }
                }
            }
        }
        //var shippingInputs = [];
        //$(".global-modal").find(".js-address-group").each(function (index, elem) {
        //    if ($(this).attr("data-attribute-required-to-save") == "OPTIONAL" && $(this).val() !== "") {
        //        shippingInputs.push(jQuery(this).attr("id"));
        //        isValid = false;
        //    }
        //});
        //if (shippingInputs.length > 0) {
        //    $(".global-modal").find(".js-address-group").each(function (index, elem) {
        //        if ($(this).attr("data-attribute-required-to-save") == "OPTIONAL" && $(this).val() === "" && $(this).data("required").length > 0) {
        //            message += "\n" + $(this).data("required");
        //        }
        //    });
        //}
        if (message !== "") {
            alert(message);
        }
        return isValid;
    }
    ShowAddressSelector(btn) {
        var me = this;
        var sourceButton = btn;
        var container = $(me._widget).find(".js-addressselector-container");
        $.when(me.GetDistributorAddresses().done(function (data, textStatus, response) {
            if (data.responseMessage) {
                var options = {
                    origin: $(sourceButton)
                };
                me._globalModal.openGlobalModal(data.responseMessage, "modal", options);
                sourceButton.button('reset');
                $(".global-modal").find(".btn-saveshippingaddress").on('click', function (e) {
                    var saveAddressButton = this;
                    var dropDown = $(".global-modal").find("#shippingaddress-list");
                    var distributorCompanyAddressId = $(dropDown).val();
                    e.preventDefault();
                    me.AddShippingAddress(distributorCompanyAddressId, saveAddressButton, me._widget);
                });
            }
        }));
    }
    // the submit is required because paypal won't allow you to use ajax to modify the amount dynamically
    // changing the amount due to shipping changes can't be done cleanly using ajax.
    // make this call anytime the checkout might change the amount to bill
    RefreshCheckout(me, addressId) {
        var pleaseWaitMessageForcheckout = $(me._widget).find("#checkout-wait-message").val();
        waitingDialog.show(pleaseWaitMessageForcheckout);
        //me._globalModal.closeGlobalModal();        
        $(me._widget).find(".js-selectedAddressid").val(addressId);
        $(me._widget).find(".widget-checkout-form").trigger("submit");
    }
    ;
    AddShippingAddress(distributorCompanyAddressId, saveAddressButton, container) {
        var me = this;
        var modalDialog = $(container).find("#customaddressselector-modal");
        var sourceButton = saveAddressButton;
        var sourceDropDown = $(container).find("#address-list");
        var params = { "distributorCompanyAddressId": parseInt(distributorCompanyAddressId) };
        var url = '/Api/Checkout/SaveParticipantAddressFromDistributor';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data) {
            if (data.status == "OK") {
                me.RefreshCheckout(me, data.selectedAddressId);
            }
            else {
                waitingDialog.hide();
                alert(data.status);
            }
        }));
    }
    AddParticipantAddress(addressId, firstName, lastName, companyName, addressName, address, address2, city, state, zipCode, country, phoneNumber, saveAddressButton, container, action, email) {
        var me = this;
        var editingAddressId = addressId;
        var editAddress = $(container).find(".js-edit-address");
        var deleteAddress = $(container).find(".js-delete-address");
        var noshippinglabel = $(container).find(".js-noshipping-label");
        var sourceButton = saveAddressButton;
        var sourceDropDown = $(container).find("#address-list");
        var params = {
            "addressId": addressId,
            "companyName": companyName,
            "addressName": addressName,
            "address": address,
            "address2": address2,
            "city": city,
            "state": state,
            "zipCode": zipCode,
            "country": country,
            "phoneNumber": phoneNumber,
            "email": email,
            "firstName": firstName,
            "lastName": lastName,
        };
        var url = '/Api/Checkout/SaveParticipantAddress';
        $.when(submitAjaxRequest(params, url, "POST").done(function (data) {
            if (data.status == "OK") {
                me.RefreshCheckout(me, data.selectedAddressId);
            }
            else {
                waitingDialog.hide();
                alert(data.status);
            }
        }));
    }
    DeleteAddress(container, button) {
        var me = this;
        var sourceDropDown = $(container).find("#address-list");
        var editAddress = $(container).find(".js-edit-address");
        var deleteAddress = $(container).find(".js-delete-address");
        var noshippinglabel = $(container).find(".js-noshipping-label");
        var addressId = $(container).find("#address-list").val();
        if (addressId === "" || addressId === null || addressId == undefined || addressId == "0") {
            bootbox.alert($(button).attr("data-select-address-to-delete-message"));
            return false;
        }
        if (addressId !== "" || addressId !== null || addressId !== undefined || addressId !== "0") {
            if (confirm($(deleteAddress).data("message"))) {
                var params = {
                    "addressId": addressId
                };
                var url = '/Api/Checkout/DeleteParticipantAddress';
                $.when(submitAjaxRequest(params, url, "DELETE").done(function (data) {
                    if (data.status == "OK") {
                        me.RefreshCheckout(me, data.selectedAddressId);
                    }
                    else {
                        waitingDialog.hide();
                        alert(data.status);
                    }
                }));
            }
        }
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
        this._globalModal = new GlobalModal(this._widgetId);
    }
    bindControls() {
        var me = this;
        me._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        $(me._widget).find(".btn-submitorder").on("click", function (e) {
            var btn = $(this);
            if (me.canProceedToSubmit) {
                btn.button('loading');
                if ($(me._widget).find(".js-addressRequired").val() === "True") {
                    e.preventDefault();
                    var address = $(me._widget).find("#address-list");
                    if ($(address).children('option').length == 0) {
                        bootbox.alert($(btn).attr("data-add-new-address-required-message"));
                        return false;
                    }
                    else {
                        me.AddOrder(btn);
                    }
                }
                else {
                    me.AddOrder(btn);
                }
            }
        });
        var container = $(me._widget).find(".js-addressselector-container");
        $(me._widget).find(".btn-addnewaddress").on("click", function (e) {
            e.preventDefault();
            var btn = $(this);
            //btn.button('loading')
            me.ShowAddressSelector(btn);
        });
        $(me._widget).find(".js-add-new-address").on("click", function (e) {
            e.preventDefault();
            me.ShowAddressForm($(this), me._widget, "add", "normal");
        });
        $(me._widget).find(".js-add-new-address_hidden").on("click", function (e) {
            e.preventDefault();
            me.ShowAddressForm($(this), me._widget, "add", "silent");
        });
        $(me._widget).find(".js-address-list").on("change", function (e) {
            var addressId = $(me._widget).find("#address-list").val();
            me.RefreshCheckout(me, addressId);
        });
        $(me._widget).find(".js-edit-address").on("click", function (e) {
            e.preventDefault();
            me.ShowAddressForm($(this), me._widget, "edit", "normal");
        });
        $(me._widget).find(".js-delete-address").on("click", function (e) {
            e.preventDefault();
            me.DeleteAddress(me._widget, this);
        });
    }
}
function refreshCartCount(reload) {
    var cartCount = getStorageCartItemCount();
    if (!reload && cartCount != null) {
        updateCartItemCount(cartCount);
        return;
    }
    var url = '/Api/ShoppingCart/GetCartItems';
    $.when(submitAjaxRequest(undefined, url, "GET").done(function (data) {
        updateCartItemCount(data.cartItemCount);
    }));
}
function updateCartItemCount(cartCount) {
    if (cartCount !== undefined && cartCount !== null) {
        var userToken = $(".cart-count-indicator").attr("data-user-identifier");
        if (localStorageIsAvailable() && userToken != null && userToken.length > 0) {
            setStorageCartItemCount(cartCount, userToken);
        }
    }
    $(".cart-count-indicator").html(cartCount);
}
function localStorageIsAvailable() {
    return (typeof (Storage) != "undefined");
}
function setStorageCartItemCount(cartItemCount, userToken) {
    var itemKey = userToken + "_" + cartItemCount;
    localStorage.setItem(itemKey, cartItemCount);
    sessionStorage.setItem(itemKey, cartItemCount);
}
function getStorageCartItemCount() {
    var cartCount = null;
    var userToken = $(".cart-count-indicator").attr("data-user-identifier");
    if (localStorageIsAvailable() && userToken != null && userToken.length > 0) {
        cartCount = localStorage.getItem(userToken + "_cartCount");
    }
    return cartCount;
}
function initCartCountMonitor() {
    // update if multiple browsers tabs are open
    window.setInterval(function () {
        var myCartCount = sessionStorage.getItem("cartCount");
        var globalCartCount = getStorageCartItemCount();
        var cartWidget = $(".widget.catalog-shoppingcart-list");
        if (myCartCount != globalCartCount && cartWidget.length > 0) {
            window.location.reload();
        }
        else {
            updateCartItemCount(null);
        }
    }, 60000);
}
function addCommas(str) {
    var parts = (str + "").split("."), main = parts[0], len = main.length, output = "", i = len - 1;
    while (i >= 0) {
        output = main.charAt(i) + output;
        if ((len - i) % 3 === 0 && i > 0) {
            output = "," + output;
        }
        --i;
    }
    // put decimal part back
    if (parts.length > 1) {
        output += "." + parts[1];
    }
    return output;
}
function formatColumn(val, format) {
    var formatted = "";
    var decimalPlaces = format.split('.').length > 1 ? format.split('.')[1].length : 0;
    if (decimalPlaces > 0) {
        var currency = format.substring(0, 1);
        if (val < 0)
            formatted = "-" + currency + (-1 * val).toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        else
            formatted = currency + (val).toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    else
        formatted = val.toLocaleString();
    return formatted;
}
$(function () {
    // locate all product list widgets on page
    $(".widget.catalog-product-list").each(function (index, item) {
        $(item).data("manager", new CatalogProductList(item));
    });
    $(".widget.catalog-product-detail").each(function (index, item) {
        $(item).data("manager", new CatalogProductDetail(item));
    });
    $(".widget.catalog-shoppingcart-list").each(function (index, item) {
        $(item).data("manager", new ShoppingCartList(item));
    });
    $(".widget.checkout-container").each(function (index, item) {
        $(item).data("manager", new Checkout(item));
    });
    if ($("html").data("rewards") !== "False") {
        refreshCartCount(getStorageCartItemCount() == null);
    }
    //   initCartCountMonitor();
});
/// <reference path="../lib/helper.admin.d.ts" />
class Search {
    constructor() {
        this.SortAscending = false;
        this.Skip = 0;
        this.Take = 9;
    }
    PerformSearch() {
        $("#ajax-loading").show();
        var dto = {
            Title: $("#search-results-title").val(),
            Description: $("#search-results-description").val(),
            SuppressTypeColumn: $("#search-results-suppresstypecolumn").is(":checked"),
            SearchType: $("#search-type").val(),
            SearchTerm: this.SearchTerm,
            SortAscending: this.SortAscending,
            SortField: this.SortField,
            Take: this.Take,
            Skip: this.Skip
        };
        var parent = this;
        trackSearchLink(window.location.pathname + '?q=' + encodeURIComponent(dto.SearchTerm));
        var url = '/Content/SearchContent';
        $.when(submitAjaxRequest(dto, url, "POST").done(function (data) {
            $("button.search-results-view-more").attr("data-startat", parseInt($("button.search-results-view-more").attr("data-startat")) + parent.Take);
            if (parent.Skip === 0) {
                $("#search-results").replaceWith(data);
            }
            else {
                // It's a Load More request, need to only update specific areas
                $(data).insertBefore("div.load-more");
                if (parseInt($("button.search-results-view-more").attr("data-startat")) >= parseInt($("#search-results").attr("data-total-results"))) {
                    $("div.load-more").hide();
                }
            }
            $("#ajax-loading").hide();
        }));
        window.location.hash = this.SearchTerm;
    }
}
var search = new Search();
$(document).ready(function () {
    if (window.location.hash.length > 0 && $("#search-query").length > 0) {
        search.SearchTerm = window.location.hash.substring(1);
        search.PerformSearch();
    }
    $("body").on("click", "#search-button", function (e) {
        e.preventDefault();
        search.Skip = 0;
        search.SearchTerm = $("#search-query").val();
        search.PerformSearch();
    });
    $("#nav-search").on("click", function (e) {
        if ($("#nav-search-overlay").hasClass("hide")) {
            $("#nav-search-overlay").removeClass("hide");
        }
        else {
        }
    });
    $("body").on("click", "div[data-action='sort']", function (e) {
        var field = $(this).attr("data-field");
        if (search.SortField === field) {
            search.SortAscending = search.SortAscending ? false : true;
        }
        $("button.search-results-view-more").attr("data-startat", "0");
        search.Skip = 0;
        search.SortField = field;
        search.SearchTerm = $("#search-query").val();
        search.PerformSearch();
    });
    $("body").on("click", ".search-results-view-more", function (e) {
        var currentNumberDisplayed = parseInt($(this).attr("data-startat"));
        search.Skip = currentNumberDisplayed;
        search.SearchTerm = $("#search-query").val();
        search.PerformSearch();
    });
    $("body").on("click", "#nav-search-cancel", function () {
        $("#nav-search-overlay").addClass("hide");
    });
});
function trackSearchLink(action) {
    var analyticField = $("html").data("ga-code");
    if (analyticField != null && analyticField.length > 0) {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                    //@ts-ignore
                }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        //@ts-ignore
        ga('create', analyticField, 'auto');
        //ga('send', 'pageview');
        //@ts-ignore
        ga('send', {
            hitType: 'pageview',
            page: action
        });
    }
}
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.thirdParty.d.ts" />
$(document).ready(function () {
    ApplyGageToolTip($('[data-toggle="tooltip"]'));
    ApplyGageToolTip($('[data-bs-toggle="tooltip"]'));
    if ($(".animate-fadein").length || $(".animate-zoomin").length) {
        window.addEventListener('scroll', animateOnScroll);
        animateOnScroll();
    }
});
function animateOnScroll() {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    $(".animate-fadein, .animate-zoomin").each(function (e) {
        if (!$(this).hasClass("animate-show")) {
            const elementPosition = this.offsetTop;
            if (scrollPosition > elementPosition - windowHeight + 200) {
                $(this).addClass('animate-show');
            }
        }
    });
}
/* Copy Text To Clipboard */
function copyToClipboardFunction(el, e) {
    e.preventDefault();
    var id = el.dataset.for;
    var text = "";
    var target = document.getElementById(id);
    if (target) {
        text = target.innerText;
    }
    // @ts-ignore
    const input = document.createElement('textarea');
    input.style.marginLeft = "-10000px";
    //  document.body.appendChild(input);
    target.parentNode.insertBefore(input, target.nextSibling);
    input.value = text;
    // @ts-ignore
    input.focus();
    // @ts-ignore
    input.select();
    document.execCommand('Copy');
    input.remove();
    el.trigger("focus"); // not sure if this method is used - for this to work, el must be a jQuery object.
}
;
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class AccountTransaction {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).find("#uxAccountTransactionListPageSize").val());
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".filter-text, .filter-close").on("click", function () {
            me.ShowHideFilter(this);
        });
        $(me._widget).find(".filter-facet").on("click", function () {
            me.SelectDeselectFacet(this);
        });
        $(me._widget).find("#uxAccountTransactionListPageSize").on("change", function () {
            me._sortBy = "datecreated";
            me._pageIndex = 0;
            me._sortAscending = "false";
            me._take = $(this).val();
            me.LoadData(false);
        });
        $(me._widget).find("#order-history-modal").on('show.bs.modal', function (event) {
            var self = this;
            var orderlineItemId = $(event.relatedTarget).attr("data-order-line-item-id");
            var params = {
                "participantOrderLineItemId": orderlineItemId,
            };
            $.ajax({
                data: params,
                method: "GET",
                url: "/Manage/ParticipantOrder/GetParticipantOrderHistory"
            }).done(function (data, textStatus, request) {
                $("#order-history-modal").find(".modal-body").html(data);
            }).fail(function (response, textStatus, errorThrown) {
                alert(errorThrown);
            });
        });
        $(me._widget).find(".js-vieworderdetail").on('click', function () {
            var expand = this;
            me.showDetail(expand);
        });
        me.ShowPager();
        $(me._widget).find(".accounttransactionListHeading").click(function () {
            var newHeader = $(this);
            var oldHeader = $(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if ($(".accounttransactionListHeading.sorting_asc").length > 0) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            $(me._widget).find("#list-items").html();
            me._sortBy = newHeader.data("sort-field");
            me._pageIndex = 0;
            me.LoadData(false);
        });
        $(me._widget).find(".button.filter-facet-apply").on("click", function () {
            me.ApplyFilter(this);
        });
    }
    SendCompositionEmail(button) {
        var params = {
            id: parseInt($(button).attr("data-order-line-item-id")),
            emailAddress: $(button).attr("data-email-address"),
        };
        var url = "/Api/ParticipantOrder/SendCompositionEmail";
        $.when(submitAjaxRequest(params, url, "POST").done((data, textStatus, request) => {
            if (data.success) {
                bootbox.alert($(button).attr("data-post-email-body"));
            }
        }));
    }
    showDetail(expand) {
        var me = this;
        var widgetContainer = $('.widget-accounttransaction-list');
        var parentContainer = $(expand).parent().closest('tr').next('tr');
        var detailContainer = $(parentContainer).find(".detail-" + $(expand).data("identifier"));
        var icon = $(expand).find('span');
        if ($(icon).hasClass('fa-chevron-down')) {
            if ($(detailContainer).hasClass("js-data-loaded")) {
                $(parentContainer).removeClass('hide');
                $(icon).toggleClass('fa-chevron-down fa-chevron-up');
            }
            else {
                $(widgetContainer).find('.js-vieworderdetail').attr('disabled', 'true');
                var identifier = $(expand).data("identifier");
                var actionid = $(expand).data("actionid");
                var source = $(expand).data("source");
                var transactiontype = $(expand).data("transactiontype");
                var participantactivityid = $(expand).data("participantactivityid");
                var showaccount = $(expand).data("showaccount");
                var showdepositsource = $(expand).data("showdepositsource");
                var activityname = $(expand).data("activityname");
                var isadmin = $(expand).data("isadmin");
                var suppressViewLink = $(widgetContainer).find('.dataTable').attr("suppress-view-link");
                $.when(me.GetOrderDetail(identifier, actionid, source, transactiontype, participantactivityid, activityname, showaccount, showdepositsource, isadmin, suppressViewLink).done(function (data, textStatus, response) {
                    $(parentContainer).removeClass('hide');
                    $(parentContainer).slideDown(1000);
                    detailContainer.html($(this).data("identifier"));
                    detailContainer.addClass("js-data-loaded");
                    $(icon).toggleClass('fa-chevron-down fa-chevron-up');
                    detailContainer.html(data);
                    $(widgetContainer).find('.js-vieworderdetail').removeAttr('disabled');
                    $(widgetContainer).find(".js-order-send-email").on("click", function (e) {
                        e.preventDefault();
                        var button = $(e.currentTarget);
                        bootbox.prompt({
                            title: $(button).attr("data-email-address-header"),
                            inputType: 'email',
                            value: $(button).attr("data-email-address"),
                            callback: function (result) {
                                if (result != null) {
                                    $(button).attr("data-email-address", result);
                                    me.SendCompositionEmail(button);
                                }
                            }
                        });
                    });
                    $(widgetContainer).find(".js-download-action").on('click', function (e) {
                        var button = $(e.currentTarget);
                        me.Download(button);
                    });
                }));
            }
        }
        else {
            $(parentContainer).addClass('hide');
            $(icon).toggleClass('fa-chevron-down fa-chevron-up');
        }
    }
    GetOrderDetail(identifier, actionid, source, transactiontype, participantactivityid, activityname, showaccount, showdepositsource, isadmin, suppressViewLink) {
        var params = {
            "source": source,
            "transactionType": transactiontype,
            "identifier": identifier,
            "actionId": actionid,
            "participantActivityId": participantactivityid,
            "activityName": activityname,
            "showAccount": showaccount,
            "showDepositSource": showdepositsource,
            "isAdmin": isadmin,
            "suppressViewLink": suppressViewLink
        };
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Api/AccountTransaction/GetTransactionDetail'
        });
    }
    SetPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find('#accounttransaction-list-pagination').html('');
            $(me._widget).find('#accounttransaction-list-pagination').html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find('#accounttransaction-list-pagination').find('#pagination').twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.LoadData(false);
                }
            });
        }
        else {
            $(me._widget).find('#accounttransaction-list-pagination').html('');
        }
    }
    LoadData(filterClose) {
        var me = this;
        var params = me.BuildParams(me._widgetId);
        var url = '/Content/RenderAccountTransactionList/' + me._widgetId.toString();
        //var url = '/Widgets/AccountTransaction/RenderAccountTransactionList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST").done((data, textStatus, request) => {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find("#list-items").html(data);
            me.ShowPager();
            if (filterClose) {
                $("#ajax-loading").modal("hide");
                $(me._widget).find(".filter-close").click();
            }
            $(me._widget).find(".js-vieworderdetail").on('click', function () {
                var expand = this;
                me.showDetail(expand);
            });
        }));
    }
    ShowHideFilter(el) {
        var me = this;
        var list = $(el).parent(".widget-accounttransactionlist").attr("id");
        var filterType = $(el).attr("data-filtertype");
        var $dropdown = $(me._widget).find("div[id='" + list + "'] .filter-drop-down[data-filtertype='" + filterType + "']");
        var $indicator = $(me._widget).find(".filter-indicator");
        var dropdownIsClosed = $dropdown.hasClass("hide");
        $(me._widget).find(".filter-drop-down").addClass("hide");
        $(me._widget).find(".filter-indicator").removeClass("fa-caret-up").addClass("fa-caret-down");
        if (dropdownIsClosed) {
            $dropdown.removeClass("hide");
            $indicator.removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    }
    SelectDeselectFacet(el) {
        var me = this;
        if ($(el).hasClass("disabled")) {
            return;
        }
        var $facetIndicator = $(el).find(".filter-facet-indicator");
        var $accountTransactionList = $(el).closest(".accounttransaction-list");
        $facetIndicator.toggleClass("fa-check");
        var contentWidgetID = me._widgetId;
        if ($facetIndicator.hasClass("fa-check")) {
            $facetIndicator.removeClass("hidden");
            $(me._widget).find("#widget-accounttransactionlist-appliedfilters-" + contentWidgetID).append("<button class='pull-left btn btn-color1 accounttransaction-list-remove-filter' data-filter-type='" + $(el).attr("data-filter-type") + "' data-filter-id='" + $(el).attr("data-filter-id") + "'><span class='fa-solid fa-check'></span> " + $(el).attr("data-name") + " | <span class='remove'>x</span></button>");
            $(me._widget).find(".accounttransaction-list-remove-filter").off("click");
            $(me._widget).find(".accounttransaction-list-remove-filter").on("click", function () {
                var filterID = parseInt($(this).attr("data-filter-id"));
                var filterType = $(this).attr("data-filter-type");
                me.SelectDeselectFacet($("button.filter-facet[data-filter-type='" + filterType + "'][data-filter-id='" + filterID + "']"));
            });
        }
        else {
            $facetIndicator.addClass("hidden");
            $(me._widget).find("#widget-accounttransactionlist-appliedfilters-" + contentWidgetID).find("button[data-filter-type='" + $(el).attr("data-filter-type") + "'][data-filter-id='" + $(el).attr("data-filter-id") + "']").remove();
        }
        me.UpdateFilter(contentWidgetID);
    }
    ApplyFilter(el) {
        var me = this;
        this.UpdateFilter(me._widgetId);
    }
    UpdateFilter(contentWidgetID) {
        var me = this;
        $('#ajax-loading').modal();
        me._sortBy = "datecreated";
        me._pageIndex = 0;
        me._sortAscending = "false";
        me.LoadData(true);
    }
    ShowPager() {
        var me = this;
        if (me._totalPages > 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
            me.SetPager();
        }
    }
    BuildParams(contentWidgetId) {
        var $transactiontypeFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] div.filter-drop-down[data-filtertype='TransactionTypes']");
        var arrayTypes = new Array;
        $transactiontypeFilter.find("span.fa-check").each(function (i, e) {
            arrayTypes.push(parseInt($(e).attr("data-id")));
        });
        var transactionTypes = arrayTypes.join(",");
        var params = {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            Skip: 0,
            TransactionTypes: transactionTypes
        };
        return params;
    }
    Download(button) {
        var params = {
            "id": parseInt($(button).attr("data-order-line-item-id")),
        };
        var url = "/Api/ParticipantOrder/DownloadAction";
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            if (data.success) {
                // parentrow status description 
                $(button).closest(".orderdetail-container").find(".js-header-orderstatus").html(data.data.orderHeaderStatus);
                ;
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                location.href = $(button).attr("data-href");
            }
        }));
    }
}
;
$(document).ready(function () {
    $(".widget-accounttransaction-list").each(function (index, item) {
        $(item).data("manager", new AccountTransaction(item));
    });
});
class AccountTransactionFielo {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this.bindControls();
    }
    bindControls() {
        var me = this;
        var take = 50;
        var offset = parseInt($(me._widget).find(".fielo-account-transaction-view-more").attr("data-offset"));
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        var htmlContentToUpdate = $(me._widget).find("#accounttransactionfielolist-items");
        var filterContentToUpdate = $(me._widget).find(".accounttransactionfilter-list");
        var fields = $(htmlContentToUpdate).attr("data-fielo-fields-list");
        var additionalFieldsList = $(htmlContentToUpdate).attr("data-fielo-additional-fields");
        if ($(me._widget).attr("data-is-edit-mode") !== "true" && fields != "") {
            if ($(me._widget).attr("data-fielo-member-id") != "") {
                me.GetTransactions(fields, 0, false, htmlContentToUpdate, filterContentToUpdate, additionalFieldsList, take, 0);
            }
        }
        $(me._widget).find(".fielo-account-transaction-view-more").on("click", function (e) {
            var viewmorebutton = $(e.currentTarget);
            me.viewMore(viewmorebutton, $(this).attr("data-offset"));
        });
        if ($(me._widget).attr("data-fielo-member-id") != "") {
            this.BindDataTable();
        }
    }
    viewMore(viewmorebutton, offset) {
        var me = this;
        var take = 50;
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        var transactionTypes = me.BuildParams(me._widgetId);
        var htmlContentToUpdate = $(me._widget).find("#accounttransactionfielolist-items");
        var filterContentToUpdate = $(me._widget).find(".accounttransactionfilter-list");
        var fields = $(htmlContentToUpdate).attr("data-fielo-fields-list");
        var additionalFieldsList = $(htmlContentToUpdate).attr("data-fielo-additional-fields");
        if ($(me._widget).attr("data-is-edit-mode") !== "true" && fields != "") {
            var currentOffSet = $(viewmorebutton).attr("data-offset");
            if (currentOffSet != undefined) {
                var nextOffSet = parseInt(currentOffSet) + 1;
                $(viewmorebutton).attr("data-offset", nextOffSet);
            }
            me.GetTransactionLineItems(fields, transactionTypes, 1, false, htmlContentToUpdate, filterContentToUpdate, additionalFieldsList, take, offset);
        }
    }
    GetTransactions(fielofieldToRetrieve, attempt, renew, htmlContentToUpdate, filterContentToUpdate, additionalFieldsList, take, offset) {
        $('#ajax-loading').modal();
        var url = "/Fielo/GetTransactionsWithAdditional/" + fielofieldToRetrieve + "/" + renew + "/" + additionalFieldsList + "/" + take + "/" + offset;
        if (additionalFieldsList == "") {
            url = "/Fielo/GetTransactionsNoAdditional/" + fielofieldToRetrieve + "/" + renew + "/" + take + "/" + offset;
        }
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: url,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.fieldName = fielofieldToRetrieve;
                    data.result.attempt = attempt + 1;
                    data.result.htmlContentToUpdate = htmlContentToUpdate;
                    data.result.filterContentToUpdate = filterContentToUpdate;
                    me.updateTransactionsUI(data.result, take, offset);
                }
            });
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateTransactionsUI(data, take, offset) {
        var me = this;
        $("#ajax-loading").modal("hide");
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetTransactions(data.fieldName, data.attempt, true, data.htmlContentToUpdate, data.filterContentToUpdate, data.additionalFieldsList, take, offset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                return;
            }
            else {
                $(data.htmlContentToUpdate).html(data.transactionHTML);
                $(data.filterContentToUpdate).html(data.filterHTML);
                $(me._widget).find(".filter-text, .filter-close").on("click", function () {
                    me.ShowHideFilter(this, false);
                });
                $(me._widget).find(".filter-facet").on("click", function () {
                    me.SelectDeselectFacet(this);
                });
                $(data.htmlContentToUpdate).find(".js-account-transaction-additional-fields").on("click", function (e) {
                    me.bindAdditionalFields($(e.currentTarget));
                });
            }
        }
    }
    bindAdditionalFields(button) {
        var transactionidentifier = $(button).attr("data-transaction-identifier");
        var childRow = $(button).closest("#accounttransactionfielolist-items").find(".js-child-row-" + transactionidentifier);
        if ($(childRow).length > 0) {
            childRow.remove();
            return;
        }
        var json = $(button).attr("data-additional-fields-json");
        var parentRow = $(button).closest("#accounttransactionfielolist-items").find(".js-parent-row-" + transactionidentifier);
        var panelHeader = $(button).closest("#accounttransactionfielolist-items").attr("data-panel-header");
        if (json !== "") {
            var jsonobj = JSON.parse(json);
            var container = "<tr class='js-child-row-" + transactionidentifier + "'><td colspan='5'><div class='panel-group' ><div class='panel panel-primary' >" +
                "<div class='panel-heading'><h4 class='panel-title' >" + panelHeader + "</h4></div>" +
                "<div class='panel-body' >";
            $.each(jsonobj, function (i, obj) {
                container = container + "<div class= 'row' > " +
                    "<div class='col-xs-2' > <label>" + obj["ApiFieldLabel"] + "</label></div> " +
                    "<div class='col-xs-10' > <label>" + obj["ApiFieldValue"] + "</label></div > " +
                    "</div>";
            });
            container = container + "</div></div></div></td></tr>";
            $(container).insertAfter(parentRow);
        }
    }
    SelectDeselectFacet(el) {
        var me = this;
        var contentWidgetID = me._widgetId;
        if ($(el).hasClass("disabled")) {
            return;
        }
        var $facetIndicator = $(el).find(".filter-facet-indicator");
        var $accountTransactionList = $(el).closest(".accounttransactionfilter-list");
        $(el).find(".filter-facet-indicator").toggleClass("fa-check");
        if ($facetIndicator.hasClass("fa-check")) {
            $facetIndicator.removeClass("hidden");
            $(me._widget).find("#widget-accounttransactionfilter-appliedfilters-" + contentWidgetID).append("<button class='pull-left btn btn-color1 accounttransactionfilter-list-remove-filter' data-filter-type='" + $(el).attr("data-filter-type") + "' data-filter-id='" + $(el).attr("data-filter-id") + "'><span class='fa-solid fa-check'></span> " + $(el).attr("data-name") + " | <span class='remove'>x</span></button>");
            $(me._widget).find(".accounttransactionfilter-list-remove-filter").off("click");
            $(me._widget).find(".accounttransactionfilter-list-remove-filter").on("click", function () {
                var filterID = $(this).attr("data-filter-id");
                var filterType = $(this).attr("data-filter-type");
                me.SelectDeselectFacet($("button.filter-facet[data-filter-type='" + filterType + "'][data-filter-id='" + filterID + "']"));
            });
        }
        else {
            $facetIndicator.addClass("hidden");
            $(me._widget).find("#widget-accounttransactionfilter-appliedfilters-" + contentWidgetID).find("button[data-filter-type='" + $(el).attr("data-filter-type") + "'][data-filter-id='" + $(el).attr("data-filter-id") + "']").remove();
        }
        me.UpdateFilter(contentWidgetID);
    }
    ApplyFilter(el) {
        var me = this;
        this.UpdateFilter(me._widgetId);
    }
    UpdateFilter(contentWidgetID) {
        var me = this;
        $('#ajax-loading').modal();
        me.LoadData(true);
    }
    LoadData(filterClose) {
        var me = this;
        var transactionTypes = me.BuildParams(me._widgetId);
        var htmlContentToUpdate = $(me._widget).find("#accounttransactionfielolist-items");
        var filterContentToUpdate = $(me._widget).find(".accounttransactionfilter-list");
        var fielofieldToRetrieve = $(htmlContentToUpdate).attr("data-fielo-fields-list");
        var additionalFieldsList = $(htmlContentToUpdate).attr("data-fielo-additional-fields");
        var me = this;
        var attempt = 1;
        //$(me._widget).find(".fielo-account-transaction-view-more").attr("data-offset", "0")
        var offset = parseInt($(me._widget).find(".fielo-account-transaction-view-more").attr("data-offset"));
        offset = offset - 1;
        me.GetTransactionLineItems(fielofieldToRetrieve, transactionTypes, attempt, false, htmlContentToUpdate, filterContentToUpdate, additionalFieldsList, 50, offset);
    }
    GetTransactionLineItems(fielofieldToRetrieve, transactionType, attempt, renew, htmlContentToUpdate, filterContentToUpdate, additionalFieldsList, take, offset) {
        var me = this;
        if (transactionType == "") {
            transactionType = "ALL";
        }
        var url = "";
        if (additionalFieldsList == "") {
            url = "/Fielo/GetTransactionLineItemsNoAdditionalFields/" + fielofieldToRetrieve + "/" + transactionType + "/" + false + "/" + take + "/" + offset;
        }
        else {
            url = "/Fielo/GetTransactionLineItemsWithAdditionalFields/" + fielofieldToRetrieve + "/" + transactionType + "/" + false + "/" + additionalFieldsList + "/" + take + "/" + offset;
        }
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: url
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.fieldName = fielofieldToRetrieve;
                    data.result.attempt = attempt + 1;
                    data.result.htmlContentToUpdate = htmlContentToUpdate;
                    data.result.filterContentToUpdate = filterContentToUpdate;
                    me.updateTransactionLineItemsUI(data.result, take, offset);
                }
            });
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    BindDataTable() {
        var me = this;
        var table = $(me._widget).find("#accounttransactionfielo-" + me._widgetId);
        // DATATABLE
        $(table).DataTable({
            searching: false,
            blengthChange: true,
            bPaginate: false,
            bInfo: false,
            order: [],
            "columnDefs": [
                { type: 'date', "orderable": false, "searchable": false, "targets": 2 },
                { "targets": 0, "orderable": false },
                { "targets": 1, "orderable": false },
                { "targets": 3, "orderable": false },
                { "targets": 4, "orderable": false },
                { "targets": 5, "orderable": false },
            ]
        });
    }
    updateTransactionLineItemsUI(data, take, offset) {
        var me = this;
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetTransactionLineItems(data.fieldName, data.transactionType, data.attempt, true, data.htmlContentToUpdate, data.filterContentToUpdate, data.additionalFieldsList, take, offset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                $("#ajax-loading").modal("hide");
                me.ShowHideFilter($(me._widget).find(".filter-text"), true);
                //me.SelectDeselectFacet($(me._widget).find(".filter-text, .filter-close"));
                return;
            }
            else {
                //var table = $(me._widget).find("#accounttransactionfielo-" + me._widgetId);
                //$(table).DataTable().destroy();
                $(data.htmlContentToUpdate).empty();
                $(data.htmlContentToUpdate).html(data.transactionHTML);
                $(data.filterContentToUpdate).html(data.filterHTML);
                //me.BindDataTable();
                $(me._widget).find(".filter-text, .filter-close").on("click", function () {
                    me.ShowHideFilter(this, false);
                });
                $(me._widget).find(".filter-facet").on("click", function () {
                    me.SelectDeselectFacet(this);
                });
                $(data.htmlContentToUpdate).find(".js-account-transaction-additional-fields").on("click", function (e) {
                    me.bindAdditionalFields($(e.currentTarget));
                });
                me.ShowHideFilter($(me._widget).find(".filter-text"), true);
                $("#ajax-loading").modal("hide");
            }
        }
    }
    BuildParams(contentWidgetId) {
        var $transactiontypeFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] div.filter-drop-down[data-filtertype='TransactionTypes']");
        var arrayTypes = new Array;
        $transactiontypeFilter.find("span.fa-check").each(function (i, e) {
            arrayTypes.push($(e).attr("data-id"));
        });
        var transactionTypes = arrayTypes.join(",");
        if (transactionTypes == "") {
            transactionTypes = "All";
        }
        return transactionTypes;
    }
    ShowHideFilter(el, close) {
        var me = this;
        var filterType = $(el).attr("data-filtertype");
        var $dropdown = $(me._widget).find("div[id='accounttransactionfilter-list'] .filter-drop-down[data-filtertype='" + filterType + "']");
        var $indicator = $(me._widget).find(".filter-indicator");
        var dropdownIsClosed = $dropdown.hasClass("hide");
        if (close) {
            dropdownIsClosed = false;
        }
        $(me._widget).find(".filter-drop-down").addClass("hide");
        $(me._widget).find(".filter-indicator").removeClass("fa-caret-up").addClass("fa-caret-down");
        if (dropdownIsClosed) {
            $dropdown.removeClass("hide");
            $indicator.removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    }
}
;
$(document).ready(function () {
    $(".widget-accounttransactionfielo").each(function (index, item) {
        $(item).data("manager", new AccountTransactionFielo(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class AgentMarketingPlan {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._widgetContainer = "widget-teamleader-team-detail-container-" + this._widgetId;
        this._globalModal = new GlobalModal(this._widgetId);
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $('.js-agent-marketing-plan-form-numeric').on('keypress', function (event) {
            var charCode = (event.which) ? event.which : event.keyCode;
            if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43 || charCode == 46) {
                return false;
            }
            this.value = this.value.replace(/[^0-9\.]/g, '');
        });
    }
}
$(document).ready(function () {
    $(".widget-agent-marketing-plan").each(function (index, item) {
        $(item).data("manager", new AgentMarketingPlan(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class ViewCompletionList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".coursecompletionsListHeading")
            .click(function () {
            var newHeader = $(this);
            var oldHeader = $(me._widget).find(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if (oldHeader.hasClass("sorting_asc")) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            //$(me._widget).find("#list-items").html();
            $(me._widget).find(".completion-list-view-more").removeAttr("disabled");
            me._sortBy = newHeader.data("sort-field");
            $(me._widget).find("#data-startat").val(0);
            me.LoadMore(me._widget);
        });
    }
    LoadMore(el) {
        var thisWidget = $(el).closest('.widget-coursecompletions');
        var contentWidgetId = parseInt(thisWidget.find("#data-contentwidgetid").val());
        var totalNumberOfCompletions = parseInt(thisWidget.find("#data-totalitem").val());
        var skip = parseInt(thisWidget.find("#data-skip").val());
        var start = parseInt(thisWidget.find("#data-startat").val());
        var dto = {
            Categories: null,
            Tags: null,
            ContentTypes: null,
            Skip: skip,
            Take: start,
            SortField: this._sortBy,
            SortAscending: this._sortAscending
        };
        var url = '/Content/RenderCompletionsList/' + contentWidgetId;
        $.when(submitAjaxRequest(dto, url, "POST", function () {
            $("#ajax-loading").modal();
        }).done(function (data, textStatus, request) {
            $("#ajax-loading").modal("hide");
            var completionsTable = '#usercompletions-completed-' + contentWidgetId;
            if (start === 0) {
                $(completionsTable).find('tbody').empty();
                $(completionsTable).find('tbody').append(data);
            }
            else {
                $(completionsTable + ' tr:last').after(data);
            }
            var numberOfItems = request.getResponseHeader('X-StartAt');
            thisWidget.find("#data-startat").val(numberOfItems);
            if (numberOfItems >= totalNumberOfCompletions)
                $(el).attr("disabled", "disabled");
        }));
    }
    GenerateTranscript(el) {
        var contentWidgetId = parseInt($(el).attr("data-contentwidgetid"));
        var participantId = parseInt($(el).attr("data-participant-id"));
        var token = $(el).attr("data-token");
        var $completionsTable = $("#usercompletions-completed-" + contentWidgetId);
        var dto = null;
        var selectedCourses = [];
        var selectedCurriculums = [];
        $completionsTable.find('input[type="checkbox"]:checked').each(function (index, row) {
            var currentRow = $(this).closest("tr");
            var itemId = parseInt(currentRow.find("td:eq(0)").attr("data-filter-id"));
            switch (currentRow.data("type")) {
                case "content":
                    selectedCourses.push(itemId);
                    break;
                case "curriculum":
                    selectedCurriculums.push(itemId);
                    break;
            }
        });
        if (selectedCourses.length === 0 && selectedCurriculums.length === 0) {
            bootbox.alert({
                title: '<span class="fa-solid fa-circle-exclamation"></span> Transcript Generation',
                message: 'Please select a course for transcript generation.',
                closeButton: true
            });
        }
        else {
            dto = {
                Token: token,
                ParticipantId: participantId,
                WidgetId: contentWidgetId,
                ContentIds: selectedCourses,
                CurriculumIds: selectedCurriculums
            };
            var url = '/Content/DownLoadEntitlementFile?' + btoa(JSON.stringify(dto));
            window.open(url, '_blank');
        }
    }
}
var viewCompletionList;
$(document).ready(function () {
    $(".widget-coursecompletions").each(function (index, item) {
        viewCompletionList = new ViewCompletionList(item);
    });
    $("body").on("click", ".completion-list-view-more", function () {
        viewCompletionList.LoadMore(this);
    });
    $("body")
        .on("click", ".completion-list-generatetranscript", function () {
        viewCompletionList
            .GenerateTranscript(this);
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class ViewContentList {
    LoadMore(el) {
        var $list = $("#" + $(el).attr("data-contentlist-id"));
        var totalNumberOftiles = parseInt($list.attr("data-numberoftiles"));
        var contentWidgetId = parseInt($list.attr("data-contentwidgetid"));
        var $listItems = $("#content-list-" + contentWidgetId + "-items");
        var dto = this.getFiltersDto(contentWidgetId);
        dto.Skip = parseInt($(el).attr("data-startat"));
        // disable the view more button (will be enabled after successful ajax call)
        $(el).prop("disabled", true);
        // remove the outline on mouse click so that there isn't a lingering outline
        $(el).on("mousedown", function () {
            $(this).css("outline", "none");
        });
        var url = '/Content/RenderContentList/' + contentWidgetId;
        $.when(submitAjaxRequest(dto, url, "POST").done(function (response) {
            // view more button enabled
            $("[data-contentlist-id='content-list-" + contentWidgetId + "']").prop("disabled", false);
        }).done(function (data) {
            $listItems.append(data);
            var totalTiles = $list.find(".list-item:not(.spacer)").length;
            if (totalTiles == 0) { // list, not tiles
                totalTiles = $list.find(".content-list-result").length;
            }
            if (totalTiles >= totalNumberOftiles) {
                $list.find(".view-more-container").hide();
            }
            $(el).attr("data-startat", totalTiles);
        }));
        globalThis.gage.log("[data-contentlist-id='content-list-" + contentWidgetId + "']");
    }
    ShowHideFilter(el) {
        var list = $(el).parent(".widget-contentlist").attr("id");
        var filterType = $(el).attr("data-filtertype");
        var $dropdown = $("div[id='" + list + "'] .filter-drop-down[data-filtertype='" + filterType + "']");
        var $indicator = $(el).find(".filter-indicator");
        var dropdownIsClosed = $dropdown.hasClass("hide");
        $(".filter-drop-down").addClass("hide");
        $(".filter-indicator").removeClass("fa-caret-up").addClass("fa-caret-down");
        if (dropdownIsClosed) {
            $dropdown.removeClass("hide");
            $indicator.removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    }
    SelectDeselectFacet(el) {
        if ($(el).hasClass("disabled")) {
            return;
        }
        var $contentList = $(el).closest(".content-list");
        var $filterParent = $(el).closest("li");
        var $facetIndicator = $filterParent.find(".filter-facet-indicator");
        $facetIndicator.toggleClass("fa-check");
        var contentWidgetID = parseInt($contentList.attr("data-contentwidgetid"));
        var filterType = $(el).attr("data-filter-type");
        if ($(el).attr("data-selected") === "false") {
            $(el).attr("data-selected", "true");
        }
        else {
            $(el).attr("data-selected", "false");
        }
        if ($facetIndicator.hasClass("fa-check")) {
            $facetIndicator.removeClass("hidden");
            $("#widget-contentlist-appliedfilters-" + contentWidgetID).append("<button class='pull-left btn btn-color1 content-list-remove-filter' data-filter-type='" + $(el).attr("data-filter-type") + "' data-filter-id='" + $(el).attr("data-filter-id") + "'><span class='fa-solid fa-check'></span> " + $(el).attr("data-name") + " | <span class='remove'>x</span></button>");
        }
        else {
            $facetIndicator.addClass("hidden");
            $("#widget-contentlist-appliedfilters-" + contentWidgetID).find("button[data-filter-type='" + $(el).attr("data-filter-type") + "'][data-filter-id='" + $(el).attr("data-filter-id") + "']").remove();
        }
        this.updateFilter(contentWidgetID);
    }
    ApplyFilter(el) {
        this.updateFilter(parseInt($(el).closest(".content-list").attr("data-contentwidgetid")));
    }
    ClearFilter(el) {
        var contentWidgetID = parseInt($(el).closest(".content-list").attr("data-contentwidgetid"));
        $("div[data-contentwidgetid='" + contentWidgetID + "'] ul.js-filter-drop-down").find("input[type=checkbox]").prop("checked", false);
        this.updateFilter(contentWidgetID);
    }
    updateFilter(contentWidgetID) {
        $('#ajax-loading').modal();
        var $list = $("#content-list-" + contentWidgetID);
        var $listItems = $("#content-list-" + contentWidgetID + "-items");
        var dto = this.getFiltersDto(contentWidgetID);
        var url = '/Content/RenderContentList/' + contentWidgetID;
        $.when(submitAjaxRequest(dto, url, "POST").done(function (data, textStatus, request) {
            var numberOfItems = parseInt(request.getResponseHeader("X-NumberOfListItems"));
            var numberOfItemsToShow = parseInt(request.getResponseHeader("X-NumberOfItemsToShow"));
            $list.find(".btn-view-more").attr("data-startat", numberOfItemsToShow);
            if (numberOfItems <= numberOfItemsToShow) {
                $list.find(".view-more-container").hide();
            }
            else {
                $list.find(".view-more-container").show();
            }
            $list.attr("data-numberoftiles", numberOfItems);
            $listItems.html(data);
            $(".filter-facet").removeClass("processed").removeClass("disabled");
            //var $filterUpdates: JQuery = $listItems.find("#content-list-" + contentWidgetID + "-filter-update");
            var $filterUpdates = $("#content-list-" + contentWidgetID);
            var $categories = JSON.parse($filterUpdates.attr("data-filters-categories"));
            $($categories).each(function (i, e) {
                var $filter = $("#content-list-filter-category-" + e.ID);
                $filter.addClass("processed");
                if (e.NumberOfItems > 0) {
                    $filter.find(".content-list-filter-count").text("(" + e.NumberOfItems + ")");
                }
            });
            var $contenttypes = JSON.parse($filterUpdates.attr("data-filters-contenttypes"));
            $($contenttypes).each(function (i, e) {
                var $filter = $("#content-list-filter-contenttype-" + e.ID);
                $filter.addClass("processed");
                if (e.NumberOfItems > 0) {
                    $filter.find(".content-list-filter-count").text("(" + e.NumberOfItems + ")");
                }
            });
            var $tags = JSON.parse($filterUpdates.attr("data-filters-tags"));
            $($tags).each(function (i, e) {
                var $filter = $("#content-list-filter-tag-" + e.ID);
                $filter.addClass("processed");
                if (e.NumberOfItems > 0) {
                    $filter.find(".content-list-filter-count").text("(" + e.NumberOfItems + ")");
                }
            });
            var $completionStatuses = JSON.parse($filterUpdates.attr("data-filters-completionstatus"));
            $($completionStatuses).each(function (i, e) {
                var $filter = $("#content-list-filter-completionstatus-" + e.ID);
                $filter.addClass("processed");
                if (e.NumberOfItems > 0) {
                    $filter.find(".content-list-filter-count").text("(" + e.NumberOfItems + ")");
                }
            });
            $(".filter-facet").not(".processed").each(function (i, e) {
                $(e).addClass("disabled");
                $(e).find(".content-list-filter-count").text("(0)");
            });
            $("#ajax-loading").modal("hide");
            $(".filter-close").click();
        }));
    }
    getFiltersDto(contentWidgetId) {
        var $categoriesFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] ul.js-filter-drop-down[data-filtertype='Categories']");
        var $tagsFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] ul.js-filter-drop-down[data-filtertype='Tags']");
        var $contentTypesFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] ul.js-filter-drop-down[data-filtertype='ContentTypes']");
        var $completionStatusesFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] ul.js-filter-drop-down[data-filtertype='CompletionStatus']");
        var categories = new Array;
        var tags = new Array;
        var contentTypes = new Array;
        var completionStatuses = new Array;
        $categoriesFilter.find("input[type=checkbox]:checked, button.filter-facet[data-selected=true]").each(function (i, e) {
            categories.push(parseInt($(e).attr("data-id")));
        });
        $tagsFilter.find("input[type=checkbox]:checked, button.filter-facet[data-selected=true]").each(function (i, e) {
            tags.push(parseInt($(e).attr("data-id")));
        });
        $contentTypesFilter.find("input[type=checkbox]:checked, button.filter-facet[data-selected=true]").each(function (i, e) {
            contentTypes.push(parseInt($(e).attr("data-id")));
        });
        $completionStatusesFilter.find("input[type=checkbox]:checked, button.filter-facet[data-selected=true]").each(function (i, e) {
            completionStatuses.push(parseInt($(e).attr("data-id")));
        });
        var dto = {
            Categories: categories,
            Tags: tags,
            ContentTypes: contentTypes,
            EntityItemTypes: contentTypes,
            CompletionStatuses: completionStatuses,
            Skip: 0
        };
        return dto;
    }
}
var viewContentList = new ViewContentList();
$(document).ready(function () {
    $("body").on("click", ".content-list-view-more", function () {
        viewContentList.LoadMore(this);
        // $(this).css("outline-color", "none");
    });
    $("body").on("click", ".content-list .filter-text, .content-list .filter-close", function () {
        viewContentList.ShowHideFilter(this);
    });
    $("body").on("click", ".content-list .filter-facet", function () {
        viewContentList.SelectDeselectFacet(this);
    });
    $("body").on("click", ".js-filter-clear", function () {
        viewContentList.ClearFilter(this);
    });
    $(".js-content-list-side-filter").on("click", ".js-content-list-filter-apply", function () {
        viewContentList.ApplyFilter(this);
    });
    $(".js-content-list-side-filter").on("click", ".js-expand-filter-section", function (e) {
        var controlId = $(this).attr("aria-controls");
        var exState = $(this).attr("aria-expanded");
        if (exState == "false") {
            $("#" + controlId).removeClass("hidden");
            $(this).attr("aria-expanded", "true");
            $(this).find("span.fa-solid").removeClass("fa-plus");
            $(this).find("span.fa-solid").addClass("fa-minus");
        }
        else {
            $("#" + controlId).addClass("hidden");
            $(this).attr("aria-expanded", "false");
            $(this).find("span.fa-solid").removeClass("fa-minus");
            $(this).find("span.fa-solid").addClass("fa-plus");
        }
    });
    $("body").on("click", ".content-list .content-list-remove-filter", function () {
        var filterID = parseInt($(this).attr("data-filter-id"));
        var filterType = $(this).attr("data-filter-type");
        viewContentList.SelectDeselectFacet($("button.filter-facet[data-filter-type='" + filterType + "'][data-filter-id='" + filterID + "']"));
    });
    $("body").on("click", ".content-list button.filter-facet-apply", function () {
        viewContentList.ApplyFilter(this);
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class EmailConfiguration {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        const me = this;
        // me.bindLocalizedTime();
        $("body").on("click", ".js-remove-list", function () {
            $(this).next(".js-remove-list-confirm").removeClass("hidden");
        });
        $("body").on("click", ".js-replace-add-list", function (e) {
            $(this).next(".js-replace-list-confirm").removeClass("hidden");
        });
        $("body").on("click", ".js-replace-list-confirm button", function () {
            $(this).closest(".js-replace-list-confirm").addClass("hidden");
        });
        $("body").on("click", ".js-remove-list-confirm button", function () {
            $(this).closest(".js-remove-list-confirm").addClass("hidden");
        });
        $("body").on("click", ".js-replace-campaign-recipient-list", function (e) {
            $(".js-global-modal").find("#uploadList").attr("data-replace-list-action", "replace");
            if ($(e.currentTarget).attr("data-is-seed-list-type") == "True") {
                $(".js-global-modal").find("#emailListType").val("Seed");
            }
            else {
                $(".js-global-modal").find("#emailListType").val("Recipient");
            }
            $(".js-global-modal #listTab").trigger("click");
        });
        $("body").on("click", ".js-upload-recipient-replace-action", function (e) {
            e.preventDefault();
            $(this).closest(".js-upload-recipient-replace-list-confirm").addClass("hidden");
            me.uploadRecipients();
        });
        $("body").on("click", ".js-upload-recipient-add-action", function (e) {
            e.preventDefault();
            $(this).closest(".js-upload-recipient-replace-list-confirm").addClass("hidden");
            $("#uploadList").attr("data-replace-list-action", "");
            me.uploadRecipients();
        });
        $("body").on("click", ".js-upload-recipient-replace-cancel-action", function (e) {
            e.preventDefault();
            $("#uploadList").attr("data-replace-list-action", "");
            $(this).closest(".js-upload-recipient-replace-list-confirm").addClass("hidden");
        });
        $("body").on("click", ".js-remove-campaign-recipient-list", function (e) {
            e.preventDefault();
            var campaignIdentifier = $(e.currentTarget).closest(".js-send-details").attr("data-campaign-identifier");
            var campaignItemScheduleId = $(e.currentTarget).closest(".js-send-details").attr('data-campaign-item-schedule-id');
            var isSeedContact = $(e.currentTarget).attr("data-is-seed-list-type") === "True";
            var emailListContainer = $(".js-global-modal").find(".js-email-list-recipient-container");
            var url = ("/EmailCampaign/DeleteContactCampaignItemSchedules/" + campaignIdentifier + "/" + campaignItemScheduleId + "/" + isSeedContact);
            // TODO: Endpoint doesn't exist.
            $.when(submitAjaxRequest(undefined, url, "DELETE").done(function (data) {
                if (data !== null) {
                    if (data.errorMessage !== null && data.errorMessage.length > 0) {
                    }
                    else {
                        const url = "/EmailCampaign/GetEmailLists/" + $(e.currentTarget).closest(".js-send-details").attr("data-campaign-identifier") + "/" + campaignItemScheduleId;
                        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                            .done(function (data, status, request) {
                            $(emailListContainer).html(data);
                            me.bindLocalizedTime();
                        })
                            .fail(function (response, textStatus, errorThrown) {
                            alert(errorThrown);
                        }));
                    }
                }
            }));
        });
        $("input[name=productSelecter]").on("click", function (el) {
            const selectedOptions = [];
            $("input:checkbox[name=productSelecter]:checked").each(function () {
                selectedOptions.push($(this).val());
            });
            if (selectedOptions.length > 0) {
                $(".js-configure-send").prop('disabled', false);
            }
            else {
                $(".js-configure-send").prop('disabled', true);
            }
        });
        $(".js-global-modal").on("change", "input[name=seedListSend]", function (e) {
            if ($(this).val() === "seperate") {
                $(".js-seed-list-schedule").removeClass("hidden");
            }
            else {
                $(".js-seed-list-schedule").addClass("hidden");
            }
        });
        $(".js-global-modal").on("change", "input[name=listSend]", function (e) {
            if ($(this).val() === "schedule") {
                $(".js-schedule-send-config").removeClass("hidden");
            }
            else {
                $(".js-schedule-send-config").addClass("hidden");
            }
        });
        $(".js-configure-send").on("click", function (e) {
            e.preventDefault();
            const id = $(e.currentTarget).attr('data-customization-identifier');
            const campaignId = $(e.currentTarget).attr('data-campaign-id');
            const campaignIdentifier = $(e.currentTarget).attr('data-campaign-identifier');
            const campaignItemId = $(e.currentTarget).attr('data-campaign-item-id');
            const campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
            const url = "/EmailCampaign/GetEmailProductCustomization/" + id + "/" + campaignIdentifier + "/" + campaignItemScheduleId;
            $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                .done(function (data, status, request) {
                var html = data;
                var globalModal = new GlobalModal(id);
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-send-modal' });
                const details = $(".js-global-modal").find(".js-send-details");
                details.attr("data-campaign-id", campaignId);
                details.attr("data-campaign-item-id", campaignItemId);
                details.attr("data-campaign-identifier", campaignIdentifier);
                details.attr("data-campaign-item-schedule-id", campaignItemScheduleId);
                details.find(".js-campaignidentifier").val(campaignIdentifier);
                details.find(".js-campaign-item-schedule-id").val(campaignItemScheduleId);
                details.attr("data-customization-identifier", id);
                $(".js-schedule-email").on("click", function (e) {
                    e.preventDefault();
                    let startDate = null;
                    let seedStartDate = null;
                    //const campaignId = details.attr("data-campaign-id");
                    //const campaignItemId = details.attr("data-campaign-item-id");
                    const campaignItemScheduleId = details.attr("data-campaign-item-schedule-id");
                    let timeZone = $(".js-schedule-send-config").find(".js-send-time-zone").val();
                    let seedTimeZone = $(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val();
                    const errorcontainer = $(".js-global-modal").find(".js-error-schedule-container");
                    $(errorcontainer).empty();
                    $(errorcontainer).addClass("hide");
                    if ($("input:radio[name='listSend']:checked").val() === "schedule" || ($("input:radio[name='seedListSend']:checked").val() === "same" && $("input:radio[name='listSend']:checked").val() === "schedule")) {
                        if ($(".js-schedule-send-config").find("#send-date").val() === "") {
                            alert("Please select a date");
                            return false;
                        }
                        if ($(".js-schedule-send-config").find("#send-time").val() === "") {
                            alert("Please select a time");
                            return false;
                        }
                        const dateString = $('#send-date-picker').data("DateTimePicker").date().format("YYYY-MM-DD") +
                            " " +
                            $('#send-time-picker').data("DateTimePicker").date().format("HH:mm:ss");
                        const timeZoneDate = dayjs.tz(dateString, timeZone);
                        startDate = timeZoneDate.utc().format();
                        seedStartDate = startDate;
                        timeZone = $(".js-schedule-send-config").find(".js-send-time-zone").val();
                        seedTimeZone = timeZone;
                    }
                    if ($(e.currentTarget).closest("#schedule").find("#sendName").val() === "") {
                        alert("Please enter a name");
                        return false;
                    }
                    if ($("input:radio[name='seedListSend']:checked").val() === "seperate") {
                        if ($(".js-schedule-seed-send-config").find("#seed-send-date").val() === "") {
                            alert("Please select a seed start date");
                            return false;
                        }
                        if ($(".js-schedule-seed-send-config").find("#seed-send-time").val() === "") {
                            alert("Please select a seed send time");
                            return false;
                        }
                        const dateString = $('#seed-send-date-picker').data("DateTimePicker").date().format("YYYY-MM-DD") +
                            " " +
                            $('#seed-send-time-picker').data("DateTimePicker").date().format("HH:mm:ss");
                        const newDate = new Date(dateString);
                        const utcDate = dayjs.utc(newDate.toString()).tz(timeZone);
                        seedStartDate = utcDate.utc().format('YYYY-MM-DD HH:mm:ss');
                        seedTimeZone = $(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val();
                    }
                    var url = "/EmailCampaign/AddCampaignSchedule";
                    var params = {
                        "campaignItemScheduleId": campaignItemScheduleId,
                        "campaignIdentifier": $(".js-global-modal").find(".js-send-details").attr("data-campaign-identifier"),
                        "campaignItemId": parseInt($(".js-global-modal").find(".js-send-details").attr("data-campaign-item-id")),
                        "name": $(e.currentTarget).closest("#schedule").find("#sendName").val(),
                        "startDateTime": startDate,
                        "timeZone": timeZone,
                        "seedStartDateTime": seedStartDate,
                        "seedTimeZone": seedTimeZone
                    };
                    $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
                        if (data.success == true) {
                            window.location.reload();
                            //$(errorcontainer).html($(errorcontainer).attr("data-success-message"));
                            //$(errorcontainer).removeClass("hide");
                        }
                        else {
                            alert(data.errorMessage);
                        }
                    }).fail(function (response, textStatus, errorThrown) {
                        alert(errorThrown);
                    }));
                });
                me.populateTimeZonesOnly($(".time-zone"));
                $("#uploadList").on("click", function (e) {
                    if ($(e.currentTarget).attr("data-replace-list-action") === "replace") {
                        $(this).next(".js-upload-recipient-replace-list-confirm").removeClass("hidden");
                    }
                    else {
                        me.uploadRecipients();
                    }
                });
                // TODO: this should be removed, there are no enpoints for AddEmailRecipient
                // there are components in cshtml that still reference this that wouldn't work.
                $(".js-upload-single-recipient").on("click", function (e) {
                    var emailListContainer = $(".js-global-modal").find(".js-email-list-recipient-container");
                    var errorcontainer = $(".js-upload-single-recipient-container").find(".js-error-single-recipient-container");
                    var campaignIdentifier = $(e.currentTarget).closest(".js-send-details").attr("data-campaign-identifier");
                    var campaignItemScheduleId = $(e.currentTarget).closest(".js-send-details").attr('data-campaign-item-schedule-id');
                    e.preventDefault();
                    var url = ("/EmailCampaign/AddEmailRecipient");
                    //TODO: ANTI  - was needs fixup due to how this worked  - data: $("#form-single-recipient").serialize()
                    //TODO XXX$.ajax({
                    //     type: "POST",
                    //    data: $("#form-single-recipient").serialize(),
                    //    dataType: 'json',
                    //    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                    //    headers: {
                    //        'RequestVerificationToken': rvaftoValue
                    //    }
                    $.when(submitAjaxRequest(undefined, url, "POST").done(function (data) {
                        if (data != null) {
                            if (data.errorMessage != null && data.errorMessage.length > 0) {
                                $(errorcontainer).html(data.errorMessage);
                                $(errorcontainer).removeClass("hide");
                            }
                            else {
                                var url = "/EmailCampaign/GetEmailLists/" + campaignIdentifier + "/" + campaignItemScheduleId;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(emailListContainer).html(data);
                                    $(errorcontainer).html($(errorcontainer).attr("data-success-message"));
                                    $(errorcontainer).removeClass("hide");
                                    $(".js-single-recipient-reset").click();
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            }
                        }
                    }));
                });
                $(".js-single-recipient-reset").on("click", function (e) {
                    e.preventDefault();
                    var campaignIdentifier = $(".js-global-modal").find(".js-send-details").find(".js-campaignidentifier").val();
                    var campaignItemScheduleId = $(".js-global-modal").find(".js-send-details").find(".js-campaign-item-schedule-id").val();
                    var productCustomizationIdentifier = $(".js-global-modal").find(".js-send-details").find(".js-product-customization-identifier").val();
                    var item = $("#form-single-recipient")[0];
                    item.reset();
                    $(".js-global-modal").find(".js-send-details").find(".js-campaignidentifier").val(campaignIdentifier);
                    $(".js-global-modal").find(".js-send-details").find(".js-campaign-item-schedule-id").val(campaignItemScheduleId);
                    $(".js-global-modal").find(".js-send-details").find(".js-product-customization-identifier").val(productCustomizationIdentifier);
                });
                $(".js-cancel-schedule").on("click", function (e) {
                    window.location.reload();
                    //globalModal.closeGlobalModal();
                });
                $(".js-close-modal-overlay").on("click", function (e) {
                    window.location.reload();
                    //globalModal.closeGlobalModal();
                });
                $("#send-data-picker-full").datetimepicker();
                $("#seed-send-data-picker-full").datetimepicker();
                $('#seed-send-date-picker').datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY'
                });
                $('#send-time-picker').datetimepicker({
                    format: 'LT'
                });
                $('#seed-send-time-picker').datetimepicker({
                    format: 'LT'
                });
                $('#send-date-picker').datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY'
                });
                if ($(".js-send-time-zone-data").val() !== "" && $(".js-send-time-zone-data").val() !== undefined) {
                    $(".js-send-time-zone").val($(".js-send-time-zone-data").val());
                }
                if ($(".js-seed-send-time-zone-data").val() !== "" && $(".js-seed-send-time-zone-data").val() !== undefined) {
                    $(".js-seed-send-time-zone").val($(".js-seed-send-time-zone-data").val());
                }
                if ($("#send-date-full").val() !== "") {
                    const setTime = dayjs.utc($('#send-date-full').val()).tz($(".js-schedule-send-config").find(".js-send-time-zone").val()).format("hh:mm A");
                    $('#send-time-picker').data("DateTimePicker").date(setTime);
                }
                if ($("#seed-send-date-full").val() !== "") {
                    const setSeedTime = dayjs.utc($('#seed-send-date-full').val()).tz($(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val()).format("hh:mm A");
                    $('#seed-send-time-picker').data("DateTimePicker").date(setSeedTime);
                }
                me.bindLocalizedTime();
            })
                .fail(function (response, textStatus, errorThrown) {
                alert(errorThrown);
            }));
        });
        $(".js-delete-send").on("click", function (e) {
            const campaignIdentifier = $(e.currentTarget).attr('data-campaign-identifier');
            const campaignItemId = $(e.currentTarget).attr('data-campaign-item-id');
            const campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
            e.preventDefault();
            const addEmailId = "add-" + $(e).attr("data-campaign-item-schedule-id");
            const testHtml = $(".js-delete-confirm-content-schedule-single-schedule").html();
            const globalModal = new GlobalModal(addEmailId);
            globalModal.openGlobalModal(testHtml, "modal", { origin: $(this), classes: 'delete-modal' });
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-identifier", campaignIdentifier);
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-item-id", campaignItemId);
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-item-schedule-id", campaignItemScheduleId);
            $(".js-global-modal").find(".js-cancel-confirm").on("click", function () {
                globalModal.closeGlobalModal();
            });
            // TODO: this should be removed, there are no enpoints for RemoveCampaignItemSchedule
            // there are components in cshtml that still reference this that wouldn't work.
            $(".js-delete-campaign-schedule").on("click", function (e) {
                var campaignIdentifier = $(e.currentTarget).attr("data-campaign-identifier");
                var campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
                var url = ("/EmailCampaign/RemoveCampaignItemSchedule/" + campaignIdentifier + "/" + campaignItemScheduleId);
                // TODO: need to pass a model!!!
                //    url: ("/EmailCampaign/RemoveCampaignItemSchedule/" + campaignIdentifier + "/" + campaignItemScheduleId),
                //    type: "DELETE",
                $.when(submitAjaxRequest(undefined, url, "DELETE").done(function (data) {
                    if (data != null) {
                        if (data.errorMessage != null && data.errorMessage.length > 0) {
                        }
                        else {
                            window.location.reload();
                        }
                    }
                }));
            });
        });
        $(".js-review-order").on("click", function (e) {
            event.preventDefault();
            const addEmailId = "add-" + $(e).attr("id");
            const testHtml = $(".js-confirm-campaign-order").html();
            const globalModal = new GlobalModal(addEmailId);
            globalModal.openGlobalModal(testHtml, "modal", { origin: $(this), classes: 'delete-modal' });
            const productCustomizations = [];
            $.each($(e.currentTarget).closest(".js-email-configuration-container").find("#campaign-schedule-items").find(".js-configure-send"), function (index, elem) {
                productCustomizations.push($(elem).attr("data-customization-identifier") + "|" + $(elem).attr("data-campaign-item-schedule-id"));
            });
            $(".js-global-modal").find(".js-confirm-campaign-order-continue").attr("identifiers", productCustomizations.join(","));
            $(".js-close-modal, .js-cancel-confirm").on("click", function () {
                globalModal.closeGlobalModal();
            });
            $(".js-confirm-campaign-order-continue").on("click", function (e) {
                e.preventDefault();
                const array = $(e.currentTarget).attr("identifiers").split(',');
                const productCustomizationIdentifiers = [];
                $.each(array, function (index, elem) {
                    const productCustomization = {
                        "identifier": elem.split("|")[0],
                        "campaignItemScheduleId": elem.split("|")[1]
                    };
                    productCustomizationIdentifiers.push(productCustomization);
                });
                var url = "/Api/ProductCustomization/CreateOrder";
                // TODO make sure that serialization worked and content type is correct
                // XXX$.ajax({
                //    data: JSON.stringify(productCustomizationIdentifiers),
                //    method: "POST",
                //    url: "/Api/ProductCustomization/CreateOrder",
                //    contentType: "application/json; charset=utf-8",
                //})
                $.when(submitAjaxRequest(productCustomizationIdentifiers, url, "POST").done(function (data, textStatus, request) {
                    if (data !== null && data.redirectUrl != null) {
                        window.location.href = data.redirectUrl;
                        return;
                    }
                }).fail(function (response, textStatus, errorThrown) {
                    alert(errorThrown);
                }));
            });
        });
    }
    uploadRecipients() {
        var me = this;
        var btn = $("#uploadList");
        var campaignIdentifier = $(btn).closest(".js-send-details").attr("data-campaign-identifier");
        var campaignItemScheduleId = $(btn).closest(".js-send-details").attr('data-campaign-item-schedule-id');
        var customizationIdentifier = $(btn).attr("data-customization-identifier");
        var replaceAction = $(btn).attr("data-replace-list-action");
        var formData = new FormData();
        var element = document.getElementById("uploadRecipientList");
        var file = element.files[0];
        var emailListContainer = $(".js-global-modal").find(".js-email-list-recipient-container");
        formData.append('file', file);
        formData.append('id', customizationIdentifier);
        formData.append('contactType', $(btn).closest(".js-upload-recipient-container").find("#emailListType").val());
        formData.append('campaignId', $(btn).closest(".js-send-details").attr("data-campaign-id"));
        formData.append('campaignIdentifier', campaignIdentifier);
        formData.append('campaignItemScheduleId', campaignItemScheduleId);
        formData.append('campaignItemScheduleId', campaignItemScheduleId);
        formData.append('replaceAction', replaceAction);
        var errorcontainer = $(".js-upload-recipient-container").find(".js-error-recipient-container");
        $(errorcontainer).empty();
        $(errorcontainer).addClass("hide");
        var url = ("/EmailCampaign/UploadEmailRecipients");
        $.when(submitAjaxRequest(undefined, url, "POST", undefined, undefined, undefined, formData).done(function (data) {
            if (data != null) {
                if (data.errorMessage != null && data.errorMessage.length > 0) {
                    $(errorcontainer).html(data.errorMessage);
                    $(errorcontainer).removeClass("hide");
                }
                else {
                    var url = "/EmailCampaign/GetEmailLists/" + campaignIdentifier + "/" + campaignItemScheduleId;
                    $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                        .done(function (data, status, request) {
                        $(emailListContainer).html(data);
                        $(errorcontainer).html($(errorcontainer).attr("data-success-message"));
                        $(errorcontainer).removeClass("hide");
                        me.bindLocalizedTime();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        alert(errorThrown);
                    }));
                }
            }
        }));
    }
    populateTimeZonesOnly(el) {
        GetTimeZoneNameList().then(function (timeZones) {
            FillTimeZoneDropDown($(el), timeZones, dayjs.tz.guess());
        });
    }
    populateTimeZones(el) {
        GetTimeZoneNameList().then(function (timeZones) {
            FillTimeZoneDropDown($(el), timeZones, dayjs.tz.guess());
        });
    }
    bindLocalizedTime() {
        $.each($(".localized-time-email-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY') + " <div><small>" + dayjs.utc(localDate).local().format('hh:mm a') + "</small></div>");
        });
    }
}
;
$(document).ready(function () {
    $(".widget-email-configuration-list").each(function (index, item) {
        $(item).data("manager", new EmailConfiguration(item));
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
///// <reference path="../../node_modules/dayjs/plugin/utc.d.ts" />
///// <reference path="../../node_modules/dayjs/plugin/timezone.d.ts" />
///// <reference path="../../node_modules/dayjs/plugin/localeData.d.ts" />
///// <reference path="../../node_modules/dayjs/plugin/localizedFormat.d.ts" />
///// <reference path="../../node_modules/dayjs/index.d.ts" />
//import dayjs = require('../../node_modules/dayjs/index');
//import utc = require("../../node_modules/dayjs/plugin/utc");
//import timezone = require("../../node_modules/dayjs/plugin/timezone");
//import localizedFormat = require("../../node_modules/dayjs/plugin/localizedFormat");
//import localeData = require("../../node_modules/dayjs/plugin/localeData");
//dayjs.extend(utc);
//dayjs.extend(timezone);
//dayjs.extend(localizedFormat);
//dayjs.extend(localeData);
class EmailManagement {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        me.bindLocalizedTime();
        $("body").on("click", ".js-remove-list", function () {
            $(this).next(".js-remove-list-confirm").removeClass("hidden");
        });
        $("body").on("click", ".js-remove-list-confirm button", function () {
            $(this).closest(".js-remove-list-confirm").addClass("hidden");
        });
        $("body").on("click", ".js-remove-campaign-recipient-list", function (e) {
            e.preventDefault();
            var campaignIdentifier = $(e.currentTarget).closest(".js-send-details").attr("data-campaign-identifier");
            var campaignItemScheduleId = $(e.currentTarget).closest(".js-send-details").attr('data-campaign-item-schedule-id');
            var isSeedContact = $(e.currentTarget).attr("data-is-seed-list-type") === "True";
            var emailListContainer = $(".js-global-modal").find(".js-email-list-recipient-container");
            var url = ("/EmailCampaign/DeleteContactCampaignItemSchedules/" + campaignIdentifier + "/" + campaignItemScheduleId + "/" + isSeedContact);
            // TODO: This endpoint doesn't exist in CS code.
            // url: ("/EmailCampaign/DeleteContactCampaignItemSchedules/" + campaignIdentifier + "/" + campaignItemScheduleId + "/" + isSeedContact),
            // type: "DELETE",
            $.when(submitAjaxRequest(undefined, url, "DELETE").done(function (data) {
                if (data != null) {
                    if (data.errorMessage != null && data.errorMessage.length > 0) {
                    }
                    else {
                        var url = "/EmailCampaign/GetEmailLists/" + $(e.currentTarget).closest(".js-send-details").attr("data-campaign-identifier") + "/" + campaignItemScheduleId;
                        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                            .done(function (data, status, request) {
                            $(emailListContainer).html(data);
                            me.bindLocalizedTime();
                        })
                            .fail(function (response, textStatus, errorThrown) {
                            alert(errorThrown);
                        }));
                    }
                }
            }));
        });
        try {
            // DATATABLE
            $("#email-schedules").DataTable({
                pageLength: 50,
                searching: false,
                "order": [[1, "asc"]],
                "columnDefs": [
                    {
                        orderable: false,
                        targets: [6]
                    },
                    {
                        targets: [1],
                        type: "date"
                    }
                ]
            });
        }
        catch (error) {
            console.log(error);
        }
        $(".js-clone-email-schedule").on("click", function (e) {
            e.preventDefault();
            var catalogAssignmentIdentifier = $(e.currentTarget).attr('data-catalog-assignment-identifier');
            var customizationExistsMessage = $(e.currentTarget).attr("data-customization-exist-message");
            var productDetailUrl = $(e.currentTarget).attr("data-product-detail-url");
            var id = $(e.currentTarget).attr('data-customization-identifier');
            var url = "/EmailCampaign/CloneSchedule/" + id;
            var cancelText = $(e.currentTarget).attr("data-cancel-text");
            var okText = $(e.currentTarget).attr("data-ok-text");
            $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                .done(function (data, status, request) {
                if (data.success) {
                    var redirectUrl = productDetailUrl + "?product-id=" + catalogAssignmentIdentifier + "&customization-identifier=" + data.data;
                    window.location.href = redirectUrl;
                }
                else {
                    if (data.errorMessage == "InProgress") {
                        bootbox.confirm({
                            message: "<p>" + customizationExistsMessage + "</p>",
                            buttons: {
                                confirm: {
                                    label: okText,
                                    className: 'btn-success'
                                },
                                cancel: {
                                    label: cancelText,
                                    className: 'btn-danger'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    window.location.href = productDetailUrl + "?product-id=" + catalogAssignmentIdentifier + "&customization-identifier=" + id;
                                    ;
                                }
                            }
                        });
                    }
                    else {
                        alert(data.errorMessage);
                    }
                }
            })
                .fail(function (response, textStatus, errorThrown) {
                alert(errorThrown);
            }));
        });
        $(".js-edit-email-schedule").on("click", function (e) {
            e.preventDefault();
            var id = $(e.currentTarget).attr('data-customization-identifier');
            var campaignId = $(e.currentTarget).attr('data-campaign-id');
            var campaignIdentifier = $(e.currentTarget).attr('data-campaign-identifier');
            var campaignItemId = $(e.currentTarget).attr('data-campaign-item-id');
            var campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
            var url = "/EmailCampaign/GetEmailSchedule/" + id + "/" + campaignIdentifier + "/" + campaignItemScheduleId;
            $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                .done(function (data, status, request) {
                var html = data;
                var globalModal = new GlobalModal(id);
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-send-modal' });
                $(".js-global-modal").find(".js-send-details").attr("data-campaign-id", campaignId);
                $(".js-global-modal").find(".js-send-details").attr("data-campaign-item-id", campaignItemId);
                $(".js-global-modal").find(".js-send-details").attr("data-campaign-identifier", campaignIdentifier);
                $(".js-global-modal").find(".js-send-details").attr("data-campaign-item-schedule-id", campaignItemScheduleId);
                $(".js-global-modal").find(".js-send-details").find(".js-campaign-item-schedule-id").val(campaignItemScheduleId);
                $(".js-global-modal").find(".js-send-details").attr("data-customization-identifier", id);
                me.populateTimeZones($(".time-zone"));
                $("#send-data-picker-full").datetimepicker();
                $('#send-time-picker').datetimepicker({
                    format: 'LT'
                });
                $('#send-date-picker').datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY'
                });
                if ($("#send-date-full").val() !== "") {
                    var setTime = dayjs($('#send-data-picker-full').data("DateTimePicker").date().format("MM/DD/YYYY h:mm A"));
                    $('#send-time-picker').data("DateTimePicker").date(setTime);
                }
                if ($(".js-send-time-zone-data").val() !== "" && $(".js-send-time-zone-data").val() != undefined) {
                    $(".js-send-time-zone").val($(".js-send-time-zone-data").val());
                }
                me.bindLocalizedTime();
                $("#uploadList").on("click", function (e) {
                    e.preventDefault();
                    me.uploadRecipients();
                });
                $(".js-update-email").on("click", function (e) {
                    e.preventDefault();
                    me.updateSchedule(this);
                });
            })
                .fail(function (response, textStatus, errorThrown) {
                alert(errorThrown);
            }));
        });
        $(".js-cancel-email").on("click", function (e) {
            var campaignIdentifier = $(e.currentTarget).attr('data-campaign-identifier');
            var campaignItemId = $(e.currentTarget).attr('data-campaign-item-id');
            var campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
            e.preventDefault();
            var addEmailId = "add-" + $(e).attr("data-campaign-item-schedule-id");
            var testHtml = $(".js-delete-confirm-content-schedule-single-schedule").html();
            var globalModal = new GlobalModal(addEmailId);
            globalModal.openGlobalModal(testHtml, "modal", { origin: $(this), classes: 'delete-modal' });
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-identifier", campaignIdentifier);
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-item-id", campaignItemId);
            $(".js-global-modal").find(".js-delete-campaign-schedule").attr("data-campaign-item-schedule-id", campaignItemScheduleId);
            $(".js-global-modal").find(".js-cancel-confirm").on("click", function () {
                globalModal.closeGlobalModal();
            });
            $(".js-delete-campaign-schedule").on("click", function (e) {
                var campaignIdentifier = $(e.currentTarget).attr("data-campaign-identifier");
                var campaignItemScheduleId = $(e.currentTarget).attr('data-campaign-item-schedule-id');
                // TODO: Endpoint doesn't exist in CS.
                var url = ("/EmailCampaign/RemoveCampaignItemSchedule/" + campaignIdentifier + "/" + campaignItemScheduleId);
                $.when(submitAjaxRequest(undefined, url, "DELETE").done(function (data) {
                    if (data != null) {
                        if (data.errorMessage != null && data.errorMessage.length > 0) {
                            alert(data.errorMessage);
                        }
                        else {
                            window.location.reload();
                        }
                    }
                }));
            });
        });
    }
    updateSchedule(btn) {
        var startDate = null;
        var campaignItemScheduleId = $(".js-global-modal").find(".js-send-details").attr("data-campaign-item-schedule-id");
        var timeZone = $(".js-schedule-send-config").find(".js-send-time-zone").val();
        var errorcontainer = $(".js-global-modal").find(".js-error-schedule-container");
        $(errorcontainer).empty();
        $(errorcontainer).addClass("hide");
        if ($(".js-schedule-send-config").find("#send-date").val() === "") {
            alert("Please select a date");
            return false;
        }
        if ($(".js-schedule-send-config").find("#send-time").val() === "") {
            alert("Please select a time");
            return false;
        }
        var dateString = $('#send-date-picker').data("DateTimePicker").date().format("YYYY-MM-DD") +
            " " +
            $('#send-time-picker').data("DateTimePicker").date().format("HH:mm:ss");
        var newDate = new Date(dateString);
        var utcDate = dayjs.utc(newDate.toString()).tz(timeZone);
        startDate = utcDate.utc().format('YYYY-MM-DD HH:mm:ss');
        timeZone = $(".js-schedule-send-config").find(".js-send-time-zone").val();
        if ($(btn).closest("#schedule").find("#sendName").val() === "") {
            alert("Please enter a name");
            return false;
        }
        var url = "/EmailCampaign/UpdateCampaignSchedule";
        var params = {
            "campaignItemScheduleId": campaignItemScheduleId,
            "campaignIdentifier": $(".js-global-modal").find(".js-send-details").attr("data-campaign-identifier"),
            "campaignItemId": parseInt($(".js-global-modal").find(".js-send-details").attr("data-campaign-item-id")),
            "name": $(btn).closest("#schedule").find("#sendName").val(),
            "startDateTime": startDate,
            "timeZone": timeZone
        };
        $.when(submitAjaxRequest(params, url, "post").done(function (data, textStatus, request) {
            if (data.success == true) {
                $(errorcontainer).html($(errorcontainer).attr("data-success-message"));
                $(errorcontainer).removeClass("hide");
            }
            else {
                alert(data.errorMessage);
            }
        }).fail(function (response, textStatus, errorThrown) {
            alert(errorThrown);
        }));
    }
    uploadRecipients() {
        var me = this;
        var btn = $("#uploadList");
        var campaignIdentifier = $(btn).closest(".js-send-details").attr("data-campaign-identifier");
        var campaignItemScheduleId = $(btn).closest(".js-send-details").attr('data-campaign-item-schedule-id');
        var customizationIdentifier = $(btn).attr("data-customization-identifier");
        var formData = new FormData();
        var element = document.getElementById("uploadRecipientList");
        var file = element.files[0];
        var emailListContainer = $(".js-global-modal").find(".js-email-list-recipient-container");
        formData.append('file', file);
        formData.append('id', customizationIdentifier);
        formData.append('contactType', $(btn).closest(".js-upload-recipient-container").find("#emailListType").val());
        formData.append('campaignId', $(btn).closest(".js-send-details").attr("data-campaign-id"));
        formData.append('campaignIdentifier', campaignIdentifier);
        formData.append('campaignItemScheduleId', campaignItemScheduleId);
        formData.append('campaignItemScheduleId', campaignItemScheduleId);
        formData.append('replaceAction', "");
        var errorcontainer = $(".js-upload-recipient-container").find(".js-error-recipient-container");
        $(errorcontainer).empty();
        $(errorcontainer).addClass("hide");
        var url = "/EmailCampaign/UploadEmailRecipients";
        $.when(submitAjaxRequest(undefined, url, "post", undefined, undefined, undefined, formData).done(function (data) {
            if (data != null) {
                if (data.errorMessage != null && data.errorMessage.length > 0) {
                    $(errorcontainer).html(data.errorMessage);
                    $(errorcontainer).removeClass("hide");
                }
                else {
                    var url = "/EmailCampaign/GetEmailLists/" + campaignIdentifier + "/" + campaignItemScheduleId;
                    $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                        .done(function (data, status, request) {
                        $(emailListContainer).html(data);
                        $(errorcontainer).html($(errorcontainer).attr("data-success-message"));
                        $(errorcontainer).removeClass("hide");
                        me.bindLocalizedTime();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        alert(errorThrown);
                    }));
                }
            }
        }));
    }
    populateTimeZones(el) {
        GetTimeZoneNameList().then(function (timeZones) {
            FillTimeZoneDropDown($(el), timeZones, dayjs.tz.guess());
        });
    }
    bindLocalizedTime() {
        $.each($(".localized-time-email-configuration"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY') + " <div><small>" + dayjs.utc(localDate).local().format('hh:mm a') + "</small></div>");
        });
    }
}
;
$(document).ready(function () {
    $(".widget-email-management-list").each(function (index, item) {
        $(item).data("manager", new EmailManagement(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/*import timezone = require("../../wwwroot/lib/dayjs1.11.10/plugin/timezone");*/
//import dayjs, { Dayjs } from '../../node_modules/dayjs/index';
//import utc from "../../node_modules/dayjs/plugin/utc";
//import timezone from "../../node_modules/dayjs/plugin/timezone";
//import localizedFormat from "../../node_modules/dayjs/plugin/localizedFormat";
//import localeData from "../../node_modules/dayjs/plugin/localeData";
//import timezones from "../../node_modules/timezones-list/dist/index";
//dayjs.extend(utc);
//dayjs.extend(timezone);
//dayjs.extend(localizedFormat);
//dayjs.extend(localeData);
/* ///// <reference path="../lib/moment.d.ts" /> */
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.thirdParty.d.ts" />
class FieloBadgesList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        var me = this;
        this.bindControls();
    }
    bindControls() {
        var me = this;
        var me = this;
        var take = $(me._widget).find("#pageSize").val();
        var offset = 0;
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        var statusToRetrieve = $(me._widget).find("#fieloBadgesStatusTypesToRetrieve").val();
        $(me._widget).find(".js-view-more").on("click", function (e) {
            var attempt = $(e.currentTarget).attr("data-attempt");
            var offset = $(e.currentTarget).attr("data-offset");
            if ($(e.currentTarget).attr("data-badge-status-type") == "Earned") {
                me.GetEarnedBadges("Earned", attempt, false, take, offset);
            }
            else if ($(e.currentTarget).attr("data-badge-status-type") == "Achievables") {
                me.GetUnEarnedBadges("Achievables", attempt, false, take, offset);
            }
            else if ($(e.currentTarget).attr("data-badge-status-type") == "Expired") {
                me.GetUnEarnedBadges("Expired", attempt, false, take, offset);
            }
        });
        if ($(me._widget).attr("data-is-edit-mode") !== "true" && statusToRetrieve != "") {
            if ($(me._widget).attr("data-fielo-member-id") != "") {
                var strarray = statusToRetrieve.split(',');
                for (var i = 0; i < strarray.length; i++) {
                    if (strarray[i] == "Earned") {
                        me.GetEarnedBadges("Earned", 0, false, take, offset);
                    }
                    if (strarray[i] == "Achievables") {
                        me.GetUnEarnedBadges("Achievables", 0, false, take, offset);
                    }
                    if (strarray[i] == "Expired") {
                        me.GetExpiredBadges("Expired", 0, false, take, offset);
                    }
                }
            }
            ;
        }
    }
    GetEarnedBadges(statusToRetrieve, attempt, renew, take, offset) {
        $("#earned-ajax-loading").show();
        var url = "/Fielo/GetBadges/" + statusToRetrieve + "/" + renew + "/" + take + "/" + offset;
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: url,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.fieldName = statusToRetrieve;
                    data.result.attempt = parseInt(attempt) + 1;
                    me.updateEarnedUI(data.result, take, offset);
                }
            });
        }
        else {
            alert("too many attempts");
            $("#earned-ajax-loading").hide();
            return;
        }
    }
    updateEarnedUI(data, take, offset) {
        var me = this;
        $("#earned-ajax-loading").hide();
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetEarnedBadges(data.fieldName, data.attempt, true, take, offset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                $("#earned-ajax-loading").hide();
                return;
            }
            else {
                $(".js-earned-card").find(".card-body").find(".js-card-body-row").append(data.badgeHTML);
                var container = $(".js-earned-card").find(".card-body").find(".js-card-body-row");
                var currentOffSet = $(".js-earned-card").find(".js-view-more").attr("data-offset");
                $(me._widget).find(".js-earned-card").find(".btn-view-more").removeClass("hide");
                me.SetViewMore(currentOffSet, data, $(me._widget).find(".view-more-earned-container"), $(me._widget).find("#pageSize").val());
                me.GetBadgePopDetail(container);
            }
        }
    }
    SetViewMore(currentOffSet, data, viewMoreContainer, pageSize) {
        if (currentOffSet != undefined) {
            var nextOffSet = parseInt(currentOffSet) + parseInt(pageSize);
            if (data.totalRecords != undefined) {
                if (parseInt(data.totalRecords) <= (parseInt(currentOffSet) + parseInt(pageSize))) {
                    $(viewMoreContainer).remove();
                }
                else {
                    $(viewMoreContainer).find(".js-view-more").attr("data-offset", nextOffSet);
                    $(viewMoreContainer).find(".js-view-more").attr("data-attempt", 1);
                }
            }
        }
    }
    GetBadgePopDetail(container) {
        var me = this;
        $(container).find(".js-fielobadge-img").each(function (e) {
            $(this).on("click", function (e) {
                // Explicitly hide all entitlement panels, we do not allow more
                // than one to be open at a time.
                $(".widget-entitlement-info").addClass('hidden');
                // Show only the active info panel
                $(this).siblings(".widget-entitlement-info").removeClass('hidden');
                $(document.body).off("click", me.clickHandlerFieloBadge);
                $(document.body).on("click", me.clickHandlerFieloBadge);
            });
        });
    }
    GetUnEarnedBadges(statusToRetrieve, attempt, renew, take, offset) {
        $("#unearned-ajax-loading").show();
        var url = "/Fielo/GetBadges/" + statusToRetrieve + "/" + renew + "/" + take + "/" + offset;
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: url,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.fieldName = statusToRetrieve;
                    data.result.attempt = parseInt(attempt) + 1;
                    me.updateUnEarnedUI(data.result, take, offset);
                }
            });
        }
        else {
            alert("too many attempts");
            $("#unearned-ajax-loading").hide();
            return;
        }
    }
    updateUnEarnedUI(data, take, offset) {
        var me = this;
        $("#unearned-ajax-loading").hide();
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetUnEarnedBadges(data.fieldName, data.attempt, true, take, offset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                return;
            }
            else {
                $(".js-unearned-card").find(".card-body").find(".js-card-body-row").append(data.badgeHTML);
                var container = $(".js-unearned-card").find(".card-body").find(".js-card-body-row");
                var currentOffSet = $(".js-unearned-card").find(".js-view-more").attr("data-offset");
                $(me._widget).find(".js-unearned-card").find(".btn-view-more").removeClass("hide");
                me.SetViewMore(currentOffSet, data, $(me._widget).find(".view-more-unearned-container"), $(me._widget).find("#pageSize").val());
                me.GetBadgePopDetail(container);
            }
        }
    }
    GetExpiredBadges(statusToRetrieve, attempt, renew, take, offset) {
        $("#expired-ajax-loading").show();
        var url = "/Fielo/GetBadges/" + statusToRetrieve + "/" + renew + "/" + take + "/" + offset;
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: url,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.fieldName = statusToRetrieve;
                    data.result.attempt = parseInt(attempt) + 1;
                    me.updateExpiredUI(data.result, take, offset);
                }
            });
        }
        else {
            alert("too many attempts");
            $("#expired-ajax-loading").hide();
            return;
        }
    }
    updateExpiredUI(data, take, offset) {
        var me = this;
        $("#expired-ajax-loading").hide();
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetExpiredBadges(data.fieldName, data.attempt, true, take, offset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                return;
            }
            else {
                $(".js-expired-card").find(".card-body").find(".js-card-body-row").append(data.badgeHTML);
                var container = $(".js-expired-card").find(".card-body").find(".js-card-body-row");
                var currentOffSet = $(".js-expired-card").find(".js-view-more").attr("data-offset");
                $(me._widget).find(".js-expired-card").find(".btn-view-more").removeClass("hide");
                me.SetViewMore(currentOffSet, data, $(me._widget).find(".view-more-expired-container"), $(me._widget).find("#pageSize").val());
                me.GetBadgePopDetail(container);
            }
        }
    }
    clickHandlerFieloBadge(e) {
        if (!$(e.target).siblings(".widget-entitlement-info").is(":visible")) {
            var me = this;
            if ($(e.target).hasClass('widget-entitlement-info') || $(e.target).parents('.widget-entitlement-info').length) {
                // User clicked inside open modal
                // Check if they clicked close button, otherwise ignore
                if ($(e.target).hasClass('close')) {
                    $(document.body).off("click", me.clickHandlerFieloBadge);
                    $(".widget-entitlement-info").addClass('hidden');
                }
            }
            else {
                // If click is outside of modal, simply close
                $(document.body).off("click", me.clickHandlerFieloBadge);
                $(".widget-entitlement-info").addClass('hidden');
            }
        }
    }
    ;
}
;
$(document).ready(function () {
    $(".widget-fielobadges-list").each(function (index, item) {
        $(item).data("manager", new FieloBadgesList(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/*import timezone = require("../../wwwroot/lib/dayjs1.11.10/plugin/timezone");*/
//import dayjs, { Dayjs } from '../../node_modules/dayjs/index';
//import utc from "../../node_modules/dayjs/plugin/utc";
//import timezone from "../../node_modules/dayjs/plugin/timezone";
//import localizedFormat from "../../node_modules/dayjs/plugin/localizedFormat";
//import localeData from "../../node_modules/dayjs/plugin/localeData";
//import timezones from "../../node_modules/timezones-list/dist/index";
//dayjs.extend(utc);
//dayjs.extend(timezone);
//dayjs.extend(localizedFormat);
//dayjs.extend(localeData);
/* ///// <reference path="../lib/moment.d.ts" /> */
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.thirdParty.d.ts" />
class FieloLeaderBoardList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        var me = this;
        this.bindControls();
    }
    bindControls() {
        var me = this;
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        if ($(me._widget).attr("data-fielo-member-id") != "") {
            //me.BindDataTable();
        }
        $(me._widget).find(".js-fielo-leaderboard-card-footer").addClass("hide");
        if ($(me._widget).attr("data-is-edit-mode") !== "true") {
            if ($(me._widget).attr("data-fielo-member-id") != "") {
                me.GetLeaderBoard(0, false, true, false);
                $(me._widget).on("change", "#leaderboards", function (e) {
                    e.preventDefault();
                    $(me._widget).find("#leaderboardfielo-" + me._widgetId).DataTable().destroy();
                    me.GetLeaderBoard(1, false, false, false);
                });
            }
        }
        ;
    }
    GetLeaderBoard(attempt, renew, isPageLoad, isReset) {
        var me = this;
        $("#leaderboard-ajax-loading").show();
        var fromDate = "";
        var toDate = "";
        if ($(me._widget).find("#start-date").length > 0) {
            fromDate = $(me._widget).find("#start-date").val();
            toDate = $(me._widget).find("#end-date").val();
        }
        var missionRequested = $(me._widget).find("#leaderboards").val();
        if (isReset) {
            fromDate = "";
            toDate = "";
            missionRequested = "";
        }
        var params = {
            MissionsDisplayRequested: missionRequested,
            FromDate: fromDate,
            ToDate: toDate,
            Renew: renew,
            LimitToSpecificMissions: $(me._widget).attr("data-fielo-limittospecificmissions") == "True" ? true : false,
            MaximumLeaderboardsToReturn: $(me._widget).attr("data-fielo-maximumleaderboardstoreturn") == "" ? null : parseInt($(me._widget).attr("data-fielo-maximumleaderboardstoreturn")),
            MissionsToDisplay: $(me._widget).attr("data-fielo-missionstodisplay"),
            MaximumNumberofEntriesToDisplayPerLeaderboard: $(me._widget).attr("data-fielo-maximumnumberofentriestodisplayperleaderboard") == "" ? null : parseInt($(me._widget).attr("data-fielo-maximumnumberofentriestodisplayperleaderboard")),
            LeaderboardType: $(me._widget).attr("data-fielo-leaderboardtype"),
            LeaderboardScope: $(me._widget).attr("data-fielo-leaderboardscope"),
            LeaderboardStatus: $(me._widget).attr("data-fielo-leaderboardstatus"),
            LeaderboardOrder: $(me._widget).attr("data-fielo-leaderboardorder"),
            ParticipantIdentificationOptions: $(me._widget).attr("data-fielo-participantIdentificationOptions"),
            RelatedOrganizationNamesDisplayAsAnonymous: $(me._widget).attr("data-fielo-relatedorganizationnamesdisplayasanonymous") == "True" ? true : false,
            SuppressProfilePhoto: $(me._widget).attr("data-fielo-suppressprofilephoto") == "True" ? true : false,
            SuppressScore: $(me._widget).attr("data-fielo-SuppressScore") == "True" ? true : false,
            AllowParticipantToConstrainByDate: $(me._widget).attr("data-fielo-allowparticipanttoconstrainbydate") == "True" ? true : false,
            IsPageLoad: isPageLoad,
            InitialAllLeaderboards: $(me._widget).find("#initialAllLeaderboards").val()
        };
        var url = "/Fielo/GetLeaderboard/";
        var me = this;
        if (attempt < 5) {
            $.when(submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.attempt = attempt + 1;
                    me.updateLeaderboardUI(data.result, isPageLoad, isReset);
                }
            })
                .fail(function (response, textStatus, errorThrown) {
                alert("too many attempts");
                $("#leaderboard-ajax-loading").hide();
                return;
            }));
        }
        else {
            alert("too many attempts");
            $("#leaderboard-ajax-loading").hide();
            return;
        }
    }
    updateLeaderboardUI(data, isPageLoad, isReset) {
        var me = this;
        $("#leaderboard-ajax-loading").hide();
        $(me._widget).find(".js-fielo-leaderboard-card-footer").addClass("hide");
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetLeaderBoard(data.attempt, true, isPageLoad, isReset);
            }
            else if (data.errorCode != "") {
                alert(data.errorMessage);
                $("#leaderboard-ajax-loading").hide();
                return;
            }
            else if (data.errorMessage == "NORECORDS") {
                $(me._widget).find(".leaderboardfielolist-items").empty();
                $(me._widget).find(".js-fielo-leaderboard-card-footer").removeClass("hide");
            }
            else {
                $(me._widget).find(".js-leaderboard-filter-container").html(data.filterHTML);
                $(me._widget).find(".leaderboardfielolist-items").html(data.memberListHTML);
                me.BindDatePickers();
                me.BindFilterButtons();
                me.BindDataTable();
            }
        }
    }
    BindFilterButtons() {
        var me = this;
        if ($(me._widget).find(".js-refresh-button").length > 0) {
            $(me._widget).find(".js-refresh-button").click(function (e) {
                e.preventDefault();
                $(me._widget).find(".js-fielo-leaderboard-card-footer").addClass("hide");
                $(me._widget).find("#leaderboardfielo-" + me._widgetId).DataTable().destroy();
                me.GetLeaderBoard(0, false, false, false);
            });
            $(me._widget).find(".js-reset-button").click(function (e) {
                $(me._widget).find(".js-fielo-leaderboard-card-footer").addClass("hide");
                e.preventDefault();
                $(me._widget).find("#leaderboardfielo-" + me._widgetId).DataTable().destroy();
                me.GetLeaderBoard(0, false, false, true);
            });
        }
    }
    BindDatePickers() {
        var me = this;
        if ($(me._widget).find("#start-date").length > 0) {
            var pickers = ConfigureDatePicker($('.trigger-date'), "MM/dd/yyyy");
            var startPicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; })[0][1];
            var endDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; })[0][1];
            //BindDatePickerEvents(startPicker, endDatePicker, document.getElementById("startdatepicker"), document.getElementById("enddatepicker"));
        }
    }
    BindDataTable() {
        var me = this;
        var table = $(me._widget).find("#leaderboardfielo-" + me._widgetId);
        // DATATABLE
        $(table).DataTable({
            searching: false,
            blengthChange: false,
            bPaginate: false,
            bInfo: false,
            order: [[0, "asc"]]
        });
    }
}
$(document).ready(function () {
    $(".widget-fieloleaderboard-list").each(function (index, item) {
        $(item).data("manager", new FieloLeaderBoardList(item));
    });
});
export class FieloProfile {
    constructor(widget) {
        this._widget = widget;
        this._dateFormat = $(widget).attr("data-date-format");
        this.initialize();
    }
    initialize() {
        var me = this;
        if ($(me._widget).attr("data-is-edit-mode") !== "true") {
            if ($(me._widget).attr("data-fielo-member-id") != "") {
                me.GetFieloSessionStatus(0, false);
            }
        }
    }
    GetFieloSessionStatus(attempt, renew) {
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: "/Fielo/GetFieloSessionStatus" + "/" + renew,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.attempt = attempt + 1;
                    me.updateSessionCheck(data.result);
                }
            });
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateSessionCheck(data) {
        var me = this;
        if (data != null) {
            if (!data.success) {
                me.GetFieloSessionStatus(data.attempt, true);
            }
            else if (data.errorCode != undefined) {
                if (data.errorCode == "INVALID_SESSION_ID") {
                    me.GetFieloSessionStatus(data.attempt, true);
                }
                else if (data.errorCode != "") {
                    alert(data.errorMessage);
                    return;
                }
                else {
                    if (data.success) {
                        if ($(me._widget).attr("data-fielo-member-id") != "") {
                            me.bindControls();
                        }
                    }
                }
            }
        }
    }
    bindControls() {
        var me = this;
        var membersRequests = [];
        var memberRequest = {
            "dataType": null,
            "callType": null,
            "pointValue": null,
            "fieldName": "",
            "renew": false,
            "placeHolderToUpdate": ""
        };
        if ($(me._widget).find("#FieloProfile-Name-Field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#FieloProfile-Name-Field").attr("Id");
            var fieloField = $(me._widget).find("#FieloProfile-Name-Field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#FieloProfile-Name-Field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberName",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#FieloProfile-Email-Field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#FieloProfile-Email-Field").attr("Id");
            var fieloField = $(me._widget).find("#FieloProfile-Email-Field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#FieloProfile-Email-Field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberEmail",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#FieloProfile-JoinDate-Field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#FieloProfile-JoinDate-Field").attr("Id");
            var fieloField = $(me._widget).find("#FieloProfile-JoinDate-Field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#FieloProfile-JoinDate-Field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberJoinDate",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#FieloProfile-AccountName-Field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#FieloProfile-AccountName-Field").attr("Id");
            var fieloField = $(me._widget).find("#FieloProfile-AccountName-Field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#FieloProfile-AccountName-Field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberAccountName",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#FieloProfile-ProfilePicture-Field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#FieloProfile-ProfilePicture-Field").attr("Id");
            var fieloField = $(me._widget).find("#FieloProfile-ProfilePicture-Field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#FieloProfile-ProfilePicture-Field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberProfilePicture",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        // Handle custom fields
        $(me._widget).find(".fieloprofile-custom-field").each(function (index, elem) {
            var placeHolderToUpdate = $(elem).attr("Id");
            var fieloField = $(elem).attr("data-fielo-field");
            var dataType = $(elem).attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberCustomField",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        });
        me.GetCommmonMember(0, membersRequests);
    }
    GetCommmonMember(attempt, membersRequests) {
        var me = this;
        if (attempt < 5) {
            $.when(submitAjaxRequest(membersRequests, "/Fielo/GetCommonMember", "POST").done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.attempt = attempt + 1;
                    data.result.memberRequests = membersRequests;
                    me.updateCommmonMemberUI(data.result);
                }
            }));
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateCommmonMemberUI(data) {
        var me = this;
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetCommmonMember(data.attempt, data.membersRequests);
            }
            else if (data.errorCode != "") {
                data.attempt = data.attempt + 1;
                me.GetCommmonMember(data.attempt, data.membersRequests);
                return;
            }
            else {
                if (data.responseData != null && data.responseData != undefined && data.responseData.memberResponseObject != null && data.responseData.memberResponseObject !== undefined) {
                    $.each(data.responseData.memberResponseObject, function (index, value) {
                        if (value.callType == "GetMemberProfilePicture") {
                            $("#" + value.placeHolderToUpdate).attr("src", value.formattedData);
                        }
                        else {
                            $("#" + value.placeHolderToUpdate).html(value.formattedData);
                        }
                    });
                }
            }
        }
    }
}
$(document).ready(function () {
    $(".widget-fieloprofile").each(function (index, item) {
        $(item).data("manager", new FieloProfile(item));
    });
});
window["FieloProfile"] = FieloProfile;
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class InProgressCustomization {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).find("#uxInProgressCustomizationListPageSize").val());
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find("#uxInProgressCustomizationListPageSize").on("change", function () {
            me._sortBy = "datecreated";
            me._pageIndex = 0;
            me._sortAscending = "false";
            me._take = $(this).val();
            me.loadData(false);
        });
        $(me._widget).find(".js-delete-inprogresscustomization").on("click", function (e) {
            var button = $(e.currentTarget);
            var title = $(button).attr("data-delete-title");
            var body = $(button).attr("data-delete-message");
            var cancelButton = $(button).attr("data-cancel-button");
            var removeButton = $(button).attr("data-ok-button");
            var customizationidentifier = $(button).attr("data-customization-Identifier");
            var deleteButton = button;
            bootbox.confirm({
                title: title,
                message: body,
                buttons: {
                    'cancel': { label: cancelButton },
                    'confirm': { label: removeButton }
                },
                callback(confirmed) {
                    if (confirmed) {
                        var params = {
                            Identifier: customizationidentifier
                        };
                        var url = "/Api/ProductCustomization/DeleteCustomization";
                        $.when(submitAjaxRequest(params, url, "DELETE")
                            .done(function (data, textStatus, request) {
                            $(deleteButton).closest('tr').remove();
                        })
                            .fail(function (response, textStatus, errorThrown) {
                        }));
                    }
                }
            });
        });
        me.showPager();
        $(me._widget).find(".InProgressCustomizationListHeading").click(function (e) {
            var newHeader = $(e.currentTarget);
            ;
            var oldHeader = $(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if ($(".InProgressCustomizationListHeading.sorting_asc").length > 0) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            $(me._widget).find("#list-items").html();
            me._sortBy = newHeader.data("sort-field");
            me._pageIndex = 0;
            me.loadData(false);
        });
    }
    setPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find('#inprogresscustomization-list-pagination').html('');
            $(me._widget).find('#inprogresscustomization-list-pagination').html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find('#inprogresscustomization-list-pagination').find('#pagination').twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.loadData(false);
                }
            });
        }
        else {
            $(me._widget).find('#inprogresscustomization-list-pagination').html('');
        }
    }
    loadData(filterClose) {
        var me = this;
        var params = me.buildParams(me._widgetId);
        var url = '/Content/RenderInProgressCustomizationList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "post").done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find("#list-items").html(data);
            me.showPager();
        }));
    }
    showPager() {
        var me = this;
        if (me._totalPages > 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
            me.setPager();
        }
    }
    buildParams(contentWidgetId) {
        return {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            Skip: 0,
        };
    }
}
;
$(document).ready(function () {
    $(".widget-inprogresscustomization-list").each(function (index, item) {
        $(item).data("manager", new InProgressCustomization(item));
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class LeaderBoard {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).attr("data-take"));
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        //  this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        me.ShowPager();
        $(me._widget).find(".leaderboardListHeading").click(function () {
            var newHeader = $(this);
            var oldHeader = $(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if ($(".leaderboardListHeading.sorting_asc").length > 0) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            $(me._widget).find("#list-items").html();
            me._sortBy = newHeader.data("sort-field");
            me._pageIndex = 0;
            me.LoadData(false);
        });
    }
    SetPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find('#leaderboard-list-pagination').html('');
            $(me._widget).find('#leaderboard-list-pagination').html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find('#leaderboard-list-pagination').find('#pagination').twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.LoadData(false);
                }
            });
        }
        else {
            $(me._widget).find('#leaderboard-list-pagination').html('');
        }
    }
    LoadData(filterClose) {
        var me = this;
        var params = me.BuildParams(me._widgetId);
        var url = '/Content/RenderLeaderBoardList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "post")
            .done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find("#list-items").html(data);
            me.ShowPager();
        }));
    }
    ShowPager() {
        var me = this;
        if (me._totalPages > 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
            me.SetPager();
        }
    }
    BuildParams(contentWidgetId) {
        var $transactiontypeFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] div.filter-drop-down[data-filtertype='TransactionTypes']");
        var arrayTypes = new Array;
        $transactiontypeFilter.find("span.fa-check").each(function (i, e) {
            arrayTypes.push(parseInt($(e).attr("data-id")));
        });
        var transactionTypes = arrayTypes.join(",");
        var params = {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            Skip: 0,
            TransactionTypes: transactionTypes
        };
        return params;
    }
}
;
$(document).ready(function () {
    $(".widget-leaderboard-list").each(function (index, item) {
        $(item).data("manager", new LeaderBoard(item));
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class ListPromotions {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).find(".js-listpromotions-pagesize").val());
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        me.BindTooltips();
        $(me._widget).find(".js-listpromotions-pagesize").on("change", function () {
            me._sortBy = "begindate";
            me._pageIndex = 0;
            me._sortAscending = "false";
            me._take = $(this).val();
            me.LoadData();
        });
        me.ShowPager();
        $(me._widget).find(".js-listpromotions-sortby").on("change", function () {
            me._sortAscending = $(this).find(':selected').data("sortasc");
            me._sortBy = $(this).val();
            $(me._widget).find("#list-items").html();
            me._pageIndex = 0;
            me.LoadData();
        });
        $(me._widget).find(".js-resetfilters").on("click", function () {
            me.ResetFilters();
            me.LoadData();
        });
        $(me._widget).find("#SearchButton").on("click", function () {
            me._pageIndex = 0;
            me.LoadData();
        });
        $(me._widget).find(".js-toggle-filters").on("click", function () {
            var origText = $(this).html();
            var altTextHolder = $(me._widget).find(".js-filter-alt-text");
            $(this).html(altTextHolder.html());
            altTextHolder.html(origText);
            if ($(me._widget).find("#filterFieldset").hasClass("collapse")) {
                $(me._widget).find("#filterFieldset").removeClass("collapse");
            }
            else {
                $(me._widget).find("#filterFieldset").addClass("collapse");
            }
        });
        //$(me._widget).find("#IsBonus").on("click", function () {
        //    me._pageIndex = 0;
        //    me.LoadData();
        //});
        //$(me._widget).find("#ShowFuture").on("click", function () {
        //    me._pageIndex = 0;
        //    me.LoadData();
        //});
        $(me._widget).find("#FilterActivityTypes").multiselect({ numberDisplayed: 0 });
    }
    BindTooltips() {
        $(this._widget).find('.participant-activity-tooltip').tooltip();
    }
    SetPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find('#listpromotions-pagination').html('');
            $(me._widget).find('#listpromotions-pagination').html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find('#listpromotions-pagination').find('#pagination').twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.LoadData();
                }
            });
        }
        else {
            $(me._widget).find('#listpromotions-pagination').html('');
        }
    }
    LoadData() {
        var me = this;
        var params = me.BuildParams(me._widgetId);
        // Show loading indicator
        $(this._widget).find('.js-loading-overlay').removeClass('hidden');
        var url = '/Content/RenderActivityCriteriaList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "post")
            .done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find("#list-items").html(data);
            me.ShowPager();
            me.BindTooltips();
            // Hide loading indicator
            $(me._widget).find('.js-loading-overlay').addClass('hidden');
        }));
    }
    ShowPager() {
        var me = this;
        if (me._totalPages > 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
        }
        me.SetPager();
    }
    BuildParams(contentWidgetId) {
        var me = this;
        var isShowFutureSelected = $(me._widget).find("#ShowFuture").is(":checked");
        var showFuture = isShowFutureSelected !== null ? isShowFutureSelected : false;
        var selectedActivityTypes = $(me._widget).find("#FilterActivityTypes").val();
        var activityTypes = selectedActivityTypes != null ? selectedActivityTypes.join(",") : null;
        var isBonusSelected = $(me._widget).find("#IsBonus").is(":checked");
        var isBonus = isBonusSelected !== null ? isBonusSelected : false;
        var searchText = $(me._widget).find("#SearchText").val();
        var params = {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            ActivityTypes: activityTypes,
            ShowFuture: showFuture,
            IsBonus: isBonus,
            SearchText: searchText
        };
        return params;
    }
    ResetFilters() {
        $(this._widget).find("#ShowFuture").prop('checked', false);
        $(this._widget).find("#IsBonus").prop('checked', false);
        $(this._widget).find("#SearchText").val("");
        $(this._widget).find("#FilterActivityTypes").val("");
        $(this._widget).find("#FilterActivityTypes").multiselect('refresh');
    }
}
;
$(document).ready(function () {
    $(".widget-listpromotion").each(function (index, item) {
        $(item).data("manager", new ListPromotions(item));
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
class MyProject {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).find("#uxMyProjectListPageSize").val());
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".filter-text, .filter-close").on("click", function () {
            me.ShowHideFilter(this);
        });
        $(me._widget).find(".filter-facet").on("click", function () {
            me.selectDeselectFacet(this);
        });
        $(me._widget).find("#uxMyProjectListPageSize").on("change", function () {
            me._sortBy = "datecreated";
            me._pageIndex = 0;
            me._sortAscending = "false";
            me._take = $(this).val();
            me.loadData(false);
        });
        $(me._widget).find(".js-delete-order").on("click", function (e) {
            me.delete($(e.currentTarget));
        });
        $(me._widget).find(".js-vieworderdetail").on('click', function () {
            var expand = this;
            me.showDetail(expand);
        });
        me.showPager();
        $(me._widget).find(".js-order-send-email").on("click", function (e) {
            e.preventDefault();
            var button = $(e.currentTarget);
            bootbox.prompt({
                title: $(button).attr("data-email-address-header"),
                inputType: 'email',
                value: $(button).attr("data-email-address"),
                callback: function (result) {
                    if (result != null) {
                        $(button).attr("data-email-address", result);
                        me.SendCompositionEmail(button);
                    }
                }
            });
        });
        $(me._widget).find(".myProjectListHeading").click(function () {
            var newHeader = $(this);
            var oldHeader = $(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if ($(".myProjectListHeading.sorting_asc").length > 0) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            $(me._widget).find("#list-items").html();
            me._sortBy = newHeader.data("sort-field");
            me._pageIndex = 0;
            me.loadData(false);
        });
        $(me._widget).find(".button.filter-facet-apply").on("click", function () {
            me.applyFilter(this);
        });
        $(me._widget).find("#order-history-modal").on('show.bs.modal', function (event) {
            var self = this;
            var orderlineItemId = $(event.relatedTarget).attr("data-order-line-item-id");
            var params = {
                "participantOrderLineItemId": orderlineItemId,
            };
            $.ajax({
                data: params,
                method: "GET",
                url: "/Manage/ParticipantOrder/GetParticipantOrderHistory"
            }).done(function (data, textStatus, request) {
                $("#order-history-modal").find(".modal-body").html(data);
            });
        });
    }
    SendCompositionEmail(button) {
        var params = {
            id: parseInt($(button).attr("data-order-line-item-id")),
            emailAddress: $(button).attr("data-email-address"),
            "updateStatus": true
        };
        var url = "/Api/ParticipantOrder/SendCompositionEmail";
        $.when(submitAjaxRequest(params, url, "post")
            .done((data, textStatus, request) => {
            if (data.success) {
                $(button).closest(".orderdetail-container").find(".js-header-orderstatus").html(data.data.orderHeaderStatus);
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                bootbox.alert($(button).attr("data-post-email-body"));
            }
        }));
    }
    openDirectMailListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/DirectMail/GetDirectMailListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/DirectMail/DownloadDirectMailListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-direct-maillistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openEmailUploadedListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetEmailUploadedListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/EmailCampaign/DownloadEmailUploadedListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-emailuploadedlistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openMicrositeListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetMicrositeListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/EmailCampaign/DownloadMicrositeListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-micrositelistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openContactActivityList(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetActivitySummaryListLimited/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                $(".global-modal-inner-container").find(".js-download-activity-list").click(function (e) {
                    var dataType = $(e.currentTarget).attr("data-type");
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var title = $(e.currentTarget).attr("data-title");
                    var body = $(e.currentTarget).attr("data-body");
                    // @ts-ignore
                    var uniqueId = 'EmailOrderDownload-' + getUniqueGuid();
                    var url = "/EmailCampaign/DownloadActivitySummaryList" +
                        "?orderLineItemDetailIdentifier=" + orderLineItemDetailIdentifier +
                        "&contactListIdentifier=" + contactListIdentifier +
                        "&fileType=" + dataType +
                        "&uniqueId=" + uniqueId +
                        "&searchText=" + searchText;
                    e.preventDefault();
                    // @ts-ignore
                    bootbox.dialog({
                        title: title,
                        message: body +
                            '<div id="progress-wrapper-upload">' +
                            '<div class="progress-wrapper">' +
                            '<div class="progress-indicator text-center">' +
                            '</div></div></div>',
                        closeButton: false
                    });
                    // move box to front
                    $(".bootbox.modal.bootbox").css({ "z-index": "10006" });
                    // initialize process status row, and return to call loop
                    // @ts-ignore
                    updateProgressStatus(uniqueId, '/API/Manage/ProcessStatus/AddProgress/', function () { progressBar(url, uniqueId); });
                });
                // @ts-ignore
                function progressBar(url, uniqueId) {
                    $.when(submitAjaxRequest(null, url, "GET")
                        .done(function (data, textStatus, request) {
                        // tell process it is done
                        $('#loadupload-loop').val('1');
                        // swallow success since I will handle it with the ProgressStatus
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        // swallow timeout error since I will handle it with the ProgressStatus
                    }));
                    var pollingStop = $('#loadupload-loop'); // used for a quick exit from the loop if applicable
                    var progressWrapper = $('#progress-wrapper-upload');
                    // getStatus is a recursive process which waits for 0% or 100%. When found, run the passed function, which is in the helper.
                    getStatus(uniqueId, '/API/Manage/ProcessStatus/GetCurrentProgress/', pollingStop, progressWrapper, 
                    // @ts-ignore
                    function () {
                        // done, reset and get the file
                        $('#loadupload-loop').val('0');
                        var finalUrl = '/EmailCampaign/GetDownLoadFile?UniqueId=' + uniqueId;
                        // @ts-ignore
                        window.location = finalUrl;
                        // remove the process status row
                        //updateProgressStatus(uniqueId, '/API/Manage/ProcessStatus/RemoveProgress/');
                    });
                }
                $(".global-modal-inner-container").find(".js-campaign-list-filter-button-reset").click(function (e) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var me = this;
                    $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val("");
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var params = {
                        "searchText": searchText
                    };
                    $.ajax({
                        data: params,
                        method: "GET",
                        url: "/EmailCampaign/GetActivitySummaryListLimitedDataOnly/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
                    }).done(function (data, textStatus, request) {
                        if (data) {
                            $(".global-modal-inner-container").find(".js-campaign-list-filtered-table").html(data);
                        }
                    });
                });
                $(".global-modal-inner-container").find(".js-campaign-list-filter-button").click(function (e) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var me = this;
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var params = {
                        "searchText": searchText
                    };
                    $.ajax({
                        data: params,
                        method: "GET",
                        url: "/EmailCampaign/GetActivitySummaryListLimitedDataOnly/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
                    }).done(function (data, textStatus, request) {
                        if (data) {
                            $(".global-modal-inner-container").find(".js-campaign-list-filtered-table").html(data);
                        }
                    });
                });
            }
            else {
            }
        });
    }
    openMicrositeActivityList(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        $.ajax({
            method: "GET",
            url: "/Microsite/GetActivitySummaryList/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                $(".global-modal-inner-container").find(".js-download-activity-list").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-activity-list").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    window.location.href = "/Microsite/DownloadActivitySummaryList/" +
                        contactListIdentifier +
                        "/" +
                        $(".global-modal-inner-container").find(".js-micrositedownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    download(button) {
        var params = {
            "id": parseInt($(button).attr("data-order-line-item-id")),
        };
        var url = "/Api/ParticipantOrder/DownloadAction";
        $.when(submitAjaxRequest(params, url, "post").done(function (data, textStatus, request) {
            if (data.success) {
                // parentrow status description 
                var parentrowIdentifier = $(button).attr("data-transaction-identifier");
                var parentrow = $(button).closest("#list-items").find(".js-row-parent-" + parentrowIdentifier);
                $(parentrow).find(".js-order-status").html(data.data.orderHeaderStatus);
                // header status description in my project
                var orderdetailrow = $(button).closest("#list-items")
                    .find(".detail-" + parentrowIdentifier)
                    .find(".js-header-orderstatus")
                    .html(data.data.orderHeaderStatus);
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                location.href = $(button).attr("data-href");
            }
        }));
    }
    sendCompositionEmail(button) {
        var params = {
            "id": parseInt($(button).attr("data-order-line-item-id")),
            "emailAddress": $(button).attr("data-email-address"),
            "updateStatus": true
        };
        var url = "/Api/ParticipantOrder/SendCompositionEmail";
        $.when(submitAjaxRequest(params, url, "post").done(function (data, textStatus, request) {
            // TODO XXX$.ajax({
            if (data.success) {
                // parentrow status description 
                var parentrowIdentifier = $(button).attr("data-transaction-identifier");
                var parentrow = $(button).closest("#list-items").find(".js-row-parent-" + parentrowIdentifier);
                $(parentrow).find(".js-order-status").html(data.data.orderHeaderStatus);
                // header status description in my project
                var orderdetailrow = $(button).closest("#list-items")
                    .find(".detail-" + parentrowIdentifier)
                    .find(".js-header-orderstatus")
                    .html(data.data.orderHeaderStatus);
                // detail  status description 
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                bootbox.alert($(button).attr("data-post-email-body"));
            }
        }));
    }
    delete(button) {
        var title = $(button).attr("data-delete-title");
        var body = $(button).attr("data-delete-message");
        var cancelButton = $(button).attr("data-cancel-button");
        var removeButton = $(button).attr("data-ok-button");
        var orderidentifier = $(button).attr("data-order-identifier");
        bootbox.confirm({
            title: title,
            message: body,
            buttons: {
                'cancel': {
                    label: cancelButton
                },
                'confirm': {
                    label: removeButton
                }
            },
            callback: function (confirmed) {
                if (confirmed) {
                    var params = {
                        identifier: orderidentifier
                    };
                    var url = "/Api/ParticipantOrder/ArchiveOrder";
                    $.when(submitAjaxRequest(params, url, "post").done(function (data, textStatus, request) {
                        // TODO XXX$.ajax({
                        var parentRow = $(button).parent().closest('tr');
                        var detailRow = $(parentRow).next('tr').remove();
                        $(parentRow).remove();
                        bootbox.alert("done");
                    }));
                }
            }
        });
    }
    resubmitOrderItem(button, displayPopup) {
        var params = {
            "orderLineItemId": parseInt($(button).attr("data-order-line-item-id")),
            "orderIdentifier": $(button).attr("data-order-identifier")
        };
        $.ajax({
            data: params,
            method: "GET",
            url: "/Api/ParticipantOrder/ResubmitOrderItem"
        }).done(function (data, textStatus, request) {
            if (data.success) {
                $(button).addClass("hide");
                $(button).closest(".orderdetail-item-row").find(".js-check-status").removeClass("hide");
            }
            else {
                if (displayPopup) {
                    alert(data.errorMessage);
                }
            }
        });
    }
    openFaceBookPost(button) {
        var me = this;
        var orderLineItemId = $(button).attr("data-order-line-item-id");
        var child = window.open("/SocialPost/GetFaceBookUserToken", 'self', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no');
        var leftDomain = false;
        var interval = setInterval(function () {
            try {
                if (child.document.domain === document.domain) {
                    if (child.document.readyState === "complete") {
                        // we're here when the child window returned to our domain
                        var child_url = child.document.URL;
                        if (child_url.indexOf("code=") !== -1) {
                            var accessToken = $(child.document).contents().find("body pre").html();
                            $(button).attr("facebook-access-token", accessToken);
                            clearInterval(interval);
                            child.close();
                            var dto = {
                                "accessToken": accessToken,
                                "orderLineItemId": orderLineItemId
                            };
                            if (accessToken !== "") {
                                var url = "/SocialPost/GetAccountLists/" + accessToken + "/" + orderLineItemId;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    var globalModal = new GlobalModal(accessToken);
                                    var html = data;
                                    globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-facebook-post-information--modal' });
                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html("");
                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("");
                                    $(".global-modal-inner-container").find(".js-submit-facebook-post").attr("data-order-line-item-id", orderLineItemId);
                                    $(".global-modal-inner-container").find("#imageurl").attr("src", $(button).attr("data-image-url"));
                                    var pages = $(".global-modal-inner-container").find(".js-facebook-post-pages");
                                    $(pages).multiselect({ numberDisplayed: 0 });
                                    $(pages).multiselect();
                                    $(".global-modal-inner-container").find(".js-submit-facebook-post").click(function (e) {
                                        var submitButton = $(e.currentTarget);
                                        $(submitButton).attr("disabled", "disabled");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").addClass("hide");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html("");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("");
                                        var requiredMessage = $(e.currentTarget).attr("data-required-error-message");
                                        var postedMessage = $(e.currentTarget).attr("data-post-submitted-message");
                                        var postedText = $(submitButton).attr("data-posted-text");
                                        if ($(pages).length > 0 && ($(pages).val() == "" || $(pages).val() == null)) {
                                            alert(requiredMessage);
                                            return false;
                                        }
                                        else {
                                            var pageIds = $(pages).val().toString();
                                            var errorHeader = $(e.currentTarget).attr("data-error-header");
                                            var columnErrorHeader = $(e.currentTarget).attr("data-error-header-error");
                                            var columnPageNameHeader = $(e.currentTarget).attr("data-error-header-page-name");
                                            var postSuccessfulSubHeading = $(e.currentTarget).attr("data-post-sucessful-subheading");
                                            var dto = {
                                                "pageId": pageIds,
                                                "orderLineItemId": orderLineItemId
                                            };
                                            var url = "/SocialPost/PostPhoto";
                                            var notSubmittedMessage = "";
                                            var postError = false;
                                            $.when(globalThis.gage.submitAjaxRequest(dto, url, "POST")
                                                .done(function (data, status, request) {
                                                $(submitButton).removeAttr("disabled");
                                                var table = "<table class='table table-responsive'><thead><tr><th>" + columnPageNameHeader + "</th><th>" + columnErrorHeader + "</th></tr></thead>";
                                                $.each(data.result, function (i, v) {
                                                    var statusCode = v.statusCode;
                                                    if (statusCode == "OK") {
                                                        statusCode = postedText;
                                                    }
                                                    if (v.statusCode != "OK") {
                                                        postError = true;
                                                    }
                                                    if (v.faceBookPostURL !== "") {
                                                        table += "<tr><td> <a  target='_blank' href='" + v.faceBookPostURL + "'>" + v.postName + "</a></td><td>" + statusCode + "</td></tr>";
                                                    }
                                                    else {
                                                        table += "<tr><td>" + v.postName + "</td><td>" + statusCode + "</td></tr>";
                                                    }
                                                });
                                                table += "</table>";
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html(errorHeader);
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("<p class='alert alert-info' >" + postSuccessfulSubHeading + " </p>");
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").append(table);
                                                $(".global-modal-inner-container").find(".js-messagecontainer").removeClass("hide");
                                                if (postError) {
                                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".js-messagecontainer-reset-permission-container").removeClass("hide");
                                                }
                                                else {
                                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".js-messagecontainer-reset-permission-container").addClass("hide");
                                                }
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-managed-facebook-pages-container").remove();
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-submit-facebook-post").remove();
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-cancel-confirmation-link").addClass("hide");
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-close-confirmation-link").removeClass("hide");
                                                //$(button).closest(".js-action-container").find(".js-post-social-network-revoke").click();
                                            })
                                                .fail(function (response, textStatus, errorThrown) {
                                                globalModal.closeGlobalModal();
                                                alert(errorThrown);
                                                $(submitButton).removeAttr("disabled");
                                            }));
                                        }
                                    });
                                    $(".global-modal-inner-container").find(".js-reset-permission").click(function (e) {
                                        globalModal.closeGlobalModal();
                                        $(".js-facebook-reset-permission").click();
                                    });
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                }));
                            }
                        }
                    }
                }
                else {
                    // this code should never be reached, 
                    // as the x-site security check throws
                    // but just in case
                    leftDomain = true;
                }
            }
            catch (e) {
                // we're here when the child window has been navigated away or closed
                if (child.closed) {
                    clearInterval(interval);
                    return;
                }
                // navigated to another domain  
                leftDomain = true;
            }
        }, 500);
    }
    resetFaceBookPermissions(button) {
        $(button).attr("disabled", "disabled");
        var child = window.open("/SocialPost/GetFaceBookUserToken", 'self', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no');
        var successMessage = $(button).attr("data-reset-permission-success-message");
        var leftDomain = false;
        var interval = setInterval(function () {
            try {
                if (child.document.domain === document.domain) {
                    if (child.document.readyState === "complete") {
                        // we're here when the child window returned to our domain
                        var child_url = child.document.URL;
                        if (child_url.indexOf("code=") !== -1) {
                            var accessToken = $(child.document).contents().find("body pre").html();
                            clearInterval(interval);
                            child.close();
                            if (accessToken !== "") {
                                var params = {
                                    AccessToken: accessToken
                                };
                                $.when(globalThis.gage.submitAjaxRequest(params, "/SocialPost/DeletePermission/", "DELETE")
                                    .done(function (data, status, request) {
                                    if (data != null && data.result == 200) {
                                        bootbox.alert(successMessage);
                                        $(button).removeAttr("disabled");
                                    }
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                    $(button).removeAttr("disabled");
                                }));
                            }
                        }
                    }
                }
                else {
                    // this code should never be reached, 
                    // as the x-site security check throws
                    // but just in case
                    leftDomain = true;
                }
            }
            catch (e) {
                // we're here when the child window has been navigated away or closed
                if (child.closed) {
                    clearInterval(interval);
                    return;
                }
                // navigated to another domain  
                leftDomain = true;
            }
        }, 500);
    }
    checkCompositionFileStatus(button, showModal) {
        waitingDialog.show($(button).attr("data-wait-message"));
        var me = this;
        var params = {
            "orderItemId": parseInt($(button).attr("data-order-line-item-id")),
        };
        var uri = "/Api/ParticipantOrder/CheckCompositionFileStatus";
        $.ajax({
            data: params,
            method: "GET",
            url: uri
        }).done(function (data, textStatus, request) {
            waitingDialog.hide();
            if (data.success) {
                var transactionidentifier = $(button).attr("data-transaction-identifier");
                var parentrow = $(button).closest("#list-items").find(".js-row-parent-" + transactionidentifier);
                var detailrow = $(button).closest("#list-items").find(".detail-" + transactionidentifier);
                var expandbutton = $(parentrow).find(".js-vieworderdetail");
                var icon = $(expandbutton).find('span');
                $(icon).toggleClass('fa-chevron-up fa-chevron-down');
                $(detailrow).removeClass("js-data-loaded");
                $(parentrow).find(".js-order-status").html(data.orderHeaderStatus);
                me.showDetail(expandbutton);
            }
            else {
                if (data.fileStatus == "None") {
                    $(button).addClass("hide");
                    $(button).closest(".orderdetail-item-row").find(".js-resubmit-order-item").removeClass("hide");
                    bootbox.alert($(button).attr("data-customization-error-none-instruction"));
                }
                //if (data.fileStatus !== "None") {
                //    if (showModal) {
                //        bootbox.alert(data.errorMessage);
                //    }
                //}
            }
        });
    }
    openCancelCampaignMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var sendSequenceNumber = $(button).closest(".js-order-detail-row").attr("data-send-sequence-number") === "" ? 0 : $(button).closest(".js-order-detail-row").attr("data-send-sequence-number");
        var seedSequenceNumber = $(button).closest(".js-order-detail-row").attr("data-seed-sequence-number") === "" ? 0 : $(button).closest(".js-order-detail-row").attr("data-seed-sequence-number");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var params = {
                        SendSequenceNumber: sendSequenceNumber,
                        SeedSequenceNumber: seedSequenceNumber,
                        OrderLineItemId: orderLineItemId,
                        IsAdmin: false
                    };
                    var url = "/EmailCampaign/CancelCampaign";
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row").html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".localized-time-email-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".js-campaign-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        var x = 1;
                    }));
                    return true;
                }
            }
        });
    }
    openCancelSocialPostMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var orderLineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var url = "/SocialPost/CancelSocialPost/" + orderLineItemId + "/" + orderLineItemDetailId + "/false";
                    $.when(globalThis.gage.submitAjaxRequest(null, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row").html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".js-social-post-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                    return true;
                }
            }
        });
    }
    openCancelMicrositeMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var orderLineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var params = {
                        OrderLineItemId: orderLineItemId,
                        OrderLineItemDetailId: orderLineItemDetailId,
                        IsAdmin: false
                    };
                    var url = "/Microsite/CancelMicrosite/";
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row").html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".localized-time-microsite-launch-date-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".localized-time-microsite-archive-date-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".js-microsite-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                    return true;
                }
            }
        });
    }
    modifyCampaignDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var suppressViewLink = $(button).attr("data-suppress-view-link") == "False" ? false : true;
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-send-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                GlobalPopulateTimeZones($(".js-global-modal").find(".time-zone"));
                if ($(".js-global-modal").find(".js-send-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-send-time-zone-data").val() !== undefined) {
                    $(".js-send-time-zone").val($(".js-send-time-zone-data").val());
                }
                if ($(".js-global-modal").find(".js-seed-send-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-seed-send-time-zone-data").val() !== undefined) {
                    $(".js-global-modal").find(".js-seed-send-time-zone").val($(".js-seed-send-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#send-date-full").val() !== "") {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#send-date-full').val(), $(".js-global-modal").find(".js-schedule-send-config").find(".js-send-time-zone").val(), $(".js-global-modal").find('#send-time'), $(".js-global-modal").find('#send-date-picker'), $(".js-global-modal").find('#send-date'));
                }
                if ($(".js-global-modal").find("#seed-send-date-full").val() !== "" && $(".js-global-modal").find("#seed-send-date-full").val() !== undefined) {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#seed-send-date-full').val(), $(".js-global-modal").find(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val(), $(".js-global-modal").find('#seed-send-time'), $(".js-global-modal").find('#seed-send-date-picker'), $(".js-global-modal").find('#seed-send-date'));
                }
                var sendDateEl = $(".js-global-modal").find('#send-date-picker').get(0);
                var sendDateTimeEl = $(".js-global-modal").find('#send-time-picker').get(0);
                var seedSendDateEl = $(".js-global-modal").find('#seed-send-date-picker').get(0);
                var seedSendDateTimeEl = $(".js-global-modal").find('#seed-send-time-picker').get(0);
                ConfigureDatePicker($(".js-global-modal").find('#send-date-picker'));
                ConfigureDatePicker($(".js-global-modal").find('#seed-send-date-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#send-time-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#seed-send-time-picker'));
                //InitializeDatePickerForOrder(sendDateEl, sendDateTimeEl, seedSendDateEl, seedSendDateTimeEl);
                $(".js-global-modal").find(".js-change-campaign-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-campaign-dates").on("click", function (e) {
                    var errorMessage = "";
                    var recipientSendDateRequired = $(e.currentTarget).attr("data-recipient-send-date-required");
                    var seedSendDateRequired = $(e.currentTarget).attr("data-seed-send-date-required");
                    var recipientSendTimeRequired = $(e.currentTarget).attr("data-recipient-send-time-required");
                    var seedSendTimeRequired = $(e.currentTarget).attr("data-seed-send-time-required");
                    var recipientSendDateGreaterThanToday = $(e.currentTarget).attr("data-recipient-send-date-greater-than-today");
                    var seedSendDateGreaterThanToday = $(e.currentTarget).attr("data-seed-send-date-greater-than-today");
                    var timeZone = $(".js-global-modal").find(".js-schedule-send-config").find(".js-send-time-zone").val();
                    var seedTimeZone = $(".js-global-modal").find(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val();
                    var seedSendDateGreaterThanSendDate = $(e.currentTarget).attr("data-seed-send-date-greater-than-send-date");
                    if ($(".js-global-modal").find(".js-schedule-send-config").find("#send-date").val() === "") {
                        errorMessage += recipientSendDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-send-config").find("#send-time").val() === "") {
                        errorMessage += recipientSendTimeRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-seed-send-config").length > 0) {
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").find("#seed-send-date").val() === "") {
                            errorMessage += seedSendDateRequired + "<br/>";
                        }
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").find("#seed-send-time").val() === "") {
                            errorMessage += seedSendTimeRequired + "<br/>";
                        }
                    }
                    if (errorMessage === "") {
                        var sendDateString = $(".js-global-modal").find('#send-date').val() +
                            " " +
                            $(".js-global-modal").find('#send-time').val();
                        var currentDate = new Date().toISOString();
                        var startDate = GetISODate(dayjs(sendDateString), timeZone, "MM/DD/YYYY hh:mm:s a");
                        if (startDate < currentDate) {
                            errorMessage += recipientSendDateGreaterThanToday + "<br/>";
                        }
                        var seedDateString = null;
                        var seedStartDate = null;
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").length > 0) {
                            if ($(".js-global-modal").find('#seed-send-date').val() != "") {
                                seedDateString = $(".js-global-modal").find('#seed-send-date').val() +
                                    " " +
                                    $(".js-global-modal").find('#seed-send-time').val();
                                var seedStartDate = GetISODate(dayjs(seedDateString), seedTimeZone, "MM/DD/YYYY hh:mm:s a");
                                if (seedStartDate < currentDate) {
                                    errorMessage += seedSendDateGreaterThanToday + "<br/>";
                                }
                                if (seedStartDate > startDate) {
                                    errorMessage += seedSendDateGreaterThanSendDate + "<br/>";
                                }
                            }
                        }
                        if (errorMessage === "") {
                            if (seedDateString == null) {
                                seedTimeZone = null;
                            }
                            var campaignDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "sendDate": startDate,
                                "sendTimeZone": timeZone,
                                "seedSendDate": seedStartDate,
                                "seedSendTimeZone": seedTimeZone
                            };
                            var url = "/EmailCampaign/UpdateCampaignOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(campaignDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/EmailCampaign/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId + "/" + suppressViewLink;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-campaign").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifyCampaignDates(button);
                                    });
                                    $(refreshContainer).find(".js-download-action").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.download(button);
                                    });
                                    $(refreshContainer).find(".js-remove-campaign").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelCampaignMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    modifyMicrositeDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var suppressViewLink = $(button).attr("data-suppress-view-link") == "False" ? false : true;
        $.ajax({
            method: "GET",
            url: "/Microsite/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                GlobalPopulateTimeZones($(".js-global-modal").find(".time-zone"));
                if ($(".js-global-modal").find(".js-launch-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-launch-time-zone-data").val() !== undefined) {
                    $(".js-launch-time-zone").val($(".js-launch-time-zone-data").val());
                }
                if ($(".js-global-modal").find(".js-archive-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-archive-time-zone-data").val() !== undefined) {
                    $(".js-global-modal").find(".js-archive-time-zone").val($(".js-archive-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#launch-date-full").val() !== "") {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#launch-date-full').val(), $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val(), $(".js-global-modal").find('#launch-time'), $(".js-global-modal").find('#launch-date-picker'), $(".js-global-modal").find("#launch-date"));
                }
                if ($(".js-global-modal").find("#archive-date-full").val() !== "" && $(".js-global-modal").find("#archive-date-full").val() !== undefined) {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#archive-date-full').val(), $(".js-global-modal").find(".js-schedule-archive-config").find(".js-archive-time-zone").val(), $(".js-global-modal").find('#archive-time'), $(".js-global-modal").find('#archive-date-picker'), $(".js-global-modal").find("#archive-date"));
                }
                var launchDateEl = $(".js-global-modal").find('#launch-date-picker').get(0);
                var archiveDateEl = $(".js-global-modal").find('#archive-date-picker').get(0);
                var launchTimeEl = $(".js-global-modal").find('#launch-time-picker').get(0);
                var archiveTimeEl = $(".js-global-modal").find('#archive-time-picker').get(0);
                ConfigureDatePicker($(".js-global-modal").find('#launch-date-picker'));
                ConfigureDatePicker($(".js-global-modal").find('#archive-date-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#launch-time-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#archive-time-picker'));
                //InitializeDatePickerForOrder(launchDateEl, launchTimeEl, archiveDateEl, archiveTimeEl);
                // me.bindLocalizedTime();
                $(".js-global-modal").find(".js-change-microsite-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-microsite-dates").on("click", function (e) {
                    var errorMessage = "";
                    var launchDateRequired = $(e.currentTarget).attr("data-launch-date-required");
                    var archiveDateRequired = $(e.currentTarget).attr("data-archive-date-required");
                    var launchTimeRequired = $(e.currentTarget).attr("data-launch-time-required");
                    var archiveTimeRequired = $(e.currentTarget).attr("data-archive-time-required");
                    var timeZone = $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val();
                    var archiveTimeZone = $(".js-global-modal").find(".js-schedule-archive-config").find(".js-archive-time-zone").val();
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-date").val() === "") {
                        errorMessage += launchDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-time").val() === "") {
                        errorMessage += launchTimeRequired + "<br/>";
                    }
                    if (errorMessage === "") {
                        var launchDateString = $(".js-global-modal").find('#launch-date').val() +
                            " " +
                            $(".js-global-modal").find('#launch-time').val();
                        var launchDate = GetISODate(dayjs(launchDateString), timeZone, "MM/DD/YYYY hh:mm:s a");
                        var archiveDateString = null;
                        var archiveDate = null;
                        if ($(".js-global-modal").find(".js-schedule-archive-config").length > 0) {
                            if ($(".js-global-modal").find('#archive-date').val() != "") {
                                archiveDateString =
                                    $(".js-global-modal").find('#archive-date').val() +
                                        " " +
                                        $(".js-global-modal").find('#archive-time').val();
                                archiveDate = GetISODate(dayjs(archiveDateString), archiveTimeZone, "MM/DD/YYYY hh:mm:s a");
                            }
                        }
                        if (errorMessage === "") {
                            if (archiveDateString == null) {
                                archiveTimeZone = null;
                            }
                            var micrositeDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "launchDate": launchDate,
                                "launchTimeZone": timeZone,
                                "archiveDate": archiveDate,
                                "archiveTimeZone": archiveTimeZone
                            };
                            var url = "/Microsite/UpdateMicrositeOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(micrositeDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/Microsite/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId + "/" + suppressViewLink;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-microsite").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifyMicrositeDates(button);
                                    });
                                    $(refreshContainer).find(".js-remove-microsite").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelMicrositeMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    modifySocialPostDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        $.ajax({
            method: "GET",
            url: "/SocialPost/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                $(".js-global-modal").find("#launch-data-picker-full").datetimepicker();
                me.populateTimeZonesOnly($(".js-global-modal").find(".time-zone"));
                $(".js-global-modal").find('#launch-time-picker').datetimepicker({
                    format: 'LT'
                });
                $(".js-global-modal").find('#launch-date-picker').datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY'
                });
                if ($(".js-global-modal").find(".js-launch-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-launch-time-zone-data").val() !== undefined) {
                    $(".js-launch-time-zone").val($(".js-launch-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#launch-date-full").val() !== "") {
                    const setTime = dayjs.utc($(".js-global-modal").find('#launch-date-full').val()).tz($(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val()).format("hh:mm A");
                    $(".js-global-modal").find('#launch-time-picker').data("DateTimePicker").date(setTime);
                    var localDate = dayjs.utc($(".js-global-modal").find('#launch-date-full').val())
                        .tz($(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val()).local()
                        .format('MM/DD/YYYY');
                    $(".js-global-modal").find('#launch-date').val(localDate);
                    $(".js-global-modal").find("#launch-date").attr("value", (localDate + " " + setTime));
                    $(".js-global-modal").find('#launch-date-picker').data("DateTimePicker").date($(".js-global-modal").find("#launch-date").attr("value"));
                }
                // me.bindLocalizedTime();
                $(".js-global-modal").find(".js-change-social-post-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-social-post-dates").on("click", function (e) {
                    var errorMessage = "";
                    var launchDateRequired = $(e.currentTarget).attr("data-launch-date-required");
                    var launchTimeRequired = $(e.currentTarget).attr("data-launch-time-required");
                    var timeZone = $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val();
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-date").val() === "") {
                        errorMessage += launchDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-time").val() === "") {
                        errorMessage += launchTimeRequired + "<br/>";
                    }
                    if (errorMessage === "") {
                        var launchDateString = $(".js-global-modal").find('#launch-date-picker').data("DateTimePicker").date()
                            .format("YYYY-MM-DD") +
                            " " +
                            $(".js-global-modal").find('#launch-time-picker').data("DateTimePicker").date()
                                .format("HH:mm:ss");
                        var timeZoneDate = dayjs.tz(launchDateString, timeZone);
                        var launchDate = timeZoneDate.utc().format();
                        if (errorMessage === "") {
                            var socialPostDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "launchDate": launchDate,
                                "launchTimeZone": timeZone,
                            };
                            var url = "/SocialPost/UpdateMicrositeOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(socialPostDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/SocialPost/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-social-post").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifySocialPostDates(button);
                                    });
                                    $(refreshContainer).find(".js-remove-social-post").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelSocialPostMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    populateTimeZonesOnly(el) {
        var timeZones = Intl.supportedValuesOf("timeZone");
        $(el).append("<option value='UTC'>UTC</option>");
        $.each(timeZones, function (i, v) {
            $(el).append("<option value='" + v + "'>" + v + "</option>");
        });
        // Set default time zone based on their location
        $(el).find("option[value='" + dayjs.tz.guess() + "']").attr('selected', "true");
    }
    populateTimeZones(el) {
        var timeZones = Intl.supportedValuesOf("timeZone");
        $(el).append("<option value='UTC'>UTC</option>");
        $.each(timeZones, function (i, v) {
            $(el).append("<option value='" + v + "'>" + v + "</option>");
        });
        // Set default time zone based on their location
        $(el).find("option[value='" + dayjs.tz.guess() + "']").attr('selected', "true");
    }
    bindLocalizedTime() {
        var me = this;
        $.each($(me._widget).find(".localized-time-email-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + "  <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
        });
        $.each($(me._widget).find(".localized-time-microsite-launch-date-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
        });
        $.each($(me._widget).find(".localized-time-microsite-archive-date-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
        });
    }
    showDetail(expand) {
        var me = this;
        var widgetContainer = $('.widget-myproject-list');
        var parentContainer = $(expand).parent().closest('tr').next('tr');
        var detailContainer = $(parentContainer).find(".detail-" + $(expand).data("identifier"));
        var icon = $(expand).find('span');
        if ($(icon).hasClass('fa-chevron-down')) {
            if ($(detailContainer).hasClass("js-data-loaded")) {
                $(parentContainer).removeClass('hide');
                $(icon).toggleClass('fa-chevron-down fa-chevron-up');
                if ($(detailContainer).find(".js-check-status").length > 0) {
                    var statusButton = $(detailContainer).find(".js-check-status");
                    me.checkCompositionFileStatus(statusButton, true);
                }
                if ($(detailContainer).find(".js-post-social-network-action").length > 0) {
                    $(detailContainer).find(".js-post-social-network-action").on('click', function () {
                        var expand = this;
                        me.openFaceBookPost(expand);
                    });
                }
                if ($(detailContainer).find(".js-facebook-reset-permission").length > 0) {
                    $(detailContainer).find(".js-facebook-reset-permission").on('click', function () {
                        var expand = this;
                        me.resetFaceBookPermissions(expand);
                    });
                }
            }
            else {
                $(widgetContainer).find('.js-vieworderdetail').attr('disabled', 'true');
                var identifier = $(expand).data("identifier");
                var source = "order";
                var suppressViewLink = $(widgetContainer).find('.dataTable').attr("suppress-view-link");
                $.when(me.getOrderDetail(identifier, source, suppressViewLink).done(function (data, textStatus, response) {
                    $(parentContainer).removeClass('hide');
                    $(parentContainer).slideDown(1000);
                    detailContainer.html($(this).data("identifier"));
                    detailContainer.addClass("js-data-loaded");
                    $(icon).toggleClass('fa-chevron-down fa-chevron-up');
                    detailContainer.html(data);
                    $(widgetContainer).find('.js-vieworderdetail').removeAttr('disabled');
                    $(widgetContainer).find(".js-download-action").on('click', function () {
                        var expand = this;
                        me.download(expand);
                    });
                    if ($(detailContainer).find(".js-check-status").length > 0) {
                        var statusButton = $(detailContainer).find(".js-check-status");
                        //me.checkCompositionFileStatus(statusButton, true);
                        $(detailContainer).find(".js-check-status").on('click', function () {
                            var expand = this;
                            me.checkCompositionFileStatus(expand, true);
                        });
                    }
                    if ($(detailContainer).find(".js-post-social-network-action").length > 0) {
                        $(detailContainer).find(".js-post-social-network-action").on('click', function () {
                            var expand = this;
                            me.openFaceBookPost(expand);
                        });
                    }
                    if ($(detailContainer).find(".js-resubmit-order-item").length > 0) {
                        $(detailContainer).find(".js-resubmit-order-item").on('click', function () {
                            var expand = this;
                            me.resubmitOrderItem(expand, false);
                        });
                    }
                    if ($(detailContainer).find(".js-order-send-email").length > 0) {
                        $(detailContainer).find(".js-order-send-email").on("click", function (e) {
                            e.preventDefault();
                            var button = $(e.currentTarget);
                            bootbox.prompt({
                                title: $(button).attr("data-email-address-header"),
                                inputType: 'email',
                                value: $(button).attr("data-email-address"),
                                callback: function (result) {
                                    if (result != null) {
                                        $(button).attr("data-email-address", result);
                                        me.SendCompositionEmail(button);
                                    }
                                }
                            });
                        });
                    }
                    me.bindLocalizedTime();
                    if ($(detailContainer).find(".js-modify-campaign").length > 0) {
                        $(detailContainer).find(".js-modify-campaign").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.modifyCampaignDates(button);
                        });
                    }
                    if ($(detailContainer).find(".js-remove-campaign").length > 0) {
                        $(detailContainer).find(".js-remove-campaign").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.openCancelCampaignMessage(button);
                        });
                    }
                    if ($(detailContainer).find(".js-microsite-activity-list").length > 0) {
                        $(detailContainer).find(".js-microsite-activity-list").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.openMicrositeActivityList(button);
                        });
                    }
                    $(detailContainer).find(".js-direct-mail-list-recipients").on('click', function (e) {
                        var button = $(e.currentTarget);
                        me.openDirectMailListRecipients(button);
                    });
                    $(detailContainer).find(".js-email-uploaded-list-recipients").on('click', function (e) {
                        var button = $(e.currentTarget);
                        me.openEmailUploadedListRecipients(button);
                    });
                    $(detailContainer).find(".js-microsite-list-recipients").on('click', function (e) {
                        var button = $(e.currentTarget);
                        me.openMicrositeListRecipients(button);
                    });
                    if ($(detailContainer).find(".js-contact-activity-list").length > 0) {
                        $(detailContainer).find(".js-contact-activity-list").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.openContactActivityList(button);
                        });
                    }
                    if ($(detailContainer).find(".js-modify-microsite").length > 0) {
                        $(detailContainer).find(".js-modify-microsite").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.modifyMicrositeDates(button);
                        });
                    }
                    if ($(detailContainer).find(".js-modify-social-post").length > 0) {
                        $(detailContainer).find(".js-modify-social-post").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.modifySocialPostDates(button);
                        });
                    }
                    if ($(detailContainer).find(".js-remove-microsite").length > 0) {
                        $(detailContainer).find(".js-remove-microsite").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.openCancelMicrositeMessage(button);
                        });
                    }
                    if ($(detailContainer).find(".js-remove-social-post").length > 0) {
                        $(detailContainer).find(".js-remove-social-post").on('click', function (e) {
                            var button = $(e.currentTarget);
                            me.openCancelSocialPostMessage(button);
                        });
                    }
                }));
            }
        }
        else {
            $(parentContainer).addClass('hide');
            $(icon).toggleClass('fa-chevron-down fa-chevron-up');
        }
    }
    getOrderDetail(identifier, source, suppressViewLink) {
        var params = {
            "source": source,
            "identifier": identifier,
            "suppressViewLink": suppressViewLink
        };
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Api/AccountTransaction/GetTransactionDetail'
        });
    }
    setPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find('#myproject-list-pagination').html('');
            $(me._widget).find('#myproject-list-pagination').html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find('#myproject-list-pagination').find('#pagination').twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.loadData(false);
                }
            });
        }
        else {
            $(me._widget).find('#myproject-list-pagination').html('');
        }
    }
    loadData(filterClose) {
        var me = this;
        var params = me.buildParams(me._widgetId);
        var url = '/Content/RenderOrderList/' + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            me._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            me._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(me._widget).find("#list-items").html(data);
            me.showPager();
            if (filterClose) {
                $("#ajax-loading").modal("hide");
                $(me._widget).find(".filter-close").click();
            }
            $(me._widget).find(".js-vieworderdetail").on('click', function (e) {
                me.showDetail($(e.currentTarget));
            });
            $(me._widget).find(".js-delete-order").on('click', function (e) {
                me.delete($(e.currentTarget));
            });
        }));
    }
    ShowHideFilter(el) {
        var me = this;
        var list = $(el).parent(".widget-myprojectlist").attr("id");
        var filterType = $(el).attr("data-filtertype");
        var $dropdown = $(me._widget).find("div[id='" + list + "'] .filter-drop-down[data-filtertype='" + filterType + "']");
        var $indicator = $(me._widget).find(".filter-indicator");
        var dropdownIsClosed = $dropdown.hasClass("hide");
        $(me._widget).find(".filter-drop-down").addClass("hide");
        $(me._widget).find(".filter-indicator").removeClass("fa-caret-up").addClass("fa-caret-down");
        if (dropdownIsClosed) {
            $dropdown.removeClass("hide");
            $indicator.removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    }
    selectDeselectFacet(el) {
        var me = this;
        if ($(el).hasClass("disabled")) {
            return;
        }
        var $facetIndicator = $(el).find(".filter-facet-indicator");
        var $accountTransactionList = $(el).closest(".accounttransaction-list");
        $facetIndicator.toggleClass("fa-check");
        var contentWidgetID = me._widgetId;
        if ($facetIndicator.hasClass("fa-check")) {
            $facetIndicator.removeClass("hidden");
            $(me._widget).find("#widget-myprojectlist-appliedfilters-" + contentWidgetID).append("<button class='pull-left btn btn-color1 myproject-list-remove-filter' data-filter-type='" + $(el).attr("data-filter-type") + "' data-filter-id='" + $(el).attr("data-filter-id") + "'><span class='fa-solid fa-check'></span> " + $(el).attr("data-name") + " | <span class='remove'>x</span></button>");
            $(me._widget).find(".myproject-list-remove-filter").off("click");
            $(me._widget).find(".myproject-list-remove-filter").on("click", function () {
                var filterID = parseInt($(this).attr("data-filter-id"));
                var filterType = $(this).attr("data-filter-type");
                me.selectDeselectFacet($("button.filter-facet[data-filter-type='" + filterType + "'][data-filter-id='" + filterID + "']"));
            });
        }
        else {
            $facetIndicator.addClass("hidden");
            $(me._widget).find("#widget-myprojectlist-appliedfilters-" + contentWidgetID).find("button[data-filter-type='" + $(el).attr("data-filter-type") + "'][data-filter-id='" + $(el).attr("data-filter-id") + "']").remove();
        }
        me.UpdateFilter(contentWidgetID);
    }
    applyFilter(el) {
        var me = this;
        this.UpdateFilter(me._widgetId);
    }
    UpdateFilter(contentWidgetID) {
        var me = this;
        $('#ajax-loading').modal();
        me._sortBy = "datecreated";
        me._pageIndex = 0;
        me._sortAscending = "false";
        me.loadData(true);
    }
    showPager() {
        var me = this;
        if (me._totalPages > 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
            me.setPager();
        }
    }
    buildParams(contentWidgetId) {
        var $statustypeFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] div.filter-drop-down[data-filtertype='StatusTypes']");
        var arrayTypes = new Array;
        $statustypeFilter.find("span.fa-check").each(function (i, e) {
            arrayTypes.push(parseInt($(e).attr("data-id")));
        });
        var statusTypes = arrayTypes.join(",");
        var params = {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            Skip: 0,
            StatusTypes: statusTypes
        };
        return params;
    }
}
;
$(document).ready(function () {
    $(".widget-myproject-list").each(function (index, item) {
        $(item).data("manager", new MyProject(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class OrderDetail {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this.bindControls();
    }
    bindControls() {
        var me = this;
        window.setTimeout(function () {
            $(me._widget).find(".orderdetail-item-row").each(function (i, obj) {
                if ($(obj).find(".js-check-status").length > 0) {
                    var statusButton = $(obj).find(".js-check-status");
                    if ($(statusButton).attr("data-product-type-id") !== "10") {
                        me.checkCompositionFileStatus(statusButton, false);
                    }
                }
            });
        }, 150000);
        $(me._widget).find(".js-download-pdf").on("click", function (e) {
            me.downloadPdf($(e.currentTarget));
        });
        $(me._widget).find(".js-send-list-based-email").on("click", function (e) {
            me.sendListBasedEmail(e);
        });
        $(me._widget).find(".orderdetail-item-row").each(function (i, obj) {
            if ($(obj).find(".js-check-status").length > 0) {
                var statusButton = $(obj).find(".js-check-status");
                if ($(statusButton).attr("data-product-type-id") !== "10") {
                    me.checkCompositionFileStatus(statusButton, false);
                }
            }
        });
        $(me._widget).find(".js-order-send-email").on("click", function (e) {
            e.preventDefault();
            var button = $(e.currentTarget);
            bootbox.prompt({
                title: $(button).attr("data-email-address-header"),
                inputType: 'email',
                value: $(button).attr("data-email-address"),
                callback: function (result) {
                    if (result != null) {
                        var validEmail = emailRegex.test(result);
                        if (!validEmail) {
                            var invalidEmailErroMessage = $(button).attr("data-invalid-email-message");
                            bootbox.alert(invalidEmailErroMessage);
                            $(".bootbox.modal.bootbox-alert").css({ "z-index": "10006" });
                            return false;
                        }
                        $(button).attr("data-email-address", result);
                        me.SendCompositionEmail(button);
                    }
                }
            });
        });
        $(me._widget).find("#order-history-modal").on('show.bs.modal', function (event) {
            var self = this;
            var orderlineItemId = $(event.relatedTarget).attr("data-order-line-item-id");
            var params = {
                "participantOrderLineItemId": orderlineItemId,
            };
            $.ajax({
                data: params,
                method: "GET",
                url: "/Manage/ParticipantOrder/GetParticipantOrderHistory"
            }).done(function (data, textStatus, request) {
                $("#order-history-modal").find(".modal-body").html(data);
            });
        });
        $(me._widget).find(".js-download-action").on('click', function () {
            var expand = this;
            me.download(expand);
        });
        $(me._widget).find(".js-post-social-network-action").on('click', function () {
            var button = this;
            me.openFaceBookPost(button);
        });
        $(me._widget).find(".js-facebook-reset-permission").on('click', function (e) {
            var button = this;
            me.resetFaceBookPermissions(button);
        });
        $(me._widget).find(".js-check-status").on('click', function () {
            var expand = this;
            me.checkCompositionFileStatus(expand, true);
        });
        $(me._widget).find(".js-resubmit-order-item").on('click', function () {
            var expand = this;
            me.resubmitOrderItem(expand, false);
        });
        $(me._widget).find(".js-modify-campaign").on('click', function (e) {
            var button = $(e.currentTarget);
            me.modifyCampaignDates(button);
        });
        $(me._widget).find(".js-contact-activity-list").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openContactActivityList(button);
        });
        $(me._widget).find(".js-email-uploaded-list-recipients").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openEmailUploadedListRecipients(button);
        });
        $(me._widget).find(".js-microsite-list-recipients").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openMicrositeListRecipients(button);
        });
        $(me._widget).find(".js-direct-mail-list-recipients").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openDirectMailListRecipients(button);
        });
        $(me._widget).find(".js-microsite-activity-list").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openMicrositeActivityList(button);
        });
        $(me._widget).find(".js-modify-microsite").on('click', function (e) {
            var button = $(e.currentTarget);
            me.modifyMicrositeDates(button);
        });
        $(me._widget).find(".js-modify-social-post").on('click', function (e) {
            var button = $(e.currentTarget);
            me.modifySocialPostDates(button);
        });
        $(me._widget).find(".js-remove-campaign").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openCancelCampaignMessage(button);
        });
        $(me._widget).find(".js-remove-microsite").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openCancelMicrositeMessage(button);
        });
        $(me._widget).find(".js-remove-social-post").on('click', function (e) {
            var button = $(e.currentTarget);
            me.openCancelSocialPostMessage(button);
        });
        me.bindLocalizedTime();
    }
    openMicrositeActivityList(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        $.ajax({
            method: "GET",
            url: "/Microsite/GetActivitySummaryList/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                $(".global-modal-inner-container").find(".js-download-activity-list").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-activity-list").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    window.location.href = "/Microsite/DownloadActivitySummaryList/" +
                        contactListIdentifier +
                        "/" +
                        $(".global-modal-inner-container").find(".js-micrositedownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openEmailUploadedListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetEmailUploadedListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-email-uploaded-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/EmailCampaign/DownloadEmailUploadedListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-emailuploadedlistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openDirectMailListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/DirectMail/GetDirectMailListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-direct-mail-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/DirectMail/DownloadDirectMailListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-direct-maillistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openMicrositeListRecipients(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetMicrositeListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var table = $(".global-modal-inner-container").find(".dataTable");
                // DATATABLE
                $(table).DataTable({
                    "pageLength": 25,
                    "searching": false,
                    "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">'
                });
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").attr("data-contact-list-identifier", contactListIdentifier);
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").attr("data-item-detail-identifier", orderLineItemDetailIdentifier);
                $(".global-modal-inner-container").find(".js-download-microsite-list-recipients").click(function (e) {
                    var contactListIdentifier = $(e.currentTarget).attr("data-contact-list-identifier");
                    var orderLineItemDetailIdentifier = $(e.currentTarget).attr("data-item-detail-identifier");
                    window.location.href = "/EmailCampaign/DownloadMicrositeListRecipients/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier + "/" + $(".global-modal-inner-container").find(".js-micrositelistrecipientsdownloadfiletype").val();
                });
            }
            else {
            }
        });
    }
    openContactActivityList(button) {
        var me = this;
        var contactListIdentifier = $(button).attr("data-contact-list-identifier");
        var orderLineItemDetailIdentifier = $(button).attr("data-item-detail-identifier");
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetActivitySummaryListLimited/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(contactListIdentifier);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                $(".global-modal-inner-container").find(".js-download-activity-list").click(function (e) {
                    var dataType = $(e.currentTarget).attr("data-type");
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var title = $(e.currentTarget).attr("data-title");
                    var body = $(e.currentTarget).attr("data-body");
                    // handles big files without timing out
                    // @ts-ignore
                    var uniqueId = 'EmailOrderDownload-' + getUniqueGuid();
                    var url = "/EmailCampaign/DownloadActivitySummaryList" +
                        "?orderLineItemDetailIdentifier=" + orderLineItemDetailIdentifier +
                        "&contactListIdentifier=" + contactListIdentifier +
                        "&fileType=" + dataType +
                        "&uniqueId=" + uniqueId +
                        "&searchText=" + searchText;
                    e.preventDefault();
                    // @ts-ignore
                    bootbox.dialog({
                        title: title,
                        message: body +
                            '<div id="progress-wrapper-upload">' +
                            '<div class="progress-wrapper">' +
                            '<div class="progress-indicator text-center">' +
                            '</div></div></div>',
                        closeButton: false
                    });
                    // move box to front
                    $(".bootbox.modal.bootbox").css({ "z-index": "10006" });
                    // initialize process status row, and return to call loop
                    // @ts-ignore
                    updateProgressStatus(uniqueId, '/API/Manage/ProcessStatus/AddProgress/', function () { progressBar(url, uniqueId); });
                });
                // @ts-ignore
                function progressBar(url, uniqueId) {
                    $.when(submitAjaxRequest(null, url, "GET")
                        .done(function (data, textStatus, request) {
                        // tell process it is done
                        $('#loadupload-loop').val('1');
                        // swallow success since I will handle it with the ProgressStatus
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        // swallow timeout error since I will handle it with the ProgressStatus
                    }));
                    var pollingStop = $('#loadupload-loop'); // used for a quick exit from the loop if applicable
                    var progressWrapper = $('#progress-wrapper-upload');
                    // getStatus is a recursive process which waits for 0% or 100%. When found, run the passed function, which is in the helper.
                    getStatus(uniqueId, '/API/Manage/ProcessStatus/GetCurrentProgress/', pollingStop, progressWrapper, 
                    // @ts-ignore
                    function () {
                        // done, reset and get the file
                        $('#loadupload-loop').val('0');
                        var finalUrl = '/EmailCampaign/GetDownLoadFile?UniqueId=' + uniqueId;
                        // @ts-ignore
                        window.location = finalUrl;
                        // remove the process status row
                        //updateProgressStatus(uniqueId, '/API/Manage/ProcessStatus/RemoveProgress/');
                    });
                }
                $(".global-modal-inner-container").find(".js-campaign-list-filter-button-reset").click(function (e) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var me = this;
                    $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val("");
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var params = {
                        "searchText": searchText
                    };
                    $.ajax({
                        data: params,
                        method: "GET",
                        url: "/EmailCampaign/GetActivitySummaryListLimitedDataOnly/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
                    }).done(function (data, textStatus, request) {
                        if (data) {
                            $(".global-modal-inner-container").find(".js-campaign-list-filtered-table").html(data);
                        }
                    });
                });
                $(".global-modal-inner-container").find(".js-campaign-list-filter-button").click(function (e) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var me = this;
                    var searchText = $(".global-modal-inner-container").find(".js-campaign-list-filter-text").val();
                    var params = {
                        "searchText": searchText
                    };
                    $.ajax({
                        data: params,
                        method: "GET",
                        url: "/EmailCampaign/GetActivitySummaryListLimitedDataOnly/" + orderLineItemDetailIdentifier + "/" + contactListIdentifier
                    }).done(function (data, textStatus, request) {
                        if (data) {
                            $(".global-modal-inner-container").find(".js-campaign-list-filtered-table").html(data);
                        }
                    });
                });
            }
            else {
            }
        });
    }
    modifyCampaignDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var suppressViewLink = $(button).attr("data-suppress-view-link") == "False" ? false : true;
        $.ajax({
            method: "GET",
            url: "/EmailCampaign/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-send-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                GlobalPopulateTimeZones($(".js-global-modal").find(".time-zone"));
                if ($(".js-global-modal").find(".js-send-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-send-time-zone-data").val() !== undefined) {
                    $(".js-send-time-zone").val($(".js-send-time-zone-data").val());
                }
                if ($(".js-global-modal").find(".js-seed-send-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-seed-send-time-zone-data").val() !== undefined) {
                    $(".js-global-modal").find(".js-seed-send-time-zone").val($(".js-seed-send-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#send-date-full").val() !== "") {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#send-date-full').val(), $(".js-global-modal").find(".js-schedule-send-config").find(".js-send-time-zone").val(), $(".js-global-modal").find('#send-time'), $(".js-global-modal").find('#send-date-picker'), $(".js-global-modal").find('#send-date'));
                }
                if ($(".js-global-modal").find("#seed-send-date-full").val() !== "" && $(".js-global-modal").find("#seed-send-date-full").val() !== undefined) {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#seed-send-date-full').val(), $(".js-global-modal").find(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val(), $(".js-global-modal").find('#seed-send-time'), $(".js-global-modal").find('#seed-send-date-picker'), $(".js-global-modal").find('#seed-send-date'));
                }
                var sendDateEl = $(".js-global-modal").find('#send-date-picker').get(0);
                var sendDateTimeEl = $(".js-global-modal").find('#send-time-picker').get(0);
                var seedSendDateEl = $(".js-global-modal").find('#seed-send-date-picker').get(0);
                var seedSendDateTimeEl = $(".js-global-modal").find('#seed-send-time-picker').get(0);
                ConfigureDatePicker($(".js-global-modal").find('#send-date-picker'));
                ConfigureDatePicker($(".js-global-modal").find('#seed-send-date-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#send-time-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#seed-send-time-picker'));
                //InitializeDatePickerForOrder(sendDateEl, sendDateTimeEl, seedSendDateEl, seedSendDateTimeEl);
                $(".js-global-modal").find(".js-change-campaign-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-campaign-dates").on("click", function (e) {
                    var errorMessage = "";
                    var recipientSendDateRequired = $(e.currentTarget).attr("data-recipient-send-date-required");
                    var seedSendDateRequired = $(e.currentTarget).attr("data-seed-send-date-required");
                    var recipientSendTimeRequired = $(e.currentTarget).attr("data-recipient-send-time-required");
                    var seedSendTimeRequired = $(e.currentTarget).attr("data-seed-send-time-required");
                    var recipientSendDateGreaterThanToday = $(e.currentTarget).attr("data-recipient-send-date-greater-than-today");
                    var seedSendDateGreaterThanToday = $(e.currentTarget).attr("data-seed-send-date-greater-than-today");
                    var timeZone = $(".js-global-modal").find(".js-schedule-send-config").find(".js-send-time-zone").val();
                    var seedTimeZone = $(".js-global-modal").find(".js-schedule-seed-send-config").find(".js-seed-send-time-zone").val();
                    var seedSendDateGreaterThanSendDate = $(e.currentTarget).attr("data-seed-send-date-greater-than-send-date");
                    if ($(".js-global-modal").find(".js-schedule-send-config").find("#send-date").val() === "") {
                        errorMessage += recipientSendDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-send-config").find("#send-time").val() === "") {
                        errorMessage += recipientSendTimeRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-seed-send-config").length > 0) {
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").find("#seed-send-date").val() === "") {
                            errorMessage += seedSendDateRequired + "<br/>";
                        }
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").find("#seed-send-time").val() === "") {
                            errorMessage += seedSendTimeRequired + "<br/>";
                        }
                    }
                    if (errorMessage === "") {
                        var sendDateString = $(".js-global-modal").find('#send-date').val() +
                            " " +
                            $(".js-global-modal").find('#send-time').val();
                        var currentDate = new Date().toISOString();
                        var startDate = GetISODate(dayjs(sendDateString), timeZone, "MM/DD/YYYY hh:mm:s a");
                        if (startDate < currentDate) {
                            errorMessage += recipientSendDateGreaterThanToday + "<br/>";
                        }
                        var seedDateString = null;
                        var seedStartDate = null;
                        if ($(".js-global-modal").find(".js-schedule-seed-send-config").length > 0) {
                            if ($(".js-global-modal").find('#seed-send-date').val() != "") {
                                seedDateString = $(".js-global-modal").find('#seed-send-date').val() +
                                    " " +
                                    $(".js-global-modal").find('#seed-send-time').val();
                                var seedStartDate = GetISODate(dayjs(seedDateString), seedTimeZone, "MM/DD/YYYY hh:mm:s a");
                                if (seedStartDate < currentDate) {
                                    errorMessage += seedSendDateGreaterThanToday + "<br/>";
                                }
                                if (seedStartDate > startDate) {
                                    errorMessage += seedSendDateGreaterThanSendDate + "<br/>";
                                }
                            }
                        }
                        if (errorMessage === "") {
                            if (seedDateString == null) {
                                seedTimeZone = null;
                            }
                            var campaignDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "sendDate": startDate,
                                "sendTimeZone": timeZone,
                                "seedSendDate": seedStartDate,
                                "seedSendTimeZone": seedTimeZone
                            };
                            var url = "/EmailCampaign/UpdateCampaignOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(campaignDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/EmailCampaign/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId + "/" + suppressViewLink;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-campaign").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifyCampaignDates(button);
                                    });
                                    $(refreshContainer).find(".js-download-action").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.download(button);
                                    });
                                    $(refreshContainer).find(".js-remove-campaign").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelCampaignMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    modifyMicrositeDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var suppressViewLink = $(button).attr("data-suppress-view-link") == "False" ? false : true;
        $.ajax({
            method: "GET",
            url: "/Microsite/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                GlobalPopulateTimeZones($(".js-global-modal").find(".time-zone"));
                if ($(".js-global-modal").find(".js-launch-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-launch-time-zone-data").val() !== undefined) {
                    $(".js-launch-time-zone").val($(".js-launch-time-zone-data").val());
                }
                if ($(".js-global-modal").find(".js-archive-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-archive-time-zone-data").val() !== undefined) {
                    $(".js-global-modal").find(".js-archive-time-zone").val($(".js-archive-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#launch-date-full").val() !== "") {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#launch-date-full').val(), $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val(), $(".js-global-modal").find('#launch-time'), $(".js-global-modal").find('#launch-date-picker'), $(".js-global-modal").find("#launch-date"));
                }
                if ($(".js-global-modal").find("#archive-date-full").val() !== "" && $(".js-global-modal").find("#archive-date-full").val() !== undefined) {
                    SetModifiedDatesForCustomization($(".js-global-modal").find('#archive-date-full').val(), $(".js-global-modal").find(".js-schedule-archive-config").find(".js-archive-time-zone").val(), $(".js-global-modal").find('#archive-time'), $(".js-global-modal").find('#archive-date-picker'), $(".js-global-modal").find("#archive-date"));
                }
                var launchDateEl = $(".js-global-modal").find('#launch-date-picker').get(0);
                var archiveDateEl = $(".js-global-modal").find('#archive-date-picker').get(0);
                var launchTimeEl = $(".js-global-modal").find('#launch-time-picker').get(0);
                var archiveTimeEl = $(".js-global-modal").find('#archive-time-picker').get(0);
                ConfigureDatePicker($(".js-global-modal").find('#launch-date-picker'));
                ConfigureDatePicker($(".js-global-modal").find('#archive-date-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#launch-time-picker'));
                ConfigureTimePicker($(".js-global-modal").find('#archive-time-picker'));
                //InitializeDatePickerForOrder(launchDateEl, launchTimeEl, archiveDateEl, archiveTimeEl);
                // me.bindLocalizedTime();
                $(".js-global-modal").find(".js-change-microsite-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-microsite-dates").on("click", function (e) {
                    var errorMessage = "";
                    var launchDateRequired = $(e.currentTarget).attr("data-launch-date-required");
                    var archiveDateRequired = $(e.currentTarget).attr("data-archive-date-required");
                    var launchTimeRequired = $(e.currentTarget).attr("data-launch-time-required");
                    var archiveTimeRequired = $(e.currentTarget).attr("data-archive-time-required");
                    var timeZone = $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val();
                    var archiveTimeZone = $(".js-global-modal").find(".js-schedule-archive-config").find(".js-archive-time-zone").val();
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-date").val() === "") {
                        errorMessage += launchDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-time").val() === "") {
                        errorMessage += launchTimeRequired + "<br/>";
                    }
                    if (errorMessage === "") {
                        var launchDateString = $(".js-global-modal").find('#launch-date').val() +
                            " " +
                            $(".js-global-modal").find('#launch-time').val();
                        var launchDate = GetISODate(dayjs(launchDateString), timeZone, "MM/DD/YYYY hh:mm:s a");
                        var archiveDateString = null;
                        var archiveDate = null;
                        if ($(".js-global-modal").find(".js-schedule-archive-config").length > 0) {
                            if ($(".js-global-modal").find('#archive-date').val() != "") {
                                archiveDateString =
                                    $(".js-global-modal").find('#archive-date').val() +
                                        " " +
                                        $(".js-global-modal").find('#archive-time').val();
                                archiveDate = GetISODate(dayjs(archiveDateString), archiveTimeZone, "MM/DD/YYYY hh:mm:s a");
                            }
                        }
                        if (errorMessage === "") {
                            if (archiveDateString == null) {
                                archiveTimeZone = null;
                            }
                            var micrositeDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "launchDate": launchDate,
                                "launchTimeZone": timeZone,
                                "archiveDate": archiveDate,
                                "archiveTimeZone": archiveTimeZone
                            };
                            var url = "/Microsite/UpdateMicrositeOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(micrositeDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/Microsite/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId + "/" + suppressViewLink;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-microsite").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifyMicrositeDates(button);
                                    });
                                    $(refreshContainer).find(".js-remove-microsite").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelMicrositeMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    modifySocialPostDates(button) {
        var me = this;
        var lineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        $.ajax({
            method: "GET",
            url: "/SocialPost/GetParticipantOrderDetail/" + lineItemDetailId
        }).done(function (data, textStatus, request) {
            if (data) {
                var globalModal = new GlobalModal(lineItemDetailId);
                var html = data;
                globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-launch-modal' });
                var refreshContainer = $(button).closest(".js-order-detail-row");
                $(".js-global-modal").find("#launch-data-picker-full").datetimepicker();
                GlobalPopulateTimeZones($(".js-global-modal").find(".time-zone"));
                $(".js-global-modal").find('#launch-time-picker').datetimepicker({
                    format: 'LT'
                });
                $(".js-global-modal").find('#launch-date-picker').datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY'
                });
                if ($(".js-global-modal").find(".js-launch-time-zone-data").val() !== "" && $(".js-global-modal").find(".js-launch-time-zone-data").val() !== undefined) {
                    $(".js-launch-time-zone").val($(".js-launch-time-zone-data").val());
                }
                if ($(".js-global-modal").find("#launch-date-full").val() !== "") {
                    const setTime = dayjs.utc($(".js-global-modal").find('#launch-date-full').val()).tz($(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val()).format("hh:mm A");
                    $(".js-global-modal").find('#launch-time-picker').data("DateTimePicker").date(setTime);
                    var localDate = dayjs.utc($(".js-global-modal").find('#launch-date-full').val())
                        .tz($(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val()).local()
                        .format('MM/DD/YYYY');
                    $(".js-global-modal").find('#launch-date').val(localDate);
                    $(".js-global-modal").find("#launch-date").attr("value", (localDate + " " + setTime));
                    $(".js-global-modal").find('#launch-date-picker').data("DateTimePicker").date($(".js-global-modal").find("#launch-date").attr("value"));
                }
                // me.bindLocalizedTime();
                $(".js-global-modal").find(".js-change-social-post-dates").attr("data-order-line-item-detail-id", lineItemDetailId);
                $(".js-global-modal").find(".js-change-social-post-dates").on("click", function (e) {
                    var errorMessage = "";
                    var launchDateRequired = $(e.currentTarget).attr("data-launch-date-required");
                    var launchTimeRequired = $(e.currentTarget).attr("data-launch-time-required");
                    var timeZone = $(".js-global-modal").find(".js-schedule-launch-config").find(".js-launch-time-zone").val();
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-date").val() === "") {
                        errorMessage += launchDateRequired + "<br/>";
                    }
                    if ($(".js-global-modal").find(".js-schedule-launch-config").find("#launch-time").val() === "") {
                        errorMessage += launchTimeRequired + "<br/>";
                    }
                    if (errorMessage === "") {
                        var launchDateString = $(".js-global-modal").find('#launch-date-picker').data("DateTimePicker").date()
                            .format("YYYY-MM-DD") +
                            " " +
                            $(".js-global-modal").find('#launch-time-picker').data("DateTimePicker").date()
                                .format("HH:mm:ss");
                        var timeZoneDate = dayjs.tz(launchDateString, timeZone);
                        var launchDate = timeZoneDate.utc().format();
                        if (errorMessage === "") {
                            var socialPostDatesDtO = {
                                "orderLineItemDetailId": lineItemDetailId,
                                "launchDate": launchDate,
                                "launchTimeZone": timeZone,
                            };
                            var url = "/SocialPost/UpdateMicrositeOrderLineItemDetail" + "/" + lineItemDetailId;
                            $.when(globalThis.gage.submitAjaxRequest(socialPostDatesDtO, url, "PUT")
                                .done(function (data, textStatus, request) {
                                globalModal.closeGlobalModal();
                                var url = "/SocialPost/GetParticipantOrderDetailForDisplay" + "/" + lineItemDetailId;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    $(refreshContainer).html(data);
                                    $(refreshContainer).find(".js-modify-social-post").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.modifySocialPostDates(button);
                                    });
                                    $(refreshContainer).find(".js-remove-social-post").on('click', function (e) {
                                        var button = $(e.currentTarget);
                                        me.openCancelSocialPostMessage(button);
                                    });
                                    me.bindLocalizedTime();
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                }));
                            })
                                .fail(function (response, textStatus, errorThrown) {
                                bootbox.alert(response.responseJSON.errorMessage);
                                return false;
                            }));
                        }
                        else {
                            bootbox.alert(errorMessage);
                            return false;
                        }
                    }
                    else {
                        bootbox.alert(errorMessage);
                        return false;
                    }
                });
            }
            else {
            }
        });
    }
    bindLocalizedTime() {
        var me = this;
        $.each($(me._widget).find(".localized-time-email-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + "  <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
            //$(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY') + " <div><small>" + dayjs.utc(localDate).local().format('hh:mm a') + "</small></div>");
        });
        $.each($(me._widget).find(".localized-time-microsite-launch-date-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
            //$(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY') + " <div><small>" + dayjs.utc(localDate).local().format('hh:mm a') + "</small></div>");
        });
        $.each($(me._widget).find(".localized-time-microsite-archive-date-configuration"), function (i, e) {
            const localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <div><small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small></div>");
        });
    }
    openCancelSocialPostMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var orderLineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var url = "/SocialPost/CancelSocialPost/" + orderLineItemId + "/" + orderLineItemDetailId + "/false";
                    $.when(globalThis.gage.submitAjaxRequest(null, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row").html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".js-social-post-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                    return true;
                }
            }
        });
    }
    openCancelMicrositeMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var orderLineItemDetailId = $(button).attr("data-order-line-item-detail-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var params = {
                        OrderLineItemId: orderLineItemId,
                        OrderLineItemDetailId: orderLineItemDetailId,
                        IsAdmin: false
                    };
                    var url = "/Microsite/CancelMicrosite/";
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row").html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".localized-time-microsite-launch-date-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".localized-time-microsite-archive-date-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".js-microsite-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                    return true;
                }
            }
        });
    }
    openCancelCampaignMessage(button) {
        var yesText = $(button).attr("data-yes-text");
        var noText = $(button).attr("data-no-text");
        var overwriteMessage = $(button).attr("data-campaign-cancel-message");
        var sendSequenceNumber = $(button).closest(".js-order-detail-row").attr("data-send-sequence-number") === "" ? 0 : $(button).closest(".js-order-detail-row").attr("data-send-sequence-number");
        var seedSequenceNumber = $(button).closest(".js-order-detail-row").attr("data-seed-sequence-number") === "" ? 0 : $(button).closest(".js-order-detail-row").attr("data-seed-sequence-number");
        var orderLineItemId = $(button).closest(".js-order-detail-row").attr("data-order-line-item-id");
        var cancelledStatusText = $(button).attr("data-cancelled-status-text");
        bootbox.confirm({
            message: "<p>" + overwriteMessage + "</p>",
            buttons: {
                confirm: {
                    label: yesText,
                    className: 'btn-success'
                },
                cancel: {
                    label: noText,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var params = {
                        SendSequenceNumber: sendSequenceNumber,
                        SeedSequenceNumber: seedSequenceNumber,
                        OrderLineItemId: orderLineItemId,
                        IsAdmin: false
                    };
                    var url = "/EmailCampaign/CancelCampaign/";
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
                        .done(function (data, textStatus, request) {
                        $(button).closest(".js-order-detail-row").find(".js-order-status-row")
                            .html(cancelledStatusText);
                        $(button).closest(".js-order-detail-row").find(".localized-time-email-configuration").remove();
                        $(button).closest(".js-order-detail-row").find(".js-campaign-action-row").remove();
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        var x = 1;
                    }));
                    return true;
                }
            }
        });
    }
    sendListBasedEmail(e) {
        e.preventDefault();
        var id = $(e.currentTarget).attr('data-product-catalog-assignment-identifier');
        var postMessage = $(e.currentTarget).attr('data-post-email-body');
        var orderDetailId = $(e.currentTarget).attr('data-order-line-item-id');
        var url = "/EmailCampaign/GetListBasedEmailFields/" + id + "/";
        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
            .done(function (data, status, request) {
            var globalModal = new GlobalModal(id);
            var html = data;
            globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-send-modal' });
            $(".js-global-modal").find(".js-send-details").find(".js-order-detail-id").val(orderDetailId);
            $(".js-send-test-list-based-email").on("click", function (e) {
                e.preventDefault();
                var url = "/Api/ParticipantOrder/SendListBasedEmail";
                var params = $("#form-list-email-fields").serialize();
                $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
                    if (data != null) {
                        bootbox.alert(postMessage);
                        globalModal.closeGlobalModal();
                    }
                }));
            });
        })
            .fail(function (response, textStatus, errorThrown) {
            alert(errorThrown);
        }));
    }
    SendCompositionEmail(button) {
        var params = {
            id: parseInt($(button).attr("data-order-line-item-id")),
            emailAddress: $(button).attr("data-email-address"),
            "updateStatus": true
        };
        var url = "/Api/ParticipantOrder/SendCompositionEmail";
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            if (data.success) {
                $(button).closest(".orderdetail-container").find(".js-header-orderstatus").html(data.data.orderHeaderStatus);
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                bootbox.alert($(button).attr("data-post-email-body"));
            }
        }));
    }
    resubmitOrderItem(button, displayPopup) {
        waitingDialog.show($(button).attr("data-wait-message"));
        var params = {
            "orderLineItemId": parseInt($(button).attr("data-order-line-item-id")),
            "orderIdentifier": $(button).attr("data-order-identifier")
        };
        $.ajax({
            data: params,
            method: "GET",
            url: "/Api/ParticipantOrder/ResubmitOrderItem"
        }).done(function (data, textStatus, request) {
            waitingDialog.hide();
            if (data.success) {
                location.reload();
            }
            else {
                if (displayPopup) {
                    alert(data.errorMessage);
                }
            }
        });
    }
    checkCompositionFileStatus(button, showAlert) {
        waitingDialog.show($(button).attr("data-wait-message"));
        var params = {
            "orderItemId": parseInt($(button).attr("data-order-line-item-id")),
        };
        var uri = "/Api/ParticipantOrder/CheckCompositionFileStatus";
        $.ajax({
            data: params,
            method: "GET",
            url: uri
        }).done(function (data, textStatus, request) {
            waitingDialog.hide();
            if (data.success) {
                if (data.orderHeaderStatus == "Complete") {
                    location.reload();
                }
            }
            else {
                waitingDialog.hide();
                if (data.fileStatus == "None") {
                    $(button).addClass("hide");
                    $(button).closest(".orderdetail-item-row").find(".js-resubmit-order-item").removeClass("hide");
                    bootbox.alert($(button).attr("data-customization-error-none-instruction"));
                }
                //if (data.fileStatus !== "None") {
                //    if (showAlert) {
                //        bootbox.alert(data.errorMessage);
                //    }
                //}
            }
        });
    }
    download(button) {
        var params = {
            "id": parseInt($(button).attr("data-order-line-item-id")),
        };
        var url = "/Api/ParticipantOrder/DownloadAction";
        $.when(submitAjaxRequest(params, url, "POST").done(function (data, textStatus, request) {
            if (data.success) {
                // parentrow status description 
                $(button).closest(".orderdetail-container").find(".js-header-orderstatus").html(data.data.orderHeaderStatus);
                ;
                $(button).closest(".orderdetail-item-row").find(".js-order-status").html(data.data.orderLineItemStatus);
                location.href = $(button).attr("data-href");
            }
        }));
    }
    openFaceBookPost(button) {
        var me = this;
        var orderLineItemId = $(button).attr("data-order-line-item-id");
        var child = window.open("/SocialPost/GetFaceBookUserToken", 'self', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no');
        var leftDomain = false;
        var interval = setInterval(function () {
            try {
                if (child.document.domain === document.domain) {
                    if (child.document.readyState === "complete") {
                        // we're here when the child window returned to our domain
                        var child_url = child.document.URL;
                        if (child_url.indexOf("code=") !== -1) {
                            var accessToken = $(child.document).contents().find("body pre").html();
                            $(button).attr("facebook-access-token", accessToken);
                            clearInterval(interval);
                            child.close();
                            if (accessToken !== "") {
                                var dto = {
                                    "accessToken": accessToken,
                                    "orderLineItemId": orderLineItemId
                                };
                                var url = "/SocialPost/GetAccountLists/" + accessToken + "/" + orderLineItemId;
                                $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
                                    .done(function (data, status, request) {
                                    var globalModal = new GlobalModal(accessToken);
                                    var html = data;
                                    globalModal.openGlobalModal(html, "panel", { origin: $(this), classes: 'configure-facebook-post-information--modal' });
                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html("");
                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("");
                                    $(".global-modal-inner-container").find(".js-submit-facebook-post").attr("data-order-line-item-id", orderLineItemId);
                                    $(".global-modal-inner-container").find("#imageurl").attr("src", $(button).attr("data-image-url"));
                                    var pages = $(".global-modal-inner-container").find(".js-facebook-post-pages");
                                    $(pages).multiselect({ numberDisplayed: 0 });
                                    $(pages).multiselect();
                                    $(".global-modal-inner-container").find(".js-submit-facebook-post").click(function (e) {
                                        var submitButton = $(e.currentTarget);
                                        $(submitButton).attr("disabled", "disabled");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").addClass("hide");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html("");
                                        $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("");
                                        var requiredMessage = $(submitButton).attr("data-required-error-message");
                                        var postedMessage = $(submitButton).attr("data-post-submitted-message");
                                        var postedText = $(submitButton).attr("data-posted-text");
                                        if ($(pages).length > 0 && ($(pages).val() == "" || $(pages).val() == null)) {
                                            alert(requiredMessage);
                                            return false;
                                        }
                                        else {
                                            var pageIds = $(pages).val().toString();
                                            var errorHeader = $(e.currentTarget).attr("data-error-header");
                                            var columnErrorHeader = $(e.currentTarget).attr("data-error-header-error");
                                            var columnPageNameHeader = $(e.currentTarget).attr("data-error-header-page-name");
                                            var postSuccessfulSubHeading = $(e.currentTarget).attr("data-post-sucessful-subheading");
                                            var dto = {
                                                "pageId": pageIds,
                                                "orderLineItemId": orderLineItemId
                                            };
                                            var url = "/SocialPost/PostPhoto";
                                            var notSubmittedMessage = "";
                                            var postError = false;
                                            $.when(globalThis.gage.submitAjaxRequest(dto, url, "POST")
                                                .done(function (data, status, request) {
                                                $(submitButton).removeAttr("disabled");
                                                var table = "<table class='table table-responsive'><thead><tr><th>" + columnPageNameHeader + "</th><th>" + columnErrorHeader + "</th></tr></thead>";
                                                $.each(data.result, function (i, v) {
                                                    var statusCode = v.statusCode;
                                                    if (statusCode == "OK") {
                                                        statusCode = postedText;
                                                    }
                                                    if (v.statusCode != "OK") {
                                                        postError = true;
                                                    }
                                                    if (v.faceBookPostURL !== "") {
                                                        table += "<tr><td> <a  target='_blank' href='" + v.faceBookPostURL + "'>" + v.postName + "</a></td><td>" + statusCode + "</td></tr>";
                                                    }
                                                    else {
                                                        table += "<tr><td>" + v.postName + "</td><td>" + statusCode + "</td></tr>";
                                                    }
                                                });
                                                table += "</table>";
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-heading").html(errorHeader);
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").html("<p class='alert alert-info' >" + postSuccessfulSubHeading + " </p>");
                                                $(".global-modal-inner-container").find(".js-messagecontainer").find(".panel-body").append(table);
                                                $(".global-modal-inner-container").find(".js-messagecontainer").removeClass("hide");
                                                if (postError) {
                                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".js-messagecontainer-reset-permission-container").removeClass("hide");
                                                }
                                                else {
                                                    $(".global-modal-inner-container").find(".js-messagecontainer").find(".js-messagecontainer-reset-permission-container").addClass("hide");
                                                }
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-managed-facebook-pages-container").remove();
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-submit-facebook-post").remove();
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-cancel-confirmation-link").addClass("hide");
                                                $(".global-modal-inner-container").find(".submit-facebook-post-container").find(".js-close-confirmation-link").removeClass("hide");
                                                //$(button).closest(".js-action-container").find(".js-post-social-network-revoke").click();
                                            })
                                                .fail(function (response, textStatus, errorThrown) {
                                                globalModal.closeGlobalModal();
                                                alert(errorThrown);
                                                $(submitButton).removeAttr("disabled");
                                            }));
                                        }
                                    });
                                    $(".global-modal-inner-container").find(".js-reset-permission").click(function (e) {
                                        globalModal.closeGlobalModal();
                                        $(".js-facebook-reset-permission").click();
                                    });
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                }));
                            }
                        }
                    }
                }
                else {
                    // this code should never be reached, 
                    // as the x-site security check throws
                    // but just in case
                    leftDomain = true;
                }
            }
            catch (e) {
                // we're here when the child window has been navigated away or closed
                if (child.closed) {
                    clearInterval(interval);
                    return;
                }
                // navigated to another domain  
                leftDomain = true;
            }
        }, 500);
    }
    resetFaceBookPermissions(button) {
        $(button).attr("disabled", "disabled");
        var child = window.open("/SocialPost/GetFaceBookUserToken", 'self', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no');
        var successMessage = $(button).attr("data-reset-permission-success-message");
        var leftDomain = false;
        var interval = setInterval(function () {
            try {
                if (child.document.domain === document.domain) {
                    if (child.document.readyState === "complete") {
                        // we're here when the child window returned to our domain
                        var child_url = child.document.URL;
                        if (child_url.indexOf("code=") !== -1) {
                            var accessToken = $(child.document).contents().find("body pre").html();
                            clearInterval(interval);
                            child.close();
                            if (accessToken !== "") {
                                var params = {
                                    AccessToken: accessToken
                                };
                                $.when(globalThis.gage.submitAjaxRequest(params, "/SocialPost/DeletePermission/", "DELETE")
                                    .done(function (data, status, request) {
                                    if (data != null && data.result == 200) {
                                        bootbox.alert(successMessage);
                                        $(button).removeAttr("disabled");
                                    }
                                })
                                    .fail(function (response, textStatus, errorThrown) {
                                    alert(errorThrown);
                                    $(button).removeAttr("disabled");
                                }));
                            }
                        }
                    }
                }
                else {
                    // this code should never be reached, 
                    // as the x-site security check throws
                    // but just in case
                    leftDomain = true;
                }
            }
            catch (e) {
                // we're here when the child window has been navigated away or closed
                if (child.closed) {
                    clearInterval(interval);
                    return;
                }
                // navigated to another domain  
                leftDomain = true;
            }
        }, 500);
    }
    downloadPdf(dropDown) {
        var me = this;
        var lineItemId = $(dropDown).attr("data-order-line-item-id");
        var templateIdentifier = lineItemId + "-" + $(dropDown).attr("data-template-name");
        var productIdentifier = $(dropDown).attr("data-product-identifier");
        window.location.href = "/Api/ParticipantOrder/DownloadPdf?id=" + productIdentifier + "&templateIdentifier=" + templateIdentifier;
    }
}
;
$(document).ready(function () {
    $(".widget-orderdetail").each(function (index, item) {
        $(item).data("manager", new OrderDetail(item));
    });
});
/// <reference path="../lib/twbs-pagination.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class ParticipantActivityList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._pageIndex = 0;
        this._totalPages = parseFloat($(this._widget).attr("data-total-pages"));
        this._take = parseInt($(this._widget).find("#uxParticipantActivityListPageSize").val());
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._sortBy = $(this._widget).attr("data-sort-by");
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".filter-text, .filter-close").on("click", function () {
            me.ShowHideFilter(this);
        });
        $(me._widget).find(".filter-facet").on("click", function () {
            me.SelectDeselectFacet(this);
        });
        $(me._widget).find("#uxParticipantActivityListPageSize").on("change", function () {
            me._sortBy = "activitydate";
            me._pageIndex = 0;
            me._sortAscending = "false";
            me._take = $(this).val();
            me.LoadData(false, null);
        });
        $(me._widget).find(".js-viewparticipantactivitylistdetail").on("click", function () {
            var expand = this;
            me.showDetail(expand);
        });
        $(me._widget).find(".js-participantactivity-list-search-filter").on("click", function (e) {
            var datarequiredtext = $(this).data("requiredtext");
            var dataattributerequiredtext = $(this).data("attributerequiredtext");
            var btn = $(this);
            e.preventDefault();
            var searchText = $(me._widget).find(".js-participantactivity-list-search-text").val();
            var activityType = $(me._widget).find(".js-participantactivitysearchactivitytype").val();
            var errorMessage = "";
            if (searchText === "") {
                errorMessage = datarequiredtext;
            }
            if (activityType === "") {
                errorMessage += "\n" + dataattributerequiredtext;
            }
            if (errorMessage !== "") {
                alert(errorMessage);
                return false;
            }
            me._searchActivityTypeId = activityType;
            me._searchText = searchText;
            btn.prop('disabled', true);
            me.LoadData(false, btn);
        });
        $(me._widget).find(".js-reset-participantactivity-list-search-filter").on("click", function (e) {
            var btn = $(this);
            $(me._widget).find(".js-participantactivity-list-search-text").val("");
            $(me._widget).find(".js-participantactivitysearchactivitytype").val("");
            me._searchText = "";
            me._searchActivityTypeId = "";
            btn.prop('disabled', true);
            me.LoadData(false, btn);
        });
        me.ShowPager();
        $(me._widget).find(".participantactivityListHeading").click(function () {
            var newHeader = $(this);
            var oldHeader = $(".dataTable").find(".sorting_asc,.sorting_desc");
            if (newHeader.data("sort-field") === oldHeader.data("sort-field")) // change direction
             {
                if ($(".participantactivityListHeading.sorting_asc").length > 0) {
                    //change from ASC to DESC
                    oldHeader.removeClass("sorting_asc");
                    newHeader.addClass("sorting_desc");
                    me._sortAscending = "false";
                }
                else {
                    //change from DESC to ASC
                    oldHeader.removeClass("sorting_desc");
                    newHeader.addClass("sorting_asc");
                    me._sortAscending = "true";
                }
            }
            else // change sort column
             {
                oldHeader.removeClass("sorting_asc").removeClass("sorting_desc").addClass("sorting");
                newHeader.removeClass("sorting").addClass("sorting_asc");
                me._sortAscending = "true";
            }
            $(me._widget).find("#list-items").html();
            me._sortBy = newHeader.data("sort-field");
            me._pageIndex = 0;
            me.LoadData(false, null);
        });
        $(me._widget).find(".button.filter-facet-apply").on("click", function () {
            me.ApplyFilter(this);
        });
    }
    showDetail(expand) {
        var me = this;
        var widgetContainer = $(".widget-participantactivitylist");
        var parentContainer = $(expand).parent().closest("tr").next("tr");
        var detailContainer = $(parentContainer).find(".detail-" + $(expand).data("activityid"));
        var icon = $(expand).find("span");
        if ($(icon).hasClass("fa-chevron-down")) {
            if ($(detailContainer).hasClass("js-data-loaded")) {
                $(parentContainer).removeClass("hide");
                $(icon).toggleClass("fa-chevron-down fa-chevron-up");
            }
            else {
                $(widgetContainer).find(".js-viewparticipantactivitylistdetail").attr("disabled", "true");
                var activitydate = $(expand).data("activitydate");
                var activityTypeId = $(expand).data("activitytypeid");
                var activityId = $(expand).data("activityid");
                var activityItem = $(expand).data("activityitem");
                var participantId = $(expand).data("participantid");
                var multiplier = $(expand).data("multiplier");
                $.when(me.GetParticipantActivityDetail(participantId, activityTypeId, activityId, activityItem, activitydate, multiplier).done(function (data, textStatus, response) {
                    $(parentContainer).removeClass("hide");
                    $(parentContainer).slideDown(1000);
                    detailContainer.html($(this).data("identifier"));
                    detailContainer.addClass("js-data-loaded");
                    $(icon).toggleClass("fa-chevron-down fa-chevron-up");
                    detailContainer.html(data);
                    $(widgetContainer).find(".js-viewparticipantactivitylistdetail").removeAttr("disabled");
                }));
            }
        }
        else {
            $(parentContainer).addClass("hide");
            $(icon).toggleClass("fa-chevron-down fa-chevron-up");
        }
    }
    GetParticipantActivityDetail(participantId, activityTypeId, activityId, activityItem, activityDate, multiplier) {
        var updatedactivityItem = activityItem;
        if (activityItem !== "") {
            updatedactivityItem = JSON.stringify(activityItem);
        }
        var params = {
            "participantId": participantId,
            "activityTypeId": activityTypeId,
            "activityId": activityId,
            "activityItem": updatedactivityItem,
            "activityDate": activityDate,
            "multiplier": multiplier
        };
        return $.ajax({
            method: "GET",
            url: "/Api/Participant/GetParticipantActivityDetail",
            data: params,
        });
    }
    SetPager() {
        var me = this;
        var defaultOpts = {};
        if (me._totalPages !== 0) {
            $(me._widget).find("#participantactivity-list-pagination").html("");
            $(me._widget).find("#participantactivity-list-pagination").html('<ul id="pagination" class="pagination-sm"></ul>');
            $(me._widget).find("#participantactivity-list-pagination").find("#pagination").twbsPagination({
                initiateStartPageClick: false,
                totalPages: me._totalPages,
                startPage: (me._pageIndex === 0 ? 1 : (me._pageIndex + 1)),
                onPageClick: function (event, page) {
                    me._pageIndex = (page - 1);
                    me.LoadData(false, null);
                }
            });
        }
        else {
            $(me._widget).find("#participantactivity-list-pagination").html("");
        }
    }
    LoadData(filterClose, btn) {
        var me = this;
        var params = me.BuildParams(me._widgetId);
        var url = "/Content/RenderParticipantActivityList/" + me._widgetId.toString();
        $.when(submitAjaxRequest(params, url, "POST").done((data, textStatus, request) => {
            this._pageIndex = parseInt(request.getResponseHeader("X-PageIndex"));
            this._totalPages = parseFloat(request.getResponseHeader("X-TotalPages"));
            $(this._widget).find("#list-items").html(data);
            this.ShowPager();
            if (filterClose) {
                $("#ajax-loading").modal("hide");
                $(this._widget).find(".filter-close").click();
            }
            $(this._widget).find(".js-viewparticipantactivitylistdetail").on("click", function () {
                var expand = this;
                me.showDetail(expand);
            });
            if (btn != null) {
                btn.prop('disabled', false);
            }
        }));
    }
    ShowHideFilter(el) {
        var me = this;
        var list = $(el).parent(".widget-participantactivitylist").attr("id");
        var filterType = $(el).attr("data-filtertype");
        var $dropdown = $(me._widget).find("div[id='" + list + "'] .filter-drop-down[data-filtertype='" + filterType + "']");
        var $indicator = $(me._widget).find(".filter-indicator");
        var dropdownIsClosed = $dropdown.hasClass("hide");
        $(me._widget).find(".filter-drop-down").addClass("hide");
        $(me._widget).find(".filter-indicator").removeClass("fa-caret-up").addClass("fa-caret-down");
        if (dropdownIsClosed) {
            $dropdown.removeClass("hide");
            $indicator.removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    }
    SelectDeselectFacet(el) {
        var me = this;
        if ($(el).hasClass("disabled")) {
            return;
        }
        var $facetIndicator = $(el).find(".filter-facet-indicator");
        var $accountTransactionList = $(el).closest(".participantactivity-list");
        $facetIndicator.toggleClass("fa-check");
        var contentWidgetID = me._widgetId;
        if ($facetIndicator.hasClass("fa-check")) {
            $facetIndicator.removeClass("hidden");
            $(me._widget).find("#widget-participantactivitylist-appliedfilters-" + contentWidgetID).append("<button class='pull-left btn btn-color1 participantactivity-list-remove-filter' data-filter-type='" + $(el).attr("data-filter-type") + "' data-filter-id='" + $(el).attr("data-filter-id") + "'><span class='fa-solid fa-check'></span> " + $(el).attr("data-name") + " | <span class='remove'>x</span></button>");
            $(me._widget).find(".participantactivity-list-remove-filter").off("click");
            $(me._widget).find(".participantactivity-list-remove-filter").on("click", function () {
                var filterID = parseInt($(this).attr("data-filter-id"));
                var filterType = $(this).attr("data-filter-type");
                me.SelectDeselectFacet($("button.filter-facet[data-filter-type='" + filterType + "'][data-filter-id='" + filterID + "']"));
            });
        }
        else {
            $facetIndicator.addClass("hidden");
            $(me._widget).find("#widget-participantactivitylist-appliedfilters-" + contentWidgetID).find("button[data-filter-type='" + $(el).attr("data-filter-type") + "'][data-filter-id='" + $(el).attr("data-filter-id") + "']").remove();
        }
        me.UpdateFilter(contentWidgetID);
    }
    ApplyFilter(el) {
        var me = this;
        this.UpdateFilter(me._widgetId);
    }
    UpdateFilter(contentWidgetID) {
        var me = this;
        $("#ajax-loading").modal();
        me._sortBy = "activitydate";
        me._pageIndex = 0;
        me._sortAscending = "false";
        me.LoadData(true, null);
    }
    ShowPager() {
        var me = this;
        if (me._totalPages >= 0) {
            if (me._totalPages < 1) {
                me._totalPages = 0;
            }
            else {
                me._totalPages = Math.ceil(me._totalPages);
            }
            me.SetPager();
        }
    }
    BuildParams(contentWidgetId) {
        var $activitytypeFilter = $("div[data-contentwidgetid='" + contentWidgetId + "'] div.filter-drop-down[data-filtertype='ActivityTypes']");
        var arrayTypes = new Array;
        $activitytypeFilter.find("span.fa-check").each(function (i, e) {
            arrayTypes.push(parseInt($(e).attr("data-id")));
        });
        var activityTypes = arrayTypes.join(",");
        var params = {
            Take: this._take,
            PageIndex: this._pageIndex,
            SortBy: this._sortBy,
            SortAscending: this._sortAscending,
            Skip: 0,
            ActivityTypes: activityTypes,
            SearchText: this._searchText,
            SearchAttributeTypeId: this._searchActivityTypeId
        };
        return params;
    }
}
;
$(document).ready(function () {
    $(".widget-participantactivity-list").each(function (index, item) {
        $(item).data("manager", new ParticipantActivityList(item));
    });
});
class Points {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this.bindControls();
    }
    bindControls() {
        var me = this;
        var isFielo = $(me._widget).find(".participant-points").attr("data-is-fielo");
        var htmlContentToUpdate = $(me._widget).find("#formatted-points");
        if (isFielo == "True" && $(me._widget).find(".participant-points").attr("data-fielo-member-id") != "") {
            var fielocustomfield = $(me._widget).find(".participant-points").attr("data-fielo-custom-field");
            me.GetMemberCall(fielocustomfield, 0, false, htmlContentToUpdate);
        }
    }
    GetMemberCall(fielocustomfield, attempt, renew, htmlContentToUpdate) {
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: "/Fielo/GetMember/" + fielocustomfield + "/" + renew,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null && data.result != undefined) {
                    data.result.fieldName = fielocustomfield;
                    data.result.attempt = attempt + 1;
                    data.result.htmlContentToUpdate = htmlContentToUpdate;
                    me.updateUI(data.result);
                }
            });
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateUI(data) {
        var me = this;
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetMemberCall(data.fieldName, data.attempt, true, data.htmlContentToUpdate);
            }
            else if (data.errorCode != "") {
                data.result.attempt = data.result.attempt + 1;
                me.GetMemberCall(data.fieldName, data.attempt, true, data.htmlContentToUpdate);
                return;
            }
            else {
                $(data.htmlContentToUpdate).html(data.responseData.formattedData);
            }
        }
    }
}
;
$(document).ready(function () {
    $(".widget-points").each(function (index, item) {
        $(item).data("manager", new Points(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
/// <reference path="../lib/helper.thirdParty.d.ts" />
class TeamLeaderTeamDetail {
    constructor(widget) {
        this.FilterValues = [];
        this.FilterTrackedValues = [];
        this._widget = widget;
        this.initialize();
    }
    getValidationDiv(className) {
        var validationDiv;
        var validationDivTemp = $(".js-global-modal").find(className);
        var isArray = $.isArray(validationDiv);
        if (isArray) {
            validationDiv = $(validationDivTemp[0]);
        }
        return validationDiv;
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._widgetContainer = "widget-teamleader-team-detail-container-" + this._widgetId;
        this._globalModal = new GlobalModal(this._widgetId);
        GlobalPopulateTimeZones($("#time-zone"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        //$(this._widget).find('.copy-link').tooltip({
        //    trigger: 'click',
        //    placement: 'bottom'
        //});
        ApplyGageToolTip($(this._widget).find('.copy-link'));
        // Localize Date/Times for Assignments
        $.each($(".localized-time"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
        });
        // Localize Date/Times for Student List
        $.each($(".localized-time-joined"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
        });
        var activeTab = me.getUrlVars()["activeTab"];
        if (activeTab) {
            //$("." + me._widgetContainer).find('.nav-tabs a[href="#' + activeTab + '"]').tab('show');
            // @ts-ignore
            bootstrap.Tab.getOrCreateInstance(document.querySelector('#' + activeTab + '-tab')).show();
        }
        $("." + me._widgetContainer).on("click", ".js-member-completion", function (e) {
            e.preventDefault();
            me.getTeamContentCompletionForParticipant($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-save-team-detail", function (e) {
            e.preventDefault();
            me.saveTeam($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-add-assignment", function (e) {
            e.preventDefault();
            me.getContentSelector($(e.currentTarget));
        });
        // Bulk edit start and end dates for assignments
        $("." + me._widgetContainer).on("click", ".js-edit-assignments", function (e) {
            me.getEditAssignmentsSelector($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-remove-content-assignment", function (e) {
            e.preventDefault();
            me.removeContentAssignment($(e.currentTarget));
        });
        //$('body').tooltip({
        //    selector: '[data-toggle=tooltip]'
        //});
        ApplyGageToolTip($('[data-toggle="tooltip"]'));
        ApplyGageToolTip($('[data-bs-toggle="tooltip"]'));
        $(".js-global-modal").on("click", ".js-show-system-names", function (e) {
            var source = $(".js-global-modal").find(".js-course-selection");
            if ($(e.currentTarget).is(":checked")) {
                $.each(source, function (index, element) {
                    $(element).attr("data-display-value", $(element).attr("data-content-name"));
                    $(element).closest(".js-selected-course-row").find("#contentname").html($(element).attr("data-content-name"));
                    $(element).find("td").find("#contentname").html($(element).attr("data-content-name"));
                });
            }
            else {
                $.each(source, function (index, element) {
                    $(element).attr("data-display-value", $(element).attr("data-content-item-name"));
                    $(element).closest(".js-selected-course-row").find("#contentname").html($(element).attr("data-content-item-name"));
                    $(element).find("td").find("#contentname").html($(element).attr("data-content-item-name"));
                });
            }
        });
        $(".js-global-modal").on("click", ".js-remove-course", function () {
            var contentid = $(this).attr("data-content-id");
            $(this).closest("tr").remove();
            var buttons = $(".content-id-" + contentid).find("button.js-course-selection");
            buttons.removeAttr("disabled");
            //buttons.find("span.fa-solid").removeClass("fa-check").addClass("fa-plus");
            buttons.find("span.fas").removeClass("fa-check").addClass("fa-plus");
            buttons.attr("data-selected", "false");
            // Show any curriclum rows that were previoulsy hidden
            var parentCurriculumId = null;
            $(".content-id-" + contentid + " button.js-course-selection").each(function (i, e) {
                if ($(e).attr('data-parent') != "") {
                    parentCurriculumId = $(e).attr('data-parent');
                }
            });
            if ($("button.js-course-selection[data-parent=" + parentCurriculumId + "]:not(:disabled)").length > 0) {
                var currButton = $("tr.curriculum-id-" + parentCurriculumId).find("button.js-curriculum-selection");
                currButton.removeAttr("disabled");
                //currButton.find("span.fa-solid").removeClass("fa-check").addClass("fa-plus");
                currButton.find("span.fas").removeClass("fa-check").addClass("fa-plus");
            }
            if ($(".js-assignments-list").find(".js-assigned-course").length == 0) {
                $(".js-assignments-list").addClass("hidden");
                $(".js-no-assignments").removeClass("hidden");
            }
        });
        $(".js-global-modal").on("click", ".set-up-assignments", function () {
            $(".global-modal-container").animate({
                scrollTop: $("#setupAssignments").offset().top
            }, 2000);
        });
        $(".js-global-modal").on("click", ".js-curriculum-selection", function (e) {
            var alreadyAdded = $(this).attr("data-selected");
            if (alreadyAdded === "false") {
                $(this).attr("data-selected", "true");
                //$(this).find("span.fa-solid").removeClass("fa-plus").addClass("fa-check");
                $(this).find("span.fas").removeClass("fa-plus").addClass("fa-check");
            }
            else {
                $(this).attr("data-selected", "false");
                //$(this).find("span.fa-solid").removeClass("fa-check").addClass("fa-plus");
                $(this).find("span.fas").removeClass("fa-check").addClass("fa-plus");
            }
            var fieldName = $(this).attr('data-field-name');
            $(".js-global-modal .js-assignments-list").removeClass('hidden');
            $(".js-global-modal .js-no-assignments").addClass("hidden");
            $.each($('.js-global-modal .js-course-selection[data-parent=' + fieldName + ']'), function (i, e) {
                if (alreadyAdded === "false") {
                    if ($(e).attr("data-selected") === "false") {
                        $(e).trigger('click');
                    }
                }
                else {
                    if ($(e).attr("data-selected") === "true") {
                        $(e).trigger('click');
                    }
                }
            });
        });
        $(".js-global-modal").on("click", ".js-course-selection", function (e) {
            var alreadyAdded = $(this).attr("data-selected");
            var contentid = $(this).attr("data-content-id");
            var buttons = $(".content-id-" + contentid).find("button.js-course-selection");
            var numberOfAssginments = 0;
            var contentitemname = $(this).attr('data-content-item-name');
            if (alreadyAdded === "false") {
                var contentname = $(this).attr('data-content-name');
                //var contentitemname = $(this).attr('data-content-item-name');
                var displayvalue = $(this).attr('data-display-value');
                var contenttype = $(this).attr('data-content-type');
                var contentidentifier = $(this).attr('data-content-identifier');
                var timeZone = $("#time-zone").val();
                var rawStartDate = $(".js-global-modal").attr("data-team-start-date");
                var rawEndDate = $(".js-global-modal").attr("data-team-end-date");
                var formattedRawStartDate = "";
                var formattedRawEndDate = "";
                if (rawStartDate != "") {
                    formattedRawStartDate = DisplayDateInTimeZoneFormat(rawStartDate, "MM/DD/YYYY", timeZone);
                }
                if (rawEndDate != "") {
                    formattedRawEndDate = DisplayDateInTimeZoneFormat(rawEndDate, "MM/DD/YYYY", timeZone);
                }
                buttons.attr("data-selected", "true");
                //buttons.find("span.fa-solid").removeClass("fa-plus").addClass("fa-check");
                buttons.find("span.fas").removeClass("fa-plus").addClass("fa-check");
                $(".js-global-modal .js-assignments-list").removeClass('hidden');
                $(".js-global-modal .js-no-assignments").addClass("hidden");
                if ($('.js-global-modal .js-assignments-list .js-course-selection[data-content-identifier=' + contentidentifier + ']').length === 0) {
                    var params = {
                        ContentName: contentname,
                        ContentItemName: contentitemname,
                        ContentIdentifier: contentidentifier,
                        ContentId: contentid,
                        DisplayValue: displayvalue,
                        ContentType: contenttype,
                        StartDate: formattedRawStartDate,
                        EndDate: formattedRawEndDate
                    };
                    $.when(globalThis.gage.submitAjaxRequest(params, "/Team/GetSingleTeamContentAssignment", "GET")
                        .done(function (data, textStatus, request) {
                        $(".js-global-modal .js-assignments-list tbody").append(data);
                        var startDateEl = $('#selected-course-start-datepicker-' + contentid).get(0);
                        var endDateEl = $('#selected-course-end-datepicker-' + contentid).get(0);
                        // @ts-ignore
                        me.initializeDatePickerForAddContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, false);
                        numberOfAssginments = $(".js-selected-courses tbody tr").length;
                        $(".js-assignments-counter").text(numberOfAssginments);
                        if (numberOfAssginments > 0) {
                            $(".js-items-added-summary").removeClass("hidden");
                        }
                        else {
                            $(".js-items-added-summary").addClass("hidden");
                        }
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
                // Hide any curriculums that have no visible courses under them remaining 
                var parentCurriculumId = null;
                $(".content-id-" + contentid + " button.js-course-selection").each(function (i, e) {
                    if ($(e).attr('data-parent') != "") {
                        parentCurriculumId = $(e).attr('data-parent');
                    }
                });
                if ($("button.js-course-selection[data-parent=" + parentCurriculumId + "]:not(:disabled)").length == 0) {
                    var currButton = $("tr.curriculum-id-" + parentCurriculumId).find("button.js-curriculum-selection");
                    currButton.attr("disabled", "disabled");
                    //currButton.find("span.fa-solid").removeClass("fa-plus").addClass("fa-check");
                    currButton.find("span.fas").removeClass("fa-plus").addClass("fa-check");
                }
                var addMsg = $(".js-add-message").text();
                addMsg = addMsg.replace("{assignmentName}", contentitemname);
                $(".js-last-action-msg").text(addMsg);
            }
            else {
                buttons.attr("data-selected", "false");
                //buttons.find("span.fa-solid").removeClass("fa-check").addClass("fa-plus");
                buttons.find("span.fas").removeClass("fa-check").addClass("fa-plus");
                $("tr.js-assigned-course[data-content-id=" + contentid + "]").remove();
                if ($("tr.js-assigned-course").length === 0) {
                    $(".js-global-modal .js-assignments-list").addClass('hidden');
                    $(".js-global-modal .js-no-assignments").removeClass("hidden");
                }
                var removeMsg = $(".js-remove-message").text();
                removeMsg = removeMsg.replace("{assignmentName}", contentitemname);
                $(".js-last-action-msg").text(removeMsg);
                numberOfAssginments = $(".js-selected-courses tbody tr").length;
                $(".js-assignments-counter").text(numberOfAssginments);
                if (numberOfAssginments > 0) {
                    $(".js-items-added-summary").removeClass("hidden");
                }
                else {
                    $(".js-items-added-summary").addClass("hidden");
                }
            }
        });
        $(".js-global-modal").on("click", ".js-save-course-assignment", function (e) {
            e.preventDefault();
            me.saveTeamContent($(e.currentTarget));
        });
        /* Save Edit Course Assginment Dates */
        $(".js-global-modal").on("click", ".js-save-edit-assignments", function (e) {
            e.preventDefault();
            me.saveEditAssignments($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-edit-course-details", function (e) {
            e.preventDefault();
            me.getCourseDetail($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-remove-member", function (e) {
            e.preventDefault();
            me.removeMember($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-promote-member, .js-demote-member", function (e) {
            e.preventDefault();
            me.changeRole($(e.currentTarget));
        });
        $(".js-global-modal").on("click", ".js-save-course-detail", function (e) {
            e.preventDefault();
            me.saveCourseDetail($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-completions-for-course", function (e) {
            e.preventDefault();
            me.getParticipantCompletionsForCourse($(e.currentTarget));
        });
        $(".js-global-modal").on("click", ".js-toggle-courses", function () {
            var currentState = $(this).attr("data-state");
            var identifier = $(this).closest("tr").attr("id");
            if (currentState == "collapsed") {
                $(this).attr('data-state', 'expanded');
                $(".js-curriculum-list-table").find("tr[data-parent=" + identifier + "]").removeClass("hidden");
                //$(this).find("span.fa-solid").removeClass("fa-caret-right").addClass("fa-caret-down");
                $(this).find("span.fas").removeClass("fa-caret-right").addClass("fa-caret-down");
            }
            else {
                $(this).attr('data-state', 'collapsed');
                $(".js-curriculum-list-table").find("tr[data-parent=" + identifier + "]").addClass("hidden");
                //$(this).find("span.fa-solid").removeClass("fa-caret-down").addClass("fa-caret-right");
                $(this).find("span.fas").removeClass("fa-caret-down").addClass("fa-caret-right");
            }
        });
        $(".js-global-modal").on("click", ".js-show-set-start-dates", function () {
            if ($(this).attr("aria-expanded") == "false") {
                $(this).attr("aria-expanded", "true");
                $(".js-global-modal").find(".js-set-start-dates-container").removeClass("hidden");
            }
            else {
                $(this).attr("aria-expanded", "false");
                $(".js-global-modal").find(".js-set-start-dates-container").addClass("hidden");
            }
        });
        $(".js-global-modal").on("click", ".js-show-set-end-dates", function () {
            if ($(this).attr("aria-expanded") == "false") {
                $(this).attr("aria-expanded", "true");
                $(".js-global-modal").find(".js-set-end-dates-container").removeClass("hidden");
            }
            else {
                $(this).attr("aria-expanded", "false");
                $(".js-global-modal").find(".js-set-end-dates-container").addClass("hidden");
            }
        });
        $(".js-global-modal").on("click", ".js-show-set-end-dates", function () {
        });
        me.setAssignmentDataTable();
        me.setMemberDataTable();
        me.bindTeamDatePickers();
    }
    setDefaultDatesForDatePicker() {
        return dayjs().format("MM/DD/YYYY hh:mm A");
    }
    copyToClipBoard() {
        var me = this;
        var textarea = document.createElement('textarea');
        textarea.textContent = $.trim($("." + me._widgetContainer).find(".js-copy-link-label").text());
        document.body.appendChild(textarea);
        var selection = document.getSelection();
        var range = document.createRange();
        range.selectNode(textarea);
        selection.removeAllRanges();
        selection.addRange(range);
        console.log('copy success', document.execCommand('copy'));
        selection.removeAllRanges();
        document.body.removeChild(textarea);
    }
    bindTeamDatePickers() {
        var originalTimeZone = $("#time-zone").attr("data-time-zone");
        if (originalTimeZone != "") {
            $("#time-zone").val(originalTimeZone);
        }
        var tz = $("#time-zone").val();
        if ($("#start-date").attr("data-start-date") != "") {
            var formattedStartDate = DisplayDateInTimeZoneFormat($("#start-date").attr("data-start-date"), "MM/DD/YYYY", tz);
            $('#start-date').val(formattedStartDate);
        }
        if ($("#end-date").attr("data-end-date") != "") {
            var formattedEndDate = DisplayDateInTimeZoneFormat($("#end-date").attr("data-end-date"), "MM/DD/YYYY", tz);
            $('#end-date').val(formattedEndDate);
        }
        var pickers = ConfigureDatePicker($('.trigger-date'));
        var startPicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; })[0][1];
        var endDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; })[0][1];
        BindDatePickerEvents(startPicker, endDatePicker, document.getElementById("startdatepicker"), document.getElementById("enddatepicker"));
    }
    setAssignmentDataTable() {
        var me = this;
        var table = $("." + me._widgetContainer).find(".table.assignment-dataTable");
        var sortable = $("." + me._widgetContainer).find(".js-add-sortable").val();
        if (sortable === "") {
            // DATATABLE
            $(table).DataTable({
                "pageLength": 25,
                "searching": true,
                "dom": '<"top"<"left jsLeftFilter"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
                order: [],
                "columnDefs": [
                    { type: 'date', "targets": 1 },
                    { type: 'date', "targets": 2 },
                    { "targets": 3, "searchable": false, "orderable": false },
                    { "targets": 4, "searchable": false, "orderable": false },
                    { "targets": 5, "searjs-curriculum-selectionchable": false, "orderable": false },
                    { "targets": 6, "searchable": false, "orderable": false }
                ],
                "drawCallback": function (settings) {
                    if ($(".jsLeftFilter").find(".js-filter-table").length === 0) {
                        var aFilters = $(".js-filter-table").clone();
                        $(".js-filter-table").appendTo(".jsLeftFilter");
                    }
                }
            });
        }
        else {
            // DATATABLE
            $(table).DataTable({
                "pageLength": 25,
                "searching": true,
                "dom": '<"top"<"left jsLeftFilter"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
                order: [],
                "columnDefs": [
                    { "targets": 0, "searchable": false, "orderable": false },
                    { type: 'date', "targets": 2 },
                    { type: 'date', "targets": 3 },
                    { "targets": 4, "searchable": false, "orderable": false },
                    { "targets": 5, "searchable": false, "orderable": false },
                    { "targets": 6, "searjs-curriculum-selectionchable": false, "orderable": false },
                    { "targets": 7, "searchable": false, "orderable": false }
                ],
                "drawCallback": function (settings) {
                    if ($(".jsLeftFilter").find(".js-filter-table").length === 0) {
                        var aFilters = $(".js-filter-table").clone();
                        $(".js-filter-table").appendTo(".jsLeftFilter");
                    }
                }
            });
        }
    }
    setAssignmentContentListDataTable() {
        var me = this;
        var table = $(".js-global-modal").find(".table.content-list-dataTable");
        // DATATABLE
        $(table).DataTable({
            "pageLength": 25,
            "searching": true,
            "dom": '<"top"<"left"><"left js-add-all-content"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
            "columnDefs": [
                { "targets": 1, "searchable": false, "orderable": false },
                { "targets": 3, "searchable": true, "orderable": false, "visible": false },
                { "targets": 4, "searchable": false, "orderable": false },
                { "targets": 5, "searchable": false, "orderable": false }
            ],
            "drawCallback": function (settings) {
                // DATATABLE
                var ogtable = $(".content-list-dataTable").DataTable();
                var availCoursesCount = 0;
                ogtable.rows({ filter: 'applied' }).every(function (index, element) {
                    var row = $(this.node());
                    var addColumn = row.find('td').eq(4);
                    var addButton = $(addColumn).find("button.js-course-selection");
                    if ($(addButton).length > 0) {
                        availCoursesCount++;
                    }
                });
                $(".js-add-all-content").find(".js-add-all-button").remove();
                var btn = $(".js-add-all-button").clone();
                $(".js-add-all-content").append(btn);
                var addAllButton = $(".js-add-all-content").find(".js-add-all-button");
                addAllButton.removeClass("hidden");
                addAllButton.text(addAllButton.text().replace("0", availCoursesCount.toString()));
                $(".js-add-all-content .js-add-all-button").on("click", function () {
                    // DATATABLE
                    var table = $(".content-list-dataTable").DataTable();
                    table.rows({ filter: 'applied' }).every(function (index, element) {
                        var row = $(this.node());
                        var addColumn = row.find('td').eq(4);
                        var addButton = $(addColumn).find("button.js-course-selection");
                        if ($(addButton).attr("data-selected") === "false") {
                            if ($(addButton).is(":visible")) {
                                $(addButton).trigger("click");
                            }
                            else {
                                var clonedBtn = $(addButton).clone();
                                $(".js-add-btn-wrapper button").replaceWith($(clonedBtn));
                                $(".js-add-btn-wrapper button").trigger("click");
                                $(addButton).attr("data-selected", "true");
                                //$(addButton).find("span.fa-solid").removeClass("fa-plus").addClass("fa-check");
                                $(addButton).find("span.fas").removeClass("fa-plus").addClass("fa-check");
                            }
                        }
                    });
                });
                $(".js-toggle-add-content-filter").on("click", function (e) {
                    var tgtFilter = $(this).attr("aria-controls");
                    var tgtState = $(this).attr("aria-expanded");
                    if (tgtState === "false") {
                        $("#" + tgtFilter).removeClass("hidden");
                        $(this).attr("aria-expanded", "true");
                        $(this).find("span").removeClass("fa-plus");
                        $(this).find("span").addClass("fa-minus");
                    }
                    else {
                        $("#" + tgtFilter).addClass("hidden");
                        $(this).attr("aria-expanded", "false");
                        $(this).find("span").removeClass("fa-minus");
                        $(this).find("span").addClass("fa-plus");
                    }
                });
            }
        });
        $(".js-tag-filter").on("click", function () {
            var tagIds = "";
            $(".js-tag-filter:checked").each(function (i, e) {
                if (tagIds != "") {
                    tagIds += "|";
                }
                tagIds += $(e).val();
            });
            // DATATABLE
            var table = $(".js-global-modal").find(".table.content-list-dataTable").DataTable();
            table.columns(3).search(tagIds, true, false).draw();
        });
    }
    setMemberDataTable() {
        var me = this;
        var table = $("." + me._widgetContainer).find(".table.member-dataTable");
        // DATATABLE
        $(table).DataTable({
            "pageLength": 25,
            "searching": true,
            "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
            "columnDefs": [
                { type: 'date', "targets": 2 },
                { "targets": 1, "searchable": false, "orderable": false },
                { "targets": 4, "searchable": false, "orderable": false },
            ]
        });
    }
    removeContentAssignment(button) {
        var me = this;
        var widgetcontainer = $(button).closest(".js-content-assignment-row").attr("data-widget-container");
        var confirmationMessage = $(button).attr("data-confirmation-message");
        var cancelText = $(button).attr("data-cancel-text");
        var okText = $(button).attr("data-ok-text");
        var teamIdentifier = $(button).attr("data-team-identifier");
        var teamContentId = $(button).attr("data-team-content-id");
        var params = {
            TeamIdentifier: teamIdentifier,
            Id: teamContentId
        };
        var url = "/Api/Manage/TeamContent/Delete/";
        bootbox.confirm({
            message: confirmationMessage,
            buttons: {
                'cancel': { label: cancelText },
                'confirm': { label: okText, className: 'btn-success' }
            },
            callback: function (confirmed) {
                if (confirmed) {
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "DELETE")
                        .done(function (data, textStatus, request) {
                        url = "/Team/RenderTeamLeaderTeamDetail/" + me._widgetId;
                        var params = {
                            teamIdentifier: teamIdentifier,
                        };
                        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                            .done(function (data, textStatus, request) {
                            $("." + widgetcontainer).html(data);
                            //$("." + widgetcontainer).find('.nav-tabs a[href="#assignments"]').tab('show');
                            // @ts-ignore
                            bootstrap.Tab.getOrCreateInstance(document.querySelector('#assignments-tab')).show();
                            GlobalPopulateTimeZones($("#time-zone"));
                            me.bindTeamDatePickers();
                            // Localize Date/Times for Assignments
                            $.each($(".localized-time"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                            });
                            // Localize Date/Times for Student List
                            $.each($(".localized-time-joined"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                            });
                        }));
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        //@ts-ignore
                        waitingDialog.hide();
                    }));
                }
            }
        });
    }
    getContentSelector(button) {
        var me = this;
        //@ts-ignore
        waitingDialog.show();
        var globalWindow = this._globalModal;
        var params = {
            selectedPageTypes: $(button).attr("data-selected-page-types"),
            selectedCategories: $(button).attr("data-selected-categories"),
            selectedTags: $(button).attr("data-selected-tags"),
            showContent: $(button).closest('#assignments').find('.js-show-content').val(),
            showCurriculum: $(button).closest('#assignments').find('.js-show-curriculum').val(),
            defaultFilterType: $(button).closest('#assignments').find('.js-default-filter-type').val(),
            teamIdentifier: $(button).attr("data-team-identifier")
        };
        $.when(globalThis.gage.submitAjaxRequest(params, "/Team/GetContentSelector", "POST")
            .done(function (data, textStatus, request) {
            //@ts-ignore
            waitingDialog.hide();
            var content = data;
            globalWindow.openGlobalModal(content, "panel", { classes: "add-assignment-modal" });
            var saveButton = $(".js-global-modal").find(".js-save-course-assignment");
            me.setAssignmentContentListDataTable();
            var widgetId = $(button).attr("data-widget-id");
            var teamidentifier = $(button).attr("data-team-identifier");
            var widgetcontainer = $(button).attr("data-widget-container");
            var allowcontentnameselection = $(button).attr("data-allow-content-name-selection");
            var defaultassignmentsource = $(button).attr("data-default-assignment-source");
            $(saveButton).attr("data-widget-id", widgetId);
            $(saveButton).attr("data-team-identifier", teamidentifier);
            $(saveButton).attr("data-widget-container", widgetcontainer);
            var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
            var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
            var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
            var formattedRawStartDate = "";
            var formattedRawEndDate = "";
            if (startDate != "") {
                formattedRawStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
            }
            if (endDate != "") {
                formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
            }
            $(".js-global-modal").attr("data-team-start-date", startDate);
            $(".js-global-modal").attr("data-team-end-date", endDate);
            $(".js-global-modal").find("#data-team-info").html(teamInfo);
            $(".js-global-modal").find(".js-assignment-tz").text($("#time-zone").val());
            // Localize Date/Times
            $.each($(".js-display-date"), function (i, e) {
                var rawDate = $(e).text();
                $(e).html(DisplayDateInLocalFormat(rawDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(rawDate, "hh:mm a") + "</small>");
            });
            if (allowcontentnameselection !== "True") {
                $(".js-global-modal").find(".showsystemnames-container").remove();
            }
            $.each($(content).find(".tab-pane"), function (i, v) {
                var id = $(v).attr('data-id');
                $(".js-global-modal").find(".tab-pane[data-id=" + id + "]").attr('id', id);
            });
            if (defaultassignmentsource === "Curriculum") {
                //$(".js-global-modal").find('.js-assignments-tabs a[href="#curriculumview"]').tab('show');
                // @ts-ignore
                bootstrap.Tab.getOrCreateInstance(document.querySelector('#curriculumview-tab')).show();
            }
            else {
                //$(".js-global-modal").find('.js-assignments-tabs a[href="#allview"]').tab('show');
                // @ts-ignore
                bootstrap.Tab.getOrCreateInstance(document.querySelector('#allview-tab')).show();
            }
            $(".js-add-assignment-content").on("click", ".js-reset-content-filters", function (e) {
                -$("#contentFilter").trigger("reset");
                // DATATABLE
                var table = $(".js-global-modal").find(".table.content-list-dataTable").DataTable();
                table.columns(3).search("", true, false).draw();
            });
            var timeZone = $("#time-zone").val();
            if (startDate != "") {
                $(".js-global-modal").find('#setStartDates').val(DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY hh:mm A", timeZone));
            }
            if (endDate != "") {
                $(".js-global-modal").find('#endStartDates').val(DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY hh:mm A", timeZone));
            }
            var startDateEl = $('#startDatesPicker').get(0);
            var endDateEl = $('#endDatesPicker').get(0);
            // @ts-ignore
            me.initializeDatePickerForAddContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, true);
            /* var showContent = $(".js-show-content").val();
            var showCurriculum = $(".js-show-curriculum").val();
            var defaultFilterType = $(".js-default-filter-type").val();
    
            if (showContent === "false") {
                $(".js-content-data").addClass("hidden").removeClass("active");
                if ($(".js-curriculum.data").val() === "true") {
                    $(".js-curriculum.data").addClass("active");
                }
            } else if (showContent === "true" && showCurriculum === "false") {
                $(".js-content-data").addClass("active");
            }
    
            if (showCurriculum === "false") {
                $(".js-curriculum-data").addClass("hidden").removeClass("active");
                if ($(".js-content-data").val() === "true") {
                    $(".js-content-data").addClass("active");
                }
            } else if (showCurriculum === "true" && showContent === "false") {
                $(".js-curriculum-data").addClass("active");
            } */
        })
            .fail(function (response, textStatus, errorThrown) {
            //@ts-ignore
            waitingDialog.hide();
        }));
    }
    initializeDatePickerForAddContentAssignment(startEl, endDateEl, startDate, endDate, loop) {
        var me = this;
        // @ts-ignore
        var datetimepicker1 = new tempusDominus.TempusDominus(startEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        // @ts-ignore
        var datetimepicker2 = new tempusDominus.TempusDominus(endDateEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        const subscriptionStart = datetimepicker1.subscribe("change.td", (e) => {
            datetimepicker2.updateOptions({
                restrictions: {
                    minDate: e.date,
                },
            });
        });
        if (loop) {
            const subscriptionLoopForStartDate = datetimepicker1.subscribe("change.td", (e) => {
                var teamSingleContentAssignmentDtos = [];
                $(".js-global-modal .js-course-start-date").each(function (i, el) {
                    var parent = $(el).closest(".js-assigned-course");
                    var endDate = $(parent).find(".js-course-end-date").val();
                    var isRequired = $(parent).find("#selected-course-is-required").is(":checked");
                    var teamSingleContentAssignmentDto = {
                        contentname: $(parent).attr('data-content-name'),
                        contentitemname: $(parent).attr('data-content-item-name'),
                        displayvalue: $(parent).attr('data-display-value'),
                        contenttype: $(parent).attr('data-content-type'),
                        contentidentifier: $(parent).attr('data-content-identifier'),
                        startDate: dayjs(e.date).format("MM/DD/YYYY"),
                        endDate: endDate,
                        contentId: $(parent).attr("data-content-id"),
                        isRequired: isRequired
                    };
                    teamSingleContentAssignmentDtos.push(teamSingleContentAssignmentDto);
                });
                if (teamSingleContentAssignmentDtos.length > 0) {
                    var params = {
                        dto: teamSingleContentAssignmentDtos
                    };
                    var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
                    var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
                    var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
                    var timeZone = $("#time-zone").val();
                    var formattedRawStartDate = "";
                    var formattedRawEndDate = "";
                    if (startDate != "") {
                        formattedRawStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
                    }
                    if (endDate != "") {
                        formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
                    }
                    $.when(globalThis.gage.submitAjaxRequest(teamSingleContentAssignmentDtos, "/Team/ReloadTeamContentAssignment", "POST")
                        .done(function (data, textStatus, request) {
                        $(".js-global-modal .js-assignments-list tbody").html(data);
                        $(".js-global-modal .js-course-start-date").each(function (i, el) {
                            var startDateEl = $("#selected-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            var endDateEl = $("#selected-course-end-datepicker-" + $(el).attr("data-id")).get(0);
                            me.initializeDatePickerForAddContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, false);
                        });
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            });
            const subscriptionLoopForEndDate = datetimepicker2.subscribe("change.td", (e) => {
                var teamSingleContentAssignmentDtos = [];
                $(".js-global-modal .js-course-end-date").each(function (i, el) {
                    var parent = $(el).closest(".js-assigned-course");
                    var startDate = $(parent).find(".js-course-start-date").val();
                    var isRequired = $(parent).find("#selected-course-is-required").is(":checked");
                    var teamSingleContentAssignmentDto = {
                        contentname: $(parent).attr('data-content-name'),
                        contentitemname: $(parent).attr('data-content-item-name'),
                        displayvalue: $(parent).attr('data-display-value'),
                        contenttype: $(parent).attr('data-content-type'),
                        contentidentifier: $(parent).attr('data-content-identifier'),
                        startDate: startDate,
                        endDate: dayjs(e.date).format("MM/DD/YYYY"),
                        contentId: $(parent).attr("data-content-id"),
                        isRequired: isRequired
                    };
                    teamSingleContentAssignmentDtos.push(teamSingleContentAssignmentDto);
                });
                if (teamSingleContentAssignmentDtos.length > 0) {
                    var params = {
                        dto: teamSingleContentAssignmentDtos
                    };
                    var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
                    var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
                    var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
                    var timeZone = $("#time-zone").val();
                    var formattedRawendDate = "";
                    var formattedRawEndDate = "";
                    if (startDate != "") {
                        formattedRawendDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
                    }
                    if (endDate != "") {
                        formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
                    }
                    $.when(globalThis.gage.submitAjaxRequest(teamSingleContentAssignmentDtos, "/Team/ReloadTeamContentAssignment", "POST")
                        .done(function (data, textStatus, request) {
                        $(".js-global-modal .js-assignments-list tbody").html(data);
                        $(".js-global-modal .js-course-end-date").each(function (i, el) {
                            var startDateEl = $("#selected-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            var endDateEl = $("#selected-course-end-datepicker-" + $(el).attr("data-id")).get(0);
                            me.initializeDatePickerForAddContentAssignment(startDateEl, endDateEl, formattedRawendDate, formattedRawEndDate, false);
                        });
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            });
        }
        //using subscribe method
        const subscription = datetimepicker2.subscribe("change.td", (e) => {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: e.date,
                },
            });
        });
        if (startDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    minDate: dayjs(startDate).toDate()
                }
            });
        }
        if (endDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate()
                }
            });
            datetimepicker2.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate(),
                    minDate: dayjs().toDate()
                }
            });
        }
    }
    initializeDatePickerForEditContentAssignment(startEl, endDateEl, startDate, endDate, loop) {
        var me = this;
        // @ts-ignore
        var datetimepicker1 = new tempusDominus.TempusDominus(startEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        // @ts-ignore
        var datetimepicker2 = new tempusDominus.TempusDominus(endDateEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        const subscriptionStart = datetimepicker1.subscribe("change.td", (e) => {
            datetimepicker2.updateOptions({
                restrictions: {
                    minDate: e.date,
                },
            });
        });
        if (loop) {
            const subscriptionLoopForStartDate = datetimepicker1.subscribe("change.td", (e) => {
                var teamSingleContentAssignmentDtos = [];
                $(".js-global-modal .js-course-start-date").each(function (i, el) {
                    var parent = $(el).closest(".js-assigned-course");
                    var endDate = $(parent).find(".js-course-end-date").val();
                    var teamSingleContentAssignmentDto = {
                        contentname: $(parent).attr('data-content-name'),
                        contentitemname: $(parent).attr('data-content-item-name'),
                        contentidentifier: $(parent).attr('data-content-identifier'),
                        startDate: dayjs(e.date).format("MM/DD/YYYY"),
                        endDate: endDate,
                        contentId: $(parent).attr("data-content-id"),
                        contentType: $(parent).attr("data-content-type"),
                        title: $(parent).attr('data-content-item-name')
                    };
                    teamSingleContentAssignmentDtos.push(teamSingleContentAssignmentDto);
                });
                if (teamSingleContentAssignmentDtos.length > 0) {
                    var params = {
                        dto: teamSingleContentAssignmentDtos
                    };
                    var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
                    var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
                    var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
                    var timeZone = $("#time-zone").val();
                    var formattedRawStartDate = "";
                    var formattedRawEndDate = "";
                    if (startDate != "") {
                        formattedRawStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
                    }
                    if (endDate != "") {
                        formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
                    }
                    $.when(globalThis.gage.submitAjaxRequest(teamSingleContentAssignmentDtos, "/Team/ReloadEditTeamContentAssignment", "POST")
                        .done(function (data, textStatus, request) {
                        $(".js-global-modal .js-edit-assignments-list tbody").html(data);
                        $(".js-global-modal .js-course-start-date").each(function (i, el) {
                            var startDateEl = $("#edit-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            var endDateEl = $("#edit-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            me.initializeDatePickerForEditContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, false);
                        });
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            });
            const subscriptionLoopForEndDate = datetimepicker2.subscribe("change.td", (e) => {
                var teamSingleContentAssignmentDtos = [];
                $(".js-global-modal .js-course-end-date").each(function (i, el) {
                    var parent = $(el).closest(".js-assigned-course");
                    var startDate = $(parent).find(".js-course-start-date").val();
                    var isRequired = $(parent).find("#selected-course-is-required").is(":checked");
                    var teamSingleContentAssignmentDto = {
                        contentname: $(parent).attr('data-content-name'),
                        contentitemname: $(parent).attr('data-content-item-name'),
                        contentidentifier: $(parent).attr('data-content-identifier'),
                        startDate: startDate,
                        endDate: dayjs(e.date).format("MM/DD/YYYY"),
                        contentId: $(parent).attr("data-content-id"),
                        contentType: $(parent).attr("data-content-type"),
                        title: $(parent).attr('data-content-item-name')
                    };
                    teamSingleContentAssignmentDtos.push(teamSingleContentAssignmentDto);
                });
                if (teamSingleContentAssignmentDtos.length > 0) {
                    var params = {
                        dto: teamSingleContentAssignmentDtos
                    };
                    var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
                    var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
                    var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
                    var timeZone = $("#time-zone").val();
                    var formattedRawendDate = "";
                    var formattedRawEndDate = "";
                    if (startDate != "") {
                        formattedRawendDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
                    }
                    if (endDate != "") {
                        formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
                    }
                    $.when(globalThis.gage.submitAjaxRequest(teamSingleContentAssignmentDtos, "/Team/ReloadEditTeamContentAssignment", "POST")
                        .done(function (data, textStatus, request) {
                        $(".js-global-modal .js-edit-assignments-list tbody").html(data);
                        $(".js-global-modal .js-course-end-date").each(function (i, el) {
                            var startDateEl = $("#edit-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            var endDateEl = $("#edit-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                            me.initializeDatePickerForEditContentAssignment(startDateEl, endDateEl, formattedRawendDate, formattedRawEndDate, false);
                        });
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            });
        }
        //using subscribe method
        const subscription = datetimepicker2.subscribe("change.td", (e) => {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: e.date,
                },
            });
        });
        if (startDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    minDate: dayjs(startDate).toDate()
                }
            });
        }
        if (endDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate()
                }
            });
            datetimepicker2.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate(),
                    minDate: dayjs().toDate()
                }
            });
        }
    }
    /* Bulk edit assignments start and end dates */
    getEditAssignmentsSelector(button) {
        var me = this;
        // @ts-ignore
        waitingDialog.show("");
        var globalWindow = this._globalModal;
        var params = {
            selectedPageTypes: $(button).attr("data-selected-page-types"),
            selectedCategories: $(button).attr("data-selected-categories"),
            selectedTags: $(button).attr("data-selected-tags"),
            showContent: $(button).closest('#assignments').find('.js-show-content').val(),
            showCurriculum: $(button).closest('#assignments').find('.js-show-curriculum').val(),
            defaultFilterType: $(button).closest('#assignments').find('.js-default-filter-type').val(),
            teamIdentifier: $(button).attr("data-team-identifier")
        };
        $.when(globalThis.gage.submitAjaxRequest(params, "/Team/GetEditAssignmentsSelector", "POST")
            .done(function (data, textStatus, request) {
            // @ts-ignore
            waitingDialog.hide();
            var content = data;
            globalWindow.openGlobalModal(content, "panel", { classes: "edit-assignment-modal" });
            var saveButton = $(".js-global-modal").find(".js-save-edit-assignments");
            var widgetId = $(button).attr("data-widget-id");
            var teamidentifier = $(button).attr("data-team-identifier");
            var widgetcontainer = $(button).attr("data-widget-container");
            $(saveButton).attr("data-widget-id", widgetId);
            $(saveButton).attr("data-team-identifier", teamidentifier);
            $(saveButton).attr("data-widget-container", widgetcontainer);
            var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
            var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
            var teamInfo = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-info");
            var timeZone = $("#time-zone").val();
            var formattedRawStartDate = "";
            var formattedRawEndDate = "";
            if (startDate != "") {
                formattedRawStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", timeZone);
            }
            if (endDate != "") {
                formattedRawEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", timeZone);
            }
            $(".js-global-modal").attr("data-team-start-date", startDate);
            $(".js-global-modal").attr("data-team-end-date", endDate);
            $(".js-global-modal").find("#data-team-info").html(teamInfo);
            $(".js-global-modal").find(".js-assignment-tz").text($("#time-zone").val());
            // Localize Date/Times
            $.each($(".js-display-date"), function (i, e) {
                var rawDate = $(e).text();
                $(e).html(DisplayDateInLocalFormat(rawDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(rawDate, "hh:mm a") + "</small>");
            });
            var startDateEl = $('#startDatesPicker').get(0);
            var endDateEl = $('#endDatesPicker').get(0);
            // @ts-ignore
            me.initializeDatePickerForEditContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, true);
            $(".js-global-modal .js-course-start-date").each(function (i, el) {
                if ($("#edit-course-start-date-" + $(el).attr("data-id")).val() != "") {
                    var formattedStartDate = DisplayDateInTimeZoneFormat($("#edit-course-start-date-" + $(el).attr("data-id")).val(), "MM/DD/YYYY", timeZone);
                    $("#edit-course-start-date-" + $(el).attr("data-id")).val(formattedStartDate);
                }
                if ($("#edit-course-end-date-" + $(el).attr("data-id")).val() != "") {
                    var formattedEndDate = DisplayDateInTimeZoneFormat($("#edit-course-end-date-" + $(el).attr("data-id")).val(), "MM/DD/YYYY", timeZone);
                    $("#edit-course-end-date-" + $(el).attr("data-id")).val(formattedEndDate);
                }
                var startDateEl = $("#edit-course-start-datepicker-" + $(el).attr("data-id")).get(0);
                var endDateEl = $("#edit-course-end-datepicker-" + $(el).attr("data-id")).get(0);
                me.initializeDatePickerForEditContentAssignment(startDateEl, endDateEl, formattedRawStartDate, formattedRawEndDate, false);
            });
        })
            .fail(function (response, textStatus, errorThrown) {
            // @ts-ignore
            waitingDialog.hide();
        }));
    }
    changeRole(button) {
        var me = this;
        var widgetcontainer = $(button).closest(".js-member-detail-row").attr("data-widget-container");
        var widgetId = $(button).closest(".js-member-detail-row").attr("data-widget-Id");
        var teamIdentifier = $(button).closest(".js-member-detail-row").attr("data-team-identifier");
        var participantId = $(button).closest(".js-member-detail-row").attr("data-participant-id");
        var action = $(button).attr("data-action");
        var confirmationMessage = $(button).attr("data-confirmation-message");
        var cancelText = $(button).attr("data-cancel-text");
        var okText = $(button).attr("data-ok-text");
        var datagroups = $(button).attr("data-groups");
        var url = "";
        if (action === "promote") {
            /*url = "/API/Manage/Team/Promote/" + teamIdentifier + "/" + participantId + "/" + datagroups;*/
            url = "/API/Manage/Team/Promote";
        }
        else {
            url = "/API/Manage/Team/Demote/";
        }
        var dto = {
            Identifier: teamIdentifier,
            OwnerParticipantID: participantId,
            GroupsCollection: datagroups
        };
        bootbox.confirm({
            message: confirmationMessage,
            buttons: {
                'cancel': { label: cancelText },
                'confirm': { label: okText, className: 'btn-success' }
            },
            callback: function (confirmed) {
                if (confirmed) {
                    $.when(globalThis.gage.submitAjaxRequest(dto, url, "POST")
                        .done(function (data, textStatus, request) {
                        var params = {
                            teamIdentifier: teamIdentifier,
                        };
                        url = "/Team/RenderTeamLeaderTeamDetail/" + widgetId;
                        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                            .done(function (data, textStatus, request) {
                            $("." + widgetcontainer).html(data);
                            //$("." + widgetcontainer).find('.nav-tabs a[href="#members"]').tab('show');
                            // @ts-ignore
                            bootstrap.Tab.getOrCreateInstance(document.querySelector('#members-tab')).show();
                            me.bindTeamDatePickers();
                            // Localize Date/Times for Assignments
                            $.each($(".localized-time"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                            });
                            // Localize Date/Times for Students
                            $.each($(".localized-time-joined"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                            });
                        }));
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            }
        });
    }
    removeMember(button) {
        var me = this;
        var widgetcontainer = $(button).closest(".js-member-detail-row").attr("data-widget-container");
        var widgetId = $(button).closest(".js-member-detail-row").attr("data-widget-Id");
        var teamIdentifier = $(button).closest(".js-member-detail-row").attr("data-team-identifier");
        var participantId = $(button).closest(".js-member-detail-row").attr("data-participant-id");
        var params = {
            Id: teamIdentifier,
            ParticipantId: participantId
        };
        var url = "/API/Manage/Team/RemoveMember/";
        var confirmationMessage = $(button).attr("data-confirmation-message");
        var cancelText = $(button).attr("data-cancel-text");
        var okText = $(button).attr("data-ok-text");
        bootbox.confirm({
            message: confirmationMessage,
            buttons: {
                'cancel': { label: cancelText },
                'confirm': { label: okText, className: 'btn-success' }
            },
            callback: function (confirmed) {
                if (confirmed) {
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                        .done(function (data, textStatus, request) {
                        var params = {
                            teamIdentifier: teamIdentifier,
                        };
                        url = "/Team/RenderTeamLeaderTeamDetail/" + widgetId;
                        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                            .done(function (data, textStatus, request) {
                            $("." + widgetcontainer).html(data);
                            //$("." + widgetcontainer).find('.nav-tabs a[href="#members"]').tab('show');
                            // @ts-ignore
                            bootstrap.Tab.getOrCreateInstance(document.querySelector('#members-tab')).show();
                            me.bindTeamDatePickers();
                            // Localize Date/Times for Assignments
                            $.each($(".localized-time"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                            });
                            // Localize Date/Times for Students
                            $.each($(".localized-time-joined"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                            });
                        }));
                    })
                        .fail(function (response, textStatus, errorThrown) {
                    }));
                }
            }
        });
    }
    getCourseDetail(button) {
        var me = this;
        var saveButton = $(".js-edit-course-detail-container").find(".js-save-course-detail");
        var availabledate = $(button).attr("data-teamcontent-availabledate") === ""
            ? ""
            : $(button).attr("data-teamcontent-availabledate");
        var duedate = $(button).attr("data-teamcontent-duedate") === ""
            ? ""
            : $(button).attr("data-teamcontent-duedate");
        $(".js-unformatted-startdate").text(availabledate + " UTC");
        $(".js-unformatted-duedate").text(duedate + " UTC");
        var isrequired = $(button).attr("data-teamcontent-isrequired");
        var contentname = $(button).attr("data-teamcontent-coursename");
        var tz = $("#time-zone").val();
        var dateHeader = me.makeDate($(button).attr("data-anytime-text"));
        $(".js-edit-course-detail-container").find(".js-edit-course-name").html(contentname);
        $(".js-edit-course-detail-container").find(".js-edit-team-dates").html(dateHeader);
        $(".js-edit-course-detail-container").find(".js-edit-course-isrequired").removeAttr("checked");
        if (isrequired === "True") {
            $(".js-edit-course-detail-container").find(".js-edit-course-isrequired").attr("checked", "checked");
        }
        var widgetId = $(button).closest(".widget-teamleader-team-detail").attr("data-contentwidgetid");
        var teamContentId = $(button).attr("data-teamcontent-id");
        var contentIdentifier = $(button).attr("data-content-identifier");
        var teamidentifier = $(button).attr("data-team-identifier");
        var widgetcontainer = $(button).attr("data-widget-container");
        $(saveButton).attr("team-content-id", teamContentId);
        $(saveButton).attr("data-widget-id", widgetId);
        $(saveButton).attr("data-content-identifier", contentIdentifier);
        $(saveButton).attr("data-team-identifier", teamidentifier);
        $(saveButton).attr("data-widget-container", widgetcontainer);
        var content = $(".js-edit-course-detail-container").html();
        content = content.replace(new RegExp("copy-", "g"), "");
        var globalWindow = this._globalModal;
        globalWindow.openGlobalModal(content, "panel", { classes: "edit-course-modal" });
        var formattedStartDate = "";
        if (availabledate != "") {
            formattedStartDate = DisplayDateInTimeZoneFormat(availabledate, "MM/DD/YYYY", tz);
            $(".js-global-modal").find(".js-edit-course-availabledate").val(formattedStartDate);
        }
        var formattedEndDate = "";
        if ((duedate != "") && (duedate != "" && dayjs.utc(duedate).local() > dayjs())) {
            formattedEndDate = DisplayDateInTimeZoneFormat(duedate, "MM/DD/YYYY", tz);
            $(".js-global-modal").find(".js-edit-course-duedate").val(formattedEndDate);
        }
        $(".js-global-modal").find(".js-editassignment-tz").text($("#time-zone").val());
        var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
        var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
        var formattedTeamStartDate = "";
        var formattedTeamEndDate = "";
        if (startDate != "") {
            formattedTeamStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", tz);
        }
        if (endDate != "") {
            formattedTeamEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", tz);
        }
        var startEl = $("#coursestartdatepicker").get(0);
        var endDateEl = $("#duedatepicker").get(0);
        me.bindDatePickers(startEl, endDateEl, formattedTeamStartDate, formattedTeamEndDate);
    }
    makeDate(anyTime) {
        var me = this;
        var startDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-start-date");
        var endDate = $("." + me._widgetContainer).find(".widget-teamleader-team-detail").attr("data-team-end-date");
        var dateHeader = "";
        if (startDate !== "") {
            dateHeader = "(" + dayjs.utc(startDate).local().format('MM/DD/YYYY') + " <small>" + dayjs.utc(startDate).local().format('hh:mm a') + "</small>" + "<span class=\"hidden\">" + startDate + " UTC</span>";
        }
        else {
            dateHeader = "(" + anyTime;
        }
        if (endDate) {
            dateHeader += " - " + dayjs.utc(endDate).local().format('MM/DD/YYYY') + " <small>" + dayjs.utc(endDate).local().format('hh:mm a') + "</small>" + "<span class=\"hidden\">" + endDate + " UTC</span>";
        }
        else {
            dateHeader += " - " + endDate;
        }
        dateHeader += ")";
        return dateHeader;
    }
    bindDatePickers(startEl, endDateEl, startDate, endDate) {
        var me = this;
        // @ts-ignore
        var datetimepicker1 = new tempusDominus.TempusDominus(startEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        // @ts-ignore
        var datetimepicker2 = new tempusDominus.TempusDominus(endDateEl, {
            useCurrent: false,
            localization: {
                locale: 'en-US',
                format: 'MM/dd/yyyy',
            },
            display: {
                viewMode: 'calendar',
                keepOpen: false,
                buttons: {
                    close: false,
                },
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                }
            },
        });
        const subscriptionStart = datetimepicker1.subscribe("change.td", (e) => {
            datetimepicker2.updateOptions({
                restrictions: {
                    minDate: e.date,
                },
            });
        });
        //using subscribe method
        const subscription = datetimepicker2.subscribe("change.td", (e) => {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: e.date,
                },
            });
        });
        if (startDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    minDate: dayjs(startDate).toDate()
                }
            });
        }
        if (endDate) {
            datetimepicker1.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate()
                }
            });
            datetimepicker2.updateOptions({
                restrictions: {
                    maxDate: dayjs(endDate).toDate(),
                    minDate: dayjs().toDate()
                }
            });
        }
    }
    getParticipantCompletionsForCourse(button) {
        var me = this;
        var globalWindow = this._globalModal;
        var identifier = $(button).attr("data-team-identifier");
        var contentidentifier = $(button).attr('data-content-identifier');
        var url = "/Team/GetParticipantCompletionsForContent/" + identifier + "/" + contentidentifier;
        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
            .done(function (data, textStatus, request) {
            globalWindow.openGlobalModal(data, "panel", { classes: "team-detail-panel" });
            var table = $(".js-global-modal").find(".table.dataTable");
            // DATATABLE
            $(table).DataTable({
                "searching": true,
                "columnDefs": [
                    {
                        "targets": 2,
                        "searchable": false
                    }
                ],
            });
            var filterTable = $(".js-global-modal").find(".datatableFilter");
            $(filterTable).on("change", function () {
                me.filterDataTable(me.FilterValues, this);
            });
        })
            .fail(function (response, textStatus, errorThrown) {
        }));
    }
    filterDataTable(FilterValues, e) {
        try {
            var table = $(".js-global-modal").find(".table.dataTable");
            var filterType = $(e).data("filter-type");
            var filterColumn = $(e).data("filter-column");
            FilterValues[filterType] = "";
            if ($(e).is(":checked") && $(e).data('filter-type') === filterType) {
                var val = $(e).val();
                if (val !== "all") {
                    val = "^" + val + "$";
                    FilterValues[filterType] = FilterValues[filterType] + val + "|";
                    FilterValues[filterType] = FilterValues[filterType].slice(0, -1);
                    // DATATABLE
                    $(table).DataTable().columns(filterColumn).search(FilterValues[filterType], true, false).draw();
                }
                else {
                    $(table).DataTable().search('').columns().search('').draw();
                }
            }
        }
        catch (e) {
            alert(e.message);
        }
    }
    saveCourseDetail(button) {
        var me = this;
        var globalWindow = this._globalModal;
        var widgetcontainer = $(button).attr("data-widget-container");
        var widgetId = $(button).attr("data-widget-Id");
        var identifier = $(button).attr("data-team-identifier");
        var contentidentifier = $(button).attr('data-content-identifier');
        var url = "/Api/Manage/TeamContent/";
        var availabledate = $("#availableDate").val();
        var tz = $(me._widget).find("#time-zone").val();
        if (availabledate != "") {
            availabledate = SetTime(availabledate, '00', '00', '00');
            availabledate = GetISODate(availabledate, tz, "MM/DD/YYYY hh:mm:ss a");
        }
        var duedate = $('#dueDate').val();
        if (duedate != "") {
            duedate = SetTime(duedate, '23', '59', '59');
            duedate = GetISODate(duedate, tz, "MM/DD/YYYY hh:mm:s a");
        }
        var params = {};
        params = {
            teamIdentifier: identifier,
            contentIdentifier: contentidentifier,
            availableDate: availabledate,
            dueDate: duedate,
            isRequired: $(".js-global-modal").find(".js-edit-course-isrequired").is(":checked")
        };
        $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
            .done(function (data, textStatus, request) {
            params = {
                teamIdentifier: identifier,
            };
            url = "/Team/RenderTeamLeaderTeamDetail/" + widgetId;
            $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + widgetcontainer).html(data);
                GlobalPopulateTimeZones($("." + widgetcontainer).find("#time-zone"));
                me.bindTeamDatePickers();
                // Localize Date/Times for Assignments
                $.each($(".localized-time"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
                // Localize Date/Times for Students
                $.each($(".localized-time-joined"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                });
                //$("." + widgetcontainer).find('.nav-tabs a[href="#assignments"]').tab('show');
                // @ts-ignore
                bootstrap.Tab.getOrCreateInstance(document.querySelector('#assignments-tab')).show();
                globalWindow.closeGlobalModal();
                me.setAssignmentDataTable();
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
            var errorContainer = me.getValidationDiv(".js-validation-container");
            /*var errorContainer = $(".js-global-modal").find(".js-validation-container");*/
            $(errorContainer).removeClass("col-lg-offset-2");
            globalThis.gage.getValidationErrorMessage(errorContainer, response);
        }));
    }
    saveTeamContent(button) {
        var me = this;
        $(button).attr("disabled", "true");
        $(".js-wait-add-assignment").removeClass("hidden");
        var globalWindow = this._globalModal;
        var widgetcontainer = $(button).attr("data-widget-container");
        var timeZone = $("#time-zone").val();
        var widgetId = $(button).attr("data-widget-Id");
        var contentId = $(".js-global-modal .js-assignments-list").find(".js-course-selection")
            .map(function () {
            return $(this).attr("data-content-identifier");
        }).get().join();
        var identifier = $(button).attr("data-team-identifier");
        var result = [];
        var selected = $(".js-global-modal .js-assignments-list").find(".js-assigned-course");
        $.each(selected, function (index, item) {
            var field = {
                "contentIdentifier": null,
                "contentId": null,
                "availableDate": null,
                "dueDate": null,
                "isRequired": false
            };
            field.contentIdentifier = $(this).attr("data-content-identifier");
            field.contentId = $(this).attr("data-content-id");
            var sDate = $("#selected-course-start-date-" + field.contentId).val();
            var dDate = $("#selected-course-end-date-" + field.contentId).val();
            if (sDate != "") {
                sDate = SetTime(sDate, '00', '00', '00');
                sDate = GetISODate(sDate, timeZone, "MM/DD/YYYY hh:mm:ss a");
            }
            if (dDate != "") {
                dDate = SetTime(dDate, '23', '59', '59');
                dDate = GetISODate(dDate, timeZone, "MM/DD/YYYY hh:mm:s a");
            }
            field.availableDate = sDate == null ? null : sDate;
            field.dueDate = dDate == null ? null : dDate;
            field.isRequired = $(this).find("#selected-course-is-required").is(":checked");
            result.push(field);
        });
        var params = {};
        params = {
            teamIdentifier: identifier,
            contentDetails: result,
        };
        var url = "/Api/Manage/TeamContent";
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            params = {
                teamIdentifier: identifier,
            };
            url = "/Team/RenderTeamLeaderTeamDetail/" + widgetId;
            $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + widgetcontainer).html(data);
                //$("." + widgetcontainer).find('.nav-tabs a[href="#assignments"]').tab('show');
                // @ts-ignore
                bootstrap.Tab.getOrCreateInstance(document.querySelector('#assignments-tab')).show();
                GlobalPopulateTimeZones($("#time-zone"));
                me.bindTeamDatePickers();
                // Localize Date/Times for Assignments
                $.each($(".localized-time"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
                // Localize Date/Times for Students
                $.each($(".localized-time-joined"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                });
                globalWindow.closeGlobalModal();
                me.setAssignmentDataTable();
                $(button).attr("disabled", "false");
                $(".js-wait-add-assignment").addClass("hidden");
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
            $(button).attr("disabled", "false");
            $(".js-wait-add-assignment").addClass("hidden");
            var errorContainer = me.getValidationDiv(".js-validation-container");
            /*var errorContainer = $(".js-global-modal").find(".js-validation-container");*/
            $(errorContainer).removeClass("col-lg-offset-2");
            globalThis.gage.getValidationErrorMessage(errorContainer, response);
        }));
    }
    saveEditAssignments(button) {
        var me = this;
        $(button).attr("disabled", "true");
        $(".js-wait-edit-assignment").removeClass("hidden");
        var globalWindow = this._globalModal;
        var widgetcontainer = $(button).attr("data-widget-container");
        var timeZone = $("#time-zone").val();
        var widgetId = $(button).attr("data-widget-Id");
        /* var contentId = $(".js-global-modal .js-assignments-list").find(".js-course-selection")
            .map(function () {
                return $(this).attr("data-content-identifier");
            }).get().join(); */
        var identifier = $(button).attr("data-team-identifier");
        var result = [];
        var selected = $(".js-global-modal .js-edit-assignments-list").find(".js-assigned-course");
        $.each(selected, function (index, item) {
            var field = {
                "contentIdentifier": null,
                "contentId": null,
                "availableDate": null,
                "dueDate": null,
                "isRequired": false
            };
            field.contentIdentifier = $(this).attr("data-content-identifier");
            field.contentId = $(this).attr("data-content-id");
            var sDate = $("#edit-course-start-date-" + field.contentId).val();
            var dDate = $("#edit-course-end-date-" + field.contentId).val();
            if (sDate != "") {
                sDate = SetTime(sDate, '00', '00', '00');
                sDate = GetISODate(sDate, timeZone, "MM/DD/YYYY hh:mm:ss a");
            }
            if (dDate != "") {
                dDate = SetTime(dDate, '23', '59', '59');
                dDate = GetISODate(dDate, timeZone, "MM/DD/YYYY hh:mm:s a");
            }
            field.availableDate = sDate == null ? null : sDate;
            field.dueDate = dDate == null ? null : dDate;
            field.isRequired = $(this).find("#selected-course-is-required").is(":checked");
            result.push(field);
        });
        var params = {};
        params = {
            teamIdentifier: identifier,
            contentDetails: result,
        };
        /* Need to hook-up to endpoint */
        var url = "/Api/Manage/TeamContent/UpdateTeamContentAssignments";
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            params = {
                teamIdentifier: identifier,
            };
            url = "/Team/RenderTeamLeaderTeamDetail/" + widgetId;
            $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + widgetcontainer).html(data);
                //$("." + widgetcontainer).find('.nav-tabs a[href="#assignments"]').tab('show');
                // @ts-ignore
                bootstrap.Tab.getOrCreateInstance(document.querySelector('#assignments-tab')).show();
                GlobalPopulateTimeZones($("#time-zone"));
                me.bindTeamDatePickers();
                // Localize Date/Times for Assignments
                $.each($(".localized-time"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
                // Localize Date/Times for Students
                $.each($(".localized-time-joined"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                });
                globalWindow.closeGlobalModal();
                me.setAssignmentDataTable();
                $(button).attr("disabled", "false");
                $(".js-wait-add-assignment").addClass("hidden");
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
            $(button).attr("disabled", "false");
            $(".js-wait-add-assignment").addClass("hidden");
            /*var errorContainer = $(".js-global-modal").find(".js-validation-container");*/
            var errorContainer = me.getValidationDiv(".js-validation-container");
            $(errorContainer).removeClass("col-lg-offset-2");
            globalThis.gage.getValidationErrorMessage(errorContainer, response);
        }));
    }
    getTeamContentCompletionForParticipant(button) {
        var me = this;
        var identifier = $(button).closest(".widget-teamleader-team-detail").attr("data-team-identifier");
        var participantId = $(button).attr("data-participant-id");
        var params = {
            teamIdentifier: identifier,
            participantId: participantId
        };
        $.when(globalThis.gage.submitAjaxRequest(params, "/Team/GetTeamContentCompletionForParticipant", "GET")
            .done(function (data, textStatus, request) {
            var options = {
                classes: "member-detail-panel"
            };
            me._globalModal.openGlobalModal(data, "panel", options);
            ApplyGagePopOverParticipant($('[data-bs-toggle="popover"]'));
            $.each($(".localized-time2"), function (i, e) {
                var localDate = $(e).text();
                $(e).text(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
            });
        }));
    }
    compareDates(dateTimeA, dateTimeB) {
        var momentA = new Date(dateTimeA);
        var momentB = new Date(dateTimeB);
        if (momentA > momentB)
            return 1;
        else if (momentA < momentB)
            return -1;
        else
            return 0;
    }
    saveTeam(button) {
        $(".js-save-team-detail").attr("disabled", "true");
        $(".js-wait-team-properties").removeClass("hidden");
        var currentPageUrl = $(button).attr("data-current-page-url");
        var widgetId = $(button).attr("data-widgetId");
        var widgetcontainer = $(button).attr("data-widget-container");
        var identifier = $(button).closest(".widget-teamleader-team-detail").attr("data-team-identifier");
        var url = "/Api/Manage/Team/Update/" + identifier;
        var method = "PUT";
        if (identifier == undefined || identifier.trim().length == 0) {
            url = "/Api/Manage/Team/Create";
            method = "POST";
        }
        var me = this;
        var overwriteMessage = $(button).attr("data-overwrite-message");
        var startDate = $('#start-date').val();
        var endDate = $('#end-date').val();
        var tz = $(me._widget).find("#time-zone").val();
        var itemStatusId = parseInt($(me._widget).find("#item-status").val());
        var assignmentSortOrder = $(me._widget).find(".js-assignment-sort-order").val();
        if (startDate != "") {
            startDate = SetTime(startDate, '00', '00', '00');
            startDate = GetISODate(startDate, tz, "MM/DD/YYYY hh:mm:ss a");
        }
        if (endDate != "") {
            endDate = SetTime(endDate, '23', '59', '59');
            endDate = GetISODate(endDate, tz, "MM/DD/YYYY hh:mm:s a");
        }
        if (startDate !== null || endDate !== null) {
            if (tz == null || tz == undefined) {
                alert("TimeZone must be selected");
                $(".js-save-team-detail").attr("disabled", "false");
                $(".js-wait-team-properties").addClass("hidden");
                $(".js-save-team-detail").removeattr("disabled");
                return false;
            }
        }
        if (startDate !== null && endDate !== null) {
            if (me.compareDates(endDate, startDate) < 0) {
                alert("End Date must be greater then Start Date");
                $(".js-save-team-detail").attr("disabled", "false");
                $(".js-wait-team-properties").addClass("hidden");
                $(".js-save-team-detail").removeattr("disabled");
                return false;
            }
        }
        var params = {};
        params = {
            teamName: $(me._widget).find("#team-name").val(),
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
            itemStatusId: itemStatusId,
            teamAssignmentSortOrder: assignmentSortOrder,
            timeZone: tz
        };
        $.when(globalThis.gage.submitAjaxRequest(params, url, method)
            .done(function (data, textStatus, request) {
            params = {
                id: widgetId,
                teamIdentifier: identifier,
                teamSaved: true
            };
            url = '/Team/RenderTeamLeaderTeamDetail/' + widgetId;
            $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                window.location.href = currentPageUrl;
                $(".js-save-team-detail").removeAttr("disabled");
                $("." + widgetcontainer).html(data);
                $(".js-wait-team-properties").addClass("hidden");
                GlobalPopulateTimeZones($("#time-zone"));
                me.bindTeamDatePickers();
                // Localize Date/Times for Assignments
                $.each($(".localized-time"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
                // Localize Date/Times for Students
                $.each($(".localized-time-joined"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
                });
                me.setAssignmentDataTable();
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
            $(".js-save-team-detail").removeAttr("disabled");
            $(".js-wait-team-properties").addClass("hidden");
            if (response.responseJSON !== undefined && response.responseJSON.data != undefined && response.responseJSON.data == "duplicate") {
                if (confirm(overwriteMessage)) {
                    //params = {
                    //	teamName: $(me._widget).find("#team-name").val(),
                    //	startDate: $(me._widget).find("#start-date").val() !== "" ? $(me._widget).find("#start-date").val() : null,
                    //	endDate: $(me._widget).find("#end-date").val() !== "" ? $(me._widget).find("#end-date").val() : null,
                    //	TimeZone: $("#time-zone").val(),
                    //	itemStatusId: itemStatusId,
                    //	teamAssignmentSortOrder: $(me._widget).find(".js-assignment-sort-order").val(),
                    //	overRide: true
                    //};
                    params = {
                        teamName: $(me._widget).find("#team-name").val(),
                        startDate: startDate ? startDate : null,
                        endDate: endDate ? endDate : null,
                        itemStatusId: itemStatusId,
                        teamAssignmentSortOrder: assignmentSortOrder,
                        timeZone: tz,
                        overRide: true
                    };
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "PUT")
                        .done(function (data, textStatus, request) {
                        params = {
                            id: widgetId,
                            teamIdentifier: identifier,
                            teamSaved: true
                        };
                        url = '/Team/RenderTeamLeaderTeamDetail/' + widgetId;
                        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                            .done(function (data, textStatus, request) {
                            location.reload();
                            //$("." + widgetcontainer).html(data);
                        }));
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        var errorContainer = $("." + widgetcontainer).find(".js-validation-container");
                        errorContainer.removeClass("col-lg-offset-2");
                        getValidationErrorMessage(errorContainer, response);
                    }));
                }
            }
            else {
                var errorContainer = $("." + widgetcontainer).find(".js-validation-container");
                errorContainer.removeClass("col-lg-offset-2");
                getValidationErrorMessage(errorContainer, response);
            }
        }));
    }
    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
            return "";
        });
        return vars;
    }
}
;
$(document).ready(function () {
    ApplyGagePopOverParticipant($('[data-bs-toggle="popover"]'));
    $(".widget-teamleader-team-detail").each(function (index, item) {
        $(item).data("manager", new TeamLeaderTeamDetail(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/*import timezone = require("../../wwwroot/lib/dayjs1.11.10/plugin/timezone");*/
//import dayjs, { Dayjs } from '../../node_modules/dayjs/index';
//import utc from "../../node_modules/dayjs/plugin/utc";
//import timezone from "../../node_modules/dayjs/plugin/timezone";
//import localizedFormat from "../../node_modules/dayjs/plugin/localizedFormat";
//import localeData from "../../node_modules/dayjs/plugin/localeData";
//import timezones from "../../node_modules/timezones-list/dist/index";
//dayjs.extend(utc);
//dayjs.extend(timezone);
//dayjs.extend(localizedFormat);
//dayjs.extend(localeData);
/* ///// <reference path="../lib/moment.d.ts" /> */
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.thirdParty.d.ts" />
class TeamLeaderTeamList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._globalModal = new GlobalModal(this._widgetId);
        this._widgetContainer = "widget-teamleader-team-list-container-" + this._widgetId;
        this.bindControls();
        var x = 1;
    }
    bindControls() {
        var me = this;
        // Localize Date/Times
        $.each($(".localized-time-team-list"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
        });
        $("." + me._widgetContainer).on("click", ".js-create-new-team", function (e) {
            e.preventDefault();
            var content = $(".js-new-team-content").html();
            var options = {
                classes: "new-team-panel"
            };
            content = content.replace(new RegExp("new-startdatepicker", "g"), "startdatepicker");
            content = content.replace(new RegExp("new-start-date", "g"), "start-date");
            content = content.replace(new RegExp("new-enddatepicker", "g"), "enddatepicker");
            content = content.replace(new RegExp("new-end-date", "g"), "end-date");
            content = content.replace(new RegExp("new-time-zone", "g"), "time-zone");
            me._globalModal.openGlobalModal(content, "panel", options);
            $(".js-global-modal").find("#end-date").attr("min", dayjs(new Date()).format("YYYY-MM-DD"));
            var pickers = ConfigureDatePicker($(".js-global-modal").find('.trigger-date'));
            var startPicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; })[0][1];
            var endDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; })[0][1];
            BindDatePickerEvents(startPicker, endDatePicker, document.getElementById("startdatepicker"), document.getElementById("enddatepicker"));
            GlobalPopulateTimeZones($("#time-zone"));
        });
        $("." + me._widgetContainer).on("click", "#includeDeletedTeam", function (e) {
            me.applyFilter($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", "#includeExpiredTeam", function (e) {
            me.applyFilter($(e.currentTarget));
        });
        $(".js-global-modal").on("click", ".js-save-team", function (e) {
            e.preventDefault();
            me.saveTeam($(e.currentTarget));
        });
        me.setUpDataTable();
        $("." + me._widgetContainer).on("click", ".js-copy-team", function (e) {
            e.preventDefault();
            me.getTeamOptionsForExistingTeam($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-copy-team-from-other-team", function (e) {
            e.preventDefault();
            $(e.currentTarget).attr("is-new", "true");
            me.getTeamOptionsFromOTherTeam($(e.currentTarget));
            GlobalPopulateTimeZones($("#time-zone"));
        });
        $("." + me._widgetContainer).on("click", ".js-remove-team", function (e) {
            e.preventDefault();
            if (confirm($(e.currentTarget).attr("data-confirmation-message"))) {
                me.removeTeam($(e.currentTarget));
            }
        });
        $("." + me._widgetContainer).on("click", ".js-reinstate-team", function (e) {
            e.preventDefault();
            if (confirm($(e.currentTarget).attr("data-confirmation-message"))) {
                me.reinstateTeam($(e.currentTarget));
            }
        });
        if ($("." + me._widgetContainer).find(".js-querystring-copy-code").val() !== "") {
            var copyCode = $("." + me._widgetContainer).find(".js-querystring-copy-code").val();
            var button = $("." + me._widgetContainer).find(".js-copy-team-from-other-team");
            $(button).attr("data-querystring-copy-code", copyCode);
            $(button).attr("is-new", "false");
            me.getTeamOptionsFromOTherTeam(button);
            GlobalPopulateTimeZones($("#time-zone"));
        }
    }
    populateTimeZones(el) {
        var timeZones = Intl.supportedValuesOf("timeZone");
        $(el).append("<option value='UTC'>UTC</option>");
        $.each(timeZones, function (i, v) {
            $(el).append("<option value='" + v + "'>" + v + "</option>");
        });
        // Set default time zone based on their location
        $(el).find("option[value='" + dayjs.tz.guess() + "']").attr('selected', "true");
    }
    setUpDataTable() {
        var me = this;
        var table = $("." + me._widgetContainer).find(".table.dataTable");
        // DATATABLE
        $(table).DataTable({
            "pageLength": 10,
            "searching": true,
            "dom": '<"top"<"left jsLeftFilter"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
            order: [],
            "columnDefs": [
                { type: 'date', "targets": 1 },
                { type: 'date', "targets": 2 },
                { "targets": 4, "searchable": false },
                { "targets": 5, "searchable": false, "orderable": false }
            ],
            "drawCallback": function (settings) {
                if ($(".jsLeftFilter").find(".js-filter-table").length === 0) {
                    var aFilters = $(".js-filter-table").clone();
                    $(".js-filter-table").appendTo(".jsLeftFilter");
                }
            }
        });
    }
    removeTeam(button) {
        var me = this;
        var teamidentifier = $(button).closest(".js-team-row").attr("data-team-identifier");
        /*var url = "/API/Manage/Team/Delete/" + teamidentifier;*/
        var url = "/API/Manage/Team/Delete";
        var params = {
            Identifier: teamidentifier
        };
        $.when(globalThis.gage.submitAjaxRequest(params, url, "DELETE")
            .done(function (data, textStatus, request) {
            url = "/Team/RenderTeamLeaderTeamList/" + me._widgetId;
            $.when(globalThis.gage.submitAjaxRequest(null, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + me._widgetContainer).html(data);
                // Localize Date/Times
                $.each($(".localized-time-team-list"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
        }));
    }
    reinstateTeam(button) {
        var me = this;
        var teamidentifier = $(button).closest(".js-team-row").attr("data-team-identifier");
        /*var url = "/API/Manage/Team/Reinstate/" + teamidentifier;*/
        var url = "/API/Manage/Team/Reinstate";
        var params = {
            Identifier: teamidentifier
        };
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            url = "/Team/RenderTeamLeaderTeamList/" + me._widgetId;
            $.when(globalThis.gage.submitAjaxRequest(null, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + me._widgetContainer).html(data);
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
        }));
    }
    applyFilter(button) {
        var me = this;
        waitingDialog.show("");
        var includeDeleted = $(button).closest(".widget-teamleader-team-list").find("#includeDeletedTeam").length > 0 ? $(button).closest(".widget-teamleader-team-list").find("#includeDeletedTeam").is(":checked") : false;
        var includeExpired = $(button).closest(".widget-teamleader-team-list").find("#includeExpiredTeam").length > 0 ? $(button).closest(".widget-teamleader-team-list").find("#includeExpiredTeam").is(":checked") : false;
        var params = {
            IncludeDeleted: includeDeleted,
            IncludeExpired: includeExpired
        };
        var url = "/Team/RenderTeamLeaderTeamList/" + me._widgetId;
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            waitingDialog.hide();
            $("." + me._widgetContainer).html(data);
            me.setUpDataTable();
            me.setLocalTimes();
        })
            .fail(function (response, textStatus, errorThrown) {
            waitingDialog.hide();
            me.setLocalTimes();
        }));
    }
    setLocalTimes() {
        $.each($(".localized-time-team-list"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
            //DisplayDateInLocalFormat(localDate, "hh:mm a")
        });
    }
    getTeamOptionsForExistingTeam(button) {
        var me = this;
        var widgetId = $(button).closest(".widget-teamleader-team-list").attr("data-contentwidgetid");
        var widgetcontainer = me._widgetContainer;
        var teamidentifier = $(button).closest(".js-team-row").attr("data-team-identifier");
        var teamName = $(button).closest(".js-team-row").attr("data-team-name");
        var originalTimeZone = $(button).closest(".js-team-row").attr("data-team-tz");
        var startDate = $(button).attr("data-start-date") === ""
            ? ""
            : $(button).attr("data-start-date");
        var endDate = $(button).attr("data-end-date") === ""
            ? ""
            : $(button).attr("data-end-date");
        var showFuture = $(button).attr("data-show-future");
        var contentClone = $(button).closest(".widget-teamleader-team-list").find(".js-copy-team-container").clone();
        $(contentClone).find(".js-copy-team-promocode-row").remove();
        var globalWindow = this._globalModal;
        var contentHtml = $(contentClone).html();
        contentHtml = contentHtml.replace(RegExp("copy-startdatepicker", "g"), "startdatepicker");
        contentHtml = contentHtml.replace(new RegExp("copy-start-date", "g"), "start-date");
        contentHtml = contentHtml.replace(new RegExp("copy-team-name", "g"), "team-name");
        contentHtml = contentHtml.replace("copy-enddatepicker", "enddatepicker");
        contentHtml = contentHtml.replace(new RegExp("copy-end-date", "g"), "end-date");
        contentHtml = contentHtml.replace(new RegExp("copy-time-zone", "g"), "time-zone");
        contentHtml = contentHtml.replace(new RegExp("copy-original-time-zone", "g"), "original-time-zone");
        globalWindow.openGlobalModal(contentHtml, "panel", { classes: "copy-team-modal" });
        GlobalPopulateTimeZones($("#time-zone"));
        $("#original-time-zone").val(originalTimeZone);
        var globalContainer = $(".js-global-modal");
        $(globalContainer).find("#team-name").val(teamName);
        if (startDate != "") {
            $(".js-unformatted-sdate").text(startDate + " UTC");
            var formattedStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY", originalTimeZone);
            //var formattedStartDate = DisplayDateInTimeZoneFormat(startDate, "MM/DD/YYYY 12:00:01 AM", originalTimeZone);
            $('#start-date').val(formattedStartDate);
        }
        if ((startDate != "") && (endDate != "" && dayjs.utc(endDate).local() > dayjs())) {
            $(".js-unformatted-edate").text(endDate + " UTC");
            var formattedEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY", originalTimeZone);
            //var formattedEndDate = DisplayDateInTimeZoneFormat(endDate, "MM/DD/YYYY 12:00:00 AM", originalTimeZone);
            $('#end-date').val(formattedEndDate);
        }
        var pickers = ConfigureDatePicker($(globalContainer).find('.trigger-date'));
        var startPicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; })[0][1];
        var endDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; })[0][1];
        BindDatePickerEvents(startPicker, endDatePicker, document.getElementById("startdatepicker"), document.getElementById("enddatepicker"));
        /*
        var currentStartDatePicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; });
        var startPicker = currentStartDatePicker[0][1];
        var currentEndDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; });
        var endDatePicker = currentEndDatePicker[0][1];

        const startPickerElement = document.getElementById("startdatepicker");
        startPickerElement.addEventListener("change.td", (e) => {
            // @ts-ignore
            endDatePicker.updateOptions({ restrictions: { minDate: e.detail.date } });
        });

        //using subscribe method
        const endDatePickerElement = document.getElementById("enddatepicker");

        endDatePickerElement.addEventListener("change.td", (e) => {
            // @ts-ignore
            startPicker.updateOptions({ restrictions: { maxD: e.detail.date } });
        });


        */
        if (originalTimeZone != "") {
            $("#time-zone").find("option[value='" + originalTimeZone + "']").attr('selected', "true");
        }
        $(globalContainer).find("#team-name").val(teamName);
        $(globalContainer).find(".js-copy-team-options").attr("data-show-future", showFuture);
        $(globalContainer).find(".js-copy-team-button").attr("data-team-identifier", teamidentifier);
        $(globalContainer).find(".js-copy-team-button").attr("data-widgetId", widgetId);
        $(globalContainer).find(".js-copy-team-button").attr("data-widget-container", widgetcontainer);
        var dueDateRow = $(globalContainer).find(".js-copy-team-due-date-row");
        var keeprequiredAssignmentRow = $(globalContainer).find(".js-copy-team-keep-required-assignment-row");
        me.resetSettings(globalContainer);
        $(globalContainer).find(".js-copy-team-options").on("change", function (e) {
            $(keeprequiredAssignmentRow).addClass("hide");
            if ($(e.currentTarget).val() === "AssignmentsOnly" || $(e.currentTarget).val() === "MembersAndAssignments") {
                $(keeprequiredAssignmentRow).removeClass("hide");
                if ($(e.currentTarget).attr("data-show-future") === "True") {
                    $(dueDateRow).removeClass("hide");
                }
            }
        });
        $(globalContainer).find(".js-copy-team-button").on("click", function (e) {
            widgetcontainer = $(e.currentTarget).attr("data-widget-container");
            widgetId = $(e.currentTarget).attr("data-widgetId");
            teamidentifier = $(e.currentTarget).attr("data-team-identifier");
            var overwriteMessage = $(e.currentTarget).attr("data-overwrite-message");
            var copyOptions = $(globalContainer).find(".js-copy-team-options");
            var timezonerequired = $(e.currentTarget).attr("data-timezone-required");
            var teamnamerequired = $(e.currentTarget).attr("data-teamname-required");
            var teamcopyoptionrequired = $(e.currentTarget).attr("data-teamcopyoption-required");
            var timeZone = $(".js-global-modal ").find("#time-zone").val();
            var originalTimeZone = $(".js-global-modal ").find("#original-time-zone").val();
            if (!timeZone) {
                alert(timezonerequired);
                return false;
            }
            if ($(globalContainer).find("#team-name").val() === "") {
                alert(teamnamerequired);
                return false;
            }
            if ($(copyOptions).val() === "") {
                alert(teamcopyoptionrequired);
                return false;
            }
            var params = {};
            var startDate = $('#start-date').val();
            var endDate = $('#end-date').val();
            if (startDate != "") {
                startDate = SetTime(startDate, '00', '00', '00');
                startDate = GetISODate(startDate, timeZone, "MM/DD/YYYY hh:mm:ss a");
            }
            if (endDate != "") {
                endDate = SetTime(endDate, '23', '59', '59');
                endDate = GetISODate(endDate, timeZone, "MM/DD/YYYY hh:mm:s a");
            }
            if (startDate != null && endDate != null) {
                if (me.compareDates(endDate, startDate) < 0) {
                    alert("End Date must be greater than Start Date");
                    return false;
                }
            }
            me.copyTeamCommon(globalWindow, globalContainer, widgetId, widgetcontainer, overwriteMessage, copyOptions, startDate, endDate, timeZone, originalTimeZone, $(e.currentTarget).attr("data-team-identifier"), null);
        });
    }
    copyTeamCommon(globalWindow, globalContainer, widgetId, widgetcontainer, overwriteMessage, copyOptions, startDate, endDate, timeZone, originalTimeZone, teamIdentifier, joinCode) {
        var me = this;
        $(globalContainer).find(".js-copy-team-button").attr("disabled", "true");
        $(".js-wait-copy-team").removeClass("hidden");
        var now = dayjs().tz(originalTimeZone);
        var localOffset = now.utcOffset();
        now.tz(timeZone);
        var centralOffset = now.utcOffset();
        var diffInMinutes = localOffset - centralOffset;
        var teamName = $(globalContainer).find("#team-name").val();
        if (teamName === undefined) {
            teamName = $(globalContainer).find("#copy-team-name").val();
        }
        if (teamName === undefined) {
            teamName = "";
        }
        var params = {};
        params =
            {
                "TeamJoinCode": joinCode,
                "TeamName": teamName,
                "StartDate": startDate,
                "EndDate": endDate,
                "TimeZone": timeZone,
                "TimeZoneDiffMinutes": diffInMinutes,
                "CopyOption": $(copyOptions).val(),
                "TeamIdentifier": teamIdentifier,
                "CopyDates": $(globalContainer).find(".js-copy-team-duedate").is(":checked"),
                "KeepRequiredAssigmentSetting": $(globalContainer).find(".js-copy-team-keep-required-assignment").is(":checked")
            };
        var url = "/Api/Manage/Team/Copy";
        // this may be incorrect widgetcontainer needs to be the actual container object and not a selector!!!
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            var url = "/Team/RenderTeamLeaderTeamList/" + widgetId;
            $.when(globalThis.gage.submitAjaxRequest(null, url, "POST")
                .done(function (data, textStatus, request) {
                $("." + widgetcontainer).html(data);
                globalWindow.closeGlobalModal();
                // Localize Date/Times
                $.each($(".localized-time-team-list"), function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
                $(globalContainer).find(".js-copy-team-button").removeAttr("disabled");
                $(".js-wait-copy-team").addClass("hidden");
                var uri = window.location.toString();
                if (uri.indexOf("?") > 0) {
                    var clean_uri = uri.substring(0, uri.indexOf("?"));
                    window.history.replaceState({}, document.title, clean_uri);
                }
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
            $(globalContainer).find(".js-copy-team-button").removeAttr("disabled");
            $(".js-wait-copy-team").addClass("hidden");
            if (response.responseJSON.data == "duplicate") {
                if (confirm(overwriteMessage)) {
                    params = {
                        "TeamJoinCode": joinCode,
                        "TeamName": $(globalContainer).find("#team-name").val(),
                        "StartDate": startDate,
                        "EndDate": endDate,
                        "TimeZone": timeZone,
                        "TimeZoneDiffMinutes": diffInMinutes,
                        "CopyOption": $(copyOptions).val(),
                        "TeamIdentifier": teamIdentifier,
                        "CopyDates": $(globalContainer).find(".js-copy-team-duedate").is(":checked"),
                        "KeepRequiredAssigmentSetting": $(globalContainer).find(".js-copy-team-keep-required-assignment").is(":checked"),
                        "Override": true
                    };
                    url = "/Api/Manage/Team/Copy";
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                        .done(function (data, textStatus, request) {
                        var url = "/Team/RenderTeamLeaderTeamList/" + widgetId;
                        $.when(globalThis.gage.submitAjaxRequest(null, url, "POST")
                            .done(function (data, textStatus, request) {
                            $("." + widgetcontainer).html(data);
                            globalWindow.closeGlobalModal();
                            // Localize Date/Times
                            $.each($(".localized-time-team-list"), function (i, e) {
                                var localDate = $(e).text();
                                $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                            });
                        }));
                        var uri = window.location.toString();
                        if (uri.indexOf("?") > 0) {
                            var clean_uri = uri.substring(0, uri.indexOf("?"));
                            window.history.replaceState({}, document.title, clean_uri);
                        }
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        alert(response.responseJSON.errorMessage);
                    }));
                }
                else {
                    return false;
                }
            }
            else {
                alert(response.responseJSON.errorMessage);
            }
        }));
    }
    getTeamOptionsFromOTherTeam(button) {
        var me = this;
        var widgetId = $(button).closest(".widget-teamleader-team-list").attr("data-contentwidgetid");
        var content = $(button).closest(".widget-teamleader-team-list").find(".js-copy-team-container").html();
        var copyCode = $(button).attr("data-querystring-copy-code");
        var isnew = $(button).attr("is-new");
        var widgetcontainer = me._widgetContainer;
        var globalWindow = this._globalModal;
        content = content.replace(new RegExp("copy-team-name", "g"), "team-name");
        content = content.replace(new RegExp("copy-teamjoincode", "g"), "teamjoincode");
        content = content.replace("copy-startdatepicker", "startdatepicker");
        content = content.replace(new RegExp("copy-start-date", "g"), "start-date");
        content = content.replace("copy-enddatepicker", "enddatepicker");
        content = content.replace(new RegExp("copy-end-date", "g"), "end-date");
        content = content.replace(new RegExp("copy-time-zone", "g"), "time-zone");
        content = content.replace(new RegExp("copy-original-time-zone", "g"), "original-time-zone");
        globalWindow.openGlobalModal(content, "panel", { classes: "copy-team-modal" });
        var showFuture = $(button).attr("data-show-future");
        var globalContainer = $(".js-global-modal");
        $(globalContainer).find(".js-copy-team-button").attr("data-widgetId", widgetId);
        $(globalContainer).find(".js-copy-team-button").attr("data-widget-container", widgetcontainer);
        var dueDateRow = $(globalContainer).find(".js-copy-team-due-date-row");
        var keeprequiredAssignmentRow = $(globalContainer).find(".js-copy-team-keep-required-assignment-row");
        me.resetSettings(globalContainer);
        $(globalContainer).find(".js-copy-team-joincode").val(copyCode);
        if (isnew === "false") {
            $(globalContainer).find(".js-copy-code-validation").val("True");
        }
        else {
            (globalContainer).find(".js-copy-team-joincode").val("");
        }
        $(globalContainer).find(".js-copy-team-options").on("change", function (e) {
            $(keeprequiredAssignmentRow).addClass("hide");
            if ($(e.currentTarget).val() === "AssignmentsOnly" || $(e.currentTarget).val() === "MembersAndAssignments") {
                $(keeprequiredAssignmentRow).removeClass("hide");
                if ($(e.currentTarget).attr("data-show-future") == "True") {
                    $(dueDateRow).removeClass("hide");
                }
            }
        });
        $(globalContainer).find(".js-validate-code").on("click", function (e) {
            e.preventDefault();
            me.validateCode(globalContainer);
        });
        $(globalContainer).find(".js-copy-team-button").on("click", function (e) {
            widgetcontainer = $(e.currentTarget).attr("data-widget-container");
            widgetId = $(e.currentTarget).attr("data-widgetId");
            var overwriteMessage = $(e.currentTarget).attr("data-overwrite-message");
            var timeZone = $(".js-global-modal ").find("#time-zone").val();
            var originalTimeZone = $(".js-global-modal ").find("#original-time-zone").val();
            var timezonerequired = $(e.currentTarget).attr("data-timezone-required");
            var teamnamerequired = $(e.currentTarget).attr("data-teamname-required");
            var teamcoderequired = $(e.currentTarget).attr("data-teamcode-required");
            var teamcopyoptionrequired = $(e.currentTarget).attr("data-teamcopyoption-required");
            if (!timeZone) {
                alert(timezonerequired);
                return false;
            }
            var copyOptions = $(globalContainer).find(".js-copy-team-options");
            if ($(globalContainer).find(".js-copy-team-joincode").val() == "") {
                alert(teamnamerequired);
                return false;
            }
            if ($(globalContainer).find("#team-name").val() === "") {
                alert(teamcoderequired);
                return false;
            }
            if ($(copyOptions).val() === "") {
                alert(teamcopyoptionrequired);
                return false;
            }
            var params = {};
            var startDate = $('#start-date').val();
            var endDate = $('#end-date').val();
            if (startDate != "") {
                startDate = SetTime(startDate, '00', '00', '00');
                startDate = GetISODate(startDate, timeZone, "MM/DD/YYYY hh:mm:ss a");
            }
            if (endDate != "") {
                endDate = SetTime(endDate, '23', '59', '59');
                endDate = GetISODate(endDate, timeZone, "MM/DD/YYYY hh:mm:s a");
            }
            if (startDate !== null && endDate !== null) {
                if (me.compareDates(endDate, startDate) < 0) {
                    alert("End Date must be greater than Start Date");
                    return false;
                }
            }
            me.copyTeamCommon(globalWindow, globalContainer, widgetId, widgetcontainer, overwriteMessage, copyOptions, startDate, endDate, timeZone, originalTimeZone, null, $(globalContainer).find(".js-copy-team-joincode").val());
        });
        if (isnew === "false") {
            $(globalContainer).find(".js-validate-code").click();
        }
    }
    validateCode(globalContainer) {
        var me = this;
        me.resetSettings(globalContainer);
        var code = $(globalContainer).find(".js-copy-team-joincode").val();
        if (code === "") {
            alert("Please enter code to validate");
            return false;
        }
        var params = {};
        var url = "/Api/Manage/Team/ValidateTeamCode/" + code;
        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
            .done(function (data, textStatus, request) {
            if (data.endDate === undefined) {
                $(globalContainer).find(".js-copy-team-options").attr("data-show-future", "True");
                $(globalContainer).find("#start-date").val("");
                $(globalContainer).find("#end-date").val("");
                $(globalContainer).find("#team-name").val(data.teamName);
                $(globalContainer).find("#original-time-zone").val(data.timeZone);
            }
            else {
                var dateToCheck = data.endDate;
                var currentDate = new Date();
                dateToCheck = new Date(dateToCheck);
                if (dateToCheck > currentDate) {
                    $(globalContainer).find(".js-copy-team-options").attr("data-show-future", "True");
                    var startDate;
                    var endDate;
                    if (data.startDate !== undefined) {
                        $(".js-unformatted-sdate").text(data.startDate + " UTC");
                        var formattedStartDate = DisplayDateInTimeZoneFormat(data.startDate, "MM/DD/YYYY", data.timeZone);
                        $('#start-date').val(formattedStartDate);
                    }
                    if (data.endDate !== undefined) {
                        $(".js-unformatted-edate").text(data.endDate + " UTC");
                        endDate = dayjs.utc(data.endDate).tz(data.timeZone);
                        if (endDate > dayjs()) {
                            var formattedStartDate = DisplayDateInTimeZoneFormat(data.startDate, "MM/DD/YYYY", data.timeZone);
                            var formattedEndDate = DisplayDateInTimeZoneFormat(data.endDate, "MM/DD/YYYY", data.timeZone);
                            $('#end-date').val(formattedEndDate);
                            $('#start-date').val(formattedStartDate);
                        }
                    }
                    var pickers = ConfigureDatePicker($(globalContainer).find('.trigger-date'));
                    var startPicker = pickers.filter(function (element) { return element[0] == "startdatepicker"; })[0][1];
                    var endDatePicker = pickers.filter(function (element) { return element[0] == "enddatepicker"; })[0][1];
                    BindDatePickerEvents(startPicker, endDatePicker, document.getElementById("startdatepicker"), document.getElementById("enddatepicker"));
                    var teamName = data.teamName;
                    $(globalContainer).find("#team-name").val(teamName);
                    $(globalContainer).find("#original-time-zone").val(data.timeZone);
                    $(globalContainer).find("#time-zone").val(data.timeZone);
                }
                else {
                    $(globalContainer).find(".js-copy-team-options").attr("data-show-future", "False");
                }
            }
        })
            .fail(function (response, textStatus, errorThrown) {
            $(globalContainer).find(".js-validate-error-container").html(response.responseJSON.errorMessage);
        }));
    }
    compareDates(dateTimeA, dateTimeB) {
        var momentA = new Date(dateTimeA);
        var momentB = new Date(dateTimeB);
        if (momentA > momentB)
            return 1;
        else if (momentA < momentB)
            return -1;
        else
            return 0;
    }
    resetSettings(globalContainer) {
        var dueDateRow = $(globalContainer).find(".js-copy-team-due-date-row");
        var keeprequiredAssignmentRow = $(globalContainer).find(".js-copy-team-keep-required-assignment-row");
        $(dueDateRow).addClass("hide");
        $(dueDateRow).find(".js-copy-team-duedate").attr("checked", "false");
        $(keeprequiredAssignmentRow).addClass("hide");
        $(keeprequiredAssignmentRow).find(".js-copy-team-keep-required-assignment").attr("checked", "false");
    }
    saveTeam(button) {
        var me = this;
        $(button).attr("disabled", "true");
        $(".js-please-wait").removeClass("hidden");
        var helpText = $(".js-please-wait").text();
        $(".js-please-wait-a11y").text(helpText);
        var url = "/Api/Manage/Team/Create";
        var widgetId = $(button).attr("data-widgetId");
        var widgetcontainer = $(button).attr("data-widget-container");
        var globalWindow = this._globalModal;
        var timeZone = $(".js-global-modal ").find("#time-zone").val();
        if (!timeZone) {
            alert("Time Zone must be selected");
            return false;
        }
        var overwriteMessage = $(button).attr("data-overwrite-message");
        var detailUrl = $(button).attr("data-detail-page-url");
        var startDate = $('#start-date').val();
        if (startDate != "") {
            startDate = SetTime(startDate, '00', '00', '00');
            startDate = GetISODate(startDate, timeZone, "MM/DD/YYYY hh:mm:ss a");
        }
        var endDate = $("#end-date").val();
        if (endDate != "") {
            endDate = SetTime(endDate, '23', '59', '59');
            endDate = GetISODate(endDate, timeZone, "MM/DD/YYYY hh:mm:s a");
        }
        if (startDate !== "" && endDate !== "") {
            if (me.compareDates(endDate, startDate) < 0) {
                alert("End Date must be greater then Start Date");
                return false;
            }
        }
        var params = {};
        params = {
            teamName: $(".js-global-modal").find("#team-name").val(),
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
            teamAssignmentSortOrder: $(".js-global-modal").find("#new-assignment-sort-order").val(),
            timeZone: timeZone,
        };
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            $(".js-please-wait-a11y").text("");
            window.location.href = detailUrl + "?identifier=" + data.identifier + "&activeTab=assignments";
        })
            .fail(function (response, textStatus, errorThrown) {
            $(".js-please-wait-a11y").text("");
            $(button).attr("disabled", "false");
            $(".js-please-wait").addClass("hidden");
            var errorContainer = $(".js-global-modal ").find(".js-validation-container");
            if (response.responseJSON.data == "duplicate") {
                if (confirm(overwriteMessage)) {
                    params = {
                        teamName: $(".js-global-modal ").find("#team-name").val(),
                        startDate: startDate ? startDate : null,
                        endDate: endDate ? endDate : null,
                        timeZone: timeZone,
                        overRide: true
                    };
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                        .done(function (data, textStatus, request) {
                        var url = "/Team/RenderTeamLeaderTeamList/" + widgetId;
                        $.when(globalThis.gage.submitAjaxRequest(null, url, "POST")
                            .done(function (data, textStatus, request) {
                            $("." + widgetcontainer).html(data);
                            globalWindow.closeGlobalModal();
                            me.setUpDataTable();
                        }));
                    })
                        .fail(function (response, textStatus, errorThrown) {
                        $(errorContainer).removeClass("col-lg-offset-2");
                        globalThis.gage.getValidationErrorMessage(errorContainer, response);
                    }));
                }
            }
            else {
                $(errorContainer).removeClass("col-lg-offset-2");
                globalThis.gage.getValidationErrorMessage(errorContainer, response);
            }
        }));
    }
}
;
$(document).ready(function () {
    ApplyGagePopOverParticipant($('[data-toggle="popover"]'));
    $(".widget-teamleader-team-list").each(function (index, item) {
        $(item).data("manager", new TeamLeaderTeamList(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
class TeamMemberContentAssignmentDueList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._globalModal = new GlobalModal(this._widgetId);
        this._widgetContainer = "widget-teammember-content-assignment-due-list-container-" + this._widgetId;
        this.bindControls();
    }
    bindControls() {
        var me = this;
        // Localize Date/Times
        $.each($(".js-localized-date"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
        });
        $("." + me._widgetContainer).on("click", ".js-show-past", function (e) {
            e.preventDefault();
            if (confirm($(e.currentTarget).attr("data-confirmation-message"))) {
                me.showPast($(e.currentTarget));
            }
        });
        $("." + me._widgetContainer).on("click", ".js-assignments-expand", function (e) {
            if ($(this).attr("aria-expanded") === "false") {
                $(this).attr("aria-expanded", "true");
                $("." + me._widgetContainer).find(".js-my-assignments").removeClass("hidden");
                $(this).find(".js-assignments-icon").text("-");
            }
            else {
                $(this).attr("aria-expanded", "false");
                $("." + me._widgetContainer).find(".js-my-assignments").addClass("hidden");
                $(this).find(".js-assignments-icon").text("+");
            }
        });
    }
    showPast(button) {
        var me = this;
        var url = "/Api/Manage/Team/LeaveTeam/" + $(button).attr("data-team-identifier");
    }
}
;
$(document).ready(function () {
    $(".widget-teammember-content-assignment-due-list").each(function (index, item) {
        $(item).data("manager", new TeamMemberContentAssignmentDueList(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
class TeamMemberContentAssigmentList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._globalModal = new GlobalModal(this._widgetId);
        this._widgetContainer = "widget-teammember-content-assignment-list-container-" + this._widgetId;
        this.bindControls();
    }
    bindControls() {
        var me = this;
        // Localize Date/Times
        $.each($(".localized-time"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
        });
        var table = $("." + me._widgetContainer).find(".table.dataTable");
        // DATATABLE
        $(table).DataTable({
            order: [],
            "pageLength": 25,
            "searching": true,
            "dom": '<"top"<"left"><"right"f><"clearfix">>rt<"bottom"<"left"l><"right"p>><"clearfix">',
            "columnDefs": [
                { type: 'date', "targets": 1, "searchable": false },
                { type: 'date', "targets": 2, "searchable": false },
                { "targets": 3, "orderable": false },
                { "targets": 4, "orderable": false },
                { "targets": 5, "searchable": false }
            ]
        });
        $("." + me._widgetContainer).on("click", ".js-leave-team", function (e) {
            e.preventDefault();
            if (confirm($(e.currentTarget).attr("data-confirmation-message"))) {
                me.leaveTeam($(e.currentTarget));
            }
        });
    }
    leaveTeam(button) {
        var me = this;
        /*var url = "/Api/Manage/Team/LeaveTeam/" + $(button).attr("data-team-identifier");*/
        var url = "/Api/Manage/Team/LeaveTeam";
        var redirectUrl = $(button).attr("data-team-member-list-page-url");
        var widgetId = me._widgetId;
        var widgetcontainer = me._widgetContainer;
        var dto = {
            Identifier: $(button).attr("data-team-identifier")
        };
        $.when(globalThis.gage.submitAjaxRequest(dto, url, "POST")
            .done(function (data, textStatus, request) {
            var url = "/Team/RenderTeamMemberList/" + widgetId;
            var params = {
                teamIdentifier: $(button).attr("data-team-identifier")
            };
            $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                .done(function (data, textStatus, request) {
                window.location.href = redirectUrl;
            }));
        })
            .fail(function (response, textStatus, errorThrown) {
        }));
    }
}
;
$(document).ready(function () {
    $(".widget-teammember-content-assignment-list").each(function (index, item) {
        $(item).data("manager", new TeamMemberContentAssigmentList(item));
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/gage.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
/// <reference path="../lib/helper.timezones.d.ts" />
/// <reference path="../lib/helper.orders.d.ts" />
class TeamMemberTeamList {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this._globalModal = new GlobalModal(this._widgetId);
        this._widgetContainer = "widget-teammember-team-list-container-" + this._widgetId;
        this.bindControls();
    }
    bindControls() {
        var me = this;
        // Localize Date/Times
        $.each($(".local-time"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
        });
        $("." + me._widgetContainer).on("click", "#join-team", function (e) {
            e.preventDefault();
            me.joinTeam($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", ".js-select-team-to-join", function (e) {
            e.preventDefault();
            me.selectTeamsTojoin($(e.currentTarget));
        });
        $("." + me._widgetContainer).on("click", "#includeExpired", function (e) {
            me.applyFilter($(e.currentTarget));
        });
        if ($("." + me._widgetContainer).find("#showteamjoinmodal").val() === "True") {
            var promobox = $("." + me._widgetContainer).find("#join-code");
            var joinbutton = $("." + me._widgetContainer).find("#join-team");
            var cancelText = $("." + me._widgetContainer).find("#canceltext").val();
            var okText = $("." + me._widgetContainer).find("#ok").val();
            ;
            var joinconfirmationtext = $("." + me._widgetContainer).find("#joinconfirmationtext").val();
            bootbox.confirm({
                message: "<p>" + joinconfirmationtext + "</p>",
                buttons: {
                    confirm: {
                        label: okText,
                        className: 'btn-success'
                    },
                    cancel: {
                        label: cancelText,
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        $("." + me._widgetContainer).find("#join-team").click();
                        return true;
                    }
                    else {
                        $(promobox).val("");
                    }
                }
            });
        }
    }
    applyFilter(button) {
        var me = this;
        waitingDialog.show("");
        var includeExpired = $(button).closest(".widget-teammember-team-list").find("#includeExpired").length > 0 ? $(button).closest(".widget-teammember-team-list").find("#includeExpired").is(":checked") : false;
        var params = {
            Id: me._widgetId,
            PostBackData: "{ 'IncludeExpired': '" + includeExpired + "'}"
            /*IncludeExpired: includeExpired*/
        };
        var url = "/Team/RenderTeamMemberTeamList/"; /* + me._widgetId;*/
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            waitingDialog.hide();
            $("." + me._widgetContainer).html(data);
            me.setLocalTimes();
            me.setUpClassTable();
        })
            .fail(function (response, textStatus, errorThrown) {
            waitingDialog.hide();
        }));
    }
    setLocalTimes() {
        $.each($(".local-time"), function (i, e) {
            var localDate = $(e).text();
            $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
            $(e).text(dayjs.utc(localDate).local().format('MM/DD/YYYY'));
        });
    }
    joinTeam(button) {
        var me = this;
        var memberListUrl = $(button).attr("data-team-member-team-list-pageurl");
        var joinCode = $("." + me._widgetContainer).find("#join-code").val();
        if (joinCode === "") {
            alert($(button).attr("data-required-message"));
            return false;
        }
        var notFoundMessage = $(button).attr("data-not-found-message");
        /*var url = "/API/Manage/Team/AddMember/" + joinCode;*/
        var params = {
            Identifier: joinCode
        };
        var url = "/API/Manage/Team/AddMember";
        $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
            .done(function (data, textStatus, request) {
            window.location.href = memberListUrl;
        })
            .fail(function (response, textStatus, errorThrown) {
            if (response.status == "404") {
                alert(notFoundMessage);
            }
            else if (response.responseJSON !== undefined) {
                alert(response.responseJSON.errorMessage);
            }
            else {
                alert(response.responseText);
            }
        }));
    }
    setUpClassTable() {
        var me = this;
        var table = $("." + me._widgetContainer).find(".dataTable");
        // DATATABLE
        $(table).DataTable({
            "searching": true,
            "columnDefs": [
                { type: 'date', "targets": 1 },
                { type: 'date', "targets": 2 },
                { "targets": 3, "searchable": false, "orderable": false }
            ]
        });
    }
    selectTeamsTojoin(button) {
        var me = this;
        var url = "/Team/TeamsToJoin/";
        $.when(globalThis.gage.submitAjaxRequest(null, url, "GET")
            .done(function (data, textStatus, request) {
            me._globalModal.openGlobalModal(data, "panel", { classes: "team-join-modal panel-lg" });
            var globalContainer = $(".js-global-modal");
            var table = $(globalContainer).find(".dataTable");
            // DATATABLE
            $(table).DataTable({
                "searching": true,
                "columnDefs": [
                    { type: 'date', "targets": 1 },
                    { type: 'date', "targets": 2 },
                    { "targets": 3, "searchable": false, "orderable": false }
                ]
            });
            $(globalContainer).find(".js-team-popup-header").html($(button).attr("data-join-popup-header"));
            $(globalContainer).find(".js-join-selected-team").html($(button).attr("data-join-button-text"));
            $(globalContainer).on("click", ".js-join-selected-team", function (e) {
                $(e.currentTarget).attr("disabled", "true");
                var identity = $(e.currentTarget).attr("data-team-identifier");
                $(".js-wait-join-team[data-wait-for='" + identity + "']").removeClass("hidden");
                var participantId = $("#participant-id").val();
                var teamIdentifier = $(e.currentTarget).attr("data-team-identifier");
                /*var url = "/API/Manage/Team/JoinTeam/" + teamIdentifier;*/
                var params = {
                    Identifier: teamIdentifier
                };
                var url = "/API/Manage/Team/JoinTeam/";
                $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                    .done(function (data, textStatus, request) {
                    url = "/Team/RenderTeamMemberTeamList/"; /* + me._widgetId;*/
                    var params = {
                        Id: me._widgetId,
                        PostBackData: null
                        /*IncludeExpired: includeExpired*/
                    };
                    $.when(globalThis.gage.submitAjaxRequest(params, url, "POST")
                        .done(function (data, textStatus, request) {
                        $("." + me._widgetContainer).html(data);
                        $(".js-wait-join-team[data-wait-for='" + identity + "']").addClass("hidden");
                    }));
                })
                    .fail(function (response, textStatus, errorThrown) {
                    $(e.currentTarget).attr("disabled", "false");
                    $(".js-wait-join-team[data-wait-for='" + identity + "']").addClass("hidden");
                    alert(response.responseJSON.errorMessage);
                }));
            });
        })
            .fail(function (response, textStatus, errorThrown) {
            alert(response.responseJSON.errorMessage);
        }));
    }
}
;
$(document).ready(function () {
    $(".widget-teammember-team-list").each(function (index, item) {
        $(item).data("manager", new TeamMemberTeamList(item));
    });
});
class UserStatusFielo {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        var me = this;
        //this.bindControls();
        if ($(me._widget).attr("data-is-edit-mode") !== "true") {
            if ($(me._widget).attr("data-fielo-member-id") != "") {
                me.GetFieloSessionStatus(0, false);
            }
        }
    }
    GetFieloSessionStatus(attempt, renew) {
        var me = this;
        if (attempt < 5) {
            $.ajax({
                method: "GET",
                url: "/Fielo/GetFieloSessionStatus" + "/" + renew,
            }).done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.attempt = attempt + 1;
                    me.updateSessionCheck(data.result);
                }
            });
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateSessionCheck(data) {
        var me = this;
        if (data != null) {
            if (!data.success) {
                me.GetFieloSessionStatus(data.attempt, true);
            }
            else if (data.errorCode != undefined) {
                if (data.errorCode == "INVALID_SESSION_ID") {
                    me.GetFieloSessionStatus(data.attempt, true);
                }
                else if (data.errorCode != "") {
                    alert(data.errorMessage);
                    return;
                }
                else {
                    if (data.success) {
                        if ($(me._widget).attr("data-fielo-member-id") != "") {
                            me.bindControls();
                        }
                    }
                }
            }
        }
    }
    bindControls() {
        var me = this;
        var membersRequests = [];
        var memberRequest = {
            "dataType": null,
            "callType": null,
            "pointValue": null,
            "fieldName": "",
            "renew": false,
            "placeHolderToUpdate": ""
        };
        if ($(me._widget).find("#js-current-point-balance").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#js-current-point-balance").attr("Id");
            var fieloField = $(me._widget).find("#js-current-point-balance").attr("data-fielo-field");
            var dataType = $(me._widget).find("#js-current-point-balance").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetPointBalance",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#js-custom-field").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#js-custom-field").attr("Id");
            var fieloField = $(me._widget).find("#js-custom-field").attr("data-fielo-field");
            var dataType = $(me._widget).find("#js-custom-field").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetCustomFieloField",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#js-point-value").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#js-point-value").attr("Id");
            var fieloField = $(me._widget).find("#js-point-value").attr("data-fielo-field");
            var dataType = $(me._widget).find("#js-point-value").attr("data-type");
            var pointValue = $(me._widget).find("#js-point-value").attr("data-point-value") !== ""
                ? parseFloat($(me._widget).find("#js-point-value").attr("data-point-value"))
                : 1;
            memberRequest = {
                "dataType": dataType,
                "callType": "GetPointValue",
                "pointValue": pointValue,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        if ($(me._widget).find("#js-current-level").length > 0) {
            var placeHolderToUpdate = $(me._widget).find("#js-current-level").attr("Id");
            var fieloField = $(me._widget).find("#js-current-level").attr("data-fielo-field");
            var dataType = $(me._widget).find("#js-current-level").attr("data-type");
            memberRequest = {
                "dataType": dataType,
                "callType": "GetMemberLevel",
                "pointValue": 1,
                "fieldName": fieloField,
                "renew": false,
                "placeHolderToUpdate": placeHolderToUpdate
            };
            membersRequests.push(memberRequest);
        }
        me.GetCommmonMember(0, membersRequests);
    }
    GetCommmonMember(attempt, membersRequests) {
        var me = this;
        if (attempt < 5) {
            $.when(submitAjaxRequest(membersRequests, "/Fielo/GetCommonMember", "POST").done(function (data, textStatus, request) {
                if (data != null && data.result != null) {
                    data.result.attempt = attempt + 1;
                    data.result.memberRequests = membersRequests;
                    me.updateCommmonMemberUI(data.result);
                }
            }));
        }
        else {
            alert("too many attempts");
            return;
        }
    }
    updateCommmonMemberUI(data) {
        var me = this;
        if (data != null && data.errorCode != undefined) {
            if (data.errorCode == "INVALID_SESSION_ID") {
                me.GetCommmonMember(data.attempt, data.membersRequests);
            }
            else if (data.errorCode != "") {
                data.attempt = data.attempt + 1;
                me.GetCommmonMember(data.attempt, data.membersRequests);
                return;
            }
            else {
                if (data.responseData != null && data.responseData != undefined && data.responseData.memberResponseObject != null && data.responseData.memberResponseObject !== undefined) {
                    $.each(data.responseData.memberResponseObject, function (index, value) {
                        $("#" + value.placeHolderToUpdate).html(value.formattedData);
                    });
                }
            }
        }
    }
}
;
$(document).ready(function () {
    $(".widget-userstatusfielo").each(function (index, item) {
        $(item).data("manager", new UserStatusFielo(item));
    });
});
/// <reference path="../standaloneComponents/FileUpload.ts" />
$(document).ready(function () {
    //function UploadImage(fileField, $hiddenField) {
    //    if (fileField.files[0] != null) {
    //        var formData = new FormData();
    //        formData.append('file', fileField.files[0]);
    //        $.ajax({
    //            url: ("/API/Content/UploadFile"),
    //            type: "POST",
    //            data: formData,
    //            processData: false,
    //            cache: false,
    //            contentType: false
    //        }).done(function (data) {
    //            gage.log(data.data.fileName);
    //            $hiddenField.attr("data-url", data.data.url);
    //            $hiddenField.text(data.data.fileName);
    //            $hiddenField.removeClass("hide");
    //        });
    //    }
    //}
    //$('input[type="file"]').change(function () {
    //    UploadImage(this, $(this).parent().find("div.filename"));
    //});
    var showRecaptcha = $('#showRecaptcha').val();
    if (showRecaptcha) {
        var element = document.getElementById("submit-contact-button");
        if (element != undefined) {
            element.disabled = true;
        }
    }
    $(document).on("change", ".widget-contact-form input[type='file']", function (e) {
        var container = $(this).parent();
        var fileProgress = $(container).find(".file-progress");
        var fileInput = $(container).find("input[type='file']");
        var file = e.target.files[0];
        var originalFilename = file.name;
        var fileUpload = new FileUpload(file, null);
        $(fileInput).hide();
        $(container).find(".js-change-image-button").hide();
        $(fileProgress).find(".progress-wrapper").show();
        fileUpload.onProgressChangeCallback = function (value) {
            var percentText = value.toString() + '%';
            $(fileProgress).find(".progress-wrapper .progress-indicator").text(percentText);
            $(fileProgress).find(".progress-wrapper .progress-indicator").width(percentText);
        };
        fileUpload.onCompleteCallback = function () {
            var queryStart = fileUpload.url.indexOf("?");
            var cdnUrl = fileUpload.url.substr(0, queryStart);
            $(container).find(".filename").text(originalFilename);
            $(container).find(".CdnUrl").val(cdnUrl);
            $(container).find(".js-change-image-button").show();
            $(fileProgress).find(".progress-wrapper .progress-indicator").text("0");
            $(fileProgress).find(".progress-wrapper .progress-indicator").width("0%");
            $(fileProgress).find(".progress-wrapper").hide();
        };
        fileUpload.usePortalUploadPath = true;
        fileUpload.enforceFileTypes = true;
        fileUpload.uploadFile();
    });
    $("body").on("click", "#submit-contact-button", function (e) {
        e.preventDefault();
        var id = "#" + $(this).data("id");
        var emailErrorMessage = $('#submit-contact-button').attr("data-invalid-email");
        if (emailErrorMessage == undefined) {
            emailErrorMessage = "Please enter a valid email address.";
        }
        $.validator.addMethod("contact-form-email", function (value, element) {
            return this.optional(element) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        }, emailErrorMessage);
        var validator = $(id).validate();
        if (validator.form()) {
            if ($("#ContactFormOperationComplete").val() == 'False') {
                bootbox.dialog({
                    title: '<span class="fa-solid fa-floppy-disk"></span> ' + $('#savingContactTitle').val(),
                    message: $('#savingContactMessage').val(),
                    closeButton: false
                });
                $(id).trigger("submit");
                setTimeout(function () {
                    validator.resetForm();
                }, 100);
            }
        }
    });
});
/// <reference path="../lib/jquery.d.ts" />
class CurriculumTeamContentListWidget {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var self = this;
        try {
            var html = $(".js-course-content").html();
            var globalModal = new GlobalModal("content-assignment-list");
            if ($(self._widget).find("#FlyoutInitialDisplayBehavior").val() == "Open") {
                if ($("body.client-theme").length) {
                    globalModal.openGlobalModal(html, "panel", { classes: "content-assignment-list", panelAlignment: "left", animate: true });
                }
            }
            if ($(self._widget).find("#FlyoutInitialDisplayBehavior").val() == "OpenCloseAfter") {
                if ($("body.client-theme").length) {
                    globalModal.openGlobalModal(html, "panel", { classes: "content-assignment-list", panelAlignment: "left", animate: true });
                }
                setTimeout(function () {
                    globalModal.closeGlobalModal();
                }, 2000);
            }
            $(self._widget).find(".js-open-class-list").on("click", function (e) {
                globalModal.openGlobalModal(html, "panel", { classes: "content-assignment-list", panelAlignment: "left", animate: true });
                $("#globalmodal-content-assignment-list").find(".localized-time").each(function (i, e) {
                    var localDate = $(e).text();
                    $(e).html(DisplayDateInLocalFormat(localDate, "MM/DD/YYYY") + " <small>" + DisplayDateInLocalFormat(localDate, "hh:mm a") + "</small>");
                });
            });
        }
        catch (error) {
            console.error(error);
        }
        $(document).on('OnContentCompetionWidgetCompletionCheck', function () {
            var trackableWidgets = $("[data-trackable='true']");
            var dataCompletedWidgetCount = 0;
            $("[data-trackable='true']").each(function (index, elem) {
                if ($(elem).attr("data-participant-completed") == "true") {
                    dataCompletedWidgetCount += 1;
                }
            });
            if (dataCompletedWidgetCount == trackableWidgets.length) {
                var urlParameters = window.location.href.slice(window.location.href.indexOf('?') + 1);
                var params = {
                    "id": self._widgetId.toString(),
                    "source": urlParameters
                };
                $.ajax({
                    data: params,
                    method: "GET",
                    url: '/Content/RenderCurriculumTeamContentList',
                    success: function (data) {
                        $(self._widget).find(".user-curriculumteamcontentlist-inner").html(data);
                        if ($(self._widget).find("#IsWidgetVisible").val() === "True") {
                            $(self._widget).find(".js-open-class-list").on("click", function (e) {
                                globalModal.openGlobalModal(html, "panel", { classes: "content-assignment-list", panelAlignment: "left", animate: true });
                            });
                            if ($(self._widget).find("#FlyoutCompletionDisplayBehavior").val() == "Open") {
                                if ($("body.client-theme").length) {
                                    globalModal.openGlobalModal(html, "panel", { classes: "content-assignment-list", panelAlignment: "left", animate: true });
                                }
                            }
                        }
                    }
                });
            }
        });
    }
}
$(function () {
    // locate all product list widgets on page
    $(".user-curriculumteamcontentlist").each(function (index, item) {
        $(item).data("manager", new CurriculumTeamContentListWidget(item));
    });
});
window["CurriculumTeamContentListWidget"] = CurriculumTeamContentListWidget;
/// <reference path="../lib/jquery.d.ts" />
class DSODashboard {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".js-children-transactions").on('click', function () {
            var expand = this;
            me.showTransactions(expand, this);
        });
        $(me._widget).find(".js-children-locations").on('click', function () {
            var expand = this;
            me.showLocations(expand, this);
        });
    }
    showTransactions(expand, origin) {
        var me = this;
        var parentContainer = $(me._widget).find("#list-items").find('.js-row-transactions-' + $(expand).data("participantid"));
        var detailContainer = $(parentContainer).find(".js-transactions-" + $(expand).data("participantid"));
        $(detailContainer).find('.js-chidren-transactions').attr('disabled', 'true');
        var identifier = $(expand).data("participantid");
        $.when(me.Children(identifier).done(function (data, textStatus, response) {
            var modalHeading = $(".js-transactions-heading").text();
            var htmlSource = $("<div><h1 class='h2'>" + modalHeading + "</h1>" + $(parentContainer).html() + "</div>");
            if (data.trim() === "") {
                $(htmlSource).find("table").remove();
                var noTransactionsMsg = $(".js-no-transactions").text();
                $(htmlSource).append("<i>" + noTransactionsMsg + "</i>");
            }
            else {
                $(htmlSource).find("tbody").append(data);
            }
            $(htmlSource).find(".accounttransactionListHeading").removeClass("sorting").removeClass("sorting_desc");
            $(htmlSource).find(".dataTable").removeClass("table-striped");
            var globalModal = new GlobalModal("dso-locations");
            globalModal.openGlobalModal($(htmlSource).html(), "panel", { origin: $(origin), classes: "dso-modal" });
            $(".dso-modal").find(".js-vieworderdetail").on('click', function () {
                var expand = this;
                me.showTransactionDetail(expand);
            });
        }));
    }
    showTransactionDetail(expand) {
        var me = this;
        var widgetContainer = $('.widget-accounttransaction-list');
        var parentContainer = $(expand).parent().closest('tr').next('tr');
        var detailContainer = $(parentContainer).find(".detail-" + $(expand).data("identifier"));
        var icon = $(expand).find('span');
        if ($(icon).hasClass('fa-chevron-down')) {
            if ($(detailContainer).hasClass("js-data-loaded")) {
                $(parentContainer).removeClass('hide');
                $(icon).toggleClass('fa-chevron-down fa-chevron-up');
            }
            else {
                $(widgetContainer).find('.js-vieworderdetail').attr('disabled', 'true');
                var identifier = $(expand).data("identifier");
                var actionid = $(expand).data("actionid");
                var source = $(expand).data("source");
                var transactiontype = $(expand).data("transactiontype");
                var participantactivityid = $(expand).data("participantactivityid");
                var showaccount = $(expand).data("showaccount");
                var showdepositsource = $(expand).data("showdepositsource");
                var activityname = $(expand).data("activityname");
                var isadmin = $(expand).data("isadmin");
                $.when(me.GetOrderDetail(identifier, actionid, source, transactiontype, participantactivityid, activityname, showaccount, showdepositsource, isadmin).done(function (data, textStatus, response) {
                    $(parentContainer).removeClass('hide');
                    $(parentContainer).slideDown(1000);
                    detailContainer.html($(this).data("identifier"));
                    detailContainer.addClass("js-data-loaded");
                    $(icon).toggleClass('fa-chevron-down fa-chevron-up');
                    detailContainer.html(data);
                    $(detailContainer).find(".dataTable").removeClass("table-striped");
                }));
            }
        }
        else {
            $(parentContainer).addClass('hide');
            $(icon).toggleClass('fa-chevron-down fa-chevron-up');
        }
    }
    GetOrderDetail(identifier, actionid, source, transactiontype, participantactivityid, activityname, showaccount, showdepositsource, isadmin) {
        var params = {
            "source": source,
            "transactionType": transactiontype,
            "identifier": identifier,
            "actionId": actionid,
            "participantActivityId": participantactivityid,
            "activityName": activityname,
            "showAccount": showaccount,
            "showDepositSource": showdepositsource,
            "isaAmin": isadmin
        };
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Api/AccountTransaction/GetTransactionDetail'
        });
    }
    Children(participantId) {
        var me = this;
        var params = {
            "participantId": null
        };
        params.participantId = participantId;
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Distributor/GetTransactions',
            cache: false,
            traditional: true
        });
    }
    showLocations(expand, origin) {
        var me = this;
        var identifier = $(expand).data("participantid");
        $.when(me.Locations(identifier).done(function (data, textStatus, response) {
            var modalHeading = $(".js-locations-heading").text();
            data = "<h1 class='h2'>" + modalHeading + "</h2>" + data;
            var globalModal = new GlobalModal("dso-locations");
            globalModal.openGlobalModal(data, "panel", { origin: $(origin), classes: "dso-modal" });
        }));
    }
    Locations(participantId) {
        var me = this;
        var params = {
            "participantId": null
        };
        params.participantId = participantId;
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Distributor/GetLocations',
            cache: false,
            traditional: true
        });
    }
}
$(document).ready(function () {
    $(".widget_dsodashboard").each(function (index, item) {
        $(item).data("manager", new DSODashboard(item));
    });
});
window["DSODashboard"] = DSODashboard;
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
export class DSOSetup {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".js-reset-dso-button").click(function (e) {
            var table = $(me._widget).find(".js-participants");
            $(this).closest(".panel-body").find(".js-dsosearchtext").val("");
            $(table).addClass('hidden');
        });
        $(me._widget).find(".js-find-dso-button").click(function (e) {
            e.preventDefault();
            if ($(me._widget).find(".js-dsosearchtext").val() === "") {
                alert($(this).data("required-text"));
                return false;
            }
            me.findDSO();
        });
        $(me._widget).on('click', '.js-distributors', function () {
            var expand = this;
            me.showDistributors(expand, this);
        });
        $(me._widget).find(".js-dsosearchtext").on("keypress", function (e) {
            if (e.keyCode == 13)
                $(me._widget).find(".js-find-dso-button").click();
        });
        $(me._widget).find(".js-shownewhierarchypanel").click(function (e) {
            e.preventDefault();
            $(me._widget).find(".js-panel-search").addClass("hidden");
            $(me._widget).find(".js-participants").addClass("hidden");
            $(me._widget).find(".js-panel-create").removeClass("hidden");
        });
        $(me._widget).find(".js-button-save-practice").on('click', function (e) {
            e.preventDefault();
            var topHierarchyLevelParticipantId = $(this).data("parent-identifier");
            if (me.validateInput()) {
                me.saveAddPractice(topHierarchyLevelParticipantId);
            }
        });
        $(me._widget).find(".js-addnew-hierarchy").click(function (e) {
            e.preventDefault();
            var errorpanel = $(me._widget).find(".js-panel-error");
            var successpanel = $(me._widget).find(".js-panel-success");
            var successmessage = $(successpanel).data("fileupload-success-message");
            $(errorpanel).addClass("hidden");
            $(successpanel).addClass("hidden");
            var errorcontainer = $(errorpanel).find(".js-panel-errorcontainer");
            var successcontainer = $(successpanel).find(".js-panel-successcontainer");
            var bodycontainer = $(me._widget).find(".js-participants #list-items");
            var fileObject = $(me._widget).find("#file");
            var file = document.getElementById($(fileObject).attr("id"));
            var form = $(file).closest("form")[0];
            var formData = new FormData(form);
            formData.append('tophierarchylevel', $(me._widget).find(".js-tophierarchyleveltext").val());
            formData.append('midhierarchylevel', $(me._widget).find(".js-midhierarchyleveltext").val());
            formData.append('pointssplit', $(me._widget).find(".js-pointssplit").val());
            var url = ("/Distributor/ImportHierarchy");
            $.when(submitAjaxRequest(undefined, url, "post", undefined, undefined, undefined, formData)
                .done(function (data, textStatus, request) {
                if (data != null) {
                    if (data.success == false && data.response.data != null && data.response.data.length > 0) {
                        var html = '<ul class="list-group">';
                        $(data.response.data).each(function (index, value) {
                            html += '<li class="list-group-item">' + value + '</li>';
                        });
                        $(errorcontainer).html(html);
                        $(errorpanel).removeClass("hidden");
                    }
                    else if (data.success == true && data.response.data != null) {
                        if (data.response.data.length > 0) {
                            var html = '<ul class="list-group">';
                            $(data.response.data).each(function (index, value) {
                                html += '<li class="list-group-item">' + value + '</li>';
                            });
                            $(successcontainer).html(html);
                            $(successpanel).find(".panel-heading").html(successmessage);
                            $(me._widget).find(".js-invite-tophierarchy-member").on('click', function (e) {
                                e.preventDefault();
                                var errorMessage = $(this).data("errormessage");
                                var successMessage = $(this).data("successmessage");
                                me.SendIndividualEmail(0, $(this).attr("data-identifier"), successMessage, errorMessage);
                            });
                        }
                        $(successpanel).removeClass("hidden");
                        if (data.response.output !== "") {
                            $(bodycontainer).html(data.response.output);
                            $(bodycontainer).find(".js-group-row").addClass("success");
                            var table = $(me._widget).find(".js-participants");
                            $(me._widget).find(".js-panel-search").removeClass("hidden");
                            $(me._widget).find(".js-panel-create").addClass("hidden");
                            $(me._widget).find(".js-children").on('click', function () {
                                var expand = this;
                                me.showChildren(expand);
                            });
                            $(table).removeClass("hidden");
                        }
                    }
                }
            }));
        });
        $(me._widget).find("#file").on("change", function (e) {
            me.selectFileToImport(this);
        });
        me.removePracticeLocation();
        $(me._widget).find(".js-button-add-location").on('click', function (e) {
            e.preventDefault();
        });
        $(me._widget).find(".js-close-createnew").on("click", function (e) {
            e.preventDefault();
            $(me._widget).find(".js-panel-search").removeClass("hidden");
            $(me._widget).find(".js-panel-create").addClass("hidden");
            $(me._widget).find(".js-panel-search").removeClass("hidden");
            $(me._widget).find(".js-file-upload-summary").addClass("hidden").text("");
            $(me._widget).find(".js-panel-successcontainer").html("");
            $(me._widget).find(".js-panel-errorcontainer").html("");
            $(me._widget).find(".js-panel-error").addClass("hidden");
            $(me._widget).find(".js-panel-success").addClass("hidden");
            $(me._widget).find("#file").val("");
            $(me._widget).find(".js-file-upload-summary").text("");
        });
    }
    removePracticeLocation() {
        var me = this;
        $(me._widget).find(".btn-remove-practice-location-type").on("click", function (e) {
            e.preventDefault();
            $(this).closest(".js-location-type-parent").remove();
            if ($(me._widget).find(".js-location-type-container .js-practice-location-type").length == 1) {
                $(me._widget).find(".js-location-type-container .btn-remove-practice-location-type").addClass("hidden");
            }
            else {
                $(me._widget).find(".js-location-type-container .btn-remove-practice-location-type").removeClass("hidden");
            }
        });
    }
    SendIndividualEmail(participantId, template, successMessage, errorMessage) {
        var me = this;
        var params = {
            ParticipantId: participantId,
            Template: template
        };
        /*var url = "/Distributor/SendIndividualEmail?participantId=" + participantId + "&template=" + template;*/
        var url = "/Distributor/SendIndividualEmail";
        $.when(submitAjaxRequest(params, url, "post", function () { $("#ajax-loading").modal(); })
            .done(function (data, textStatus, request) {
            $("#ajax-loading").modal("hide");
            if (data != null) {
                if (data.success === true) {
                    alert(successMessage);
                }
                else {
                    alert(errorMessage);
                }
            }
        }));
    }
    SendGroupEmail(participantId, successMessage, errorMessage) {
        var me = this;
        var model = {
            participantId: participantId,
            midHierarchyLevelGroupId: $(me._widget).find(".js-midhierarchyleveltext").val()
        };
        var url = "/Distributor/SendInvitationEmailByParent";
        $.when(submitAjaxRequest(model, url, "post", function () { $("#ajax-loading").modal(); })
            .done((data, textStatus, request) => {
            $("#ajax-loading").modal("hide");
            if (data != null) {
                if (data.success === true) {
                    alert(successMessage);
                }
                else {
                    alert(errorMessage);
                }
            }
        }));
    }
    saveAddPractice(topHierarchyLevelParticipantId) {
        var me = this;
        var errorpanel = $(me._widget).find(".js-panel-location-error");
        var successpanel = $(me._widget).find(".js-panel-success");
        $(errorpanel).addClass("hidden");
        $(successpanel).addClass("hidden");
        var successmessage = $(successpanel).data("record-success-message");
        var errorcontainer = $(errorpanel).find(".js-panel-location-error-container");
        var successcontainer = $(successpanel).find(".js-panel-successcontainer");
        var bodycontainer = $(me._widget).find(".js-participants #list-items");
        var model = {
            CompanyName: null,
            FirstName: null,
            LastName: null,
            Email: null,
            PhoneNumber: null,
            Country: null,
            Language: null,
            JobTitle: null,
            KerrPreferredNumberOfOperatories: null,
            NPINumber: null,
            PreferredLocationTypeId: 2,
            Locations: null,
            Tophierarchylevel: $(me._widget).find(".js-tophierarchyleveltext").val(),
            Midhierarchylevel: $(me._widget).find(".js-midhierarchyleveltext").val(),
            TopHierarchyLevelParticipantId: topHierarchyLevelParticipantId,
            PreferredLocationType: $(me._widget).find(".js-preferredlocationtype").val()
        };
        var locations = null;
        model.CompanyName = $(".js-practice-companyname").val() == "" ? null : $(".js-practice-companyname").val();
        model.FirstName = $(".js-practice-firstname").val() == "" ? null : $(".js-practice-firstname").val();
        model.LastName = $(".js-practice-lastname").val() == "" ? null : $(".js-practice-lastname").val();
        model.Email = $(".js-practice-email").val() == "" ? null : $(".js-practice-email").val();
        model.PhoneNumber = $(".js-practice-phonenumber").val() == "" ? null : $(".js-practice-phonenumber").val();
        model.Country = $(".js-practice-country").val();
        model.Language = $(".js-practice-language").val();
        model.JobTitle = $(".js-practice-jobtitle").val() == "" ? null : $(".js-practice-jobtitle").val();
        model.NPINumber = $(".js-practice-npinumber").val() == "" ? null : $(".js-practice-npinumber").val();
        model.KerrPreferredNumberOfOperatories = $(".js-practice-operatories").val() == "" ? null : $(".js-practice-operatories").val();
        locations = $(me._widget).find(".js-location-container .js-practice-location").map(function () {
            if (this.value != "") {
                return this.value;
            }
        }).get().join(',');
        model.Locations = locations;
        var url = "/Distributor/AddHierarchy";
        $.when(submitAjaxRequest(model, url, "post")
            .done(function (data, textStatus, request) {
            if (data != null) {
                if (data.success == false && data.response.data != null && data.response.data.length > 0) {
                    var html = '<ul class="list-group">';
                    $(data.response.data).each(function (index, value) {
                        ;
                        html += '<li class="list-group-item">' + value + '</li>';
                    });
                    $(errorcontainer).html(html);
                    $(errorpanel).removeClass("hidden");
                    $("#practiceModalError").modal();
                }
                else if (data.success == true && data.response.data != null) {
                    if (data.response.data.length > 0) {
                        var html = '<ul class="list-group">';
                        $(data.response.data).each(function (index, value) {
                            html += '<li class="list-group-item">' + value + '</li>';
                        });
                        $(successcontainer).html(html);
                        $(successpanel).find(".panel-heading").html(successmessage);
                    }
                    $(successpanel).removeClass("hidden");
                    if (data.response.output !== "") {
                        $(bodycontainer).html(data.response.output);
                        $(bodycontainer).find(".js-group-row").addClass("success");
                        var table = $(me._widget).find(".js-participants");
                        $(me._widget).find(".js-panel-search").removeClass("hidden");
                        $(me._widget).find(".js-panel-create").addClass("hidden");
                        $(me._widget).find(".js-children").on('click', function () {
                            var expand = this;
                            me.showChildren(expand);
                        });
                        $(table).removeClass("hidden");
                        $(me._widget).find("#practiceModal").modal("hide");
                        $(me._widget).find("#practiceModal").find("input").val("");
                        $(me._widget).find("#practiceModal").find('select option:first-child').attr("selected", "selected");
                    }
                }
            }
        }));
    }
    validateInput() {
        var me = this;
        var errormessage = "";
        if ($(me._widget).find(".js-practice-firstname").val() == "") {
            errormessage = "First Name is required\n";
        }
        if ($(me._widget).find(".js-practice-lastname").val() == "") {
            errormessage += "Last Name is required\n";
        }
        if ($(me._widget).find(".js-practice-email").val() == "") {
            errormessage += "Email is required\n";
        }
        if ($(me._widget).find(".js-practice-email").val() != "") {
            var email_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
            if (!email_regex.test($(me._widget).find(".js-practice-email").val())) {
                errormessage += "Email is invalid\n";
            }
        }
        if ($(me._widget).find(".js-practice-phonenumber").val() == "") {
            errormessage += "Phone number is required\n";
        }
        if ($(me._widget).find(".js-practice-operatories").val() == "") {
            errormessage += "Operatories Name is required\n";
        }
        if (errormessage == "") {
            return true;
        }
        alert(errormessage);
        return false;
    }
    selectFileToImport(input) {
        if (input.files.length) {
            $(".js-file-upload-summary").removeClass("hidden").text(input.files[0].name);
        }
        else {
            $(".js-file-upload-summary").addClass("hidden").text("");
        }
    }
    findDSO() {
        var me = this;
        var table = $(me._widget).find(".js-participants");
        var bodycontainer = $(me._widget).find(".js-participants #list-items");
        var norecordscontainer = $(me._widget).find(".js-norecordsfound");
        $(me._widget).find(".js-panel-success").addClass("hidden");
        $(me._widget).find(".js-dso-loader").removeClass("hidden");
        $(bodycontainer).html("");
        $.when(me.Search($(me._widget).find(".js-dsosearchtext").val()).done((data, textStatus, response) => {
            $(me._widget).find(".js-dso-loader").addClass("hidden");
            $(table).addClass("hidden");
            $(norecordscontainer).addClass("hidden");
            if ($.trim(data) === "") {
                $(norecordscontainer).removeClass("hidden");
            }
            else {
                $(bodycontainer).html(data);
                $(bodycontainer).find(".js-group-row").addClass("success");
                $(this._widget).find(".js-children").on('click', function () {
                    var expand = this;
                    me.showChildren(expand);
                });
                $(table).removeClass("hidden");
                $(this._widget).find(".js-invite-tophierarchy-member").on('click', function (e) {
                    e.preventDefault();
                    var errorMessage = $(this).data("errormessage");
                    var successMessage = $(this).data("successmessage");
                    me.SendIndividualEmail($(this).attr("data-identifier"), "parent", successMessage, errorMessage);
                });
                $(me._widget).find(".js-invite-all-primary-members").on('click', function (e) {
                    e.preventDefault();
                    var errorMessage = $(this).data("errormessage");
                    var successMessage = $(this).data("successmessage");
                    me.SendGroupEmail($(this).attr("data-identifier"), successMessage, errorMessage);
                });
            }
        }));
    }
    SetDistributorCompanyAddressesForParticipant(participantId, addressId, clientId) {
        var me = this;
        var dto = {
            ParticipantId: participantId,
            DistributorCompanyDto: {
                Addresses: [{
                        ParticipantID: participantId,
                        ID: addressId,
                        //DistributorCompanyClientID: clientId
                        PointMatchingField: clientId
                    }]
            }
        };
        //var params = { id: null, addressQueue: null };
        //params.id = participantId;
        //params.addressQueue = JSON.stringify(dto);
        //console.log(params.addressQueue);
        var processingModalTitle = $("#adding-practice-modal-processing-title").val();
        var processingModalBody = $("#adding-practice-modal-processing-message").val();
        var box = bootbox.dialog({
            show: false,
            title: '<span class="fa-solid fa-floppy-disk"></span>&nbsp;&nbsp;' + processingModalTitle,
            message: "<i class=\"fa fa-refresh fa-spin\"></i> " + processingModalBody,
            closeButton: false
        });
        var url = "/Manage/User/SetDistributorCompanyAddressesForDSOParticipant";
        $.when(submitAjaxRequest(dto, url, "post", function () {
            box.modal('hide');
        }).done(function (data) {
            box.modal("hide");
            $(me._widget).find("#distributor-company-search-modal").modal("hide");
            var td = $(me._widget).find(".js-participants #list-items").find("[data-parent-identifier='" + $("#globalmodal-dso-detail").find(".js-parentparticipantid").val() + "']");
            $(td).removeClass("js-data-loaded");
            $(td).closest(".js-row-" + $("#globalmodal-dso-detail").find(".js-parentparticipantid").val()).addClass("hide");
            var parentrow = $(td).closest(".dataTable").find(".js-parentrow-" + $("#globalmodal-dso-detail").find(".js-parentparticipantid").val());
            var icon = $(parentrow).find(".js-children span");
            $(icon).removeClass('fa-chevron-up');
            $(icon).addClass("fa-chevron-down");
            $.when(me.Distributors(participantId).done((data, textStatus, response) => {
                $("#globalmodal-dso-detail").find(".global-modal-inner-container").html(data);
                $("#globalmodal-dso-detail").find(".distributor-company-search-trigger").click(function (e) {
                    e.preventDefault();
                    var participantId = $(this).attr("data-participantid");
                    var dataTable = $(me._widget).find("#distributor-company-search-data-table");
                    me.GetDistributorCompanies(participantId, dataTable);
                });
            }));
        }));
    }
    GetDistributorCompanies(participantId, dataTable) {
        var me = this;
        if (!$.fn.DataTable.isDataTable(dataTable)) {
            // DATATABLE
            $(dataTable).DataTable({
                "pageLength": 10,
                "processing": true,
                "language": {
                    'loadingRecords': 'Loading',
                    'processing': '<strong>Processing</strong>'
                },
                "serverSide": true,
                //"deferLoading": 0,
                "paging": true,
                "ordering": false,
                "searching": true,
                "info": true,
                "lengthChange": false,
                "dom": '<"top"fl>rt<"bottom"ip><"clear">',
                "scrollY": '600px',
                "ajax": {
                    "url": "/Manage/User/GetDistributorCompanies",
                    "type": "GET",
                    "data": function (data) {
                        data.id = participantId;
                    },
                    "dataSrc": function (json) {
                        return json.data;
                    }
                },
                "drawCallback": function () {
                    var api = this.api();
                    var rows = api.rows({ page: "current" }).nodes();
                    var last = null;
                    api.column(3, { page: "current" }).data().each(function (group, i) {
                        if (last !== group) {
                            $(rows).eq(i).before('<tr><td colspan="4" style=\"background-color:#fafafa;border-top:1px solid #A9A9A9;\" class=\"text-left\"><h4>' + group + '</h4></td></tr>');
                            last = group;
                        }
                    });
                },
                "columnDefs": [
                    {
                        "targets": 0,
                        "searchable": false,
                        "orderable": false,
                        "className": "text-center",
                        "render": function (data, type, full, meta) {
                            var addButtonText = $(me._widget).find("#distributor-company-search-modal-add-practice-button").val();
                            var ownerLabel = $(me._widget).find("#distributor-company-search-modal-address-owner-label").val();
                            var claimedLabel = $(me._widget).find("#distributor-company-search-modal-address-claimed-label").val();
                            var htm = "";
                            if (full.IsParticipantAddressOwner === true) {
                                htm = "<span class=\"label label-success\">" + ownerLabel + "</span>";
                            }
                            else if (full.Claimed === true) {
                                htm = "<span class=\"label label-danger\">" + claimedLabel + "</span>";
                            }
                            else {
                                htm = "<button class=\"btn btn-primary add-address\" " + "data-id=\"" + full.ID + "\"" + "data-distributorcompanyclientid=\"" + full.DistributorCompanyClientID + "\" " + "data-pointmatchingfield=\"" + full.PointMatchingField + "\"><i class=\"fa fa-plus\"></i> " + addButtonText + "</button>";
                            }
                            return htm;
                        }
                    },
                    {
                        "targets": 1,
                        "searchable": false,
                        "orderable": false,
                        "render": function (data, type, full) {
                            var htm = "<strong>" + full.DistributorCompanyName + "</strong>";
                            return htm;
                        }
                    },
                    { "targets": 2, "searchable": false, "orderable": false, "data": "Address" },
                    //{ "targets": 3, "searchable": false, "orderable": false, "data": "DistributorCompanyClientID", "visible": false }
                    { "targets": 3, "searchable": false, "orderable": false, "data": "SelectionGroup", "visible": false }
                ],
                "pagingType": "full",
                "initComplete": function () {
                    var input = $("#distributor-company-search-modal .dataTables_filter input").off();
                    var self = this.api();
                    var $searchButton = $("<button class=\"btn btn-primary\">").text("Search").click(function () {
                        self.search(input.val()).draw();
                    });
                    $(".dataTables_filter").append($searchButton);
                }
            });
        }
        else {
            $(dataTable).DataTable().search("").columns().search("").draw();
        }
        // bring processing message to the front
        $(me._widget).find('#distributor-company-search-data-table_processing').css('z-index', '99999');
        $(me._widget).find("#distributor-company-search-modal").attr("data-participantid", participantId);
        $(me._widget).find("#distributor-company-search-modal").modal("show");
    }
    showDistributors(expand, origin) {
        var me = this;
        var identifier = $(expand).data("identifier");
        $("#ajax-loading").modal();
        $.when(me.Distributors(identifier).done((data, textStatus, response) => {
            $("#ajax-loading").modal("hide");
            var globalModal = new GlobalModal("dso-detail");
            globalModal.openGlobalModal(data, "panel", { origin: $(origin), classes: "dso-modal" });
            $("#globalmodal-dso-detail").find(".distributor-company-search-trigger").click(function (e) {
                e.preventDefault();
                var participantId = $(this).attr("data-participantid");
                var dataTable = $(me._widget).find("#distributor-company-search-data-table");
                me.GetDistributorCompanies(participantId, dataTable);
            });
        }));
    }
    showChildren(expand) {
        var me = this;
        var bodycontainer = $(me._widget).find(".js-participants #list-items");
        var parentContainer = $(expand).parent().closest("tr").next("tr");
        var detailContainer = $(parentContainer).find(".detail-" + $(expand).data("identifier"));
        var icon = $(expand).find("span");
        if ($(icon).hasClass('fa-chevron-down')) {
            $(".js-children").not(expand).find(".fa-chevron-up").removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $(".js-children").not(expand).parent().closest('tr').next('tr').addClass('hide');
            $(icon).toggleClass('fa-chevron-down fa-chevron-up');
            if ($(detailContainer).hasClass("js-data-loaded")) {
                $(parentContainer).removeClass('hide');
                // $(icon).switchClass('fa-chevron-down fa-chevron-up', '1000', "easeInOutQuad");
            }
            else {
                $(bodycontainer).find('.js-chidren').attr('disabled', 'true');
                var identifier = $(expand).data("identifier");
                $.when(me.children(identifier).done(function (data, textStatus, response) {
                    $(parentContainer).removeClass('hide');
                    $(parentContainer).slideDown(1000);
                    detailContainer.html($(this).data("identifier"));
                    detailContainer.addClass("js-data-loaded");
                    detailContainer.html(data);
                    detailContainer.find(".js-group-row").addClass("info");
                    $(bodycontainer).find(".js-vieworderdetail").removeAttr("disabled");
                    $(me._widget).find(".js-add-new-pratice").on('click', function (e) {
                        $(me._widget).find("#practiceModal").find(".js-button-save-practice").attr("data-parent-identifier", $(this).closest(".dso-mid-level-wrapper").data("parent-identifier"));
                        $(me._widget).find("#practiceModal").modal();
                    });
                    $(me._widget).find(".js-invite-primary-members").on('click', function (e) {
                        e.preventDefault();
                        var errorMessage = $(this).data("errormessage");
                        var successMessage = $(this).data("successmessage");
                        me.SendIndividualEmail($(this).attr("data-identifier"), "child", successMessage, errorMessage);
                    });
                }));
            }
        }
        else {
            $(parentContainer).addClass('hide');
            $(icon).toggleClass('fa-chevron-down fa-chevron-up');
        }
    }
    children(parentId) {
        var me = this;
        var params = {
            "searchCriteria": "",
            "topHierarchyLevelGroupId": parseInt($(this._widget).attr("data-tophierarchylevelgroup")),
            "midHierarchyLevelGroupId": parseInt($(this._widget).attr("data-midhierarchylevelgroup")),
            "parentId": null
        };
        params.searchCriteria = $(me._widget).find(".js-dsosearchtext").val();
        params.topHierarchyLevelGroupId = parseInt($(this._widget).attr("data-tophierarchylevelgroup"));
        params.midHierarchyLevelGroupId = parseInt($(this._widget).attr("data-midhierarchylevelgroup"));
        params.parentId = parentId;
        return $.ajax({
            data: params,
            method: "GET",
            url: "/Distributor/GetParticipantByHierarchy",
            cache: false,
            traditional: true
        });
    }
    Distributors(parentId) {
        var me = this;
        var params = {
            "parentId": null
        };
        params.parentId = parentId;
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Distributor/GetDistributorAddressByParent',
            cache: false,
            traditional: true
        });
    }
    Search(searchCriteria) {
        var me = this;
        var params = {
            "searchCriteria": "",
            "topHierarchyLevelGroupId": parseInt($(this._widget).attr("data-tophierarchylevelgroup")),
            "midHierarchyLevelGroupId": parseInt($(this._widget).attr("data-midhierarchylevelgroup")),
            "parentId": null
        };
        params.searchCriteria = searchCriteria;
        params.topHierarchyLevelGroupId = parseInt($(this._widget).attr("data-tophierarchylevelgroup"));
        params.midHierarchyLevelGroupId = parseInt($(this._widget).attr("data-midhierarchylevelgroup"));
        return $.ajax({
            data: params,
            method: "GET",
            url: '/Distributor/GetParticipantByHierarchy',
            cache: false,
            traditional: true
        });
    }
}
$(document).ready(() => {
    $(".widget_dsosetup").each((index, item) => {
        var dsoSetup = new DSOSetup(item);
        $(item).data("manager", dsoSetup);
        $("body").on("click", ".add-address", function (e) {
            e.preventDefault();
            var addressId = $(this).data("id");
            var participantId = $(this).closest("#distributor-company-search-modal").attr("data-participantid");
            var clientId = $(this).data("pointmatchingfield");
            dsoSetup.SetDistributorCompanyAddressesForParticipant(participantId, addressId, clientId);
        });
    });
});
window["DSOSetup"] = DSOSetup;
/// <reference path="../lib/jquery.d.ts" />
class FileWidget {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var self = this;
        $(this._widget).find(".download-link").click(function () {
            self.MarkAsCompleted();
        });
    }
    MarkAsCompleted() {
        var self = this;
        if ($(self._widget).data("tracking-complete") == "true") {
            $(self._widget).data("tracking-complete", "true");
            return;
        }
        globalThis.gage.TrackWidget($(this._widget), function () {
            $(self._widget).data("tracking-complete", "true");
            $(self._widget).data("data-participant-completed", "true");
        });
    }
}
$(function () {
    // locate all product list widgets on page
    $(".widget-file").each(function (index, item) {
        $(item).data("manager", new FileWidget(item));
    });
});
window["FileWidget"] = FileWidget;
function getHeroImageSize(imageSource) {
    var img = new Image();
    img.src = imageSource;
    globalThis.gage.log(img.width + 'x' + img.height);
}
var heroWidgets = {
    getHeroImageSize: {
        init: function (imageSource) {
            $(document).ready(function () {
                var img = new Image();
                img.src = imageSource;
                globalThis.gage.log(img.width + 'x' + img.height);
            });
        }
    }
};
$(window).on("load", function () {
    var overlayHeight, imageHeight = 0;
    $.each($('.widget-with-overlay').find('.widget-overlay'), function () {
        overlayHeight = $(this).height();
        imageHeight = $(this).parent().find('img').height();
        if (imageHeight > overlayHeight) {
            $(this).closest('.widget-with-overlay').height(imageHeight);
        }
        else {
            $(this).closest('.widget-with-overlay').height(overlayHeight);
        }
    });
});
$(document).ready(function () {
    $('#login-form').on("keydown", function (e) {
        var key = e.which;
        if (key === 13) {
            $("#login-form").trigger("submit");
        }
    });
});
/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/helper.admin.d.ts" />
class PromotionCodeWidget {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        $(this._widget).find(".promotion-code-success-message,.promotion-code-failed-message").hide();
        this.bindControls();
    }
    bindControls() {
        var self = this;
        $(this._widget).find(".promotion-code-submit").on("click", function () {
            var code = $(self._widget).find(".promotion-code-input").val();
            if (code.length > 0) {
                self.submitPromotionCode(code);
            }
        });
    }
    submitPromotionCode(code) {
        var self = this;
        $(self._widget).find(".promotion-code-success-message").hide();
        $(self._widget).find(".promotion-code-failed-message").hide();
        $(self._widget).find(".promotion-code-button").prop("disabled", true);
        var contentWidgetId = $(self._widget).attr("data-contentwidgetid");
        var dto = {
            Code: code,
            ContentWidgetId: contentWidgetId
        };
        var url = '/API/Content/SubmitPromotionCode';
        $.when(submitAjaxRequest(dto, url, "POST").done(function (data) {
            $(self._widget).find(".promotion-code-button").removeProp("disabled");
            if (data.success) {
                $(self._widget).find(".promotion-code-success-message").show();
            }
            else {
                $(self._widget).find(".promotion-code-failed-message").show();
            }
        }));
    }
}
$(function () {
    // locate all widgets on page
    $(".widget-promotion-code").each(function (index, item) {
        $(item).data("manager", new PromotionCodeWidget(item));
    });
});
window["PromotionCodeWidget"] = PromotionCodeWidget;
/// <reference path="../lib/bootbox.d.ts" />
/// <reference path="../lib/jquery.d.ts" />
class QuestionaireForm {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var me = this;
        $(me._widget).find(".submit-questionaireform-button").click(function (e) {
            e.preventDefault();
            var id = "#" + $(this).data("id");
            var validator = $(id).validate();
            if (validator.form()) {
                if ($(me._widget).find("#QuestionaireFormOperationComplete").val() == 'False') {
                    bootbox.dialog({
                        title: '<span class="fa-solid fa-floppy-disk"></span> ' + $('#savingContactTitle').val(),
                        message: $('#savingContactMessage').val(),
                        closeButton: false
                    });
                    $(me._widget).find("#QuestionaireIdentifier").val(me._widgetId);
                    $(id).trigger("submit");
                    setTimeout(function () {
                        validator.resetForm();
                    }, 100);
                }
            }
        });
        $(me._widget).find("input[type='file']").on("change", function (e) {
            var file = e.target.files[0];
            var fileUpload = new FileUpload(file, null, true);
            $(me._widget).find(".file-progress .progress-wrapper").show();
            fileUpload.onProgressChangeCallback = function (value) {
                var percentText = value.toString() + '%';
                $(me._widget).find(".file-progress .progress-wrapper .progress-indicator").text(percentText);
                $(me._widget).find(".file-progress .progress-wrapper .progress-indicator").width(percentText);
            };
            fileUpload.onCompleteCallback = function () {
                $(me._widget).find("#FileUploadUrl").attr("value", fileUpload.url);
            };
            fileUpload.uploadFile();
            fileUpload.onUploadFailCallback = function (message, uploader) {
                alert(message);
            };
        });
    }
}
$(document).ready(function () {
    $(".widget_questionaire-form").each(function (index, item) {
        $(item).data("manager", new QuestionaireForm(item));
    });
});
window["QuestionaireForm"] = QuestionaireForm;
/// <reference path="../lib/jquery.d.ts" />
class ResourceListViewWidget {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var self = this;
        $(this._widget).find(".download-link").click(function () {
            $(this).attr("data-tracking-complete", "true");
            if (self.AllLinksHaveBeenTracked()) {
                self.MarkAsCompleted();
            }
        });
    }
    AllLinksHaveBeenTracked() {
        return $(this._widget).find(".download-link[data-tracking-complete='false']").length == 0;
    }
    MarkAsCompleted() {
        var self = this;
        if ($(self._widget).attr("data-tracking-complete") == "true") {
            $(self._widget).data("tracking-complete", "true");
            return;
        }
        globalThis.gage.TrackWidget($(this._widget), function () {
            $(self._widget).data("data-participant-completed", "true");
            $(self._widget).data("tracking-complete", "true");
        });
    }
}
$(function () {
    // locate all product list widgets on page
    $(".widget-resource-list").each(function (index, item) {
        $(item).data("manager", new ResourceListViewWidget(item));
    });
});
window["ResourceListViewWidget"] = ResourceListViewWidget;
/// <reference path="../lib/jquery.d.ts" />
class UserCurriculumProgressWidget {
    constructor(widget) {
        this._widget = widget;
        this.initialize();
    }
    initialize() {
        this._widgetId = parseInt($(this._widget).attr("data-contentwidgetid"));
        this.bindControls();
    }
    bindControls() {
        var self = this;
        $("div .w-ucp-container").each(function () {
            var fullId = $(this).attr("id");
            var defaultDisplay = $(this).data("default-display");
            var n = fullId.lastIndexOf("-");
            var id = fullId.substring(n + 1);
            var hideDetailsText = $(self._widget).find("#hide-details-" + id).val();
            var showDetailsText = $(self._widget).find("#show-details-" + id).val();
            var showAdditionalElectivesText = $(self._widget).find("#show-additional-electives-" + id).val();
            var hideAdditionalElectivesText = $(self._widget).find("#hide-additional-electives-" + id).val();
            if (defaultDisplay === "Detail") {
                // $("#body-" + id).addClass("show");
                $("#detail-toggle-" + id).text(hideDetailsText);
            }
            else {
                // $("#body-" + id).removeClass("show");
                $("#header-" + id).removeClass("fang");
                $("#detail-toggle-" + id).text(showDetailsText);
            }
            $(self._widget).find("#detail-toggle-" + id).on("click", function () {
                $(this).text(function (i, txt) {
                    return txt === showDetailsText ? hideDetailsText : showDetailsText;
                });
            });
            $(self._widget).find("#additional-courses-toggle-" + id).on("click", function () {
                $(self._widget).find("#additional-courses-toggle-" + id + " span").text(function (i, txt) {
                    return txt === showAdditionalElectivesText ? hideAdditionalElectivesText : showAdditionalElectivesText;
                });
            });
        });
        $(document).on('OnContentCompetionWidgetCompletionCheck', function () {
            var trackableWidgets = $("[data-trackable='true']");
            var dataCompletedWidgetCount = 0;
            $("[data-trackable='true']").each(function (index, elem) {
                if ($(elem).attr("data-participant-completed") == "true") {
                    dataCompletedWidgetCount += 1;
                }
            });
            if (dataCompletedWidgetCount == trackableWidgets.length) {
                var params = {
                    "id": self._widgetId.toString(),
                };
                $.ajax({
                    data: params,
                    method: "GET",
                    url: '/Content/RenderUserCurriculumProgressList',
                    success: function (data) {
                        $(self._widget).find(".user-curriculum-inner").html(data);
                        var container = $(self._widget).find(".user-curriculum-inner").closest(".user-curriculum ");
                        bindEvents(container);
                    }
                });
            }
        });
        function bindEvents(container) {
            var fullId = $(container).attr("id");
            var defaultDisplay = $(container).data("default-display");
            var n = fullId.lastIndexOf("-");
            var id = fullId.substring(n + 1);
            var hideDetailsText = $(self._widget).find("#hide-details-" + id).val();
            var showDetailsText = $(self._widget).find("#show-details-" + id).val();
            var showAdditionalElectivesText = $(self._widget).find("#show-additional-electives-" + id).val();
            var hideAdditionalElectivesText = $(self._widget).find("#hide-additional-electives-" + id).val();
            if (defaultDisplay === "Detail") {
                // $("#body-" + id).addClass("show");
                $("#detail-toggle-" + id).text(hideDetailsText);
            }
            else {
                // $("#body-" + id).removeClass("show");
                $("#header-" + id).removeClass("fang");
                $("#detail-toggle-" + id).text(showDetailsText);
            }
            $(self._widget).find("#detail-toggle-" + id).on("click", function () {
                $(this).text(function (i, txt) {
                    return txt === showDetailsText ? hideDetailsText : showDetailsText;
                });
            });
            $(self._widget).find("#additional-courses-toggle-" + id).on("click", function () {
                $(self._widget).find("#additional-courses-toggle-" + id + " span").text(function (i, txt) {
                    return txt === showAdditionalElectivesText ? hideAdditionalElectivesText : showAdditionalElectivesText;
                });
            });
        }
    }
}
$(function () {
    // locate all product list widgets on page
    $(".user-curriculum").each(function (index, item) {
        $(item).data("manager", new UserCurriculumProgressWidget(item));
    });
});
window["UserCurriculumProgressWidget"] = UserCurriculumProgressWidget;
function BindUserLevelProgress() {
    $("div .widget-user-level-progress-container").each(function () {
        var container = this;
        var fullId = $(this).attr("id");
        var n = fullId.lastIndexOf("-");
        var id = fullId.substring(n + 1);
        var defaultDisplay = $("#default-display-" + id).val();
        var hideDetailsText = $("#hide-details-" + id).val();
        var showDetailsText = $("#show-details-" + id).val();
        var $toggleButton = $("#toggle-level-criteria-button-" + id);
        var $toggleText = $("#toggle-level-criteria-text-" + id);
        if (defaultDisplay === "Detail") {
            $(container).find(".ca").addClass("collapse").addClass("show");
            $toggleButton.removeClass("fa-solid fa-chevron-down").addClass("fa-solid fa-chevron-up");
            $toggleText.text(hideDetailsText);
        }
        else {
            $toggleButton.removeClass("fa-solid fa-chevron-up").addClass("fa-solid fa-chevron-down");
            $toggleText.text(showDetailsText);
        }
        $("#toggle-level-criteria-container-" + id).on("click", function (e) {
            $toggleButton.toggleClass("fa-solid fa-chevron-down").toggleClass("fa-solid fa-chevron-up");
            if ($toggleText.text() === showDetailsText) {
                $toggleText.text(hideDetailsText);
            }
            else {
                $toggleText.text(showDetailsText);
            }
        });
    });
}
$(document).ready(function () {
    BindUserLevelProgress();
});
var processScrubbingControls = function () {
    var videoIDs = $(".video-ids");
    videoIDs.each(function (index) {
        var videoID = $(this).val();
        var video = document.querySelector("#video-element_" + videoID);
        if (video == null || video == undefined) {
            return;
        }
        var hideVideoScrubbingBar = video.getAttribute("hide-video-scrubbing-bar") == "True";
        var disableForwardScrubbing = video.getAttribute("disable-forward-scrubbing") == "True";
        if (!hideVideoScrubbingBar && disableForwardScrubbing) {
            var previousTime = 0;
            video.ontimeupdate = function () {
                setTimeout(function () {
                    previousTime = video.currentTime;
                }, 1000);
            };
            video.onseeking = function () {
                if (video.currentTime > previousTime) {
                    video.currentTime = previousTime;
                }
            };
        }
        if (hideVideoScrubbingBar) {
            $("#video-element_" + videoID).addClass("widget-video-hide_scrubber");
        }
        else {
            $("#video-element_" + videoID).removeClass("widget-video-hide_scrubber");
        }
    });
};
$(function () {
    $(".widget-video-player").each(function (i, e) {
        var trackingType = parseInt($(e).data("tt"));
        switch (trackingType) {
            case 2:
                e.addEventListener("playing", function () { globalThis.gage.TrackWidget($(e)); }, true);
                break;
            case 3:
                e.addEventListener("ended", function () { globalThis.gage.TrackWidget($(e)); }, true);
                break;
        }
    });
    var videoMethods = {
        renderVideoPlayButton: function () {
            var self = this;
            var videoWrapper = $(".video-wrapper");
            $.each(videoWrapper, function (i, vw) {
                var video = $(vw).find("video");
                if (video.length) {
                    if ($(video).attr('autoplay') === undefined) {
                        self.formatVideoPlayButton(vw);
                        $(video).addClass("has-media-controls-hidden");
                        var videoPlayButton = $(vw).find('.video-overlay-play-button');
                        $(videoPlayButton).on("click", function () {
                            self.hideVideoPlayButton(video.get(0), this);
                        });
                    }
                    else {
                        //video.play();
                        //	self.hideVideoPlayButton(video.get(0), this);
                    }
                }
            });
        },
        formatVideoPlayButton: function (videoWrapper) {
            $(videoWrapper).append('\
                <svg class="video-overlay-play-button" viewBox="0 0 200 200" alt="Play video">\
                    <circle cx="100" cy="100" r="90" fill="none" stroke-width="15" stroke="#fff"/>\
                    <polygon points="70, 55 70, 145 145, 100" fill="#fff"/>\
                </svg>\
            ');
        },
        hideVideoPlayButton: function (video, videoPlayButton) {
            video.play();
            videoPlayButton.classList.add('is-hidden');
            video.classList.remove('has-media-controls-hidden');
            video.setAttribute('controls', 'controls');
        },
    };
    videoMethods.renderVideoPlayButton();
});
$(document).ready(function () {
    processScrubbingControls();
});
